//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.2.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import followIfLoginRedirect from './components/api-authorization/followIfLoginRedirect';

export class WorkTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkTypes(): Promise<WorkTypeDto[]> {
        let url_ = this.baseUrl + "/api/work-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkTypes(_response);
        });
    }

    protected processGetWorkTypes(response: Response): Promise<WorkTypeDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkTypeDto[]>(null as any);
    }

    createWorkType(command: CreateWorkTypeCommand): Promise<WorkTypeDto> {
        let url_ = this.baseUrl + "/api/work-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorkType(_response);
        });
    }

    protected processCreateWorkType(response: Response): Promise<WorkTypeDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkTypeDto>(null as any);
    }

    getWorkTypeById(id: number): Promise<WorkTypeDetailDto> {
        let url_ = this.baseUrl + "/api/work-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkTypeById(_response);
        });
    }

    protected processGetWorkTypeById(response: Response): Promise<WorkTypeDetailDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTypeDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkTypeDetailDto>(null as any);
    }

    updateWorkType(id: number, command: UpdateWorkTypeCommand): Promise<WorkTypeDto> {
        let url_ = this.baseUrl + "/api/work-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkType(_response);
        });
    }

    protected processUpdateWorkType(response: Response): Promise<WorkTypeDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkTypeDto>(null as any);
    }

    deleteWorkType(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/work-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkType(_response);
        });
    }

    protected processDeleteWorkType(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    saveWorkTypeTemplate(id: number, command: SaveWorkTypeTemplateCommand): Promise<WorkTypeDetailDto> {
        let url_ = this.baseUrl + "/api/work-types/{id}/template";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveWorkTypeTemplate(_response);
        });
    }

    protected processSaveWorkTypeTemplate(response: Response): Promise<WorkTypeDetailDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkTypeDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkTypeDetailDto>(null as any);
    }
}

export class WorksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWorks(): Promise<WorkDto[]> {
        let url_ = this.baseUrl + "/api/works";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorks(_response);
        });
    }

    protected processGetWorks(response: Response): Promise<WorkDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkDto[]>(null as any);
    }

    createWork(command: CreateWorkCommand): Promise<WorkDto> {
        let url_ = this.baseUrl + "/api/works";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWork(_response);
        });
    }

    protected processCreateWork(response: Response): Promise<WorkDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkDto>(null as any);
    }

    getWorkOptions(term: string | null | undefined, take: number | null | undefined): Promise<WorkOptionDto[]> {
        let url_ = this.baseUrl + "/api/works/options?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkOptions(_response);
        });
    }

    protected processGetWorkOptions(response: Response): Promise<WorkOptionDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkOptionDto[]>(null as any);
    }

    getWorkStatuses(): Promise<WorkStatusDto[]> {
        let url_ = this.baseUrl + "/api/works/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkStatuses(_response);
        });
    }

    protected processGetWorkStatuses(response: Response): Promise<WorkStatusDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkStatusDto[]>(null as any);
    }

    getWorkItemStatuses(): Promise<WorkItemStatusDto[]> {
        let url_ = this.baseUrl + "/api/works/item-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkItemStatuses(_response);
        });
    }

    protected processGetWorkItemStatuses(response: Response): Promise<WorkItemStatusDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkItemStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkItemStatusDto[]>(null as any);
    }

    getFinancialApprovalStatuses(): Promise<FinancialApprovalStatusDto[]> {
        let url_ = this.baseUrl + "/api/works/financial-entries/approval-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFinancialApprovalStatuses(_response);
        });
    }

    protected processGetFinancialApprovalStatuses(response: Response): Promise<FinancialApprovalStatusDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialApprovalStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialApprovalStatusDto[]>(null as any);
    }

    getWorkById(id: number): Promise<WorkDto> {
        let url_ = this.baseUrl + "/api/works/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkById(_response);
        });
    }

    protected processGetWorkById(response: Response): Promise<WorkDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkDto>(null as any);
    }

    updateWork(id: number, command: UpdateWorkCommand): Promise<WorkDto> {
        let url_ = this.baseUrl + "/api/works/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWork(_response);
        });
    }

    protected processUpdateWork(response: Response): Promise<WorkDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkDto>(null as any);
    }

    getWorkCostMap(id: number): Promise<WorkCostMapDto> {
        let url_ = this.baseUrl + "/api/works/{id}/cost-map";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkCostMap(_response);
        });
    }

    protected processGetWorkCostMap(response: Response): Promise<WorkCostMapDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkCostMapDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkCostMapDto>(null as any);
    }

    getWorkPostMortem(id: number): Promise<WorkPostMortemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/post-mortem";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkPostMortem(_response);
        });
    }

    protected processGetWorkPostMortem(response: Response): Promise<WorkPostMortemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkPostMortemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkPostMortemDto>(null as any);
    }

    getWorkFinalMap(id: number): Promise<WorkFinalMapDto> {
        let url_ = this.baseUrl + "/api/works/{id}/final-map";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkFinalMap(_response);
        });
    }

    protected processGetWorkFinalMap(response: Response): Promise<WorkFinalMapDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinalMapDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinalMapDto>(null as any);
    }

    saveWorkClosureNotes(id: number, command: SaveWorkClosureNotesCommand): Promise<WorkPostMortemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/closure-notes";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveWorkClosureNotes(_response);
        });
    }

    protected processSaveWorkClosureNotes(response: Response): Promise<WorkPostMortemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkPostMortemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkPostMortemDto>(null as any);
    }

    closeWork(id: number, command: CloseWorkCommand): Promise<WorkPostMortemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/close";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCloseWork(_response);
        });
    }

    protected processCloseWork(response: Response): Promise<WorkPostMortemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkPostMortemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkPostMortemDto>(null as any);
    }

    getWorkBudgetChapters(id: number): Promise<WorkBudgetChapterDto[]> {
        let url_ = this.baseUrl + "/api/works/{id}/budget-chapters";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkBudgetChapters(_response);
        });
    }

    protected processGetWorkBudgetChapters(response: Response): Promise<WorkBudgetChapterDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkBudgetChapterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkBudgetChapterDto[]>(null as any);
    }

    getWorkOrders(id: number): Promise<WorkOrderItemDto[]> {
        let url_ = this.baseUrl + "/api/works/{id}/orders";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkOrders(_response);
        });
    }

    protected processGetWorkOrders(response: Response): Promise<WorkOrderItemDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkOrderItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkOrderItemDto[]>(null as any);
    }

    updateWorkOrder(id: number, orderId: number, command: UpdateWorkOrderCommand): Promise<WorkOrderItemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/orders/{orderId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkOrder(_response);
        });
    }

    protected processUpdateWorkOrder(response: Response): Promise<WorkOrderItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkOrderItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkOrderItemDto>(null as any);
    }

    addWorkOrderDelivery(id: number, orderId: number, command: AddWorkOrderItemDeliveryCommand): Promise<WorkOrderItemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/orders/{orderId}/deliveries";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddWorkOrderDelivery(_response);
        });
    }

    protected processAddWorkOrderDelivery(response: Response): Promise<WorkOrderItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkOrderItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkOrderItemDto>(null as any);
    }

    deleteWorkOrderDelivery(id: number, orderId: number, deliveryId: number): Promise<WorkOrderItemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/orders/{orderId}/deliveries/{deliveryId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (deliveryId === undefined || deliveryId === null)
            throw new globalThis.Error("The parameter 'deliveryId' must be defined.");
        url_ = url_.replace("{deliveryId}", encodeURIComponent("" + deliveryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkOrderDelivery(_response);
        });
    }

    protected processDeleteWorkOrderDelivery(response: Response): Promise<WorkOrderItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkOrderItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkOrderItemDto>(null as any);
    }

    imputeWorkOrderCost(id: number, orderId: number): Promise<WorkOrderItemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/orders/{orderId}/impute-cost";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImputeWorkOrderCost(_response);
        });
    }

    protected processImputeWorkOrderCost(response: Response): Promise<WorkOrderItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkOrderItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkOrderItemDto>(null as any);
    }

    removeWorkOrderCostImputation(id: number, orderId: number): Promise<WorkOrderItemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/orders/{orderId}/impute-cost";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (orderId === undefined || orderId === null)
            throw new globalThis.Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveWorkOrderCostImputation(_response);
        });
    }

    protected processRemoveWorkOrderCostImputation(response: Response): Promise<WorkOrderItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkOrderItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkOrderItemDto>(null as any);
    }

    getWorkSubcontractors(id: number): Promise<WorkSubcontractorItemDto[]> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractors";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkSubcontractors(_response);
        });
    }

    protected processGetWorkSubcontractors(response: Response): Promise<WorkSubcontractorItemDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkSubcontractorItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkSubcontractorItemDto[]>(null as any);
    }

    createWorkSubcontractor(id: number, command: CreateWorkSubcontractorCommand): Promise<WorkSubcontractorItemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractors";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorkSubcontractor(_response);
        });
    }

    protected processCreateWorkSubcontractor(response: Response): Promise<WorkSubcontractorItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkSubcontractorItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkSubcontractorItemDto>(null as any);
    }

    updateWorkSubcontractor(id: number, itemId: number, command: UpdateWorkSubcontractorCommand): Promise<WorkSubcontractorItemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractors/{itemId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkSubcontractor(_response);
        });
    }

    protected processUpdateWorkSubcontractor(response: Response): Promise<WorkSubcontractorItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkSubcontractorItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkSubcontractorItemDto>(null as any);
    }

    imputeWorkSubcontractorCost(id: number, itemId: number): Promise<WorkSubcontractorItemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractors/{itemId}/impute-cost";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImputeWorkSubcontractorCost(_response);
        });
    }

    protected processImputeWorkSubcontractorCost(response: Response): Promise<WorkSubcontractorItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkSubcontractorItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkSubcontractorItemDto>(null as any);
    }

    removeWorkSubcontractorCostImputation(id: number, itemId: number): Promise<WorkSubcontractorItemDto> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractors/{itemId}/impute-cost";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveWorkSubcontractorCostImputation(_response);
        });
    }

    protected processRemoveWorkSubcontractorCostImputation(response: Response): Promise<WorkSubcontractorItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkSubcontractorItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkSubcontractorItemDto>(null as any);
    }

    exportWorkOrders(id: number, format: string): Promise<void> {
        let url_ = this.baseUrl + "/api/works/{id}/orders/export/{format}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportWorkOrders(_response);
        });
    }

    protected processExportWorkOrders(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportWorkSubcontractors(id: number, format: string): Promise<void> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractors/export/{format}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportWorkSubcontractors(_response);
        });
    }

    protected processExportWorkSubcontractors(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadWorkFinancialDocument(id: number, documentKindHint: WorkFinancialDocumentKind2 | null | undefined, file: FileParameter | null | undefined): Promise<WorkFinancialDocumentDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-documents?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentKindHint !== undefined && documentKindHint !== null)
            url_ += "documentKindHint=" + encodeURIComponent("" + documentKindHint) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadWorkFinancialDocument(_response);
        });
    }

    protected processUploadWorkFinancialDocument(response: Response): Promise<WorkFinancialDocumentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialDocumentDto>(null as any);
    }

    getWorkFinancialDocuments(id: number): Promise<WorkFinancialDocumentDto[]> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-documents";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkFinancialDocuments(_response);
        });
    }

    protected processGetWorkFinancialDocuments(response: Response): Promise<WorkFinancialDocumentDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkFinancialDocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialDocumentDto[]>(null as any);
    }

    getWorkFinancialDashboard(id: number): Promise<WorkFinancialDashboardDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-dashboard";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkFinancialDashboard(_response);
        });
    }

    protected processGetWorkFinancialDashboard(response: Response): Promise<WorkFinancialDashboardDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialDashboardDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialDashboardDto>(null as any);
    }

    downloadWorkFinancialDocument(id: number, documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-documents/{documentId}/file";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadWorkFinancialDocument(_response);
        });
    }

    protected processDownloadWorkFinancialDocument(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    reprocessWorkFinancialDocument(id: number, documentId: number): Promise<WorkFinancialDocumentDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-documents/{documentId}/reprocess";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReprocessWorkFinancialDocument(_response);
        });
    }

    protected processReprocessWorkFinancialDocument(response: Response): Promise<WorkFinancialDocumentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialDocumentDto>(null as any);
    }

    deleteWorkFinancialDocument(id: number, documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-documents/{documentId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkFinancialDocument(_response);
        });
    }

    protected processDeleteWorkFinancialDocument(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateWorkFinancialEntry(id: number, entryId: number, command: UpdateWorkFinancialEntryCommand): Promise<WorkFinancialEntryDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-entries/{entryId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkFinancialEntry(_response);
        });
    }

    protected processUpdateWorkFinancialEntry(response: Response): Promise<WorkFinancialEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialEntryDto>(null as any);
    }

    validateWorkFinancialEntry(id: number, entryId: number): Promise<WorkFinancialEntryDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-entries/{entryId}/validate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateWorkFinancialEntry(_response);
        });
    }

    protected processValidateWorkFinancialEntry(response: Response): Promise<WorkFinancialEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialEntryDto>(null as any);
    }

    unvalidateWorkFinancialEntry(id: number, entryId: number): Promise<WorkFinancialEntryDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-entries/{entryId}/unvalidate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnvalidateWorkFinancialEntry(_response);
        });
    }

    protected processUnvalidateWorkFinancialEntry(response: Response): Promise<WorkFinancialEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialEntryDto>(null as any);
    }

    setWorkFinancialEntryApprovalStatus(id: number, entryId: number, command: SetWorkFinancialEntryApprovalStatusCommand): Promise<WorkFinancialEntryDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-entries/{entryId}/approval-status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetWorkFinancialEntryApprovalStatus(_response);
        });
    }

    protected processSetWorkFinancialEntryApprovalStatus(response: Response): Promise<WorkFinancialEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialEntryDto>(null as any);
    }

    categorizeWorkFinancialEntry(id: number, entryId: number, command: CategorizeWorkFinancialEntryCommand): Promise<WorkFinancialEntryDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-entries/{entryId}/categorize";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategorizeWorkFinancialEntry(_response);
        });
    }

    protected processCategorizeWorkFinancialEntry(response: Response): Promise<WorkFinancialEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialEntryDto>(null as any);
    }

    matchWorkFinancialEntrySupplier(id: number, entryId: number, command: MatchWorkFinancialEntrySupplierCommand): Promise<WorkFinancialEntryDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-entries/{entryId}/match-supplier";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMatchWorkFinancialEntrySupplier(_response);
        });
    }

    protected processMatchWorkFinancialEntrySupplier(response: Response): Promise<WorkFinancialEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialEntryDto>(null as any);
    }

    createSupplierFromWorkFinancialEntry(id: number, entryId: number): Promise<WorkFinancialEntryDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-entries/{entryId}/create-supplier";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSupplierFromWorkFinancialEntry(_response);
        });
    }

    protected processCreateSupplierFromWorkFinancialEntry(response: Response): Promise<WorkFinancialEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialEntryDto>(null as any);
    }

    imputeWorkFinancialEntryCost(id: number, entryId: number): Promise<WorkFinancialEntryDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-entries/{entryId}/impute-cost";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImputeWorkFinancialEntryCost(_response);
        });
    }

    protected processImputeWorkFinancialEntryCost(response: Response): Promise<WorkFinancialEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialEntryDto>(null as any);
    }

    removeWorkFinancialEntryCostImputation(id: number, entryId: number): Promise<WorkFinancialEntryDto> {
        let url_ = this.baseUrl + "/api/works/{id}/financial-entries/{entryId}/impute-cost";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveWorkFinancialEntryCostImputation(_response);
        });
    }

    protected processRemoveWorkFinancialEntryCostImputation(response: Response): Promise<WorkFinancialEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkFinancialEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkFinancialEntryDto>(null as any);
    }

    getMeasurementAutos(id: number): Promise<MeasurementAutoDto[]> {
        let url_ = this.baseUrl + "/api/works/{id}/measurement-autos";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeasurementAutos(_response);
        });
    }

    protected processGetMeasurementAutos(response: Response): Promise<MeasurementAutoDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementAutoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementAutoDto[]>(null as any);
    }

    createMeasurementAuto(id: number, command: CreateMeasurementAutoCommand): Promise<MeasurementAutoDto> {
        let url_ = this.baseUrl + "/api/works/{id}/measurement-autos";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMeasurementAuto(_response);
        });
    }

    protected processCreateMeasurementAuto(response: Response): Promise<MeasurementAutoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasurementAutoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementAutoDto>(null as any);
    }

    getMeasurementAutoById(id: number, autoId: number): Promise<MeasurementAutoDto> {
        let url_ = this.baseUrl + "/api/works/{id}/measurement-autos/{autoId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeasurementAutoById(_response);
        });
    }

    protected processGetMeasurementAutoById(response: Response): Promise<MeasurementAutoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasurementAutoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementAutoDto>(null as any);
    }

    updateMeasurementAuto(id: number, autoId: number, command: UpdateMeasurementAutoCommand): Promise<MeasurementAutoDto> {
        let url_ = this.baseUrl + "/api/works/{id}/measurement-autos/{autoId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMeasurementAuto(_response);
        });
    }

    protected processUpdateMeasurementAuto(response: Response): Promise<MeasurementAutoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasurementAutoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementAutoDto>(null as any);
    }

    deleteMeasurementAuto(id: number, autoId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/works/{id}/measurement-autos/{autoId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMeasurementAuto(_response);
        });
    }

    protected processDeleteMeasurementAuto(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportMeasurementAutoPdf(id: number, autoId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/works/{id}/measurement-autos/{autoId}/export/pdf";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportMeasurementAutoPdf(_response);
        });
    }

    protected processExportMeasurementAutoPdf(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    approveMeasurementAuto(id: number, autoId: number): Promise<MeasurementAutoDto> {
        let url_ = this.baseUrl + "/api/works/{id}/measurement-autos/{autoId}/approve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveMeasurementAuto(_response);
        });
    }

    protected processApproveMeasurementAuto(response: Response): Promise<MeasurementAutoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasurementAutoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementAutoDto>(null as any);
    }

    reopenMeasurementAuto(id: number, autoId: number): Promise<MeasurementAutoDto> {
        let url_ = this.baseUrl + "/api/works/{id}/measurement-autos/{autoId}/reopen";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReopenMeasurementAuto(_response);
        });
    }

    protected processReopenMeasurementAuto(response: Response): Promise<MeasurementAutoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeasurementAutoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementAutoDto>(null as any);
    }

    generateInvoiceFromAuto(id: number, autoId: number): Promise<ClientInvoiceDto> {
        let url_ = this.baseUrl + "/api/works/{id}/measurement-autos/{autoId}/generate-invoice";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateInvoiceFromAuto(_response);
        });
    }

    protected processGenerateInvoiceFromAuto(response: Response): Promise<ClientInvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientInvoiceDto>(null as any);
    }

    getSubcontractorAutos(id: number): Promise<SubcontractorAutoDto[]> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractor-autos";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubcontractorAutos(_response);
        });
    }

    protected processGetSubcontractorAutos(response: Response): Promise<SubcontractorAutoDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubcontractorAutoDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorAutoDto[]>(null as any);
    }

    createSubcontractorAuto(id: number, command: CreateSubcontractorAutoCommand): Promise<SubcontractorAutoDto> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractor-autos";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSubcontractorAuto(_response);
        });
    }

    protected processCreateSubcontractorAuto(response: Response): Promise<SubcontractorAutoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractorAutoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorAutoDto>(null as any);
    }

    getSubcontractorRetentions(id: number): Promise<SubcontractorRetentionsDto> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractor-retentions";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubcontractorRetentions(_response);
        });
    }

    protected processGetSubcontractorRetentions(response: Response): Promise<SubcontractorRetentionsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractorRetentionsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorRetentionsDto>(null as any);
    }

    updateSubcontractorAuto(id: number, autoId: number, command: UpdateSubcontractorAutoCommand): Promise<SubcontractorAutoDto> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractor-autos/{autoId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSubcontractorAuto(_response);
        });
    }

    protected processUpdateSubcontractorAuto(response: Response): Promise<SubcontractorAutoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractorAutoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorAutoDto>(null as any);
    }

    deleteSubcontractorAuto(id: number, autoId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractor-autos/{autoId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSubcontractorAuto(_response);
        });
    }

    protected processDeleteSubcontractorAuto(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    approveSubcontractorAuto(id: number, autoId: number): Promise<SubcontractorAutoDto> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractor-autos/{autoId}/approve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveSubcontractorAuto(_response);
        });
    }

    protected processApproveSubcontractorAuto(response: Response): Promise<SubcontractorAutoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractorAutoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorAutoDto>(null as any);
    }

    reopenSubcontractorAuto(id: number, autoId: number): Promise<SubcontractorAutoDto> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractor-autos/{autoId}/reopen";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReopenSubcontractorAuto(_response);
        });
    }

    protected processReopenSubcontractorAuto(response: Response): Promise<SubcontractorAutoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractorAutoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorAutoDto>(null as any);
    }

    registerSubcontractorInvoice(id: number, autoId: number, command: RegisterSubcontractorInvoiceCommand): Promise<SubcontractorAutoDto> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractor-autos/{autoId}/invoice";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterSubcontractorInvoice(_response);
        });
    }

    protected processRegisterSubcontractorInvoice(response: Response): Promise<SubcontractorAutoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractorAutoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorAutoDto>(null as any);
    }

    registerSubcontractorPayment(id: number, autoId: number, command: RegisterSubcontractorPaymentCommand): Promise<SubcontractorAutoDto> {
        let url_ = this.baseUrl + "/api/works/{id}/subcontractor-autos/{autoId}/payment";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (autoId === undefined || autoId === null)
            throw new globalThis.Error("The parameter 'autoId' must be defined.");
        url_ = url_.replace("{autoId}", encodeURIComponent("" + autoId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterSubcontractorPayment(_response);
        });
    }

    protected processRegisterSubcontractorPayment(response: Response): Promise<SubcontractorAutoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractorAutoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorAutoDto>(null as any);
    }

    getWorkVariations(id: number): Promise<WorkVariationsVm> {
        let url_ = this.baseUrl + "/api/works/{id}/variations";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkVariations(_response);
        });
    }

    protected processGetWorkVariations(response: Response): Promise<WorkVariationsVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkVariationsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkVariationsVm>(null as any);
    }

    createWorkVariation(id: number, command: CreateWorkVariationCommand): Promise<WorkVariationDto> {
        let url_ = this.baseUrl + "/api/works/{id}/variations";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorkVariation(_response);
        });
    }

    protected processCreateWorkVariation(response: Response): Promise<WorkVariationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkVariationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkVariationDto>(null as any);
    }

    getWorkVariationMap(id: number): Promise<WorkVariationMapDto> {
        let url_ = this.baseUrl + "/api/works/{id}/variation-map";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkVariationMap(_response);
        });
    }

    protected processGetWorkVariationMap(response: Response): Promise<WorkVariationMapDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkVariationMapDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkVariationMapDto>(null as any);
    }

    updateWorkVariation(id: number, variationId: number, command: UpdateWorkVariationCommand): Promise<WorkVariationDto> {
        let url_ = this.baseUrl + "/api/works/{id}/variations/{variationId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (variationId === undefined || variationId === null)
            throw new globalThis.Error("The parameter 'variationId' must be defined.");
        url_ = url_.replace("{variationId}", encodeURIComponent("" + variationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkVariation(_response);
        });
    }

    protected processUpdateWorkVariation(response: Response): Promise<WorkVariationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkVariationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkVariationDto>(null as any);
    }

    deleteWorkVariation(id: number, variationId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/works/{id}/variations/{variationId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (variationId === undefined || variationId === null)
            throw new globalThis.Error("The parameter 'variationId' must be defined.");
        url_ = url_.replace("{variationId}", encodeURIComponent("" + variationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkVariation(_response);
        });
    }

    protected processDeleteWorkVariation(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    approveWorkVariation(id: number, variationId: number): Promise<WorkVariationDto> {
        let url_ = this.baseUrl + "/api/works/{id}/variations/{variationId}/approve";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (variationId === undefined || variationId === null)
            throw new globalThis.Error("The parameter 'variationId' must be defined.");
        url_ = url_.replace("{variationId}", encodeURIComponent("" + variationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveWorkVariation(_response);
        });
    }

    protected processApproveWorkVariation(response: Response): Promise<WorkVariationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkVariationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkVariationDto>(null as any);
    }

    rejectWorkVariation(id: number, variationId: number, command: RejectWorkVariationCommand): Promise<WorkVariationDto> {
        let url_ = this.baseUrl + "/api/works/{id}/variations/{variationId}/reject";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (variationId === undefined || variationId === null)
            throw new globalThis.Error("The parameter 'variationId' must be defined.");
        url_ = url_.replace("{variationId}", encodeURIComponent("" + variationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRejectWorkVariation(_response);
        });
    }

    protected processRejectWorkVariation(response: Response): Promise<WorkVariationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkVariationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkVariationDto>(null as any);
    }

    reopenWorkVariation(id: number, variationId: number): Promise<WorkVariationDto> {
        let url_ = this.baseUrl + "/api/works/{id}/variations/{variationId}/reopen";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (variationId === undefined || variationId === null)
            throw new globalThis.Error("The parameter 'variationId' must be defined.");
        url_ = url_.replace("{variationId}", encodeURIComponent("" + variationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReopenWorkVariation(_response);
        });
    }

    protected processReopenWorkVariation(response: Response): Promise<WorkVariationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkVariationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkVariationDto>(null as any);
    }

    getWorkAfterSalesInterventions(id: number): Promise<WorkAfterSalesInterventionsVm> {
        let url_ = this.baseUrl + "/api/works/{id}/after-sales";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkAfterSalesInterventions(_response);
        });
    }

    protected processGetWorkAfterSalesInterventions(response: Response): Promise<WorkAfterSalesInterventionsVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkAfterSalesInterventionsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkAfterSalesInterventionsVm>(null as any);
    }

    createWorkAfterSalesIntervention(id: number, command: CreateWorkAfterSalesInterventionCommand): Promise<WorkAfterSalesInterventionDto> {
        let url_ = this.baseUrl + "/api/works/{id}/after-sales";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorkAfterSalesIntervention(_response);
        });
    }

    protected processCreateWorkAfterSalesIntervention(response: Response): Promise<WorkAfterSalesInterventionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkAfterSalesInterventionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkAfterSalesInterventionDto>(null as any);
    }

    updateWorkAfterSalesIntervention(id: number, interventionId: number, command: UpdateWorkAfterSalesInterventionCommand): Promise<WorkAfterSalesInterventionDto> {
        let url_ = this.baseUrl + "/api/works/{id}/after-sales/{interventionId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (interventionId === undefined || interventionId === null)
            throw new globalThis.Error("The parameter 'interventionId' must be defined.");
        url_ = url_.replace("{interventionId}", encodeURIComponent("" + interventionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkAfterSalesIntervention(_response);
        });
    }

    protected processUpdateWorkAfterSalesIntervention(response: Response): Promise<WorkAfterSalesInterventionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkAfterSalesInterventionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkAfterSalesInterventionDto>(null as any);
    }

    deleteWorkAfterSalesIntervention(id: number, interventionId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/works/{id}/after-sales/{interventionId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (interventionId === undefined || interventionId === null)
            throw new globalThis.Error("The parameter 'interventionId' must be defined.");
        url_ = url_.replace("{interventionId}", encodeURIComponent("" + interventionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkAfterSalesIntervention(_response);
        });
    }

    protected processDeleteWorkAfterSalesIntervention(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WorkphotosClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkPhotos(workId: number, from: Date | null | undefined, to: Date | null | undefined, author: string | null | undefined): Promise<WorkPhotosVm> {
        let url_ = this.baseUrl + "/api/workphotos?";
        if (workId === undefined || workId === null)
            throw new globalThis.Error("The parameter 'workId' must be defined and cannot be null.");
        else
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (author !== undefined && author !== null)
            url_ += "author=" + encodeURIComponent("" + author) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkPhotos(_response);
        });
    }

    protected processGetWorkPhotos(response: Response): Promise<WorkPhotosVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkPhotosVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkPhotosVm>(null as any);
    }

    uploadWorkPhoto(workId: number, note: string | null | undefined, file: FileParameter | null | undefined): Promise<WorkPhotoDto> {
        let url_ = this.baseUrl + "/api/workphotos?";
        if (workId === undefined || workId === null)
            throw new globalThis.Error("The parameter 'workId' must be defined and cannot be null.");
        else
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        if (note !== undefined && note !== null)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadWorkPhoto(_response);
        });
    }

    protected processUploadWorkPhoto(response: Response): Promise<WorkPhotoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkPhotoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkPhotoDto>(null as any);
    }

    updateWorkPhotoNote(id: number, command: UpdateWorkPhotoNoteCommand): Promise<WorkPhotoDto> {
        let url_ = this.baseUrl + "/api/workphotos/{id}/note";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkPhotoNote(_response);
        });
    }

    protected processUpdateWorkPhotoNote(response: Response): Promise<WorkPhotoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkPhotoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkPhotoDto>(null as any);
    }

    deleteWorkPhoto(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/workphotos/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkPhoto(_response);
        });
    }

    protected processDeleteWorkPhoto(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getWorkPhotoFile(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/workphotos/{id}/file";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkPhotoFile(_response);
        });
    }

    protected processGetWorkPhotoFile(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WorkMaterialConsumptionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkMaterialConsumptions(workId: number): Promise<WorkMaterialConsumptionDto[]> {
        let url_ = this.baseUrl + "/api/work-material-consumptions?";
        if (workId === undefined || workId === null)
            throw new globalThis.Error("The parameter 'workId' must be defined and cannot be null.");
        else
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkMaterialConsumptions(_response);
        });
    }

    protected processGetWorkMaterialConsumptions(response: Response): Promise<WorkMaterialConsumptionDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkMaterialConsumptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkMaterialConsumptionDto[]>(null as any);
    }

    createWorkMaterialConsumption(command: CreateWorkMaterialConsumptionCommand): Promise<WorkMaterialConsumptionDto> {
        let url_ = this.baseUrl + "/api/work-material-consumptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorkMaterialConsumption(_response);
        });
    }

    protected processCreateWorkMaterialConsumption(response: Response): Promise<WorkMaterialConsumptionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkMaterialConsumptionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkMaterialConsumptionDto>(null as any);
    }

    updateWorkMaterialConsumption(id: number, command: UpdateWorkMaterialConsumptionCommand): Promise<WorkMaterialConsumptionDto> {
        let url_ = this.baseUrl + "/api/work-material-consumptions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkMaterialConsumption(_response);
        });
    }

    protected processUpdateWorkMaterialConsumption(response: Response): Promise<WorkMaterialConsumptionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkMaterialConsumptionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkMaterialConsumptionDto>(null as any);
    }

    deleteWorkMaterialConsumption(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/work-material-consumptions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkMaterialConsumption(_response);
        });
    }

    protected processDeleteWorkMaterialConsumption(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class WorkLaborEntriesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkLaborEntries(workId: number): Promise<WorkLaborEntryDto[]> {
        let url_ = this.baseUrl + "/api/work-labor-entries?";
        if (workId === undefined || workId === null)
            throw new globalThis.Error("The parameter 'workId' must be defined and cannot be null.");
        else
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkLaborEntries(_response);
        });
    }

    protected processGetWorkLaborEntries(response: Response): Promise<WorkLaborEntryDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkLaborEntryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkLaborEntryDto[]>(null as any);
    }

    createWorkLaborEntry(command: CreateWorkLaborEntryCommand): Promise<WorkLaborEntryDto> {
        let url_ = this.baseUrl + "/api/work-labor-entries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorkLaborEntry(_response);
        });
    }

    protected processCreateWorkLaborEntry(response: Response): Promise<WorkLaborEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkLaborEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkLaborEntryDto>(null as any);
    }

    getTimesheetWorkers(): Promise<WorkerDto[]> {
        let url_ = this.baseUrl + "/api/work-labor-entries/workers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTimesheetWorkers(_response);
        });
    }

    protected processGetTimesheetWorkers(response: Response): Promise<WorkerDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDto[]>(null as any);
    }

    getMyTimesheet(workerId: number | null | undefined, from: Date | null | undefined, to: Date | null | undefined): Promise<WorkLaborEntryDto[]> {
        let url_ = this.baseUrl + "/api/work-labor-entries/mine?";
        if (workerId !== undefined && workerId !== null)
            url_ += "workerId=" + encodeURIComponent("" + workerId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyTimesheet(_response);
        });
    }

    protected processGetMyTimesheet(response: Response): Promise<WorkLaborEntryDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkLaborEntryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkLaborEntryDto[]>(null as any);
    }

    createMyWorkLaborEntry(command: CreateMyWorkLaborEntryCommand): Promise<WorkLaborEntryDto> {
        let url_ = this.baseUrl + "/api/work-labor-entries/mine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMyWorkLaborEntry(_response);
        });
    }

    protected processCreateMyWorkLaborEntry(response: Response): Promise<WorkLaborEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkLaborEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkLaborEntryDto>(null as any);
    }

    updateWorkLaborEntry(id: number, command: UpdateWorkLaborEntryCommand): Promise<WorkLaborEntryDto> {
        let url_ = this.baseUrl + "/api/work-labor-entries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkLaborEntry(_response);
        });
    }

    protected processUpdateWorkLaborEntry(response: Response): Promise<WorkLaborEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkLaborEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkLaborEntryDto>(null as any);
    }

    deleteWorkLaborEntry(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/work-labor-entries/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkLaborEntry(_response);
        });
    }

    protected processDeleteWorkLaborEntry(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    validateWorkLaborEntry(id: number, command: ValidateWorkLaborEntryCommand): Promise<WorkLaborEntryDto> {
        let url_ = this.baseUrl + "/api/work-labor-entries/{id}/validate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateWorkLaborEntry(_response);
        });
    }

    protected processValidateWorkLaborEntry(response: Response): Promise<WorkLaborEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkLaborEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkLaborEntryDto>(null as any);
    }

    deleteMyWorkLaborEntry(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/work-labor-entries/mine/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMyWorkLaborEntry(_response);
        });
    }

    protected processDeleteMyWorkLaborEntry(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class WorkersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkers(): Promise<WorkerDto[]> {
        let url_ = this.baseUrl + "/api/workers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkers(_response);
        });
    }

    protected processGetWorkers(response: Response): Promise<WorkerDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDto[]>(null as any);
    }

    createWorker(command: CreateWorkerCommand): Promise<WorkerDto> {
        let url_ = this.baseUrl + "/api/workers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorker(_response);
        });
    }

    protected processCreateWorker(response: Response): Promise<WorkerDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDto>(null as any);
    }

    getMyWorker(): Promise<WorkerDto> {
        let url_ = this.baseUrl + "/api/workers/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyWorker(_response);
        });
    }

    protected processGetMyWorker(response: Response): Promise<WorkerDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDto>(null as any);
    }

    getWorkerOptions(term: string | null | undefined, take: number | null | undefined, includeInactive: boolean | null | undefined): Promise<LookupOptionDto[]> {
        let url_ = this.baseUrl + "/api/workers/options?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (includeInactive !== undefined && includeInactive !== null)
            url_ += "includeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerOptions(_response);
        });
    }

    protected processGetWorkerOptions(response: Response): Promise<LookupOptionDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupOptionDto[]>(null as any);
    }

    getWorkerById(id: number): Promise<WorkerDto> {
        let url_ = this.baseUrl + "/api/workers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkerById(_response);
        });
    }

    protected processGetWorkerById(response: Response): Promise<WorkerDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDto>(null as any);
    }

    updateWorker(id: number, command: UpdateWorkerCommand): Promise<WorkerDto> {
        let url_ = this.baseUrl + "/api/workers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorker(_response);
        });
    }

    protected processUpdateWorker(response: Response): Promise<WorkerDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkerDto>(null as any);
    }
}

export class WorkdiaryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkDiaryEntries(workId: number): Promise<WorkDiaryEntriesVm> {
        let url_ = this.baseUrl + "/api/workdiary?";
        if (workId === undefined || workId === null)
            throw new globalThis.Error("The parameter 'workId' must be defined and cannot be null.");
        else
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkDiaryEntries(_response);
        });
    }

    protected processGetWorkDiaryEntries(response: Response): Promise<WorkDiaryEntriesVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkDiaryEntriesVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkDiaryEntriesVm>(null as any);
    }

    createWorkDiaryEntry(command: CreateWorkDiaryEntryCommand): Promise<WorkDiaryEntryDto> {
        let url_ = this.baseUrl + "/api/workdiary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorkDiaryEntry(_response);
        });
    }

    protected processCreateWorkDiaryEntry(response: Response): Promise<WorkDiaryEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkDiaryEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkDiaryEntryDto>(null as any);
    }

    updateWorkDiaryEntry(id: number, command: UpdateWorkDiaryEntryCommand): Promise<WorkDiaryEntryDto> {
        let url_ = this.baseUrl + "/api/workdiary/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkDiaryEntry(_response);
        });
    }

    protected processUpdateWorkDiaryEntry(response: Response): Promise<WorkDiaryEntryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkDiaryEntryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkDiaryEntryDto>(null as any);
    }

    deleteWorkDiaryEntry(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/workdiary/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkDiaryEntry(_response);
        });
    }

    protected processDeleteWorkDiaryEntry(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadWorkDiaryAttachment(attachment: FileParameter | null | undefined): Promise<WorkDiaryAttachmentUploadDto> {
        let url_ = this.baseUrl + "/api/workdiary/attachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (attachment !== null && attachment !== undefined)
            content_.append("attachment", attachment.data, attachment.fileName ? attachment.fileName : "attachment");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadWorkDiaryAttachment(_response);
        });
    }

    protected processUploadWorkDiaryAttachment(response: Response): Promise<WorkDiaryAttachmentUploadDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkDiaryAttachmentUploadDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkDiaryAttachmentUploadDto>(null as any);
    }

    downloadWorkDiaryAttachment(entryId: number, attachmentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/workdiary/{entryId}/attachments/{attachmentId}/download";
        if (entryId === undefined || entryId === null)
            throw new globalThis.Error("The parameter 'entryId' must be defined.");
        url_ = url_.replace("{entryId}", encodeURIComponent("" + entryId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadWorkDiaryAttachment(_response);
        });
    }

    protected processDownloadWorkDiaryAttachment(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WorkcostsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWorkCosts(workId: number | null | undefined): Promise<WorkCostDto[]> {
        let url_ = this.baseUrl + "/api/workcosts?";
        if (workId !== undefined && workId !== null)
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkCosts(_response);
        });
    }

    protected processGetWorkCosts(response: Response): Promise<WorkCostDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkCostDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkCostDto[]>(null as any);
    }

    createWorkCost(command: CreateWorkCostCommand): Promise<WorkCostDto> {
        let url_ = this.baseUrl + "/api/workcosts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorkCost(_response);
        });
    }

    protected processCreateWorkCost(response: Response): Promise<WorkCostDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkCostDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkCostDto>(null as any);
    }

    getWorkCostTypes(): Promise<WorkCostTypeDto[]> {
        let url_ = this.baseUrl + "/api/workcosts/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkCostTypes(_response);
        });
    }

    protected processGetWorkCostTypes(response: Response): Promise<WorkCostTypeDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkCostTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkCostTypeDto[]>(null as any);
    }

    getWorkCostById(id: number): Promise<WorkCostDto> {
        let url_ = this.baseUrl + "/api/workcosts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkCostById(_response);
        });
    }

    protected processGetWorkCostById(response: Response): Promise<WorkCostDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkCostDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkCostDto>(null as any);
    }

    updateWorkCost(id: number, command: UpdateWorkCostCommand): Promise<WorkCostDto> {
        let url_ = this.baseUrl + "/api/workcosts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWorkCost(_response);
        });
    }

    protected processUpdateWorkCost(response: Response): Promise<WorkCostDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkCostDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkCostDto>(null as any);
    }

    deleteWorkCost(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/workcosts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteWorkCost(_response);
        });
    }

    protected processDeleteWorkCost(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    allocateIndirectCost(command: AllocateIndirectCostCommand): Promise<IndirectAllocationResultDto> {
        let url_ = this.baseUrl + "/api/workcosts/indirect-allocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAllocateIndirectCost(_response);
        });
    }

    protected processAllocateIndirectCost(response: Response): Promise<IndirectAllocationResultDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndirectAllocationResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndirectAllocationResultDto>(null as any);
    }
}

export class WarehousesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWarehouses(): Promise<WarehouseDto[]> {
        let url_ = this.baseUrl + "/api/warehouses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWarehouses(_response);
        });
    }

    protected processGetWarehouses(response: Response): Promise<WarehouseDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WarehouseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDto[]>(null as any);
    }

    createWarehouse(command: CreateWarehouseCommand): Promise<WarehouseDto> {
        let url_ = this.baseUrl + "/api/warehouses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWarehouse(_response);
        });
    }

    protected processCreateWarehouse(response: Response): Promise<WarehouseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDto>(null as any);
    }

    getWarehouseById(id: number): Promise<WarehouseDto> {
        let url_ = this.baseUrl + "/api/warehouses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWarehouseById(_response);
        });
    }

    protected processGetWarehouseById(response: Response): Promise<WarehouseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDto>(null as any);
    }

    updateWarehouse(id: number, command: UpdateWarehouseCommand): Promise<WarehouseDto> {
        let url_ = this.baseUrl + "/api/warehouses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateWarehouse(_response);
        });
    }

    protected processUpdateWarehouse(response: Response): Promise<WarehouseDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarehouseDto>(null as any);
    }
}

export class UsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createUser(command: CreateUserCommand): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<UserProfileDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    getUsers(): Promise<UserAdminDto[]> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<UserAdminDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAdminDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAdminDto[]>(null as any);
    }

    getUserById(userId: string): Promise<UserAdminDto> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: Response): Promise<UserAdminDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAdminDto>(null as any);
    }

    updateUser(userId: string, command: UpdateUserCommand): Promise<UserAdminDto> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<UserAdminDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAdminDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAdminDto>(null as any);
    }

    me(): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/api/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: Response): Promise<UserProfileDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    updateMe(command: UpdateMyProfileCommand): Promise<UserProfileDto> {
        let url_ = this.baseUrl + "/api/users/me";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMe(_response);
        });
    }

    protected processUpdateMe(response: Response): Promise<UserProfileDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfileDto>(null as any);
    }

    updatePreferences(command: UpdateMyPreferencesCommand): Promise<UserPreferencesDto> {
        let url_ = this.baseUrl + "/api/users/me/preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePreferences(_response);
        });
    }

    protected processUpdatePreferences(response: Response): Promise<UserPreferencesDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPreferencesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserPreferencesDto>(null as any);
    }

    uploadAvatar(avatar: FileParameter | null | undefined): Promise<UserAvatarDto> {
        let url_ = this.baseUrl + "/api/users/me/avatar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (avatar !== null && avatar !== undefined)
            content_.append("avatar", avatar.data, avatar.fileName ? avatar.fileName : "avatar");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadAvatar(_response);
        });
    }

    protected processUploadAvatar(response: Response): Promise<UserAvatarDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAvatarDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAvatarDto>(null as any);
    }

    removeAvatar(): Promise<UserAvatarDto> {
        let url_ = this.baseUrl + "/api/users/me/avatar";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveAvatar(_response);
        });
    }

    protected processRemoveAvatar(response: Response): Promise<UserAvatarDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserAvatarDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAvatarDto>(null as any);
    }
}

export class TreasuryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCashflowCalendar(days: number | null | undefined): Promise<CashflowCalendarDto> {
        let url_ = this.baseUrl + "/api/treasury/cashflow-calendar?";
        if (days !== undefined && days !== null)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCashflowCalendar(_response);
        });
    }

    protected processGetCashflowCalendar(response: Response): Promise<CashflowCalendarDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CashflowCalendarDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CashflowCalendarDto>(null as any);
    }

    getTreasuryForecast(asOf: Date | null | undefined): Promise<TreasuryForecastDto> {
        let url_ = this.baseUrl + "/api/treasury/forecast?";
        if (asOf !== undefined && asOf !== null)
            url_ += "asOf=" + encodeURIComponent(asOf ? "" + asOf.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreasuryForecast(_response);
        });
    }

    protected processGetTreasuryForecast(response: Response): Promise<TreasuryForecastDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreasuryForecastDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreasuryForecastDto>(null as any);
    }
}

export class TenantsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTenants(): Promise<TenantDto[]> {
        let url_ = this.baseUrl + "/api/tenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenants(_response);
        });
    }

    protected processGetTenants(response: Response): Promise<TenantDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TenantDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDto[]>(null as any);
    }

    createTenant(command: CreateTenantCommand): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/tenants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTenant(_response);
        });
    }

    protected processCreateTenant(response: Response): Promise<TenantDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDto>(null as any);
    }

    getTenantById(id: number): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/tenants/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantById(_response);
        });
    }

    protected processGetTenantById(response: Response): Promise<TenantDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDto>(null as any);
    }

    updateTenant(id: number, command: UpdateTenantCommand): Promise<TenantDto> {
        let url_ = this.baseUrl + "/api/tenants/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTenant(_response);
        });
    }

    protected processUpdateTenant(response: Response): Promise<TenantDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDto>(null as any);
    }
}

export class TechnicalDocumentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    uploadTechnicalDocument(budgetId: number, category: string | null | undefined, descriptionMode: string | null | undefined, temperature: number | null | undefined, document: FileParameter | null | undefined): Promise<BudgetDocumentDto> {
        let url_ = this.baseUrl + "/api/technical-documents/budgets/{budgetId}/upload?";
        if (budgetId === undefined || budgetId === null)
            throw new globalThis.Error("The parameter 'budgetId' must be defined.");
        url_ = url_.replace("{budgetId}", encodeURIComponent("" + budgetId));
        if (category !== undefined && category !== null)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (descriptionMode !== undefined && descriptionMode !== null)
            url_ += "descriptionMode=" + encodeURIComponent("" + descriptionMode) + "&";
        if (temperature !== undefined && temperature !== null)
            url_ += "temperature=" + encodeURIComponent("" + temperature) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (document !== null && document !== undefined)
            content_.append("document", document.data, document.fileName ? document.fileName : "document");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadTechnicalDocument(_response);
        });
    }

    protected processUploadTechnicalDocument(response: Response): Promise<BudgetDocumentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDocumentDto>(null as any);
    }

    getAnalysis(budgetId: number, documentId: number): Promise<TechnicalDocumentAnalysisDto> {
        let url_ = this.baseUrl + "/api/technical-documents/budgets/{budgetId}/documents/{documentId}/analysis";
        if (budgetId === undefined || budgetId === null)
            throw new globalThis.Error("The parameter 'budgetId' must be defined.");
        url_ = url_.replace("{budgetId}", encodeURIComponent("" + budgetId));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnalysis(_response);
        });
    }

    protected processGetAnalysis(response: Response): Promise<TechnicalDocumentAnalysisDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TechnicalDocumentAnalysisDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TechnicalDocumentAnalysisDto>(null as any);
    }

    approveBoqLine(lineId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/technical-documents/boq-lines/{lineId}/approve";
        if (lineId === undefined || lineId === null)
            throw new globalThis.Error("The parameter 'lineId' must be defined.");
        url_ = url_.replace("{lineId}", encodeURIComponent("" + lineId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveBoqLine(_response);
        });
    }

    protected processApproveBoqLine(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    approveAllConfidentLines(analysisId: number): Promise<ApproveAllConfidentResult> {
        let url_ = this.baseUrl + "/api/technical-documents/analyses/{analysisId}/approve-confident";
        if (analysisId === undefined || analysisId === null)
            throw new globalThis.Error("The parameter 'analysisId' must be defined.");
        url_ = url_.replace("{analysisId}", encodeURIComponent("" + analysisId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveAllConfidentLines(_response);
        });
    }

    protected processApproveAllConfidentLines(response: Response): Promise<ApproveAllConfidentResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApproveAllConfidentResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApproveAllConfidentResult>(null as any);
    }

    updateBoqLine(lineId: number, command: UpdatePreliminaryBoqLineCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/technical-documents/boq-lines/{lineId}";
        if (lineId === undefined || lineId === null)
            throw new globalThis.Error("The parameter 'lineId' must be defined.");
        url_ = url_.replace("{lineId}", encodeURIComponent("" + lineId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBoqLine(_response);
        });
    }

    protected processUpdateBoqLine(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    importBoqLineEndpoint(lineId: number, body: ImportBoqLineRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/technical-documents/boq-lines/{lineId}/import";
        if (lineId === undefined || lineId === null)
            throw new globalThis.Error("The parameter 'lineId' must be defined.");
        url_ = url_.replace("{lineId}", encodeURIComponent("" + lineId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportBoqLineEndpoint(_response);
        });
    }

    protected processImportBoqLineEndpoint(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    importAllConfidentLinesEndpoint(analysisId: number, body: ImportAllConfidentRequest): Promise<ImportAllConfidentResult> {
        let url_ = this.baseUrl + "/api/technical-documents/analyses/{analysisId}/import-confident";
        if (analysisId === undefined || analysisId === null)
            throw new globalThis.Error("The parameter 'analysisId' must be defined.");
        url_ = url_.replace("{analysisId}", encodeURIComponent("" + analysisId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportAllConfidentLinesEndpoint(_response);
        });
    }

    protected processImportAllConfidentLinesEndpoint(response: Response): Promise<ImportAllConfidentResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportAllConfidentResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportAllConfidentResult>(null as any);
    }

    importAllConfidentLinesByBudgetEndpoint(budgetId: number): Promise<ImportAllConfidentByBudgetResponse> {
        let url_ = this.baseUrl + "/api/technical-documents/budgets/{budgetId}/import-all-confident";
        if (budgetId === undefined || budgetId === null)
            throw new globalThis.Error("The parameter 'budgetId' must be defined.");
        url_ = url_.replace("{budgetId}", encodeURIComponent("" + budgetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportAllConfidentLinesByBudgetEndpoint(_response);
        });
    }

    protected processImportAllConfidentLinesByBudgetEndpoint(response: Response): Promise<ImportAllConfidentByBudgetResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportAllConfidentByBudgetResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportAllConfidentByBudgetResponse>(null as any);
    }
}

export class TaxObligationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTaxObligations(): Promise<TaxObligationDto[]> {
        let url_ = this.baseUrl + "/api/tax-obligations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaxObligations(_response);
        });
    }

    protected processGetTaxObligations(response: Response): Promise<TaxObligationDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxObligationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxObligationDto[]>(null as any);
    }

    createTaxObligation(command: CreateTaxObligationCommand): Promise<TaxObligationDto> {
        let url_ = this.baseUrl + "/api/tax-obligations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTaxObligation(_response);
        });
    }

    protected processCreateTaxObligation(response: Response): Promise<TaxObligationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxObligationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxObligationDto>(null as any);
    }

    getIvaProvisionSuggestion(year: number, granularity: string | null | undefined, period: number | null | undefined): Promise<IvaProvisionSuggestionDto> {
        let url_ = this.baseUrl + "/api/tax-obligations/iva-suggestion?";
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (granularity !== undefined && granularity !== null)
            url_ += "granularity=" + encodeURIComponent("" + granularity) + "&";
        if (period !== undefined && period !== null)
            url_ += "period=" + encodeURIComponent("" + period) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIvaProvisionSuggestion(_response);
        });
    }

    protected processGetIvaProvisionSuggestion(response: Response): Promise<IvaProvisionSuggestionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IvaProvisionSuggestionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IvaProvisionSuggestionDto>(null as any);
    }

    updateTaxObligation(id: number, command: UpdateTaxObligationCommand): Promise<TaxObligationDto> {
        let url_ = this.baseUrl + "/api/tax-obligations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTaxObligation(_response);
        });
    }

    protected processUpdateTaxObligation(response: Response): Promise<TaxObligationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxObligationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxObligationDto>(null as any);
    }

    deleteTaxObligation(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/tax-obligations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTaxObligation(_response);
        });
    }

    protected processDeleteTaxObligation(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    markTaxObligationPaid(id: number, command: MarkTaxObligationPaidCommand): Promise<TaxObligationDto> {
        let url_ = this.baseUrl + "/api/tax-obligations/{id}/mark-paid";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkTaxObligationPaid(_response);
        });
    }

    protected processMarkTaxObligationPaid(response: Response): Promise<TaxObligationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxObligationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxObligationDto>(null as any);
    }
}

export class TasksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTaskItems(scope: string | null | undefined, search: string | null | undefined): Promise<TaskItemDto[]> {
        let url_ = this.baseUrl + "/api/tasks?";
        if (scope !== undefined && scope !== null)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskItems(_response);
        });
    }

    protected processGetTaskItems(response: Response): Promise<TaskItemDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskItemDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemDto[]>(null as any);
    }

    createTaskItem(command: CreateTaskItemCommand): Promise<TaskItemDto> {
        let url_ = this.baseUrl + "/api/tasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTaskItem(_response);
        });
    }

    protected processCreateTaskItem(response: Response): Promise<TaskItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemDto>(null as any);
    }

    getTaskAssignees(): Promise<TaskAssigneeDto[]> {
        let url_ = this.baseUrl + "/api/tasks/assignees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskAssignees(_response);
        });
    }

    protected processGetTaskAssignees(response: Response): Promise<TaskAssigneeDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskAssigneeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskAssigneeDto[]>(null as any);
    }

    getTaskSummary(today: string | null | undefined): Promise<TaskSummaryVm> {
        let url_ = this.baseUrl + "/api/tasks/summary?";
        if (today !== undefined && today !== null)
            url_ += "today=" + encodeURIComponent("" + today) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskSummary(_response);
        });
    }

    protected processGetTaskSummary(response: Response): Promise<TaskSummaryVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskSummaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskSummaryVm>(null as any);
    }

    getTaskCalendar(month: string | null | undefined): Promise<TaskCalendarVm> {
        let url_ = this.baseUrl + "/api/tasks/calendar?";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskCalendar(_response);
        });
    }

    protected processGetTaskCalendar(response: Response): Promise<TaskCalendarVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskCalendarVm.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskCalendarVm>(null as any);
    }

    createRecurringTask(command: SaveRecurringTaskCommand): Promise<RecurringTaskDto> {
        let url_ = this.baseUrl + "/api/tasks/recurring";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateRecurringTask(_response);
        });
    }

    protected processCreateRecurringTask(response: Response): Promise<RecurringTaskDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecurringTaskDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecurringTaskDto>(null as any);
    }

    updateRecurringTask(id: number, command: SaveRecurringTaskCommand): Promise<RecurringTaskDto> {
        let url_ = this.baseUrl + "/api/tasks/recurring/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRecurringTask(_response);
        });
    }

    protected processUpdateRecurringTask(response: Response): Promise<RecurringTaskDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecurringTaskDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecurringTaskDto>(null as any);
    }

    deleteRecurringTask(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/tasks/recurring/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteRecurringTask(_response);
        });
    }

    protected processDeleteRecurringTask(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateTaskItem(id: number, command: UpdateTaskItemCommand): Promise<TaskItemDto> {
        let url_ = this.baseUrl + "/api/tasks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTaskItem(_response);
        });
    }

    protected processUpdateTaskItem(response: Response): Promise<TaskItemDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskItemDto>(null as any);
    }

    deleteTaskItem(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/tasks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTaskItem(_response);
        });
    }

    protected processDeleteTaskItem(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SuppliersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSuppliers(): Promise<SupplierDto[]> {
        let url_ = this.baseUrl + "/api/suppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSuppliers(_response);
        });
    }

    protected processGetSuppliers(response: Response): Promise<SupplierDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierDto[]>(null as any);
    }

    createSupplier(command: CreateSupplierCommand): Promise<SupplierDto> {
        let url_ = this.baseUrl + "/api/suppliers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSupplier(_response);
        });
    }

    protected processCreateSupplier(response: Response): Promise<SupplierDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierDto>(null as any);
    }

    getDuplicateSuppliers(): Promise<DuplicateSupplierGroupDto[]> {
        let url_ = this.baseUrl + "/api/suppliers/duplicates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDuplicateSuppliers(_response);
        });
    }

    protected processGetDuplicateSuppliers(response: Response): Promise<DuplicateSupplierGroupDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DuplicateSupplierGroupDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DuplicateSupplierGroupDto[]>(null as any);
    }

    getSupplierOptions(term: string | null | undefined, take: number | null | undefined): Promise<LookupOptionDto[]> {
        let url_ = this.baseUrl + "/api/suppliers/options?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSupplierOptions(_response);
        });
    }

    protected processGetSupplierOptions(response: Response): Promise<LookupOptionDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupOptionDto[]>(null as any);
    }

    getSupplierById(id: number): Promise<SupplierDto> {
        let url_ = this.baseUrl + "/api/suppliers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSupplierById(_response);
        });
    }

    protected processGetSupplierById(response: Response): Promise<SupplierDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierDto>(null as any);
    }

    updateSupplier(id: number, command: UpdateSupplierCommand): Promise<SupplierDto> {
        let url_ = this.baseUrl + "/api/suppliers/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSupplier(_response);
        });
    }

    protected processUpdateSupplier(response: Response): Promise<SupplierDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierDto>(null as any);
    }

    mergeSuppliers(survivorId: number, command: MergeSuppliersCommand): Promise<SupplierDto> {
        let url_ = this.baseUrl + "/api/suppliers/{survivorId}/merge";
        if (survivorId === undefined || survivorId === null)
            throw new globalThis.Error("The parameter 'survivorId' must be defined.");
        url_ = url_.replace("{survivorId}", encodeURIComponent("" + survivorId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMergeSuppliers(_response);
        });
    }

    protected processMergeSuppliers(response: Response): Promise<SupplierDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierDto>(null as any);
    }

    uploadSupplierLogo(id: number, logo: FileParameter | null | undefined): Promise<SupplierLogoDto> {
        let url_ = this.baseUrl + "/api/suppliers/{id}/logo";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (logo !== null && logo !== undefined)
            content_.append("logo", logo.data, logo.fileName ? logo.fileName : "logo");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadSupplierLogo(_response);
        });
    }

    protected processUploadSupplierLogo(response: Response): Promise<SupplierLogoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SupplierLogoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierLogoDto>(null as any);
    }
}

export class SubcontractorSpecialtiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSubcontractorSpecialties(): Promise<SubcontractorSpecialtyDto[]> {
        let url_ = this.baseUrl + "/api/subcontractor-specialties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubcontractorSpecialties(_response);
        });
    }

    protected processGetSubcontractorSpecialties(response: Response): Promise<SubcontractorSpecialtyDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubcontractorSpecialtyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorSpecialtyDto[]>(null as any);
    }
}

export class SubcontractorsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSubcontractors(): Promise<SubcontractorDto[]> {
        let url_ = this.baseUrl + "/api/subcontractors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubcontractors(_response);
        });
    }

    protected processGetSubcontractors(response: Response): Promise<SubcontractorDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubcontractorDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorDto[]>(null as any);
    }

    createSubcontractor(command: CreateSubcontractorCommand): Promise<SubcontractorDto> {
        let url_ = this.baseUrl + "/api/subcontractors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSubcontractor(_response);
        });
    }

    protected processCreateSubcontractor(response: Response): Promise<SubcontractorDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorDto>(null as any);
    }

    getSubcontractorOptions(term: string | null | undefined, take: number | null | undefined): Promise<LookupOptionDto[]> {
        let url_ = this.baseUrl + "/api/subcontractors/options?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubcontractorOptions(_response);
        });
    }

    protected processGetSubcontractorOptions(response: Response): Promise<LookupOptionDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupOptionDto[]>(null as any);
    }

    getSubcontractorById(id: number): Promise<SubcontractorDto> {
        let url_ = this.baseUrl + "/api/subcontractors/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubcontractorById(_response);
        });
    }

    protected processGetSubcontractorById(response: Response): Promise<SubcontractorDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorDto>(null as any);
    }

    updateSubcontractor(id: number, command: UpdateSubcontractorCommand): Promise<SubcontractorDto> {
        let url_ = this.baseUrl + "/api/subcontractors/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSubcontractor(_response);
        });
    }

    protected processUpdateSubcontractor(response: Response): Promise<SubcontractorDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorDto>(null as any);
    }

    uploadSubcontractorLogo(id: number, logo: FileParameter | null | undefined): Promise<SubcontractorLogoDto> {
        let url_ = this.baseUrl + "/api/subcontractors/{id}/logo";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (logo !== null && logo !== undefined)
            content_.append("logo", logo.data, logo.fileName ? logo.fileName : "logo");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadSubcontractorLogo(_response);
        });
    }

    protected processUploadSubcontractorLogo(response: Response): Promise<SubcontractorLogoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubcontractorLogoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubcontractorLogoDto>(null as any);
    }
}

export class SettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getMarginAlertRanges(): Promise<MarginAlertRangeDto[]> {
        let url_ = this.baseUrl + "/api/settings/margin-alert-ranges";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarginAlertRanges(_response);
        });
    }

    protected processGetMarginAlertRanges(response: Response): Promise<MarginAlertRangeDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarginAlertRangeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarginAlertRangeDto[]>(null as any);
    }

    saveMarginAlertRanges(command: SaveMarginAlertRangesCommand): Promise<MarginAlertRangeDto[]> {
        let url_ = this.baseUrl + "/api/settings/margin-alert-ranges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveMarginAlertRanges(_response);
        });
    }

    protected processSaveMarginAlertRanges(response: Response): Promise<MarginAlertRangeDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MarginAlertRangeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarginAlertRangeDto[]>(null as any);
    }

    getAiSettings(): Promise<AiSettingsDto> {
        let url_ = this.baseUrl + "/api/settings/ai";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAiSettings(_response);
        });
    }

    protected processGetAiSettings(response: Response): Promise<AiSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiSettingsDto>(null as any);
    }

    saveAiSettings(command: SaveAiSettingsCommand): Promise<AiSettingsDto> {
        let url_ = this.baseUrl + "/api/settings/ai";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAiSettings(_response);
        });
    }

    protected processSaveAiSettings(response: Response): Promise<AiSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiSettingsDto>(null as any);
    }

    getBankSyncSettings(): Promise<BankSyncSettingsDto> {
        let url_ = this.baseUrl + "/api/settings/bank-sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankSyncSettings(_response);
        });
    }

    protected processGetBankSyncSettings(response: Response): Promise<BankSyncSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankSyncSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankSyncSettingsDto>(null as any);
    }

    saveBankSyncSettings(command: SaveBankSyncSettingsCommand): Promise<BankSyncSettingsDto> {
        let url_ = this.baseUrl + "/api/settings/bank-sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBankSyncSettings(_response);
        });
    }

    protected processSaveBankSyncSettings(response: Response): Promise<BankSyncSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankSyncSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankSyncSettingsDto>(null as any);
    }

    testBudgetBakersConnection(command: TestBudgetBakersConnectionCommand): Promise<BudgetBakersConnectionTestDto> {
        let url_ = this.baseUrl + "/api/settings/bank-sync/test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTestBudgetBakersConnection(_response);
        });
    }

    protected processTestBudgetBakersConnection(response: Response): Promise<BudgetBakersConnectionTestDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetBakersConnectionTestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetBakersConnectionTestDto>(null as any);
    }

    getBudgetPercentageRules(): Promise<BudgetPercentageRuleDto[]> {
        let url_ = this.baseUrl + "/api/settings/budget-percentage-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBudgetPercentageRules(_response);
        });
    }

    protected processGetBudgetPercentageRules(response: Response): Promise<BudgetPercentageRuleDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BudgetPercentageRuleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetPercentageRuleDto[]>(null as any);
    }

    saveBudgetPercentageRules(command: SaveBudgetPercentageRulesCommand): Promise<BudgetPercentageRuleDto[]> {
        let url_ = this.baseUrl + "/api/settings/budget-percentage-rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBudgetPercentageRules(_response);
        });
    }

    protected processSaveBudgetPercentageRules(response: Response): Promise<BudgetPercentageRuleDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BudgetPercentageRuleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetPercentageRuleDto[]>(null as any);
    }

    getArticleClassificationRules(): Promise<ArticleClassificationRuleDto[]> {
        let url_ = this.baseUrl + "/api/settings/article-classification-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArticleClassificationRules(_response);
        });
    }

    protected processGetArticleClassificationRules(response: Response): Promise<ArticleClassificationRuleDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleClassificationRuleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleClassificationRuleDto[]>(null as any);
    }

    saveArticleClassificationRules(command: SaveArticleClassificationRulesCommand): Promise<ArticleClassificationRuleDto[]> {
        let url_ = this.baseUrl + "/api/settings/article-classification-rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveArticleClassificationRules(_response);
        });
    }

    protected processSaveArticleClassificationRules(response: Response): Promise<ArticleClassificationRuleDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleClassificationRuleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleClassificationRuleDto[]>(null as any);
    }

    getExpenseCategoryRules(): Promise<ExpenseCategoryRuleDto[]> {
        let url_ = this.baseUrl + "/api/settings/expense-category-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpenseCategoryRules(_response);
        });
    }

    protected processGetExpenseCategoryRules(response: Response): Promise<ExpenseCategoryRuleDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpenseCategoryRuleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseCategoryRuleDto[]>(null as any);
    }

    saveExpenseCategoryRules(command: SaveExpenseCategoryRulesCommand): Promise<ExpenseCategoryRuleDto[]> {
        let url_ = this.baseUrl + "/api/settings/expense-category-rules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveExpenseCategoryRules(_response);
        });
    }

    protected processSaveExpenseCategoryRules(response: Response): Promise<ExpenseCategoryRuleDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpenseCategoryRuleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseCategoryRuleDto[]>(null as any);
    }

    getFinancialSettings(): Promise<FinancialSettingsDto> {
        let url_ = this.baseUrl + "/api/settings/financial";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFinancialSettings(_response);
        });
    }

    protected processGetFinancialSettings(response: Response): Promise<FinancialSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialSettingsDto>(null as any);
    }

    saveFinancialSettings(command: SaveFinancialSettingsCommand): Promise<FinancialSettingsDto> {
        let url_ = this.baseUrl + "/api/settings/financial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveFinancialSettings(_response);
        });
    }

    protected processSaveFinancialSettings(response: Response): Promise<FinancialSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialSettingsDto>(null as any);
    }

    getIndirectCostSettings(): Promise<IndirectCostSettingsDto> {
        let url_ = this.baseUrl + "/api/settings/indirect-cost";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIndirectCostSettings(_response);
        });
    }

    protected processGetIndirectCostSettings(response: Response): Promise<IndirectCostSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndirectCostSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndirectCostSettingsDto>(null as any);
    }

    saveIndirectCostSettings(command: SaveIndirectCostSettingsCommand): Promise<IndirectCostSettingsDto> {
        let url_ = this.baseUrl + "/api/settings/indirect-cost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveIndirectCostSettings(_response);
        });
    }

    protected processSaveIndirectCostSettings(response: Response): Promise<IndirectCostSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndirectCostSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IndirectCostSettingsDto>(null as any);
    }

    getAnomalySettings(): Promise<AnomalySettingsDto> {
        let url_ = this.baseUrl + "/api/settings/anomaly-detection";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAnomalySettings(_response);
        });
    }

    protected processGetAnomalySettings(response: Response): Promise<AnomalySettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnomalySettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnomalySettingsDto>(null as any);
    }

    saveAnomalySettings(command: SaveAnomalySettingsCommand): Promise<AnomalySettingsDto> {
        let url_ = this.baseUrl + "/api/settings/anomaly-detection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAnomalySettings(_response);
        });
    }

    protected processSaveAnomalySettings(response: Response): Promise<AnomalySettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnomalySettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnomalySettingsDto>(null as any);
    }

    getCreditControlSettings(): Promise<CreditControlSettingsDto> {
        let url_ = this.baseUrl + "/api/settings/credit-control";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCreditControlSettings(_response);
        });
    }

    protected processGetCreditControlSettings(response: Response): Promise<CreditControlSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreditControlSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditControlSettingsDto>(null as any);
    }

    saveCreditControlSettings(command: SaveCreditControlSettingsCommand): Promise<CreditControlSettingsDto> {
        let url_ = this.baseUrl + "/api/settings/credit-control";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveCreditControlSettings(_response);
        });
    }

    protected processSaveCreditControlSettings(response: Response): Promise<CreditControlSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreditControlSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreditControlSettingsDto>(null as any);
    }

    getTreasurySettings(): Promise<TreasurySettingsDto> {
        let url_ = this.baseUrl + "/api/settings/treasury";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTreasurySettings(_response);
        });
    }

    protected processGetTreasurySettings(response: Response): Promise<TreasurySettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreasurySettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreasurySettingsDto>(null as any);
    }

    saveTreasurySettings(command: SaveTreasurySettingsCommand): Promise<TreasurySettingsDto> {
        let url_ = this.baseUrl + "/api/settings/treasury";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveTreasurySettings(_response);
        });
    }

    protected processSaveTreasurySettings(response: Response): Promise<TreasurySettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TreasurySettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreasurySettingsDto>(null as any);
    }
}

export class SearchClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    globalSearch(term: string, maxPerType: number | null | undefined): Promise<GlobalSearchResultDto> {
        let url_ = this.baseUrl + "/api/search?";
        if (term === undefined || term === null)
            throw new globalThis.Error("The parameter 'term' must be defined and cannot be null.");
        else
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (maxPerType !== undefined && maxPerType !== null)
            url_ += "maxPerType=" + encodeURIComponent("" + maxPerType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGlobalSearch(_response);
        });
    }

    protected processGlobalSearch(response: Response): Promise<GlobalSearchResultDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalSearchResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlobalSearchResultDto>(null as any);
    }
}

export class ScheduletasksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getScheduleTasks(workId: number | null | undefined): Promise<ScheduleTaskDto[]> {
        let url_ = this.baseUrl + "/api/scheduletasks?";
        if (workId !== undefined && workId !== null)
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScheduleTasks(_response);
        });
    }

    protected processGetScheduleTasks(response: Response): Promise<ScheduleTaskDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleTaskDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleTaskDto[]>(null as any);
    }

    createScheduleTask(command: CreateScheduleTaskCommand): Promise<ScheduleTaskDto> {
        let url_ = this.baseUrl + "/api/scheduletasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateScheduleTask(_response);
        });
    }

    protected processCreateScheduleTask(response: Response): Promise<ScheduleTaskDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTaskDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleTaskDto>(null as any);
    }

    getScheduleTaskStatuses(): Promise<ScheduleTaskStatusDto[]> {
        let url_ = this.baseUrl + "/api/scheduletasks/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScheduleTaskStatuses(_response);
        });
    }

    protected processGetScheduleTaskStatuses(response: Response): Promise<ScheduleTaskStatusDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduleTaskStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleTaskStatusDto[]>(null as any);
    }

    getScheduleTaskById(id: number): Promise<ScheduleTaskDto> {
        let url_ = this.baseUrl + "/api/scheduletasks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetScheduleTaskById(_response);
        });
    }

    protected processGetScheduleTaskById(response: Response): Promise<ScheduleTaskDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTaskDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleTaskDto>(null as any);
    }

    updateScheduleTask(id: number, command: UpdateScheduleTaskCommand): Promise<ScheduleTaskDto> {
        let url_ = this.baseUrl + "/api/scheduletasks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateScheduleTask(_response);
        });
    }

    protected processUpdateScheduleTask(response: Response): Promise<ScheduleTaskDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTaskDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleTaskDto>(null as any);
    }

    deleteScheduleTask(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/scheduletasks/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteScheduleTask(_response);
        });
    }

    protected processDeleteScheduleTask(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    notifyDelay(id: number): Promise<ScheduleTaskDto> {
        let url_ = this.baseUrl + "/api/scheduletasks/{id}/notify-delay";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNotifyDelay(_response);
        });
    }

    protected processNotifyDelay(response: Response): Promise<ScheduleTaskDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleTaskDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleTaskDto>(null as any);
    }
}

export class RentUpdatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createRentUpdateProposal(command: CreateRentUpdateProposalCommand): Promise<RentUpdateProposalDto> {
        let url_ = this.baseUrl + "/api/rent-updates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateRentUpdateProposal(_response);
        });
    }

    protected processCreateRentUpdateProposal(response: Response): Promise<RentUpdateProposalDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentUpdateProposalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentUpdateProposalDto>(null as any);
    }

    getRentUpdateProposals(rentalContractId: number | null | undefined): Promise<RentUpdateProposalDto[]> {
        let url_ = this.baseUrl + "/api/rent-updates?";
        if (rentalContractId !== undefined && rentalContractId !== null)
            url_ += "rentalContractId=" + encodeURIComponent("" + rentalContractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentUpdateProposals(_response);
        });
    }

    protected processGetRentUpdateProposals(response: Response): Promise<RentUpdateProposalDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RentUpdateProposalDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentUpdateProposalDto[]>(null as any);
    }

    applyRentUpdateProposal(id: number): Promise<RentUpdateProposalDto> {
        let url_ = this.baseUrl + "/api/rent-updates/{id}/apply";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplyRentUpdateProposal(_response);
        });
    }

    protected processApplyRentUpdateProposal(response: Response): Promise<RentUpdateProposalDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentUpdateProposalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentUpdateProposalDto>(null as any);
    }

    notifyRentUpdateProposal(id: number): Promise<RentUpdateProposalDto> {
        let url_ = this.baseUrl + "/api/rent-updates/{id}/notify";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNotifyRentUpdateProposal(_response);
        });
    }

    protected processNotifyRentUpdateProposal(response: Response): Promise<RentUpdateProposalDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentUpdateProposalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentUpdateProposalDto>(null as any);
    }

    deleteRentUpdateProposal(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/rent-updates/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteRentUpdateProposal(_response);
        });
    }

    protected processDeleteRentUpdateProposal(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RentReportsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getRentRevenueByProperty(year: number, month: number | null | undefined): Promise<RentRevenueReportDto> {
        let url_ = this.baseUrl + "/api/rent-reports/revenue-by-property?";
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentRevenueByProperty(_response);
        });
    }

    protected processGetRentRevenueByProperty(response: Response): Promise<RentRevenueReportDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentRevenueReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentRevenueReportDto>(null as any);
    }

    getPropertyProfitability(propertyId: number, year: number): Promise<PropertyProfitabilityDto> {
        let url_ = this.baseUrl + "/api/rent-reports/property-profitability?";
        if (propertyId === undefined || propertyId === null)
            throw new globalThis.Error("The parameter 'propertyId' must be defined and cannot be null.");
        else
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPropertyProfitability(_response);
        });
    }

    protected processGetPropertyProfitability(response: Response): Promise<PropertyProfitabilityDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyProfitabilityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyProfitabilityDto>(null as any);
    }

    getRentArrears(year: number, month: number | null | undefined): Promise<RentArrearsReportDto> {
        let url_ = this.baseUrl + "/api/rent-reports/arrears?";
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentArrears(_response);
        });
    }

    protected processGetRentArrears(response: Response): Promise<RentArrearsReportDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentArrearsReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentArrearsReportDto>(null as any);
    }
}

export class RentReceiptsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getRentReceipts(year: number | null | undefined, month: number | null | undefined, status: string | null | undefined, rentNoticeId: number | null | undefined): Promise<RentReceiptDto[]> {
        let url_ = this.baseUrl + "/api/rent-receipts?";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (rentNoticeId !== undefined && rentNoticeId !== null)
            url_ += "rentNoticeId=" + encodeURIComponent("" + rentNoticeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentReceipts(_response);
        });
    }

    protected processGetRentReceipts(response: Response): Promise<RentReceiptDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RentReceiptDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentReceiptDto[]>(null as any);
    }

    generateRentReceipt(command: GenerateRentReceiptCommand): Promise<RentReceiptDto> {
        let url_ = this.baseUrl + "/api/rent-receipts/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateRentReceipt(_response);
        });
    }

    protected processGenerateRentReceipt(response: Response): Promise<RentReceiptDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentReceiptDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentReceiptDto>(null as any);
    }

    setRentReceiptStatus(id: number, command: SetRentReceiptStatusCommand): Promise<RentReceiptDto> {
        let url_ = this.baseUrl + "/api/rent-receipts/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetRentReceiptStatus(_response);
        });
    }

    protected processSetRentReceiptStatus(response: Response): Promise<RentReceiptDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentReceiptDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentReceiptDto>(null as any);
    }

    deleteRentReceipt(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/rent-receipts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteRentReceipt(_response);
        });
    }

    protected processDeleteRentReceipt(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RentNoticesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    generateRentNotices(command: GenerateRentNoticesCommand): Promise<GenerateRentNoticesResultDto> {
        let url_ = this.baseUrl + "/api/rent-notices/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateRentNotices(_response);
        });
    }

    protected processGenerateRentNotices(response: Response): Promise<GenerateRentNoticesResultDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateRentNoticesResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GenerateRentNoticesResultDto>(null as any);
    }

    getRentNotices(year: number | null | undefined, month: number | null | undefined, propertyId: number | null | undefined, rentalContractId: number | null | undefined, statusCode: string | null | undefined, onlyUnpaid: boolean | null | undefined): Promise<RentNoticeDto[]> {
        let url_ = this.baseUrl + "/api/rent-notices?";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (propertyId !== undefined && propertyId !== null)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (rentalContractId !== undefined && rentalContractId !== null)
            url_ += "rentalContractId=" + encodeURIComponent("" + rentalContractId) + "&";
        if (statusCode !== undefined && statusCode !== null)
            url_ += "statusCode=" + encodeURIComponent("" + statusCode) + "&";
        if (onlyUnpaid !== undefined && onlyUnpaid !== null)
            url_ += "onlyUnpaid=" + encodeURIComponent("" + onlyUnpaid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentNotices(_response);
        });
    }

    protected processGetRentNotices(response: Response): Promise<RentNoticeDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RentNoticeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentNoticeDto[]>(null as any);
    }

    setRentNoticePaid(id: number, command: SetRentNoticePaidCommand): Promise<RentNoticeDto> {
        let url_ = this.baseUrl + "/api/rent-notices/{id}/paid";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetRentNoticePaid(_response);
        });
    }

    protected processSetRentNoticePaid(response: Response): Promise<RentNoticeDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentNoticeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentNoticeDto>(null as any);
    }

    sendRentNoticeEmail(id: number): Promise<RentNoticeDto> {
        let url_ = this.baseUrl + "/api/rent-notices/{id}/send-email";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendRentNoticeEmail(_response);
        });
    }

    protected processSendRentNoticeEmail(response: Response): Promise<RentNoticeDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentNoticeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentNoticeDto>(null as any);
    }

    deleteRentNotice(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/rent-notices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteRentNotice(_response);
        });
    }

    protected processDeleteRentNotice(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RentCollectionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    sendRentCollectionEmail(command: SendRentCollectionEmailCommand): Promise<RentCollectionActivityDto> {
        let url_ = this.baseUrl + "/api/rent-collections/send-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendRentCollectionEmail(_response);
        });
    }

    protected processSendRentCollectionEmail(response: Response): Promise<RentCollectionActivityDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentCollectionActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentCollectionActivityDto>(null as any);
    }

    logRentCollectionActivity(command: LogRentCollectionActivityCommand): Promise<RentCollectionActivityDto> {
        let url_ = this.baseUrl + "/api/rent-collections/log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogRentCollectionActivity(_response);
        });
    }

    protected processLogRentCollectionActivity(response: Response): Promise<RentCollectionActivityDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentCollectionActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentCollectionActivityDto>(null as any);
    }

    getRentCollectionActivities(rentNoticeId: number | null | undefined): Promise<RentCollectionActivityDto[]> {
        let url_ = this.baseUrl + "/api/rent-collections?";
        if (rentNoticeId !== undefined && rentNoticeId !== null)
            url_ += "rentNoticeId=" + encodeURIComponent("" + rentNoticeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentCollectionActivities(_response);
        });
    }

    protected processGetRentCollectionActivities(response: Response): Promise<RentCollectionActivityDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RentCollectionActivityDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentCollectionActivityDto[]>(null as any);
    }
}

export class RentalContractsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getRentalContractStatuses(): Promise<RentalContractStatusDto[]> {
        let url_ = this.baseUrl + "/api/rental-contracts/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentalContractStatuses(_response);
        });
    }

    protected processGetRentalContractStatuses(response: Response): Promise<RentalContractStatusDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RentalContractStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentalContractStatusDto[]>(null as any);
    }

    getExpiringRentalContracts(withinDays: number | null | undefined): Promise<RentalContractDto[]> {
        let url_ = this.baseUrl + "/api/rental-contracts/expiring?";
        if (withinDays !== undefined && withinDays !== null)
            url_ += "withinDays=" + encodeURIComponent("" + withinDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpiringRentalContracts(_response);
        });
    }

    protected processGetExpiringRentalContracts(response: Response): Promise<RentalContractDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RentalContractDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentalContractDto[]>(null as any);
    }

    getRentalContractById(id: number): Promise<RentalContractDto> {
        let url_ = this.baseUrl + "/api/rental-contracts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentalContractById(_response);
        });
    }

    protected processGetRentalContractById(response: Response): Promise<RentalContractDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentalContractDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentalContractDto>(null as any);
    }

    updateRentalContract(id: number, command: UpdateRentalContractCommand): Promise<RentalContractDto> {
        let url_ = this.baseUrl + "/api/rental-contracts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRentalContract(_response);
        });
    }

    protected processUpdateRentalContract(response: Response): Promise<RentalContractDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentalContractDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentalContractDto>(null as any);
    }

    deleteRentalContract(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/rental-contracts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteRentalContract(_response);
        });
    }

    protected processDeleteRentalContract(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRentalContracts(propertyId: number | null | undefined, tenantId: number | null | undefined, statusCode: string | null | undefined): Promise<RentalContractDto[]> {
        let url_ = this.baseUrl + "/api/rental-contracts?";
        if (propertyId !== undefined && propertyId !== null)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (statusCode !== undefined && statusCode !== null)
            url_ += "statusCode=" + encodeURIComponent("" + statusCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRentalContracts(_response);
        });
    }

    protected processGetRentalContracts(response: Response): Promise<RentalContractDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RentalContractDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentalContractDto[]>(null as any);
    }

    createRentalContract(command: CreateRentalContractCommand): Promise<RentalContractDto> {
        let url_ = this.baseUrl + "/api/rental-contracts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateRentalContract(_response);
        });
    }

    protected processCreateRentalContract(response: Response): Promise<RentalContractDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RentalContractDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RentalContractDto>(null as any);
    }
}

export class PropertiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getProperties(): Promise<PropertyDto[]> {
        let url_ = this.baseUrl + "/api/properties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProperties(_response);
        });
    }

    protected processGetProperties(response: Response): Promise<PropertyDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyDto[]>(null as any);
    }

    createProperty(command: CreatePropertyCommand): Promise<PropertyDto> {
        let url_ = this.baseUrl + "/api/properties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateProperty(_response);
        });
    }

    protected processCreateProperty(response: Response): Promise<PropertyDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyDto>(null as any);
    }

    getPropertyById(id: number): Promise<PropertyDto> {
        let url_ = this.baseUrl + "/api/properties/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPropertyById(_response);
        });
    }

    protected processGetPropertyById(response: Response): Promise<PropertyDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyDto>(null as any);
    }

    updateProperty(id: number, command: UpdatePropertyCommand): Promise<PropertyDto> {
        let url_ = this.baseUrl + "/api/properties/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProperty(_response);
        });
    }

    protected processUpdateProperty(response: Response): Promise<PropertyDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PropertyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyDto>(null as any);
    }
}

export class MeetingminutesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getMeetingMinutes(workId: number | null | undefined): Promise<MeetingMinuteDto[]> {
        let url_ = this.baseUrl + "/api/meetingminutes?";
        if (workId !== undefined && workId !== null)
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeetingMinutes(_response);
        });
    }

    protected processGetMeetingMinutes(response: Response): Promise<MeetingMinuteDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeetingMinuteDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingMinuteDto[]>(null as any);
    }

    createMeetingMinute(command: CreateMeetingMinuteCommand): Promise<MeetingMinuteDto> {
        let url_ = this.baseUrl + "/api/meetingminutes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMeetingMinute(_response);
        });
    }

    protected processCreateMeetingMinute(response: Response): Promise<MeetingMinuteDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingMinuteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingMinuteDto>(null as any);
    }

    getMeetingMinuteById(id: number): Promise<MeetingMinuteDto> {
        let url_ = this.baseUrl + "/api/meetingminutes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMeetingMinuteById(_response);
        });
    }

    protected processGetMeetingMinuteById(response: Response): Promise<MeetingMinuteDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingMinuteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingMinuteDto>(null as any);
    }

    updateMeetingMinute(id: number, command: UpdateMeetingMinuteCommand): Promise<MeetingMinuteDto> {
        let url_ = this.baseUrl + "/api/meetingminutes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMeetingMinute(_response);
        });
    }

    protected processUpdateMeetingMinute(response: Response): Promise<MeetingMinuteDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MeetingMinuteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeetingMinuteDto>(null as any);
    }

    deleteMeetingMinute(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/meetingminutes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMeetingMinute(_response);
        });
    }

    protected processDeleteMeetingMinute(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class LoansClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLoans(): Promise<LoanDto[]> {
        let url_ = this.baseUrl + "/api/loans";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLoans(_response);
        });
    }

    protected processGetLoans(response: Response): Promise<LoanDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LoanDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoanDto[]>(null as any);
    }

    createLoan(command: CreateLoanCommand): Promise<LoanDto> {
        let url_ = this.baseUrl + "/api/loans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLoan(_response);
        });
    }

    protected processCreateLoan(response: Response): Promise<LoanDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoanDto>(null as any);
    }

    getDebtOverview(): Promise<DebtOverviewDto> {
        let url_ = this.baseUrl + "/api/loans/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDebtOverview(_response);
        });
    }

    protected processGetDebtOverview(response: Response): Promise<DebtOverviewDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DebtOverviewDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DebtOverviewDto>(null as any);
    }

    getLoanById(id: number): Promise<LoanDetailDto> {
        let url_ = this.baseUrl + "/api/loans/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLoanById(_response);
        });
    }

    protected processGetLoanById(response: Response): Promise<LoanDetailDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoanDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoanDetailDto>(null as any);
    }

    updateLoan(id: number, command: UpdateLoanCommand): Promise<LoanDto> {
        let url_ = this.baseUrl + "/api/loans/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLoan(_response);
        });
    }

    protected processUpdateLoan(response: Response): Promise<LoanDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoanDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoanDto>(null as any);
    }

    registerLoanInstallmentPayment(id: number, command: RegisterLoanInstallmentPaymentCommand | undefined): Promise<LoanDetailDto> {
        let url_ = this.baseUrl + "/api/loans/{id}/register-payment";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterLoanInstallmentPayment(_response);
        });
    }

    protected processRegisterLoanInstallmentPayment(response: Response): Promise<LoanDetailDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoanDetailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoanDetailDto>(null as any);
    }
}

export class InvoicesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getInvoices(companyId: number | null | undefined, workId: number | null | undefined, entity: string | null | undefined, structural: boolean | null | undefined, subType: string | null | undefined, lifecycle: string | null | undefined, expenseCategoryId: number | null | undefined, approvalStatusCode: string | null | undefined, excludedFromSummary: boolean | null | undefined, pendingOnly: boolean | null | undefined, from: Date | null | undefined, to: Date | null | undefined, createdFrom: Date | null | undefined, createdTo: Date | null | undefined, sort: string | null | undefined, sortAscending: boolean | null | undefined, documentNumber: string | null | undefined, description: string | null | undefined, net: number | null | undefined, gross: number | null | undefined, documents: string | null | undefined, search: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Promise<InvoiceListVm> {
        let url_ = this.baseUrl + "/api/invoices?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (workId !== undefined && workId !== null)
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (structural !== undefined && structural !== null)
            url_ += "structural=" + encodeURIComponent("" + structural) + "&";
        if (subType !== undefined && subType !== null)
            url_ += "subType=" + encodeURIComponent("" + subType) + "&";
        if (lifecycle !== undefined && lifecycle !== null)
            url_ += "lifecycle=" + encodeURIComponent("" + lifecycle) + "&";
        if (expenseCategoryId !== undefined && expenseCategoryId !== null)
            url_ += "expenseCategoryId=" + encodeURIComponent("" + expenseCategoryId) + "&";
        if (approvalStatusCode !== undefined && approvalStatusCode !== null)
            url_ += "approvalStatusCode=" + encodeURIComponent("" + approvalStatusCode) + "&";
        if (excludedFromSummary !== undefined && excludedFromSummary !== null)
            url_ += "excludedFromSummary=" + encodeURIComponent("" + excludedFromSummary) + "&";
        if (pendingOnly !== undefined && pendingOnly !== null)
            url_ += "pendingOnly=" + encodeURIComponent("" + pendingOnly) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (createdFrom !== undefined && createdFrom !== null)
            url_ += "createdFrom=" + encodeURIComponent(createdFrom ? "" + createdFrom.toISOString() : "") + "&";
        if (createdTo !== undefined && createdTo !== null)
            url_ += "createdTo=" + encodeURIComponent(createdTo ? "" + createdTo.toISOString() : "") + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (documentNumber !== undefined && documentNumber !== null)
            url_ += "documentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (net !== undefined && net !== null)
            url_ += "net=" + encodeURIComponent("" + net) + "&";
        if (gross !== undefined && gross !== null)
            url_ += "gross=" + encodeURIComponent("" + gross) + "&";
        if (documents !== undefined && documents !== null)
            url_ += "documents=" + encodeURIComponent("" + documents) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvoices(_response);
        });
    }

    protected processGetInvoices(response: Response): Promise<InvoiceListVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceListVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceListVm>(null as any);
    }

    createInvoice(command: CreateInvoiceCommand): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateInvoice(_response);
        });
    }

    protected processCreateInvoice(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    exportInvoices(format: string, revenue: boolean | null | undefined, companyId: number | null | undefined, workId: number | null | undefined, entity: string | null | undefined, structural: boolean | null | undefined, subType: string | null | undefined, lifecycle: string | null | undefined, expenseCategoryId: number | null | undefined, approvalStatusCode: string | null | undefined, excludedFromSummary: boolean | null | undefined, from: Date | null | undefined, to: Date | null | undefined, createdFrom: Date | null | undefined, createdTo: Date | null | undefined, documentNumber: string | null | undefined, description: string | null | undefined, net: number | null | undefined, gross: number | null | undefined, documents: string | null | undefined, search: string | null | undefined, pendingOnly: boolean | null | undefined, ids: number[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/invoices/export/{format}?";
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (revenue !== undefined && revenue !== null)
            url_ += "revenue=" + encodeURIComponent("" + revenue) + "&";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (workId !== undefined && workId !== null)
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (structural !== undefined && structural !== null)
            url_ += "structural=" + encodeURIComponent("" + structural) + "&";
        if (subType !== undefined && subType !== null)
            url_ += "subType=" + encodeURIComponent("" + subType) + "&";
        if (lifecycle !== undefined && lifecycle !== null)
            url_ += "lifecycle=" + encodeURIComponent("" + lifecycle) + "&";
        if (expenseCategoryId !== undefined && expenseCategoryId !== null)
            url_ += "expenseCategoryId=" + encodeURIComponent("" + expenseCategoryId) + "&";
        if (approvalStatusCode !== undefined && approvalStatusCode !== null)
            url_ += "approvalStatusCode=" + encodeURIComponent("" + approvalStatusCode) + "&";
        if (excludedFromSummary !== undefined && excludedFromSummary !== null)
            url_ += "excludedFromSummary=" + encodeURIComponent("" + excludedFromSummary) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (createdFrom !== undefined && createdFrom !== null)
            url_ += "createdFrom=" + encodeURIComponent(createdFrom ? "" + createdFrom.toISOString() : "") + "&";
        if (createdTo !== undefined && createdTo !== null)
            url_ += "createdTo=" + encodeURIComponent(createdTo ? "" + createdTo.toISOString() : "") + "&";
        if (documentNumber !== undefined && documentNumber !== null)
            url_ += "documentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (net !== undefined && net !== null)
            url_ += "net=" + encodeURIComponent("" + net) + "&";
        if (gross !== undefined && gross !== null)
            url_ += "gross=" + encodeURIComponent("" + gross) + "&";
        if (documents !== undefined && documents !== null)
            url_ += "documents=" + encodeURIComponent("" + documents) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (pendingOnly !== undefined && pendingOnly !== null)
            url_ += "pendingOnly=" + encodeURIComponent("" + pendingOnly) + "&";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportInvoices(_response);
        });
    }

    protected processExportInvoices(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getInvoiceFilterOptions(revenue: boolean | null | undefined): Promise<InvoiceFilterOptionsVm> {
        let url_ = this.baseUrl + "/api/invoices/filter-options?";
        if (revenue !== undefined && revenue !== null)
            url_ += "revenue=" + encodeURIComponent("" + revenue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvoiceFilterOptions(_response);
        });
    }

    protected processGetInvoiceFilterOptions(response: Response): Promise<InvoiceFilterOptionsVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceFilterOptionsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceFilterOptionsVm>(null as any);
    }

    getRevenueInvoices(companyId: number | null | undefined, workId: number | null | undefined, entity: string | null | undefined, from: Date | null | undefined, to: Date | null | undefined, createdFrom: Date | null | undefined, createdTo: Date | null | undefined, sort: string | null | undefined, sortAscending: boolean | null | undefined, documentNumber: string | null | undefined, description: string | null | undefined, net: number | null | undefined, gross: number | null | undefined, documents: string | null | undefined, search: string | null | undefined, pendingOnly: boolean | null | undefined, approvalStatusCode: string | null | undefined, excludedFromSummary: boolean | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Promise<InvoiceListVm> {
        let url_ = this.baseUrl + "/api/invoices/revenue?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (workId !== undefined && workId !== null)
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        if (entity !== undefined && entity !== null)
            url_ += "entity=" + encodeURIComponent("" + entity) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (createdFrom !== undefined && createdFrom !== null)
            url_ += "createdFrom=" + encodeURIComponent(createdFrom ? "" + createdFrom.toISOString() : "") + "&";
        if (createdTo !== undefined && createdTo !== null)
            url_ += "createdTo=" + encodeURIComponent(createdTo ? "" + createdTo.toISOString() : "") + "&";
        if (sort !== undefined && sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (sortAscending !== undefined && sortAscending !== null)
            url_ += "sortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (documentNumber !== undefined && documentNumber !== null)
            url_ += "documentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (net !== undefined && net !== null)
            url_ += "net=" + encodeURIComponent("" + net) + "&";
        if (gross !== undefined && gross !== null)
            url_ += "gross=" + encodeURIComponent("" + gross) + "&";
        if (documents !== undefined && documents !== null)
            url_ += "documents=" + encodeURIComponent("" + documents) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (pendingOnly !== undefined && pendingOnly !== null)
            url_ += "pendingOnly=" + encodeURIComponent("" + pendingOnly) + "&";
        if (approvalStatusCode !== undefined && approvalStatusCode !== null)
            url_ += "approvalStatusCode=" + encodeURIComponent("" + approvalStatusCode) + "&";
        if (excludedFromSummary !== undefined && excludedFromSummary !== null)
            url_ += "excludedFromSummary=" + encodeURIComponent("" + excludedFromSummary) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRevenueInvoices(_response);
        });
    }

    protected processGetRevenueInvoices(response: Response): Promise<InvoiceListVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceListVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceListVm>(null as any);
    }

    getEmailImports(status: string | null | undefined, toReview: boolean | null | undefined, search: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Promise<PaginatedListOfEmailIngestionMessageDto> {
        let url_ = this.baseUrl + "/api/invoices/email-imports?";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (toReview !== undefined && toReview !== null)
            url_ += "toReview=" + encodeURIComponent("" + toReview) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailImports(_response);
        });
    }

    protected processGetEmailImports(response: Response): Promise<PaginatedListOfEmailIngestionMessageDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfEmailIngestionMessageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfEmailIngestionMessageDto>(null as any);
    }

    downloadEmailImportBody(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/invoices/email-imports/{id}/email";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadEmailImportBody(_response);
        });
    }

    protected processDownloadEmailImportBody(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDiscardedDocuments(search: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Promise<PaginatedListOfDiscardedDocumentDto> {
        let url_ = this.baseUrl + "/api/invoices/discarded?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDiscardedDocuments(_response);
        });
    }

    protected processGetDiscardedDocuments(response: Response): Promise<PaginatedListOfDiscardedDocumentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfDiscardedDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfDiscardedDocumentDto>(null as any);
    }

    reclassifyDocument(id: number): Promise<ReclassifyDocumentResult> {
        let url_ = this.baseUrl + "/api/invoices/documents/{id}/reclassify";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReclassifyDocument(_response);
        });
    }

    protected processReclassifyDocument(response: Response): Promise<ReclassifyDocumentResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReclassifyDocumentResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReclassifyDocumentResult>(null as any);
    }

    dismissDiscardedDocument(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/invoices/documents/{id}/dismiss";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDismissDiscardedDocument(_response);
        });
    }

    protected processDismissDiscardedDocument(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    dismissSkippedAttachments(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/invoices/email-imports/{id}/dismiss-skipped";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDismissSkippedAttachments(_response);
        });
    }

    protected processDismissSkippedAttachments(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    dismissAllSkippedAttachments(): Promise<number> {
        let url_ = this.baseUrl + "/api/invoices/email-imports/dismiss-skipped";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDismissAllSkippedAttachments(_response);
        });
    }

    protected processDismissAllSkippedAttachments(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    submitAllocationFeedback(command: SubmitAllocationFeedbackCommand): Promise<AllocationFeedbackDto> {
        let url_ = this.baseUrl + "/api/invoices/allocations/feedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitAllocationFeedback(_response);
        });
    }

    protected processSubmitAllocationFeedback(response: Response): Promise<AllocationFeedbackDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AllocationFeedbackDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AllocationFeedbackDto>(null as any);
    }

    getAllocationFeedback(feedbackType: string | null | undefined, supplierTaxNumber: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Promise<PaginatedListOfAllocationFeedbackDto> {
        let url_ = this.baseUrl + "/api/invoices/allocation-feedback?";
        if (feedbackType !== undefined && feedbackType !== null)
            url_ += "feedbackType=" + encodeURIComponent("" + feedbackType) + "&";
        if (supplierTaxNumber !== undefined && supplierTaxNumber !== null)
            url_ += "supplierTaxNumber=" + encodeURIComponent("" + supplierTaxNumber) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllocationFeedback(_response);
        });
    }

    protected processGetAllocationFeedback(response: Response): Promise<PaginatedListOfAllocationFeedbackDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAllocationFeedbackDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAllocationFeedbackDto>(null as any);
    }

    reprocessEmailInvoices(): Promise<ReprocessEmailInvoicesResult> {
        let url_ = this.baseUrl + "/api/invoices/reprocess-email";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReprocessEmailInvoices(_response);
        });
    }

    protected processReprocessEmailInvoices(response: Response): Promise<ReprocessEmailInvoicesResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReprocessEmailInvoicesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReprocessEmailInvoicesResult>(null as any);
    }

    resetEmailImports(): Promise<ResetEmailImportsResult> {
        let url_ = this.baseUrl + "/api/invoices/reset-email-imports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetEmailImports(_response);
        });
    }

    protected processResetEmailImports(response: Response): Promise<ResetEmailImportsResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetEmailImportsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResetEmailImportsResult>(null as any);
    }

    extractInvoiceFromDocument(file: FileParameter | null | undefined): Promise<InvoiceExtractionDto> {
        let url_ = this.baseUrl + "/api/invoices/extract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExtractInvoiceFromDocument(_response);
        });
    }

    protected processExtractInvoiceFromDocument(response: Response): Promise<InvoiceExtractionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceExtractionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceExtractionDto>(null as any);
    }

    getInvoiceDocumentStatus(documentId: number): Promise<InvoiceExtractionDto> {
        let url_ = this.baseUrl + "/api/invoices/documents/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInvoiceDocumentStatus(_response);
        });
    }

    protected processGetInvoiceDocumentStatus(response: Response): Promise<InvoiceExtractionDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceExtractionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceExtractionDto>(null as any);
    }

    downloadFinancialDocument(documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/invoices/documents/{documentId}/file";
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadFinancialDocument(_response);
        });
    }

    protected processDownloadFinancialDocument(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateInvoice(id: number, command: UpdateInvoiceCommand): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateInvoice(_response);
        });
    }

    protected processUpdateInvoice(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    deleteInvoice(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/invoices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInvoice(_response);
        });
    }

    protected processDeleteInvoice(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteInvoices(command: DeleteInvoicesCommand): Promise<DeleteInvoicesResult> {
        let url_ = this.baseUrl + "/api/invoices/batch-delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteInvoices(_response);
        });
    }

    protected processDeleteInvoices(response: Response): Promise<DeleteInvoicesResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteInvoicesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteInvoicesResult>(null as any);
    }

    validateInvoices(command: ValidateInvoicesCommand): Promise<ValidateInvoicesResult> {
        let url_ = this.baseUrl + "/api/invoices/batch-validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateInvoices(_response);
        });
    }

    protected processValidateInvoices(response: Response): Promise<ValidateInvoicesResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateInvoicesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateInvoicesResult>(null as any);
    }

    getAttentionSummary(): Promise<AttentionSummaryVm> {
        let url_ = this.baseUrl + "/api/invoices/attention-summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttentionSummary(_response);
        });
    }

    protected processGetAttentionSummary(response: Response): Promise<AttentionSummaryVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttentionSummaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttentionSummaryVm>(null as any);
    }

    setInvoiceApprovalStatus(id: number, command: SetInvoiceApprovalStatusCommand): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/approval-status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetInvoiceApprovalStatus(_response);
        });
    }

    protected processSetInvoiceApprovalStatus(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    imputeInvoiceCost(id: number): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/impute-cost";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImputeInvoiceCost(_response);
        });
    }

    protected processImputeInvoiceCost(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    removeInvoiceCostImputation(id: number): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/impute-cost";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveInvoiceCostImputation(_response);
        });
    }

    protected processRemoveInvoiceCostImputation(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    uploadInvoiceDocument(id: number, file: FileParameter | null | undefined): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/document";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadInvoiceDocument(_response);
        });
    }

    protected processUploadInvoiceDocument(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    downloadInvoiceDocument(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/invoices/{id}/document";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadInvoiceDocument(_response);
        });
    }

    protected processDownloadInvoiceDocument(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeInvoiceDocument(id: number): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/document";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveInvoiceDocument(_response);
        });
    }

    protected processRemoveInvoiceDocument(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    setInvoiceDocumentKind(id: number, isAuto: boolean): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/document/kind?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isAuto === undefined || isAuto === null)
            throw new globalThis.Error("The parameter 'isAuto' must be defined and cannot be null.");
        else
            url_ += "isAuto=" + encodeURIComponent("" + isAuto) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetInvoiceDocumentKind(_response);
        });
    }

    protected processSetInvoiceDocumentKind(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    setInvoiceCreditNote(id: number, command: SetInvoiceCreditNoteCommand): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/credit-note";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetInvoiceCreditNote(_response);
        });
    }

    protected processSetInvoiceCreditNote(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    setInvoiceAnnulment(id: number, command: SetInvoiceAnnulmentCommand): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/credit-note-annulment";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetInvoiceAnnulment(_response);
        });
    }

    protected processSetInvoiceAnnulment(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    setInvoiceSummaryExclusion(id: number, command: SetInvoiceSummaryExclusionCommand): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/summary-exclusion";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetInvoiceSummaryExclusion(_response);
        });
    }

    protected processSetInvoiceSummaryExclusion(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    setInvoicesSummaryExclusion(command: SetInvoicesSummaryExclusionCommand): Promise<SetInvoicesSummaryExclusionResult> {
        let url_ = this.baseUrl + "/api/invoices/batch-summary-exclusion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetInvoicesSummaryExclusion(_response);
        });
    }

    protected processSetInvoicesSummaryExclusion(response: Response): Promise<SetInvoicesSummaryExclusionResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SetInvoicesSummaryExclusionResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SetInvoicesSummaryExclusionResult>(null as any);
    }

    scheduleInvoicePayment(command: ScheduleInvoicePaymentCommand): Promise<ScheduleInvoicePaymentResult> {
        let url_ = this.baseUrl + "/api/invoices/batch-payment-date";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processScheduleInvoicePayment(_response);
        });
    }

    protected processScheduleInvoicePayment(response: Response): Promise<ScheduleInvoicePaymentResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleInvoicePaymentResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleInvoicePaymentResult>(null as any);
    }

    completeForecast(id: number, forecastId: number): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/complete-forecast/{forecastId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (forecastId === undefined || forecastId === null)
            throw new globalThis.Error("The parameter 'forecastId' must be defined.");
        url_ = url_.replace("{forecastId}", encodeURIComponent("" + forecastId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompleteForecast(_response);
        });
    }

    protected processCompleteForecast(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    uncompleteForecast(id: number): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/unmerge-forecast";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUncompleteForecast(_response);
        });
    }

    protected processUncompleteForecast(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    uploadInvoicePaymentProof(id: number, file: FileParameter | null | undefined): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{id}/payment-proof";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadInvoicePaymentProof(_response);
        });
    }

    protected processUploadInvoicePaymentProof(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }

    downloadInvoicePaymentProof(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/invoices/{id}/payment-proof";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadInvoicePaymentProof(_response);
        });
    }

    protected processDownloadInvoicePaymentProof(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    matchPaymentProof(file: FileParameter | null | undefined): Promise<PaymentProofProposalDto> {
        let url_ = this.baseUrl + "/api/invoices/payment-proof/match";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMatchPaymentProof(_response);
        });
    }

    protected processMatchPaymentProof(response: Response): Promise<PaymentProofProposalDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentProofProposalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentProofProposalDto>(null as any);
    }

    applyPaymentProof(command: ApplyPaymentProofCommand): Promise<ApplyPaymentProofResult> {
        let url_ = this.baseUrl + "/api/invoices/payment-proof/apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplyPaymentProof(_response);
        });
    }

    protected processApplyPaymentProof(response: Response): Promise<ApplyPaymentProofResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplyPaymentProofResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplyPaymentProofResult>(null as any);
    }

    downloadPaymentProof(proofId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/invoices/payment-proofs/{proofId}";
        if (proofId === undefined || proofId === null)
            throw new globalThis.Error("The parameter 'proofId' must be defined.");
        url_ = url_.replace("{proofId}", encodeURIComponent("" + proofId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadPaymentProof(_response);
        });
    }

    protected processDownloadPaymentProof(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeInvoicePaymentProof(proofId: number): Promise<InvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/payment-proofs/{proofId}";
        if (proofId === undefined || proofId === null)
            throw new globalThis.Error("The parameter 'proofId' must be defined.");
        url_ = url_.replace("{proofId}", encodeURIComponent("" + proofId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveInvoicePaymentProof(_response);
        });
    }

    protected processRemoveInvoicePaymentProof(response: Response): Promise<InvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceDto>(null as any);
    }
}

export class ImportJobsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getImportJob(jobId: string): Promise<BudgetQuantityImportJobStatusDto> {
        let url_ = this.baseUrl + "/api/import-jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetImportJob(_response);
        });
    }

    protected processGetImportJob(response: Response): Promise<BudgetQuantityImportJobStatusDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetQuantityImportJobStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetQuantityImportJobStatusDto>(null as any);
    }
}

export class GlossarytermsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getGlossaryTerms(): Promise<GlossaryTermDto[]> {
        let url_ = this.baseUrl + "/api/glossaryterms";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGlossaryTerms(_response);
        });
    }

    protected processGetGlossaryTerms(response: Response): Promise<GlossaryTermDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GlossaryTermDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlossaryTermDto[]>(null as any);
    }

    createGlossaryTerm(command: CreateGlossaryTermCommand): Promise<GlossaryTermDto> {
        let url_ = this.baseUrl + "/api/glossaryterms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateGlossaryTerm(_response);
        });
    }

    protected processCreateGlossaryTerm(response: Response): Promise<GlossaryTermDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlossaryTermDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlossaryTermDto>(null as any);
    }

    getGlossaryTermById(id: number): Promise<GlossaryTermDto> {
        let url_ = this.baseUrl + "/api/glossaryterms/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetGlossaryTermById(_response);
        });
    }

    protected processGetGlossaryTermById(response: Response): Promise<GlossaryTermDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlossaryTermDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlossaryTermDto>(null as any);
    }

    updateGlossaryTerm(id: number, command: UpdateGlossaryTermCommand): Promise<GlossaryTermDto> {
        let url_ = this.baseUrl + "/api/glossaryterms/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateGlossaryTerm(_response);
        });
    }

    protected processUpdateGlossaryTerm(response: Response): Promise<GlossaryTermDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlossaryTermDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlossaryTermDto>(null as any);
    }
}

export class FinancialSummaryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getFinancialSummary(companyId: number | null | undefined, year: number | null | undefined): Promise<FinancialSummaryVm> {
        let url_ = this.baseUrl + "/api/financial-summary?";
        if (companyId !== undefined && companyId !== null)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFinancialSummary(_response);
        });
    }

    protected processGetFinancialSummary(response: Response): Promise<FinancialSummaryVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialSummaryVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialSummaryVm>(null as any);
    }
}

export class FinancialDashboardClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getWorksDashboard(clientId: number | null | undefined, workStatus: string | null | undefined, financialStatus: FinancialStatus2 | null | undefined, hasPendingValidation: boolean | null | undefined, onlyCritical: boolean | null | undefined, fromDate: Date | null | undefined, toDate: Date | null | undefined): Promise<FinancialDashboardWorksDto> {
        let url_ = this.baseUrl + "/api/financial-dashboard/works?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (workStatus !== undefined && workStatus !== null)
            url_ += "workStatus=" + encodeURIComponent("" + workStatus) + "&";
        if (financialStatus !== undefined && financialStatus !== null)
            url_ += "financialStatus=" + encodeURIComponent("" + financialStatus) + "&";
        if (hasPendingValidation !== undefined && hasPendingValidation !== null)
            url_ += "hasPendingValidation=" + encodeURIComponent("" + hasPendingValidation) + "&";
        if (onlyCritical !== undefined && onlyCritical !== null)
            url_ += "onlyCritical=" + encodeURIComponent("" + onlyCritical) + "&";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "toDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorksDashboard(_response);
        });
    }

    protected processGetWorksDashboard(response: Response): Promise<FinancialDashboardWorksDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialDashboardWorksDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialDashboardWorksDto>(null as any);
    }

    getBillingDashboard(topN: number | null | undefined): Promise<BillingDashboardDto> {
        let url_ = this.baseUrl + "/api/financial-dashboard/billing?";
        if (topN !== undefined && topN !== null)
            url_ += "topN=" + encodeURIComponent("" + topN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBillingDashboard(_response);
        });
    }

    protected processGetBillingDashboard(response: Response): Promise<BillingDashboardDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingDashboardDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BillingDashboardDto>(null as any);
    }

    getTaxReconciliation(granularity: string | null | undefined, year: number | null | undefined, includeUnvalidated: boolean | null | undefined): Promise<TaxReconciliationDto> {
        let url_ = this.baseUrl + "/api/financial-dashboard/tax-reconciliation?";
        if (granularity !== undefined && granularity !== null)
            url_ += "granularity=" + encodeURIComponent("" + granularity) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (includeUnvalidated !== undefined && includeUnvalidated !== null)
            url_ += "includeUnvalidated=" + encodeURIComponent("" + includeUnvalidated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaxReconciliation(_response);
        });
    }

    protected processGetTaxReconciliation(response: Response): Promise<TaxReconciliationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaxReconciliationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaxReconciliationDto>(null as any);
    }

    exportTaxReconciliation(format: string, granularity: string | null | undefined, year: number | null | undefined, includeUnvalidated: boolean | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/financial-dashboard/tax-reconciliation/export/{format}?";
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (granularity !== undefined && granularity !== null)
            url_ += "granularity=" + encodeURIComponent("" + granularity) + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (includeUnvalidated !== undefined && includeUnvalidated !== null)
            url_ += "includeUnvalidated=" + encodeURIComponent("" + includeUnvalidated) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportTaxReconciliation(_response);
        });
    }

    protected processExportTaxReconciliation(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class FinancialApprovalStatusesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    listFinancialApprovalStatuses(): Promise<FinancialApprovalStatusDto[]> {
        let url_ = this.baseUrl + "/api/financial-approval-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processListFinancialApprovalStatuses(_response);
        });
    }

    protected processListFinancialApprovalStatuses(response: Response): Promise<FinancialApprovalStatusDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FinancialApprovalStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialApprovalStatusDto[]>(null as any);
    }

    createFinancialApprovalStatus(command: CreateFinancialApprovalStatusCommand): Promise<FinancialApprovalStatusDto> {
        let url_ = this.baseUrl + "/api/financial-approval-statuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateFinancialApprovalStatus(_response);
        });
    }

    protected processCreateFinancialApprovalStatus(response: Response): Promise<FinancialApprovalStatusDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialApprovalStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialApprovalStatusDto>(null as any);
    }

    updateFinancialApprovalStatus(id: number, command: UpdateFinancialApprovalStatusCommand): Promise<FinancialApprovalStatusDto> {
        let url_ = this.baseUrl + "/api/financial-approval-statuses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateFinancialApprovalStatus(_response);
        });
    }

    protected processUpdateFinancialApprovalStatus(response: Response): Promise<FinancialApprovalStatusDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FinancialApprovalStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinancialApprovalStatusDto>(null as any);
    }

    deleteFinancialApprovalStatus(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/financial-approval-statuses/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFinancialApprovalStatus(_response);
        });
    }

    protected processDeleteFinancialApprovalStatus(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ExpenseCategoriesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getExpenseCategories(): Promise<ExpenseCategoryDto[]> {
        let url_ = this.baseUrl + "/api/expense-categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpenseCategories(_response);
        });
    }

    protected processGetExpenseCategories(response: Response): Promise<ExpenseCategoryDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpenseCategoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseCategoryDto[]>(null as any);
    }

    createExpenseCategory(command: CreateExpenseCategoryCommand): Promise<ExpenseCategoryDto> {
        let url_ = this.baseUrl + "/api/expense-categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateExpenseCategory(_response);
        });
    }

    protected processCreateExpenseCategory(response: Response): Promise<ExpenseCategoryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseCategoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseCategoryDto>(null as any);
    }

    updateExpenseCategory(id: number, command: UpdateExpenseCategoryCommand): Promise<ExpenseCategoryDto> {
        let url_ = this.baseUrl + "/api/expense-categories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateExpenseCategory(_response);
        });
    }

    protected processUpdateExpenseCategory(response: Response): Promise<ExpenseCategoryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpenseCategoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseCategoryDto>(null as any);
    }

    deleteExpenseCategory(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/expense-categories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteExpenseCategory(_response);
        });
    }

    protected processDeleteExpenseCategory(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DocumentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getDocuments(ownerType: string, ownerId: number, section: string | null | undefined, search: string | null | undefined): Promise<EntityDocumentDto[]> {
        let url_ = this.baseUrl + "/api/documents?";
        if (ownerType === undefined || ownerType === null)
            throw new globalThis.Error("The parameter 'ownerType' must be defined and cannot be null.");
        else
            url_ += "ownerType=" + encodeURIComponent("" + ownerType) + "&";
        if (ownerId === undefined || ownerId === null)
            throw new globalThis.Error("The parameter 'ownerId' must be defined and cannot be null.");
        else
            url_ += "ownerId=" + encodeURIComponent("" + ownerId) + "&";
        if (section !== undefined && section !== null)
            url_ += "section=" + encodeURIComponent("" + section) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: Response): Promise<EntityDocumentDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityDocumentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDocumentDto[]>(null as any);
    }

    uploadDocument(ownerType: string, ownerId: number, section: string, title: string, category: string | null | undefined, counterpartyName: string | null | undefined, reference: string | null | undefined, documentDate: Date | null | undefined, notes: string | null | undefined, file: FileParameter | null | undefined): Promise<EntityDocumentDto> {
        let url_ = this.baseUrl + "/api/documents?";
        if (ownerType === undefined || ownerType === null)
            throw new globalThis.Error("The parameter 'ownerType' must be defined and cannot be null.");
        else
            url_ += "ownerType=" + encodeURIComponent("" + ownerType) + "&";
        if (ownerId === undefined || ownerId === null)
            throw new globalThis.Error("The parameter 'ownerId' must be defined and cannot be null.");
        else
            url_ += "ownerId=" + encodeURIComponent("" + ownerId) + "&";
        if (section === undefined || section === null)
            throw new globalThis.Error("The parameter 'section' must be defined and cannot be null.");
        else
            url_ += "section=" + encodeURIComponent("" + section) + "&";
        if (title === undefined || title === null)
            throw new globalThis.Error("The parameter 'title' must be defined and cannot be null.");
        else
            url_ += "title=" + encodeURIComponent("" + title) + "&";
        if (category !== undefined && category !== null)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (counterpartyName !== undefined && counterpartyName !== null)
            url_ += "counterpartyName=" + encodeURIComponent("" + counterpartyName) + "&";
        if (reference !== undefined && reference !== null)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&";
        if (documentDate !== undefined && documentDate !== null)
            url_ += "documentDate=" + encodeURIComponent(documentDate ? "" + documentDate.toISOString() : "") + "&";
        if (notes !== undefined && notes !== null)
            url_ += "notes=" + encodeURIComponent("" + notes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadDocument(_response);
        });
    }

    protected processUploadDocument(response: Response): Promise<EntityDocumentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDocumentDto>(null as any);
    }

    downloadDocument(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/documents/{id}/file";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadDocument(_response);
        });
    }

    protected processDownloadDocument(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateDocument(id: number, command: UpdateEntityDocumentCommand): Promise<EntityDocumentDto> {
        let url_ = this.baseUrl + "/api/documents/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDocument(_response);
        });
    }

    protected processUpdateDocument(response: Response): Promise<EntityDocumentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityDocumentDto>(null as any);
    }

    deleteDocument(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/documents/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDocument(_response);
        });
    }

    protected processDeleteDocument(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConfirmingPaymentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPlafond(): Promise<ConfirmingPlafondVm> {
        let url_ = this.baseUrl + "/api/confirming-payments/plafond";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPlafond(_response);
        });
    }

    protected processGetPlafond(response: Response): Promise<ConfirmingPlafondVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmingPlafondVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmingPlafondVm>(null as any);
    }

    getBanks(): Promise<ConfirmingBankDto[]> {
        let url_ = this.baseUrl + "/api/confirming-payments/banks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBanks(_response);
        });
    }

    protected processGetBanks(response: Response): Promise<ConfirmingBankDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfirmingBankDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmingBankDto[]>(null as any);
    }

    saveBanks(command: SaveConfirmingBanksCommand): Promise<ConfirmingBankDto[]> {
        let url_ = this.baseUrl + "/api/confirming-payments/banks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBanks(_response);
        });
    }

    protected processSaveBanks(response: Response): Promise<ConfirmingBankDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfirmingBankDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmingBankDto[]>(null as any);
    }

    getHistoryBySupplier(): Promise<SupplierConfirmingHistoryDto[]> {
        let url_ = this.baseUrl + "/api/confirming-payments/history-by-supplier";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHistoryBySupplier(_response);
        });
    }

    protected processGetHistoryBySupplier(response: Response): Promise<SupplierConfirmingHistoryDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierConfirmingHistoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SupplierConfirmingHistoryDto[]>(null as any);
    }

    getEligibleInvoices(): Promise<EligibleSupplierInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/confirming-payments/eligible-invoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEligibleInvoices(_response);
        });
    }

    protected processGetEligibleInvoices(response: Response): Promise<EligibleSupplierInvoiceDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EligibleSupplierInvoiceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EligibleSupplierInvoiceDto[]>(null as any);
    }

    readNotices(file: FileParameter | null | undefined): Promise<ConfirmingNoticeProposalDto> {
        let url_ = this.baseUrl + "/api/confirming-payments/read-notices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReadNotices(_response);
        });
    }

    protected processReadNotices(response: Response): Promise<ConfirmingNoticeProposalDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmingNoticeProposalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmingNoticeProposalDto>(null as any);
    }

    getConfirmingPayments(workId: number | null | undefined, supplierId: number | null | undefined, statusCode: string | null | undefined): Promise<ConfirmingPaymentDto[]> {
        let url_ = this.baseUrl + "/api/confirming-payments?";
        if (workId !== undefined && workId !== null)
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        if (supplierId !== undefined && supplierId !== null)
            url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (statusCode !== undefined && statusCode !== null)
            url_ += "statusCode=" + encodeURIComponent("" + statusCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetConfirmingPayments(_response);
        });
    }

    protected processGetConfirmingPayments(response: Response): Promise<ConfirmingPaymentDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConfirmingPaymentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmingPaymentDto[]>(null as any);
    }

    createConfirmingPayment(command: CreateConfirmingPaymentCommand): Promise<ConfirmingPaymentDto> {
        let url_ = this.baseUrl + "/api/confirming-payments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateConfirmingPayment(_response);
        });
    }

    protected processCreateConfirmingPayment(response: Response): Promise<ConfirmingPaymentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmingPaymentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmingPaymentDto>(null as any);
    }

    updateStatus(id: number, command: UpdateConfirmingPaymentStatusCommand): Promise<ConfirmingPaymentDto> {
        let url_ = this.baseUrl + "/api/confirming-payments/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateStatus(_response);
        });
    }

    protected processUpdateStatus(response: Response): Promise<ConfirmingPaymentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmingPaymentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmingPaymentDto>(null as any);
    }

    updateDetails(id: number, command: UpdateConfirmingPaymentDetailsCommand): Promise<ConfirmingPaymentDto> {
        let url_ = this.baseUrl + "/api/confirming-payments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDetails(_response);
        });
    }

    protected processUpdateDetails(response: Response): Promise<ConfirmingPaymentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmingPaymentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmingPaymentDto>(null as any);
    }

    deleteConfirmingPayment(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/confirming-payments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteConfirmingPayment(_response);
        });
    }

    protected processDeleteConfirmingPayment(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CompaniesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCompanies(): Promise<CompanyDto[]> {
        let url_ = this.baseUrl + "/api/companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCompanies(_response);
        });
    }

    protected processGetCompanies(response: Response): Promise<CompanyDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CompanyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDto[]>(null as any);
    }

    createCompany(command: CreateCompanyCommand): Promise<CompanyDto> {
        let url_ = this.baseUrl + "/api/companies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCompany(_response);
        });
    }

    protected processCreateCompany(response: Response): Promise<CompanyDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDto>(null as any);
    }

    updateCompany(id: number, command: UpdateCompanyCommand): Promise<CompanyDto> {
        let url_ = this.baseUrl + "/api/companies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateCompany(_response);
        });
    }

    protected processUpdateCompany(response: Response): Promise<CompanyDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompanyDto>(null as any);
    }

    deleteCompany(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/companies/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteCompany(_response);
        });
    }

    protected processDeleteCompany(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CommentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getComments(contextType: string, contextId: number): Promise<CommentDto[]> {
        let url_ = this.baseUrl + "/api/comments?";
        if (contextType === undefined || contextType === null)
            throw new globalThis.Error("The parameter 'contextType' must be defined and cannot be null.");
        else
            url_ += "contextType=" + encodeURIComponent("" + contextType) + "&";
        if (contextId === undefined || contextId === null)
            throw new globalThis.Error("The parameter 'contextId' must be defined and cannot be null.");
        else
            url_ += "contextId=" + encodeURIComponent("" + contextId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetComments(_response);
        });
    }

    protected processGetComments(response: Response): Promise<CommentDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommentDto[]>(null as any);
    }

    createComment(command: CreateCommentCommand): Promise<CommentDto> {
        let url_ = this.baseUrl + "/api/comments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateComment(_response);
        });
    }

    protected processCreateComment(response: Response): Promise<CommentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommentDto>(null as any);
    }

    updateComment(id: number, command: UpdateCommentCommand): Promise<CommentDto> {
        let url_ = this.baseUrl + "/api/comments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateComment(_response);
        });
    }

    protected processUpdateComment(response: Response): Promise<CommentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommentDto>(null as any);
    }

    deleteComment(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/comments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteComment(_response);
        });
    }

    protected processDeleteComment(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    uploadCommentAttachment(attachment: FileParameter | null | undefined): Promise<CommentAttachmentDto> {
        let url_ = this.baseUrl + "/api/comments/attachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (attachment !== null && attachment !== undefined)
            content_.append("attachment", attachment.data, attachment.fileName ? attachment.fileName : "attachment");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadCommentAttachment(_response);
        });
    }

    protected processUploadCommentAttachment(response: Response): Promise<CommentAttachmentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommentAttachmentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommentAttachmentDto>(null as any);
    }

    downloadCommentAttachment(commentId: number, attachmentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/comments/{commentId}/attachments/{attachmentId}/download";
        if (commentId === undefined || commentId === null)
            throw new globalThis.Error("The parameter 'commentId' must be defined.");
        url_ = url_.replace("{commentId}", encodeURIComponent("" + commentId));
        if (attachmentId === undefined || attachmentId === null)
            throw new globalThis.Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadCommentAttachment(_response);
        });
    }

    protected processDownloadCommentAttachment(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CollectionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCollectionDashboard(clientId: number | null | undefined, stage: string | null | undefined, overdueOnly: boolean | null | undefined, asOf: Date | null | undefined): Promise<CollectionDashboardDto> {
        let url_ = this.baseUrl + "/api/collections/dashboard?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (stage !== undefined && stage !== null)
            url_ += "stage=" + encodeURIComponent("" + stage) + "&";
        if (overdueOnly !== undefined && overdueOnly !== null)
            url_ += "overdueOnly=" + encodeURIComponent("" + overdueOnly) + "&";
        if (asOf !== undefined && asOf !== null)
            url_ += "asOf=" + encodeURIComponent(asOf ? "" + asOf.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCollectionDashboard(_response);
        });
    }

    protected processGetCollectionDashboard(response: Response): Promise<CollectionDashboardDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionDashboardDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollectionDashboardDto>(null as any);
    }

    getCollectionActivities(clientId: number | null | undefined, clientInvoiceId: number | null | undefined): Promise<CollectionActivityDto[]> {
        let url_ = this.baseUrl + "/api/collections/activities?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (clientInvoiceId !== undefined && clientInvoiceId !== null)
            url_ += "clientInvoiceId=" + encodeURIComponent("" + clientInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCollectionActivities(_response);
        });
    }

    protected processGetCollectionActivities(response: Response): Promise<CollectionActivityDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CollectionActivityDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollectionActivityDto[]>(null as any);
    }

    logCollectionActivity(command: LogCollectionActivityCommand): Promise<CollectionActivityDto> {
        let url_ = this.baseUrl + "/api/collections/activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogCollectionActivity(_response);
        });
    }

    protected processLogCollectionActivity(response: Response): Promise<CollectionActivityDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollectionActivityDto>(null as any);
    }

    previewCollectionEmail(clientInvoiceId: number, stage: string | null | undefined): Promise<CollectionEmailDto> {
        let url_ = this.baseUrl + "/api/collections/email-preview?";
        if (clientInvoiceId === undefined || clientInvoiceId === null)
            throw new globalThis.Error("The parameter 'clientInvoiceId' must be defined and cannot be null.");
        else
            url_ += "clientInvoiceId=" + encodeURIComponent("" + clientInvoiceId) + "&";
        if (stage !== undefined && stage !== null)
            url_ += "stage=" + encodeURIComponent("" + stage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPreviewCollectionEmail(_response);
        });
    }

    protected processPreviewCollectionEmail(response: Response): Promise<CollectionEmailDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionEmailDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollectionEmailDto>(null as any);
    }

    sendCollectionEmail(command: SendCollectionEmailCommand): Promise<CollectionActivityDto> {
        let url_ = this.baseUrl + "/api/collections/send-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendCollectionEmail(_response);
        });
    }

    protected processSendCollectionEmail(response: Response): Promise<CollectionActivityDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CollectionActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollectionActivityDto>(null as any);
    }
}

export class ClientsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getClients(): Promise<ClientDto[]> {
        let url_ = this.baseUrl + "/api/clients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClients(_response);
        });
    }

    protected processGetClients(response: Response): Promise<ClientDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto[]>(null as any);
    }

    createClient(command: CreateClientCommand): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/clients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateClient(_response);
        });
    }

    protected processCreateClient(response: Response): Promise<ClientDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto>(null as any);
    }

    getClientOptions(term: string | null | undefined, take: number | null | undefined): Promise<LookupOptionDto[]> {
        let url_ = this.baseUrl + "/api/clients/options?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientOptions(_response);
        });
    }

    protected processGetClientOptions(response: Response): Promise<LookupOptionDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupOptionDto[]>(null as any);
    }

    getClientById(id: number): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/clients/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientById(_response);
        });
    }

    protected processGetClientById(response: Response): Promise<ClientDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto>(null as any);
    }

    updateClient(id: number, command: UpdateClientCommand): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/clients/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateClient(_response);
        });
    }

    protected processUpdateClient(response: Response): Promise<ClientDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto>(null as any);
    }

    uploadClientLogo(id: number, logo: FileParameter | null | undefined): Promise<ClientLogoDto> {
        let url_ = this.baseUrl + "/api/clients/{id}/logo";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (logo !== null && logo !== undefined)
            content_.append("logo", logo.data, logo.fileName ? logo.fileName : "logo");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadClientLogo(_response);
        });
    }

    protected processUploadClientLogo(response: Response): Promise<ClientLogoDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientLogoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientLogoDto>(null as any);
    }

    getClientAccount(id: number): Promise<ClientAccountDto> {
        let url_ = this.baseUrl + "/api/clients/{id}/account";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientAccount(_response);
        });
    }

    protected processGetClientAccount(response: Response): Promise<ClientAccountDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientAccountDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientAccountDto>(null as any);
    }

    saveClientAccount(id: number, command: SaveClientAccountCommand): Promise<ClientAccountDto> {
        let url_ = this.baseUrl + "/api/clients/{id}/account";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveClientAccount(_response);
        });
    }

    protected processSaveClientAccount(response: Response): Promise<ClientAccountDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientAccountDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientAccountDto>(null as any);
    }

    getClientRisk(id: number): Promise<ClientRiskDto> {
        let url_ = this.baseUrl + "/api/clients/{id}/risk";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientRisk(_response);
        });
    }

    protected processGetClientRisk(response: Response): Promise<ClientRiskDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientRiskDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientRiskDto>(null as any);
    }
}

export class ClientInvoicesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getClientInvoices(clientId: number | null | undefined, workId: number | null | undefined, status: string | null | undefined, kind: string | null | undefined, open: boolean | null | undefined): Promise<ClientInvoiceDto[]> {
        let url_ = this.baseUrl + "/api/client-invoices?";
        if (clientId !== undefined && clientId !== null)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        if (workId !== undefined && workId !== null)
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (kind !== undefined && kind !== null)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&";
        if (open !== undefined && open !== null)
            url_ += "open=" + encodeURIComponent("" + open) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientInvoices(_response);
        });
    }

    protected processGetClientInvoices(response: Response): Promise<ClientInvoiceDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientInvoiceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientInvoiceDto[]>(null as any);
    }

    createClientInvoice(command: CreateClientInvoiceCommand): Promise<ClientInvoiceDto> {
        let url_ = this.baseUrl + "/api/client-invoices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateClientInvoice(_response);
        });
    }

    protected processCreateClientInvoice(response: Response): Promise<ClientInvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientInvoiceDto>(null as any);
    }

    getClientInvoiceStatuses(): Promise<ClientInvoiceStatusDto[]> {
        let url_ = this.baseUrl + "/api/client-invoices/statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientInvoiceStatuses(_response);
        });
    }

    protected processGetClientInvoiceStatuses(response: Response): Promise<ClientInvoiceStatusDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientInvoiceStatusDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientInvoiceStatusDto[]>(null as any);
    }

    getReceivablesAging(asOf: Date | null | undefined): Promise<ReceivablesAgingDto> {
        let url_ = this.baseUrl + "/api/client-invoices/aging?";
        if (asOf !== undefined && asOf !== null)
            url_ += "asOf=" + encodeURIComponent(asOf ? "" + asOf.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReceivablesAging(_response);
        });
    }

    protected processGetReceivablesAging(response: Response): Promise<ReceivablesAgingDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceivablesAgingDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReceivablesAgingDto>(null as any);
    }

    getClientInvoiceById(id: number): Promise<ClientInvoiceDto> {
        let url_ = this.baseUrl + "/api/client-invoices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetClientInvoiceById(_response);
        });
    }

    protected processGetClientInvoiceById(response: Response): Promise<ClientInvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientInvoiceDto>(null as any);
    }

    updateClientInvoice(id: number, command: UpdateClientInvoiceCommand): Promise<ClientInvoiceDto> {
        let url_ = this.baseUrl + "/api/client-invoices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateClientInvoice(_response);
        });
    }

    protected processUpdateClientInvoice(response: Response): Promise<ClientInvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientInvoiceDto>(null as any);
    }

    deleteClientInvoice(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/client-invoices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteClientInvoice(_response);
        });
    }

    protected processDeleteClientInvoice(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    registerClientInvoicePayment(id: number, command: RegisterClientInvoicePaymentCommand): Promise<ClientInvoiceDto> {
        let url_ = this.baseUrl + "/api/client-invoices/{id}/payment";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterClientInvoicePayment(_response);
        });
    }

    protected processRegisterClientInvoicePayment(response: Response): Promise<ClientInvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientInvoiceDto>(null as any);
    }

    changeClientInvoiceStatus(id: number, command: ChangeClientInvoiceStatusCommand): Promise<ClientInvoiceDto> {
        let url_ = this.baseUrl + "/api/client-invoices/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeClientInvoiceStatus(_response);
        });
    }

    protected processChangeClientInvoiceStatus(response: Response): Promise<ClientInvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientInvoiceDto>(null as any);
    }

    createCreditNote(id: number, command: CreateCreditNoteCommand): Promise<ClientInvoiceDto> {
        let url_ = this.baseUrl + "/api/client-invoices/{id}/credit-note";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateCreditNote(_response);
        });
    }

    protected processCreateCreditNote(response: Response): Promise<ClientInvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientInvoiceDto>(null as any);
    }

    migrateInvoiceToClientAccount(id: number, command: MigrateInvoiceToClientAccountCommand): Promise<ClientInvoiceDto> {
        let url_ = this.baseUrl + "/api/client-invoices/{id}/migrate-to-account";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMigrateInvoiceToClientAccount(_response);
        });
    }

    protected processMigrateInvoiceToClientAccount(response: Response): Promise<ClientInvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientInvoiceDto>(null as any);
    }
}

export class BudgetTemplatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBudgetTemplates(): Promise<BudgetTemplateDto[]> {
        let url_ = this.baseUrl + "/api/budget-templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBudgetTemplates(_response);
        });
    }

    protected processGetBudgetTemplates(response: Response): Promise<BudgetTemplateDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BudgetTemplateDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetTemplateDto[]>(null as any);
    }

    saveBudgetAsTemplate(budgetId: number, command: SaveBudgetAsTemplateCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/budget-templates/{budgetId}";
        if (budgetId === undefined || budgetId === null)
            throw new globalThis.Error("The parameter 'budgetId' must be defined.");
        url_ = url_.replace("{budgetId}", encodeURIComponent("" + budgetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveBudgetAsTemplate(_response);
        });
    }

    protected processSaveBudgetAsTemplate(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createBudgetFromTemplate(command: CreateBudgetFromTemplateCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/budget-templates/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBudgetFromTemplate(_response);
        });
    }

    protected processCreateBudgetFromTemplate(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteBudgetTemplate(templateId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/budget-templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new globalThis.Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBudgetTemplate(_response);
        });
    }

    protected processDeleteBudgetTemplate(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BudgetsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBudgets(): Promise<BudgetSummaryDto[]> {
        let url_ = this.baseUrl + "/api/budgets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBudgets(_response);
        });
    }

    protected processGetBudgets(response: Response): Promise<BudgetSummaryDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BudgetSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetSummaryDto[]>(null as any);
    }

    createBudget(command: CreateBudgetCommand): Promise<BudgetDto> {
        let url_ = this.baseUrl + "/api/budgets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBudget(_response);
        });
    }

    protected processCreateBudget(response: Response): Promise<BudgetDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDto>(null as any);
    }

    getBudgetById(id: number): Promise<BudgetDto> {
        let url_ = this.baseUrl + "/api/budgets/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBudgetById(_response);
        });
    }

    protected processGetBudgetById(response: Response): Promise<BudgetDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDto>(null as any);
    }

    updateBudget(id: number, command: UpdateBudgetCommand): Promise<BudgetDto> {
        let url_ = this.baseUrl + "/api/budgets/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBudget(_response);
        });
    }

    protected processUpdateBudget(response: Response): Promise<BudgetDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDto>(null as any);
    }

    getBudgetVersions(id: number): Promise<BudgetVersionDto[]> {
        let url_ = this.baseUrl + "/api/budgets/{id}/versions";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBudgetVersions(_response);
        });
    }

    protected processGetBudgetVersions(response: Response): Promise<BudgetVersionDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BudgetVersionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetVersionDto[]>(null as any);
    }

    createBudgetVersion(id: number, command: CreateBudgetVersionCommand): Promise<BudgetDto> {
        let url_ = this.baseUrl + "/api/budgets/{id}/versions";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBudgetVersion(_response);
        });
    }

    protected processCreateBudgetVersion(response: Response): Promise<BudgetDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDto>(null as any);
    }

    createBudgetFromWorkType(command: CreateBudgetFromWorkTypeCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/budgets/from-work-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBudgetFromWorkType(_response);
        });
    }

    protected processCreateBudgetFromWorkType(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateBudgetStatus(id: number, command: UpdateBudgetStatusCommand): Promise<BudgetDto> {
        let url_ = this.baseUrl + "/api/budgets/{id}/status";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBudgetStatus(_response);
        });
    }

    protected processUpdateBudgetStatus(response: Response): Promise<BudgetDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDto>(null as any);
    }

    createWorkFromBudget(id: number): Promise<WorkDto> {
        let url_ = this.baseUrl + "/api/budgets/{id}/work";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateWorkFromBudget(_response);
        });
    }

    protected processCreateWorkFromBudget(response: Response): Promise<WorkDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkDto>(null as any);
    }

    setActiveBudgetVersion(id: number): Promise<BudgetDto> {
        let url_ = this.baseUrl + "/api/budgets/{id}/versions/activate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetActiveBudgetVersion(_response);
        });
    }

    protected processSetActiveBudgetVersion(response: Response): Promise<BudgetDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDto>(null as any);
    }

    uploadBudgetDocument(id: number, document: FileParameter | null | undefined): Promise<BudgetDocumentDto> {
        let url_ = this.baseUrl + "/api/budgets/{id}/documents";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (document !== null && document !== undefined)
            content_.append("document", document.data, document.fileName ? document.fileName : "document");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUploadBudgetDocument(_response);
        });
    }

    protected processUploadBudgetDocument(response: Response): Promise<BudgetDocumentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDocumentDto>(null as any);
    }

    startBudgetQuantityImportJob(id: number, document: FileParameter | null | undefined): Promise<BudgetQuantityImportJobCreatedDto> {
        let url_ = this.baseUrl + "/api/budgets/{id}/imports/quantity-map";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (document !== null && document !== undefined)
            content_.append("document", document.data, document.fileName ? document.fileName : "document");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartBudgetQuantityImportJob(_response);
        });
    }

    protected processStartBudgetQuantityImportJob(response: Response): Promise<BudgetQuantityImportJobCreatedDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = BudgetQuantityImportJobCreatedDto.fromJS(resultData202);
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetQuantityImportJobCreatedDto>(null as any);
    }

    startBudgetQuantityImportJob2(id: number, document: FileParameter | null | undefined): Promise<BudgetQuantityImportJobCreatedDto> {
        let url_ = this.baseUrl + "/api/budgets/{id}/quantity-map/import";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (document !== null && document !== undefined)
            content_.append("document", document.data, document.fileName ? document.fileName : "document");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartBudgetQuantityImportJob2(_response);
        });
    }

    protected processStartBudgetQuantityImportJob2(response: Response): Promise<BudgetQuantityImportJobCreatedDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = BudgetQuantityImportJobCreatedDto.fromJS(resultData202);
            return result202;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetQuantityImportJobCreatedDto>(null as any);
    }

    getBudgetDocument(id: number, documentId: number): Promise<BudgetDocumentDto> {
        let url_ = this.baseUrl + "/api/budgets/{id}/documents/{documentId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBudgetDocument(_response);
        });
    }

    protected processGetBudgetDocument(response: Response): Promise<BudgetDocumentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDocumentDto>(null as any);
    }

    deleteBudgetDocument(id: number, documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/budgets/{id}/documents/{documentId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBudgetDocument(_response);
        });
    }

    protected processDeleteBudgetDocument(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    reprocessBudgetDocument(id: number, documentId: number): Promise<BudgetDocumentDto> {
        let url_ = this.baseUrl + "/api/budgets/{id}/documents/{documentId}/reprocess";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReprocessBudgetDocument(_response);
        });
    }

    protected processReprocessBudgetDocument(response: Response): Promise<BudgetDocumentDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetDocumentDto>(null as any);
    }

    downloadBudgetDocument(id: number, documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/budgets/{id}/documents/{documentId}/download";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadBudgetDocument(_response);
        });
    }

    protected processDownloadBudgetDocument(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    extractBudgetDocuments(id: number): Promise<ExtractBudgetDocumentsResult> {
        let url_ = this.baseUrl + "/api/budgets/{id}/extract";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExtractBudgetDocuments(_response);
        });
    }

    protected processExtractBudgetDocuments(response: Response): Promise<ExtractBudgetDocumentsResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExtractBudgetDocumentsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExtractBudgetDocumentsResult>(null as any);
    }

    markDocumentComplete(id: number, documentId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/budgets/{id}/documents/{documentId}/complete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (documentId === undefined || documentId === null)
            throw new globalThis.Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkDocumentComplete(_response);
        });
    }

    protected processMarkDocumentComplete(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getBudgetLineCostSuggestions(id: number, query: string, unit: string | null | undefined, limit: number | null | undefined): Promise<BudgetLineCostSuggestionDto[]> {
        let url_ = this.baseUrl + "/api/budgets/{id}/lines/suggestions?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (query === undefined || query === null)
            throw new globalThis.Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (unit !== undefined && unit !== null)
            url_ += "unit=" + encodeURIComponent("" + unit) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBudgetLineCostSuggestions(_response);
        });
    }

    protected processGetBudgetLineCostSuggestions(response: Response): Promise<BudgetLineCostSuggestionDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BudgetLineCostSuggestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetLineCostSuggestionDto[]>(null as any);
    }

    exportBudgetToExcel(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/budgets/{id}/export/excel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportBudgetToExcel(_response);
        });
    }

    protected processExportBudgetToExcel(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportBudgetToPdf(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/budgets/{id}/export/pdf";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportBudgetToPdf(_response);
        });
    }

    protected processExportBudgetToPdf(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BudgetChapterTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBudgetChapterTypes(): Promise<BudgetChapterTypeDto[]> {
        let url_ = this.baseUrl + "/api/budget-chapter-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBudgetChapterTypes(_response);
        });
    }

    protected processGetBudgetChapterTypes(response: Response): Promise<BudgetChapterTypeDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BudgetChapterTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetChapterTypeDto[]>(null as any);
    }

    createBudgetChapterType(command: CreateBudgetChapterTypeCommand): Promise<BudgetChapterTypeDto> {
        let url_ = this.baseUrl + "/api/budget-chapter-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBudgetChapterType(_response);
        });
    }

    protected processCreateBudgetChapterType(response: Response): Promise<BudgetChapterTypeDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetChapterTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetChapterTypeDto>(null as any);
    }

    updateBudgetChapterType(id: number, command: UpdateBudgetChapterTypeCommand): Promise<BudgetChapterTypeDto> {
        let url_ = this.baseUrl + "/api/budget-chapter-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBudgetChapterType(_response);
        });
    }

    protected processUpdateBudgetChapterType(response: Response): Promise<BudgetChapterTypeDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetChapterTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetChapterTypeDto>(null as any);
    }

    deleteBudgetChapterType(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/budget-chapter-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBudgetChapterType(_response);
        });
    }

    protected processDeleteBudgetChapterType(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class BudgetAreaTypesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBudgetAreaTypes(): Promise<BudgetAreaTypeDto[]> {
        let url_ = this.baseUrl + "/api/budget-area-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBudgetAreaTypes(_response);
        });
    }

    protected processGetBudgetAreaTypes(response: Response): Promise<BudgetAreaTypeDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BudgetAreaTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetAreaTypeDto[]>(null as any);
    }

    createBudgetAreaType(command: CreateBudgetAreaTypeCommand): Promise<BudgetAreaTypeDto> {
        let url_ = this.baseUrl + "/api/budget-area-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBudgetAreaType(_response);
        });
    }

    protected processCreateBudgetAreaType(response: Response): Promise<BudgetAreaTypeDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetAreaTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetAreaTypeDto>(null as any);
    }

    updateBudgetAreaType(id: number, command: UpdateBudgetAreaTypeCommand): Promise<BudgetAreaTypeDto> {
        let url_ = this.baseUrl + "/api/budget-area-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBudgetAreaType(_response);
        });
    }

    protected processUpdateBudgetAreaType(response: Response): Promise<BudgetAreaTypeDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetAreaTypeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetAreaTypeDto>(null as any);
    }

    deleteBudgetAreaType(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/budget-area-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBudgetAreaType(_response);
        });
    }

    protected processDeleteBudgetAreaType(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class BillingmilestonesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBillingMilestones(workId: number | null | undefined): Promise<BillingMilestoneDto[]> {
        let url_ = this.baseUrl + "/api/billingmilestones?";
        if (workId !== undefined && workId !== null)
            url_ += "workId=" + encodeURIComponent("" + workId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBillingMilestones(_response);
        });
    }

    protected processGetBillingMilestones(response: Response): Promise<BillingMilestoneDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BillingMilestoneDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BillingMilestoneDto[]>(null as any);
    }

    createBillingMilestone(command: CreateBillingMilestoneCommand): Promise<BillingMilestoneDto> {
        let url_ = this.baseUrl + "/api/billingmilestones";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBillingMilestone(_response);
        });
    }

    protected processCreateBillingMilestone(response: Response): Promise<BillingMilestoneDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingMilestoneDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BillingMilestoneDto>(null as any);
    }

    getBillingMilestoneById(id: number): Promise<BillingMilestoneDto> {
        let url_ = this.baseUrl + "/api/billingmilestones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBillingMilestoneById(_response);
        });
    }

    protected processGetBillingMilestoneById(response: Response): Promise<BillingMilestoneDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingMilestoneDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BillingMilestoneDto>(null as any);
    }

    updateBillingMilestone(id: number, command: UpdateBillingMilestoneCommand): Promise<BillingMilestoneDto> {
        let url_ = this.baseUrl + "/api/billingmilestones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBillingMilestone(_response);
        });
    }

    protected processUpdateBillingMilestone(response: Response): Promise<BillingMilestoneDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillingMilestoneDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BillingMilestoneDto>(null as any);
    }

    deleteBillingMilestone(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/billingmilestones/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBillingMilestone(_response);
        });
    }

    protected processDeleteBillingMilestone(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    generateInvoiceFromMilestone(id: number): Promise<ClientInvoiceDto> {
        let url_ = this.baseUrl + "/api/billingmilestones/{id}/generate-invoice";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateInvoiceFromMilestone(_response);
        });
    }

    protected processGenerateInvoiceFromMilestone(response: Response): Promise<ClientInvoiceDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientInvoiceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientInvoiceDto>(null as any);
    }
}

export class BankReconciliationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSuggestions(bankMovementId: number, search: string | null | undefined, limit: number | null | undefined): Promise<SuggestionsVm> {
        let url_ = this.baseUrl + "/api/bank-reconciliations/suggestions?";
        if (bankMovementId === undefined || bankMovementId === null)
            throw new globalThis.Error("The parameter 'bankMovementId' must be defined and cannot be null.");
        else
            url_ += "bankMovementId=" + encodeURIComponent("" + bankMovementId) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSuggestions(_response);
        });
    }

    protected processGetSuggestions(response: Response): Promise<SuggestionsVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuggestionsVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SuggestionsVm>(null as any);
    }

    autoReconcile(): Promise<AutoReconcileBankMovementsResult> {
        let url_ = this.baseUrl + "/api/bank-reconciliations/auto";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAutoReconcile(_response);
        });
    }

    protected processAutoReconcile(response: Response): Promise<AutoReconcileBankMovementsResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutoReconcileBankMovementsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoReconcileBankMovementsResult>(null as any);
    }

    getBankReconciliations(bankMovementId: number): Promise<BankReconciliationDto[]> {
        let url_ = this.baseUrl + "/api/bank-reconciliations?";
        if (bankMovementId === undefined || bankMovementId === null)
            throw new globalThis.Error("The parameter 'bankMovementId' must be defined and cannot be null.");
        else
            url_ += "bankMovementId=" + encodeURIComponent("" + bankMovementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankReconciliations(_response);
        });
    }

    protected processGetBankReconciliations(response: Response): Promise<BankReconciliationDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankReconciliationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankReconciliationDto[]>(null as any);
    }

    createBankReconciliation(command: CreateBankReconciliationCommand): Promise<BankReconciliationDto> {
        let url_ = this.baseUrl + "/api/bank-reconciliations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBankReconciliation(_response);
        });
    }

    protected processCreateBankReconciliation(response: Response): Promise<BankReconciliationDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankReconciliationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankReconciliationDto>(null as any);
    }

    deleteBankReconciliation(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/bank-reconciliations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBankReconciliation(_response);
        });
    }

    protected processDeleteBankReconciliation(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BankMovementsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBankMovements(categoryId: number | null | undefined, onlyInternalTransfers: boolean | null | undefined, onlyBankCharges: boolean | null | undefined, from: Date | null | undefined, to: Date | null | undefined, accountLabel: string | null | undefined, bankAccountId: number | null | undefined, direction: string | null | undefined, search: string | null | undefined, pageNumber: number | null | undefined, pageSize: number | null | undefined): Promise<BankMovementListVm> {
        let url_ = this.baseUrl + "/api/bank-movements?";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (onlyInternalTransfers !== undefined && onlyInternalTransfers !== null)
            url_ += "onlyInternalTransfers=" + encodeURIComponent("" + onlyInternalTransfers) + "&";
        if (onlyBankCharges !== undefined && onlyBankCharges !== null)
            url_ += "onlyBankCharges=" + encodeURIComponent("" + onlyBankCharges) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (accountLabel !== undefined && accountLabel !== null)
            url_ += "accountLabel=" + encodeURIComponent("" + accountLabel) + "&";
        if (bankAccountId !== undefined && bankAccountId !== null)
            url_ += "bankAccountId=" + encodeURIComponent("" + bankAccountId) + "&";
        if (direction !== undefined && direction !== null)
            url_ += "direction=" + encodeURIComponent("" + direction) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (pageNumber !== undefined && pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize !== undefined && pageSize !== null)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankMovements(_response);
        });
    }

    protected processGetBankMovements(response: Response): Promise<BankMovementListVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankMovementListVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankMovementListVm>(null as any);
    }

    createBankMovement(command: CreateBankMovementCommand): Promise<BankMovementDto> {
        let url_ = this.baseUrl + "/api/bank-movements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateBankMovement(_response);
        });
    }

    protected processCreateBankMovement(response: Response): Promise<BankMovementDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankMovementDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankMovementDto>(null as any);
    }

    getBankMovementCategories(): Promise<BankMovementCategoryDto[]> {
        let url_ = this.baseUrl + "/api/bank-movements/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankMovementCategories(_response);
        });
    }

    protected processGetBankMovementCategories(response: Response): Promise<BankMovementCategoryDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankMovementCategoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankMovementCategoryDto[]>(null as any);
    }

    importBankMovements(accountLabel: string | null | undefined, file: FileParameter | null | undefined): Promise<ImportBankMovementsResult> {
        let url_ = this.baseUrl + "/api/bank-movements/import?";
        if (accountLabel !== undefined && accountLabel !== null)
            url_ += "accountLabel=" + encodeURIComponent("" + accountLabel) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processImportBankMovements(_response);
        });
    }

    protected processImportBankMovements(response: Response): Promise<ImportBankMovementsResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportBankMovementsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportBankMovementsResult>(null as any);
    }

    recategorizeBankMovements(): Promise<RecategorizeBankMovementsResult> {
        let url_ = this.baseUrl + "/api/bank-movements/recategorize";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecategorizeBankMovements(_response);
        });
    }

    protected processRecategorizeBankMovements(response: Response): Promise<RecategorizeBankMovementsResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecategorizeBankMovementsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecategorizeBankMovementsResult>(null as any);
    }

    updateBankMovement(id: number, command: UpdateBankMovementCommand): Promise<BankMovementDto> {
        let url_ = this.baseUrl + "/api/bank-movements/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBankMovement(_response);
        });
    }

    protected processUpdateBankMovement(response: Response): Promise<BankMovementDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankMovementDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankMovementDto>(null as any);
    }

    deleteBankMovement(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/bank-movements/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBankMovement(_response);
        });
    }

    protected processDeleteBankMovement(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    categorizeBankMovement(id: number, command: CategorizeBankMovementCommand): Promise<BankMovementEntityResult> {
        let url_ = this.baseUrl + "/api/bank-movements/{id}/categorize";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategorizeBankMovement(_response);
        });
    }

    protected processCategorizeBankMovement(response: Response): Promise<BankMovementEntityResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankMovementEntityResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankMovementEntityResult>(null as any);
    }

    matchBankMovementSupplier(id: number, command: MatchBankMovementSupplierCommand): Promise<BankMovementEntityResult> {
        let url_ = this.baseUrl + "/api/bank-movements/{id}/supplier";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMatchBankMovementSupplier(_response);
        });
    }

    protected processMatchBankMovementSupplier(response: Response): Promise<BankMovementEntityResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankMovementEntityResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankMovementEntityResult>(null as any);
    }

    createSupplierFromBankMovement(id: number, command: CreateSupplierFromBankMovementCommand): Promise<BankMovementEntityResult> {
        let url_ = this.baseUrl + "/api/bank-movements/{id}/supplier/create";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSupplierFromBankMovement(_response);
        });
    }

    protected processCreateSupplierFromBankMovement(response: Response): Promise<BankMovementEntityResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankMovementEntityResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankMovementEntityResult>(null as any);
    }

    matchBankMovementClient(id: number, command: MatchBankMovementClientCommand): Promise<BankMovementEntityResult> {
        let url_ = this.baseUrl + "/api/bank-movements/{id}/client";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMatchBankMovementClient(_response);
        });
    }

    protected processMatchBankMovementClient(response: Response): Promise<BankMovementEntityResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankMovementEntityResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankMovementEntityResult>(null as any);
    }

    setBankMovementReconciliationExclusion(id: number, command: SetBankMovementReconciliationExclusionCommand): Promise<BankMovementDto> {
        let url_ = this.baseUrl + "/api/bank-movements/{id}/reconciliation-exclusion";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetBankMovementReconciliationExclusion(_response);
        });
    }

    protected processSetBankMovementReconciliationExclusion(response: Response): Promise<BankMovementDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankMovementDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankMovementDto>(null as any);
    }

    createClientFromBankMovement(id: number, command: CreateClientFromBankMovementCommand): Promise<BankMovementEntityResult> {
        let url_ = this.baseUrl + "/api/bank-movements/{id}/client/create";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateClientFromBankMovement(_response);
        });
    }

    protected processCreateClientFromBankMovement(response: Response): Promise<BankMovementEntityResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankMovementEntityResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankMovementEntityResult>(null as any);
    }

    recognizeBankMovementSuppliers(): Promise<RecognizeBankMovementSuppliersResult> {
        let url_ = this.baseUrl + "/api/bank-movements/recognize-suppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecognizeBankMovementSuppliers(_response);
        });
    }

    protected processRecognizeBankMovementSuppliers(response: Response): Promise<RecognizeBankMovementSuppliersResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecognizeBankMovementSuppliersResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecognizeBankMovementSuppliersResult>(null as any);
    }

    resolveBankMovementEntities(): Promise<BankMovementEntityResolution> {
        let url_ = this.baseUrl + "/api/bank-movements/resolve-entities";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResolveBankMovementEntities(_response);
        });
    }

    protected processResolveBankMovementEntities(response: Response): Promise<BankMovementEntityResolution> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankMovementEntityResolution.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankMovementEntityResolution>(null as any);
    }
}

export class BankAccountsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getBankSyncRuns(limit: number | null | undefined): Promise<BankSyncRunDto[]> {
        let url_ = this.baseUrl + "/api/bank-accounts/sync-runs?";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankSyncRuns(_response);
        });
    }

    protected processGetBankSyncRuns(response: Response): Promise<BankSyncRunDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankSyncRunDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankSyncRunDto[]>(null as any);
    }

    syncBankMovements(command: SyncBankMovementsCommand): Promise<SyncBankMovementsResult> {
        let url_ = this.baseUrl + "/api/bank-accounts/sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSyncBankMovements(_response);
        });
    }

    protected processSyncBankMovements(response: Response): Promise<SyncBankMovementsResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SyncBankMovementsResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SyncBankMovementsResult>(null as any);
    }

    getBankAccounts(): Promise<BankAccountDto[]> {
        let url_ = this.baseUrl + "/api/bank-accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBankAccounts(_response);
        });
    }

    protected processGetBankAccounts(response: Response): Promise<BankAccountDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankAccountDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankAccountDto[]>(null as any);
    }

    updateBankAccount(id: number, command: UpdateBankAccountCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/bank-accounts/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBankAccount(_response);
        });
    }

    protected processUpdateBankAccount(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    login(request: AuthLoginRequest): Promise<AuthLoginResponse> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<AuthLoginResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthLoginResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthLoginResponse>(null as any);
    }

    logout(request: AuthLogoutRequest): Promise<AuthLogoutResponse> {
        let url_ = this.baseUrl + "/api/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<AuthLogoutResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthLogoutResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthLogoutResponse>(null as any);
    }

    me2(): Promise<AuthMeResponse> {
        let url_ = this.baseUrl + "/api/auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMe2(_response);
        });
    }

    protected processMe2(response: Response): Promise<AuthMeResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthMeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthMeResponse>(null as any);
    }

    forgotPassword(request: AuthForgotPasswordRequest): Promise<AuthForgotPasswordResponse> {
        let url_ = this.baseUrl + "/api/auth/forgot-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<AuthForgotPasswordResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthForgotPasswordResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthForgotPasswordResponse>(null as any);
    }

    resetPassword(request: AuthResetPasswordRequest): Promise<AuthResetPasswordResponse> {
        let url_ = this.baseUrl + "/api/auth/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<AuthResetPasswordResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResetPasswordResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResetPasswordResponse>(null as any);
    }
}

export class AuditlogsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAuditLogs(take: number | null | undefined): Promise<AuditLogDto[]> {
        let url_ = this.baseUrl + "/api/auditlogs?";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuditLogs(_response);
        });
    }

    protected processGetAuditLogs(response: Response): Promise<AuditLogDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuditLogDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditLogDto[]>(null as any);
    }
}

export class ArticlesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getArticles(): Promise<ArticleDto[]> {
        let url_ = this.baseUrl + "/api/articles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArticles(_response);
        });
    }

    protected processGetArticles(response: Response): Promise<ArticleDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleDto[]>(null as any);
    }

    createArticle(command: CreateArticleCommand): Promise<ArticleDto> {
        let url_ = this.baseUrl + "/api/articles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateArticle(_response);
        });
    }

    protected processCreateArticle(response: Response): Promise<ArticleDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleDto>(null as any);
    }

    getArticleClassifications(): Promise<ArticleClassificationDto[]> {
        let url_ = this.baseUrl + "/api/articles/classifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArticleClassifications(_response);
        });
    }

    protected processGetArticleClassifications(response: Response): Promise<ArticleClassificationDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleClassificationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleClassificationDto[]>(null as any);
    }

    getArticleOptions(term: string | null | undefined, take: number | null | undefined): Promise<LookupOptionDto[]> {
        let url_ = this.baseUrl + "/api/articles/options?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArticleOptions(_response);
        });
    }

    protected processGetArticleOptions(response: Response): Promise<LookupOptionDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LookupOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LookupOptionDto[]>(null as any);
    }

    getArticleById(id: number): Promise<ArticleDto> {
        let url_ = this.baseUrl + "/api/articles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArticleById(_response);
        });
    }

    protected processGetArticleById(response: Response): Promise<ArticleDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleDto>(null as any);
    }

    updateArticle(id: number, command: UpdateArticleCommand): Promise<ArticleDto> {
        let url_ = this.baseUrl + "/api/articles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateArticle(_response);
        });
    }

    protected processUpdateArticle(response: Response): Promise<ArticleDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleDto>(null as any);
    }

    deleteArticle(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/articles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteArticle(_response);
        });
    }

    protected processDeleteArticle(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class ArticlecategoriesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getArticleCategories(): Promise<ArticleCategoryDto[]> {
        let url_ = this.baseUrl + "/api/articlecategories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArticleCategories(_response);
        });
    }

    protected processGetArticleCategories(response: Response): Promise<ArticleCategoryDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArticleCategoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleCategoryDto[]>(null as any);
    }

    createArticleCategory(command: CreateArticleCategoryCommand): Promise<ArticleCategoryDto> {
        let url_ = this.baseUrl + "/api/articlecategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateArticleCategory(_response);
        });
    }

    protected processCreateArticleCategory(response: Response): Promise<ArticleCategoryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleCategoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleCategoryDto>(null as any);
    }

    getArticleCategoryById(id: number): Promise<ArticleCategoryDto> {
        let url_ = this.baseUrl + "/api/articlecategories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetArticleCategoryById(_response);
        });
    }

    protected processGetArticleCategoryById(response: Response): Promise<ArticleCategoryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleCategoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleCategoryDto>(null as any);
    }

    updateArticleCategory(id: number, command: UpdateArticleCategoryCommand): Promise<ArticleCategoryDto> {
        let url_ = this.baseUrl + "/api/articlecategories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateArticleCategory(_response);
        });
    }

    protected processUpdateArticleCategory(response: Response): Promise<ArticleCategoryDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArticleCategoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArticleCategoryDto>(null as any);
    }

    deleteArticleCategory(id: number): Promise<any> {
        let url_ = this.baseUrl + "/api/articlecategories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteArticleCategory(_response);
        });
    }

    protected processDeleteArticleCategory(response: Response): Promise<any> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class AppClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getVersion(): Promise<AppVersionResponse> {
        let url_ = this.baseUrl + "/api/app/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersion(_response);
        });
    }

    protected processGetVersion(response: Response): Promise<AppVersionResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppVersionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppVersionResponse>(null as any);
    }
}

export class AiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    runChat(command: RunAiChatCommand): Promise<AiChatResponse> {
        let url_ = this.baseUrl + "/api/ai/chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunChat(_response);
        });
    }

    protected processRunChat(response: Response): Promise<AiChatResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiChatResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiChatResponse>(null as any);
    }

    runChatStream(command: RunAiChatStreamCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/ai/chat-stream";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunChatStream(_response);
        });
    }

    protected processRunChatStream(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    runChatWithMemory(command: RunAiChatWithMemoryCommand): Promise<AiChatMemoryResponse> {
        let url_ = this.baseUrl + "/api/ai/chat-memory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunChatWithMemory(_response);
        });
    }

    protected processRunChatWithMemory(response: Response): Promise<AiChatMemoryResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiChatMemoryResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiChatMemoryResponse>(null as any);
    }

    runMultiAgent(command: RunAiMultiAgentCommand): Promise<AiMultiAgentResponse> {
        let url_ = this.baseUrl + "/api/ai/multi-agent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunMultiAgent(_response);
        });
    }

    protected processRunMultiAgent(response: Response): Promise<AiMultiAgentResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiMultiAgentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiMultiAgentResponse>(null as any);
    }

    runToolCall(command: RunAiToolCallCommand): Promise<AiToolCallResponse> {
        let url_ = this.baseUrl + "/api/ai/tools";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunToolCall(_response);
        });
    }

    protected processRunToolCall(response: Response): Promise<AiToolCallResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiToolCallResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiToolCallResponse>(null as any);
    }

    runRag(command: RunAiRagCommand): Promise<AiRagResponse> {
        let url_ = this.baseUrl + "/api/ai/rag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunRag(_response);
        });
    }

    protected processRunRag(response: Response): Promise<AiRagResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiRagResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiRagResponse>(null as any);
    }

    runWorkflow(command: RunAiWorkflowCommand): Promise<AiWorkflowResponse> {
        let url_ = this.baseUrl + "/api/ai/workflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunWorkflow(_response);
        });
    }

    protected processRunWorkflow(response: Response): Promise<AiWorkflowResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiWorkflowResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiWorkflowResponse>(null as any);
    }

    runExtraction(command: RunAiExtractionCommand): Promise<AiExtractionResponse> {
        let url_ = this.baseUrl + "/api/ai/extract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunExtraction(_response);
        });
    }

    protected processRunExtraction(response: Response): Promise<AiExtractionResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AiExtractionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AiExtractionResponse>(null as any);
    }

    runHelpChat(command: RunHelpChatCommand): Promise<HelpChatResponse> {
        let url_ = this.baseUrl + "/api/ai/help/chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunHelpChat(_response);
        });
    }

    protected processRunHelpChat(response: Response): Promise<HelpChatResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelpChatResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HelpChatResponse>(null as any);
    }

    reindexBudgetLines(): Promise<ReindexBudgetLinesResult> {
        let url_ = this.baseUrl + "/api/ai/budgets/reindex";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReindexBudgetLines(_response);
        });
    }

    protected processReindexBudgetLines(response: Response): Promise<ReindexBudgetLinesResult> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReindexBudgetLinesResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReindexBudgetLinesResult>(null as any);
    }

    getBudgetLineSuggestionSettings(): Promise<BudgetLineSuggestionSettingsDto> {
        let url_ = this.baseUrl + "/api/ai/budgets/suggestions/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBudgetLineSuggestionSettings(_response);
        });
    }

    protected processGetBudgetLineSuggestionSettings(response: Response): Promise<BudgetLineSuggestionSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetLineSuggestionSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetLineSuggestionSettingsDto>(null as any);
    }

    updateBudgetLineSuggestionSettings(command: UpdateBudgetLineSuggestionSettingsCommand): Promise<BudgetLineSuggestionSettingsDto> {
        let url_ = this.baseUrl + "/api/ai/budgets/suggestions/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateBudgetLineSuggestionSettings(_response);
        });
    }

    protected processUpdateBudgetLineSuggestionSettings(response: Response): Promise<BudgetLineSuggestionSettingsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BudgetLineSuggestionSettingsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BudgetLineSuggestionSettingsDto>(null as any);
    }
}

export class AccessControlClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAccessControl(): Promise<AccessControlVm> {
        let url_ = this.baseUrl + "/api/access-control";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccessControl(_response);
        });
    }

    protected processGetAccessControl(response: Response): Promise<AccessControlVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessControlVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessControlVm>(null as any);
    }

    createRole(request: CreateRoleRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/access-control/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateRole(_response);
        });
    }

    protected processCreateRole(response: Response): Promise<string> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    renameRole(roleId: string, request: RenameRoleRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/access-control/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenameRole(_response);
        });
    }

    protected processRenameRole(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteRole(roleId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/access-control/roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteRole(_response);
        });
    }

    protected processDeleteRole(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setRoleFeatures(roleId: string, request: SetRoleFeaturesRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/access-control/roles/{roleId}/features";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetRoleFeatures(_response);
        });
    }

    protected processSetRoleFeatures(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class WorkTypeDto implements IWorkTypeDto {
    id?: number;
    name?: string;
    sortOrder?: number;
    templateLineCount?: number;

    constructor(data?: IWorkTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.templateLineCount = _data["templateLineCount"];
        }
    }

    static fromJS(data: any): WorkTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["templateLineCount"] = this.templateLineCount;
        return data;
    }
}

export interface IWorkTypeDto {
    id?: number;
    name?: string;
    sortOrder?: number;
    templateLineCount?: number;
}

export class WorkTypeDetailDto implements IWorkTypeDetailDto {
    id?: number;
    name?: string;
    sortOrder?: number;
    templateLines?: WorkTypeTemplateLineDto[];

    constructor(data?: IWorkTypeDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["templateLines"])) {
                this.templateLines = [] as any;
                for (let item of _data["templateLines"])
                    this.templateLines!.push(WorkTypeTemplateLineDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkTypeDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTypeDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.templateLines)) {
            data["templateLines"] = [];
            for (let item of this.templateLines)
                data["templateLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkTypeDetailDto {
    id?: number;
    name?: string;
    sortOrder?: number;
    templateLines?: WorkTypeTemplateLineDto[];
}

export class WorkTypeTemplateLineDto implements IWorkTypeTemplateLineDto {
    id?: number;
    areaName?: string;
    areaSortOrder?: number;
    chapterName?: string;
    chapterSortOrder?: number;
    sortOrder?: number;
    articleId?: number | undefined;
    code?: string;
    description?: string;
    unit?: string;
    quantity?: number;
    quantityPerArea?: boolean;
    unitPrice?: number;
    marginPercent?: number | undefined;

    constructor(data?: IWorkTypeTemplateLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.areaName = _data["areaName"];
            this.areaSortOrder = _data["areaSortOrder"];
            this.chapterName = _data["chapterName"];
            this.chapterSortOrder = _data["chapterSortOrder"];
            this.sortOrder = _data["sortOrder"];
            this.articleId = _data["articleId"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.quantityPerArea = _data["quantityPerArea"];
            this.unitPrice = _data["unitPrice"];
            this.marginPercent = _data["marginPercent"];
        }
    }

    static fromJS(data: any): WorkTypeTemplateLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTypeTemplateLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["areaName"] = this.areaName;
        data["areaSortOrder"] = this.areaSortOrder;
        data["chapterName"] = this.chapterName;
        data["chapterSortOrder"] = this.chapterSortOrder;
        data["sortOrder"] = this.sortOrder;
        data["articleId"] = this.articleId;
        data["code"] = this.code;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["quantityPerArea"] = this.quantityPerArea;
        data["unitPrice"] = this.unitPrice;
        data["marginPercent"] = this.marginPercent;
        return data;
    }
}

export interface IWorkTypeTemplateLineDto {
    id?: number;
    areaName?: string;
    areaSortOrder?: number;
    chapterName?: string;
    chapterSortOrder?: number;
    sortOrder?: number;
    articleId?: number | undefined;
    code?: string;
    description?: string;
    unit?: string;
    quantity?: number;
    quantityPerArea?: boolean;
    unitPrice?: number;
    marginPercent?: number | undefined;
}

export class CreateWorkTypeCommand implements ICreateWorkTypeCommand {
    name?: string;
    sortOrder?: number | undefined;

    constructor(data?: ICreateWorkTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreateWorkTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICreateWorkTypeCommand {
    name?: string;
    sortOrder?: number | undefined;
}

export class UpdateWorkTypeCommand implements IUpdateWorkTypeCommand {
    id?: number;
    name?: string;
    sortOrder?: number;

    constructor(data?: IUpdateWorkTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UpdateWorkTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUpdateWorkTypeCommand {
    id?: number;
    name?: string;
    sortOrder?: number;
}

export class SaveWorkTypeTemplateCommand implements ISaveWorkTypeTemplateCommand {
    workTypeId?: number;
    lines?: WorkTypeTemplateLineInput[];

    constructor(data?: ISaveWorkTypeTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workTypeId = _data["workTypeId"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(WorkTypeTemplateLineInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveWorkTypeTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkTypeTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workTypeId"] = this.workTypeId;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveWorkTypeTemplateCommand {
    workTypeId?: number;
    lines?: WorkTypeTemplateLineInput[];
}

export class WorkTypeTemplateLineInput implements IWorkTypeTemplateLineInput {
    areaName?: string;
    chapterName?: string;
    articleId?: number | undefined;
    code?: string;
    description?: string;
    unit?: string;
    quantity?: number;
    quantityPerArea?: boolean;
    unitPrice?: number;
    marginPercent?: number | undefined;

    constructor(data?: IWorkTypeTemplateLineInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaName = _data["areaName"];
            this.chapterName = _data["chapterName"];
            this.articleId = _data["articleId"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.quantityPerArea = _data["quantityPerArea"];
            this.unitPrice = _data["unitPrice"];
            this.marginPercent = _data["marginPercent"];
        }
    }

    static fromJS(data: any): WorkTypeTemplateLineInput {
        data = typeof data === 'object' ? data : {};
        let result = new WorkTypeTemplateLineInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["chapterName"] = this.chapterName;
        data["articleId"] = this.articleId;
        data["code"] = this.code;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["quantityPerArea"] = this.quantityPerArea;
        data["unitPrice"] = this.unitPrice;
        data["marginPercent"] = this.marginPercent;
        return data;
    }
}

export interface IWorkTypeTemplateLineInput {
    areaName?: string;
    chapterName?: string;
    articleId?: number | undefined;
    code?: string;
    description?: string;
    unit?: string;
    quantity?: number;
    quantityPerArea?: boolean;
    unitPrice?: number;
    marginPercent?: number | undefined;
}

export class WorkDto implements IWorkDto {
    id?: number;
    code?: string;
    name?: string;
    location?: string | undefined;
    clientId?: number;
    clientName?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    progressPercent?: number | undefined;
    totalValue?: number | undefined;
    spentValue?: number | undefined;
    workStatusId?: number;
    statusCode?: string;
    statusName?: string;
    budgetId?: number | undefined;
    budgetReference?: string | undefined;
    vatRate?: number;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.location = _data["location"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.progressPercent = _data["progressPercent"];
            this.totalValue = _data["totalValue"];
            this.spentValue = _data["spentValue"];
            this.workStatusId = _data["workStatusId"];
            this.statusCode = _data["statusCode"];
            this.statusName = _data["statusName"];
            this.budgetId = _data["budgetId"];
            this.budgetReference = _data["budgetReference"];
            this.vatRate = _data["vatRate"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["location"] = this.location;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["progressPercent"] = this.progressPercent;
        data["totalValue"] = this.totalValue;
        data["spentValue"] = this.spentValue;
        data["workStatusId"] = this.workStatusId;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        data["budgetId"] = this.budgetId;
        data["budgetReference"] = this.budgetReference;
        data["vatRate"] = this.vatRate;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkDto {
    id?: number;
    code?: string;
    name?: string;
    location?: string | undefined;
    clientId?: number;
    clientName?: string;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    progressPercent?: number | undefined;
    totalValue?: number | undefined;
    spentValue?: number | undefined;
    workStatusId?: number;
    statusCode?: string;
    statusName?: string;
    budgetId?: number | undefined;
    budgetReference?: string | undefined;
    vatRate?: number;
    created?: Date;
    lastModified?: Date;
}

export class CreateWorkCommand implements ICreateWorkCommand {
    name?: string;
    clientId?: number;
    location?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalValue?: number | undefined;
    vatRate?: number;

    constructor(data?: ICreateWorkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            this.location = _data["location"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.totalValue = _data["totalValue"];
            this.vatRate = _data["vatRate"];
        }
    }

    static fromJS(data: any): CreateWorkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        data["location"] = this.location;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["totalValue"] = this.totalValue;
        data["vatRate"] = this.vatRate;
        return data;
    }
}

export interface ICreateWorkCommand {
    name?: string;
    clientId?: number;
    location?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    totalValue?: number | undefined;
    vatRate?: number;
}

export class WorkOptionDto implements IWorkOptionDto {
    id?: number;
    code?: string;
    name?: string;

    constructor(data?: IWorkOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WorkOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IWorkOptionDto {
    id?: number;
    code?: string;
    name?: string;
}

export class WorkStatusDto implements IWorkStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;

    constructor(data?: IWorkStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): WorkStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IWorkStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
}

export class WorkItemStatusDto implements IWorkItemStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;

    constructor(data?: IWorkItemStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): WorkItemStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkItemStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IWorkItemStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
}

export class FinancialApprovalStatusDto implements IFinancialApprovalStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;

    constructor(data?: IFinancialApprovalStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): FinancialApprovalStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialApprovalStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IFinancialApprovalStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
}

export class WorkCostMapDto implements IWorkCostMapDto {
    workId?: number;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    deviation?: number;
    deviationPercent?: number | undefined;
    margin?: number;
    marginPercent?: number | undefined;
    overrunThresholdPercent?: number;
    overrunChapterCount?: number;
    unmappedActualCost?: number;
    areas?: CostMapAreaDto[];

    constructor(data?: IWorkCostMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.sell = _data["sell"];
            this.budgetedCost = _data["budgetedCost"];
            this.actualCost = _data["actualCost"];
            this.deviation = _data["deviation"];
            this.deviationPercent = _data["deviationPercent"];
            this.margin = _data["margin"];
            this.marginPercent = _data["marginPercent"];
            this.overrunThresholdPercent = _data["overrunThresholdPercent"];
            this.overrunChapterCount = _data["overrunChapterCount"];
            this.unmappedActualCost = _data["unmappedActualCost"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(CostMapAreaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkCostMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkCostMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["sell"] = this.sell;
        data["budgetedCost"] = this.budgetedCost;
        data["actualCost"] = this.actualCost;
        data["deviation"] = this.deviation;
        data["deviationPercent"] = this.deviationPercent;
        data["margin"] = this.margin;
        data["marginPercent"] = this.marginPercent;
        data["overrunThresholdPercent"] = this.overrunThresholdPercent;
        data["overrunChapterCount"] = this.overrunChapterCount;
        data["unmappedActualCost"] = this.unmappedActualCost;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkCostMapDto {
    workId?: number;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    deviation?: number;
    deviationPercent?: number | undefined;
    margin?: number;
    marginPercent?: number | undefined;
    overrunThresholdPercent?: number;
    overrunChapterCount?: number;
    unmappedActualCost?: number;
    areas?: CostMapAreaDto[];
}

export class CostMapAreaDto implements ICostMapAreaDto {
    name?: string;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    deviation?: number;
    deviationPercent?: number | undefined;
    margin?: number;
    marginPercent?: number | undefined;
    chapters?: CostMapChapterDto[];

    constructor(data?: ICostMapAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sell = _data["sell"];
            this.budgetedCost = _data["budgetedCost"];
            this.actualCost = _data["actualCost"];
            this.deviation = _data["deviation"];
            this.deviationPercent = _data["deviationPercent"];
            this.margin = _data["margin"];
            this.marginPercent = _data["marginPercent"];
            if (Array.isArray(_data["chapters"])) {
                this.chapters = [] as any;
                for (let item of _data["chapters"])
                    this.chapters!.push(CostMapChapterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostMapAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostMapAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sell"] = this.sell;
        data["budgetedCost"] = this.budgetedCost;
        data["actualCost"] = this.actualCost;
        data["deviation"] = this.deviation;
        data["deviationPercent"] = this.deviationPercent;
        data["margin"] = this.margin;
        data["marginPercent"] = this.marginPercent;
        if (Array.isArray(this.chapters)) {
            data["chapters"] = [];
            for (let item of this.chapters)
                data["chapters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICostMapAreaDto {
    name?: string;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    deviation?: number;
    deviationPercent?: number | undefined;
    margin?: number;
    marginPercent?: number | undefined;
    chapters?: CostMapChapterDto[];
}

export class CostMapChapterDto implements ICostMapChapterDto {
    name?: string;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    deviation?: number;
    deviationPercent?: number | undefined;
    margin?: number;
    marginPercent?: number | undefined;
    hasBudgetedCost?: boolean;
    articles?: CostMapArticleDto[];

    constructor(data?: ICostMapChapterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sell = _data["sell"];
            this.budgetedCost = _data["budgetedCost"];
            this.actualCost = _data["actualCost"];
            this.deviation = _data["deviation"];
            this.deviationPercent = _data["deviationPercent"];
            this.margin = _data["margin"];
            this.marginPercent = _data["marginPercent"];
            this.hasBudgetedCost = _data["hasBudgetedCost"];
            if (Array.isArray(_data["articles"])) {
                this.articles = [] as any;
                for (let item of _data["articles"])
                    this.articles!.push(CostMapArticleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostMapChapterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostMapChapterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sell"] = this.sell;
        data["budgetedCost"] = this.budgetedCost;
        data["actualCost"] = this.actualCost;
        data["deviation"] = this.deviation;
        data["deviationPercent"] = this.deviationPercent;
        data["margin"] = this.margin;
        data["marginPercent"] = this.marginPercent;
        data["hasBudgetedCost"] = this.hasBudgetedCost;
        if (Array.isArray(this.articles)) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICostMapChapterDto {
    name?: string;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    deviation?: number;
    deviationPercent?: number | undefined;
    margin?: number;
    marginPercent?: number | undefined;
    hasBudgetedCost?: boolean;
    articles?: CostMapArticleDto[];
}

export class CostMapArticleDto implements ICostMapArticleDto {
    code?: string;
    description?: string;
    unit?: string;
    quantity?: number;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    deviation?: number;
    deviationPercent?: number | undefined;
    margin?: number;
    marginPercent?: number | undefined;
    hasBudgetedCost?: boolean;

    constructor(data?: ICostMapArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.sell = _data["sell"];
            this.budgetedCost = _data["budgetedCost"];
            this.actualCost = _data["actualCost"];
            this.deviation = _data["deviation"];
            this.deviationPercent = _data["deviationPercent"];
            this.margin = _data["margin"];
            this.marginPercent = _data["marginPercent"];
            this.hasBudgetedCost = _data["hasBudgetedCost"];
        }
    }

    static fromJS(data: any): CostMapArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostMapArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["sell"] = this.sell;
        data["budgetedCost"] = this.budgetedCost;
        data["actualCost"] = this.actualCost;
        data["deviation"] = this.deviation;
        data["deviationPercent"] = this.deviationPercent;
        data["margin"] = this.margin;
        data["marginPercent"] = this.marginPercent;
        data["hasBudgetedCost"] = this.hasBudgetedCost;
        return data;
    }
}

export interface ICostMapArticleDto {
    code?: string;
    description?: string;
    unit?: string;
    quantity?: number;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    deviation?: number;
    deviationPercent?: number | undefined;
    margin?: number;
    marginPercent?: number | undefined;
    hasBudgetedCost?: boolean;
}

export class WorkPostMortemDto implements IWorkPostMortemDto {
    workId?: number;
    workName?: string;
    statusCode?: string;
    statusName?: string;
    isClosed?: boolean;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    plannedMargin?: number;
    plannedMarginPercent?: number | undefined;
    actualMargin?: number;
    actualMarginPercent?: number | undefined;
    marginVariance?: number;
    startDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    plannedDurationDays?: number | undefined;
    actualDurationDays?: number | undefined;
    scheduleVarianceDays?: number | undefined;
    closureNotes?: string | undefined;
    warrantyMonths?: number | undefined;
    warrantyEndDate?: Date | undefined;
    isUnderWarranty?: boolean;

    constructor(data?: IWorkPostMortemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.statusCode = _data["statusCode"];
            this.statusName = _data["statusName"];
            this.isClosed = _data["isClosed"];
            this.sell = _data["sell"];
            this.budgetedCost = _data["budgetedCost"];
            this.actualCost = _data["actualCost"];
            this.plannedMargin = _data["plannedMargin"];
            this.plannedMarginPercent = _data["plannedMarginPercent"];
            this.actualMargin = _data["actualMargin"];
            this.actualMarginPercent = _data["actualMarginPercent"];
            this.marginVariance = _data["marginVariance"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.plannedDurationDays = _data["plannedDurationDays"];
            this.actualDurationDays = _data["actualDurationDays"];
            this.scheduleVarianceDays = _data["scheduleVarianceDays"];
            this.closureNotes = _data["closureNotes"];
            this.warrantyMonths = _data["warrantyMonths"];
            this.warrantyEndDate = _data["warrantyEndDate"] ? new Date(_data["warrantyEndDate"].toString()) : undefined as any;
            this.isUnderWarranty = _data["isUnderWarranty"];
        }
    }

    static fromJS(data: any): WorkPostMortemDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkPostMortemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        data["isClosed"] = this.isClosed;
        data["sell"] = this.sell;
        data["budgetedCost"] = this.budgetedCost;
        data["actualCost"] = this.actualCost;
        data["plannedMargin"] = this.plannedMargin;
        data["plannedMarginPercent"] = this.plannedMarginPercent;
        data["actualMargin"] = this.actualMargin;
        data["actualMarginPercent"] = this.actualMarginPercent;
        data["marginVariance"] = this.marginVariance;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["plannedDurationDays"] = this.plannedDurationDays;
        data["actualDurationDays"] = this.actualDurationDays;
        data["scheduleVarianceDays"] = this.scheduleVarianceDays;
        data["closureNotes"] = this.closureNotes;
        data["warrantyMonths"] = this.warrantyMonths;
        data["warrantyEndDate"] = this.warrantyEndDate ? this.warrantyEndDate.toISOString() : undefined as any;
        data["isUnderWarranty"] = this.isUnderWarranty;
        return data;
    }
}

export interface IWorkPostMortemDto {
    workId?: number;
    workName?: string;
    statusCode?: string;
    statusName?: string;
    isClosed?: boolean;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    plannedMargin?: number;
    plannedMarginPercent?: number | undefined;
    actualMargin?: number;
    actualMarginPercent?: number | undefined;
    marginVariance?: number;
    startDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    plannedDurationDays?: number | undefined;
    actualDurationDays?: number | undefined;
    scheduleVarianceDays?: number | undefined;
    closureNotes?: string | undefined;
    warrantyMonths?: number | undefined;
    warrantyEndDate?: Date | undefined;
    isUnderWarranty?: boolean;
}

export class WorkFinalMapDto implements IWorkFinalMapDto {
    workId?: number;
    workName?: string;
    statusCode?: string;
    statusName?: string;
    isClosed?: boolean;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    plannedMargin?: number;
    plannedMarginPercent?: number | undefined;
    actualMargin?: number;
    actualMarginPercent?: number | undefined;
    marginVariance?: number;
    startDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    plannedDurationDays?: number | undefined;
    actualDurationDays?: number | undefined;
    scheduleVarianceDays?: number | undefined;
    closureNotes?: string | undefined;
    warrantyMonths?: number | undefined;
    warrantyEndDate?: Date | undefined;
    isUnderWarranty?: boolean;
    approvedAdditions?: number;
    approvedReductions?: number;
    revisedSell?: number;
    revisedMargin?: number;
    revisedMarginPercent?: number | undefined;
    variations?: WorkVariationDto[];

    constructor(data?: IWorkFinalMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.statusCode = _data["statusCode"];
            this.statusName = _data["statusName"];
            this.isClosed = _data["isClosed"];
            this.sell = _data["sell"];
            this.budgetedCost = _data["budgetedCost"];
            this.actualCost = _data["actualCost"];
            this.plannedMargin = _data["plannedMargin"];
            this.plannedMarginPercent = _data["plannedMarginPercent"];
            this.actualMargin = _data["actualMargin"];
            this.actualMarginPercent = _data["actualMarginPercent"];
            this.marginVariance = _data["marginVariance"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.actualEndDate = _data["actualEndDate"] ? new Date(_data["actualEndDate"].toString()) : undefined as any;
            this.plannedDurationDays = _data["plannedDurationDays"];
            this.actualDurationDays = _data["actualDurationDays"];
            this.scheduleVarianceDays = _data["scheduleVarianceDays"];
            this.closureNotes = _data["closureNotes"];
            this.warrantyMonths = _data["warrantyMonths"];
            this.warrantyEndDate = _data["warrantyEndDate"] ? new Date(_data["warrantyEndDate"].toString()) : undefined as any;
            this.isUnderWarranty = _data["isUnderWarranty"];
            this.approvedAdditions = _data["approvedAdditions"];
            this.approvedReductions = _data["approvedReductions"];
            this.revisedSell = _data["revisedSell"];
            this.revisedMargin = _data["revisedMargin"];
            this.revisedMarginPercent = _data["revisedMarginPercent"];
            if (Array.isArray(_data["variations"])) {
                this.variations = [] as any;
                for (let item of _data["variations"])
                    this.variations!.push(WorkVariationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkFinalMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFinalMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        data["isClosed"] = this.isClosed;
        data["sell"] = this.sell;
        data["budgetedCost"] = this.budgetedCost;
        data["actualCost"] = this.actualCost;
        data["plannedMargin"] = this.plannedMargin;
        data["plannedMarginPercent"] = this.plannedMarginPercent;
        data["actualMargin"] = this.actualMargin;
        data["actualMarginPercent"] = this.actualMarginPercent;
        data["marginVariance"] = this.marginVariance;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["actualEndDate"] = this.actualEndDate ? this.actualEndDate.toISOString() : undefined as any;
        data["plannedDurationDays"] = this.plannedDurationDays;
        data["actualDurationDays"] = this.actualDurationDays;
        data["scheduleVarianceDays"] = this.scheduleVarianceDays;
        data["closureNotes"] = this.closureNotes;
        data["warrantyMonths"] = this.warrantyMonths;
        data["warrantyEndDate"] = this.warrantyEndDate ? this.warrantyEndDate.toISOString() : undefined as any;
        data["isUnderWarranty"] = this.isUnderWarranty;
        data["approvedAdditions"] = this.approvedAdditions;
        data["approvedReductions"] = this.approvedReductions;
        data["revisedSell"] = this.revisedSell;
        data["revisedMargin"] = this.revisedMargin;
        data["revisedMarginPercent"] = this.revisedMarginPercent;
        if (Array.isArray(this.variations)) {
            data["variations"] = [];
            for (let item of this.variations)
                data["variations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkFinalMapDto {
    workId?: number;
    workName?: string;
    statusCode?: string;
    statusName?: string;
    isClosed?: boolean;
    sell?: number;
    budgetedCost?: number;
    actualCost?: number;
    plannedMargin?: number;
    plannedMarginPercent?: number | undefined;
    actualMargin?: number;
    actualMarginPercent?: number | undefined;
    marginVariance?: number;
    startDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    actualEndDate?: Date | undefined;
    plannedDurationDays?: number | undefined;
    actualDurationDays?: number | undefined;
    scheduleVarianceDays?: number | undefined;
    closureNotes?: string | undefined;
    warrantyMonths?: number | undefined;
    warrantyEndDate?: Date | undefined;
    isUnderWarranty?: boolean;
    approvedAdditions?: number;
    approvedReductions?: number;
    revisedSell?: number;
    revisedMargin?: number;
    revisedMarginPercent?: number | undefined;
    variations?: WorkVariationDto[];
}

export class WorkVariationDto implements IWorkVariationDto {
    id?: number;
    workId?: number;
    number?: string;
    description?: string;
    kind?: string;
    amount?: number;
    signedAmount?: number;
    status?: string;
    approvedAt?: Date | undefined;
    approvedByUserId?: string | undefined;
    rejectionReason?: string | undefined;
    notes?: string | undefined;
    currencyCode?: string;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWorkVariationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.number = _data["number"];
            this.description = _data["description"];
            this.kind = _data["kind"];
            this.amount = _data["amount"];
            this.signedAmount = _data["signedAmount"];
            this.status = _data["status"];
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : undefined as any;
            this.approvedByUserId = _data["approvedByUserId"];
            this.rejectionReason = _data["rejectionReason"];
            this.notes = _data["notes"];
            this.currencyCode = _data["currencyCode"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkVariationDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkVariationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["number"] = this.number;
        data["description"] = this.description;
        data["kind"] = this.kind;
        data["amount"] = this.amount;
        data["signedAmount"] = this.signedAmount;
        data["status"] = this.status;
        data["approvedAt"] = this.approvedAt ? this.approvedAt.toISOString() : undefined as any;
        data["approvedByUserId"] = this.approvedByUserId;
        data["rejectionReason"] = this.rejectionReason;
        data["notes"] = this.notes;
        data["currencyCode"] = this.currencyCode;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkVariationDto {
    id?: number;
    workId?: number;
    number?: string;
    description?: string;
    kind?: string;
    amount?: number;
    signedAmount?: number;
    status?: string;
    approvedAt?: Date | undefined;
    approvedByUserId?: string | undefined;
    rejectionReason?: string | undefined;
    notes?: string | undefined;
    currencyCode?: string;
    created?: Date;
    lastModified?: Date;
}

export class SaveWorkClosureNotesCommand implements ISaveWorkClosureNotesCommand {
    workId?: number;
    notes?: string | undefined;

    constructor(data?: ISaveWorkClosureNotesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): SaveWorkClosureNotesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveWorkClosureNotesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ISaveWorkClosureNotesCommand {
    workId?: number;
    notes?: string | undefined;
}

export class CloseWorkCommand implements ICloseWorkCommand {
    workId?: number;
    warrantyMonthsOverride?: number | undefined;
    closureNotes?: string | undefined;

    constructor(data?: ICloseWorkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.warrantyMonthsOverride = _data["warrantyMonthsOverride"];
            this.closureNotes = _data["closureNotes"];
        }
    }

    static fromJS(data: any): CloseWorkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CloseWorkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["warrantyMonthsOverride"] = this.warrantyMonthsOverride;
        data["closureNotes"] = this.closureNotes;
        return data;
    }
}

export interface ICloseWorkCommand {
    workId?: number;
    warrantyMonthsOverride?: number | undefined;
    closureNotes?: string | undefined;
}

export class WorkBudgetChapterDto implements IWorkBudgetChapterDto {
    areaName?: string;
    chapterName?: string;

    constructor(data?: IWorkBudgetChapterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaName = _data["areaName"];
            this.chapterName = _data["chapterName"];
        }
    }

    static fromJS(data: any): WorkBudgetChapterDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkBudgetChapterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["chapterName"] = this.chapterName;
        return data;
    }
}

export interface IWorkBudgetChapterDto {
    areaName?: string;
    chapterName?: string;
}

export class UpdateWorkCommand implements IUpdateWorkCommand {
    id?: number;
    clientId?: number;
    name?: string;
    location?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    progressPercent?: number | undefined;
    totalValue?: number | undefined;
    spentValue?: number | undefined;
    workStatusId?: number;

    constructor(data?: IUpdateWorkCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.name = _data["name"];
            this.location = _data["location"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.progressPercent = _data["progressPercent"];
            this.totalValue = _data["totalValue"];
            this.spentValue = _data["spentValue"];
            this.workStatusId = _data["workStatusId"];
        }
    }

    static fromJS(data: any): UpdateWorkCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["name"] = this.name;
        data["location"] = this.location;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["progressPercent"] = this.progressPercent;
        data["totalValue"] = this.totalValue;
        data["spentValue"] = this.spentValue;
        data["workStatusId"] = this.workStatusId;
        return data;
    }
}

export interface IUpdateWorkCommand {
    id?: number;
    clientId?: number;
    name?: string;
    location?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    progressPercent?: number | undefined;
    totalValue?: number | undefined;
    spentValue?: number | undefined;
    workStatusId?: number;
}

export class WorkOrderItemDto implements IWorkOrderItemDto {
    id?: number;
    workId?: number;
    code?: string;
    type?: string | undefined;
    location?: string | undefined;
    description?: string;
    unit?: string;
    quantity?: number;
    wasteQuantity?: number;
    workItemStatusId?: number;
    statusCode?: string;
    statusName?: string;
    needDate?: Date | undefined;
    deliveryDate?: Date | undefined;
    deliveryWarehouseId?: number | undefined;
    deliveryWarehouseName?: string | undefined;
    receptionResponsible?: string | undefined;
    deliveryNotes?: string | undefined;
    unitPrice?: number;
    supplier?: string | undefined;
    deliveries?: WorkOrderItemDeliveryDto[];
    balance?: number;
    imputedCostId?: number | undefined;
    imputedAmount?: number | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWorkOrderItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.wasteQuantity = _data["wasteQuantity"];
            this.workItemStatusId = _data["workItemStatusId"];
            this.statusCode = _data["statusCode"];
            this.statusName = _data["statusName"];
            this.needDate = _data["needDate"] ? new Date(_data["needDate"].toString()) : undefined as any;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined as any;
            this.deliveryWarehouseId = _data["deliveryWarehouseId"];
            this.deliveryWarehouseName = _data["deliveryWarehouseName"];
            this.receptionResponsible = _data["receptionResponsible"];
            this.deliveryNotes = _data["deliveryNotes"];
            this.unitPrice = _data["unitPrice"];
            this.supplier = _data["supplier"];
            if (Array.isArray(_data["deliveries"])) {
                this.deliveries = [] as any;
                for (let item of _data["deliveries"])
                    this.deliveries!.push(WorkOrderItemDeliveryDto.fromJS(item));
            }
            this.balance = _data["balance"];
            this.imputedCostId = _data["imputedCostId"];
            this.imputedAmount = _data["imputedAmount"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkOrderItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["code"] = this.code;
        data["type"] = this.type;
        data["location"] = this.location;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["wasteQuantity"] = this.wasteQuantity;
        data["workItemStatusId"] = this.workItemStatusId;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        data["needDate"] = this.needDate ? this.needDate.toISOString() : undefined as any;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined as any;
        data["deliveryWarehouseId"] = this.deliveryWarehouseId;
        data["deliveryWarehouseName"] = this.deliveryWarehouseName;
        data["receptionResponsible"] = this.receptionResponsible;
        data["deliveryNotes"] = this.deliveryNotes;
        data["unitPrice"] = this.unitPrice;
        data["supplier"] = this.supplier;
        if (Array.isArray(this.deliveries)) {
            data["deliveries"] = [];
            for (let item of this.deliveries)
                data["deliveries"].push(item ? item.toJSON() : undefined as any);
        }
        data["balance"] = this.balance;
        data["imputedCostId"] = this.imputedCostId;
        data["imputedAmount"] = this.imputedAmount;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkOrderItemDto {
    id?: number;
    workId?: number;
    code?: string;
    type?: string | undefined;
    location?: string | undefined;
    description?: string;
    unit?: string;
    quantity?: number;
    wasteQuantity?: number;
    workItemStatusId?: number;
    statusCode?: string;
    statusName?: string;
    needDate?: Date | undefined;
    deliveryDate?: Date | undefined;
    deliveryWarehouseId?: number | undefined;
    deliveryWarehouseName?: string | undefined;
    receptionResponsible?: string | undefined;
    deliveryNotes?: string | undefined;
    unitPrice?: number;
    supplier?: string | undefined;
    deliveries?: WorkOrderItemDeliveryDto[];
    balance?: number;
    imputedCostId?: number | undefined;
    imputedAmount?: number | undefined;
    created?: Date;
    lastModified?: Date;
}

export class WorkOrderItemDeliveryDto implements IWorkOrderItemDeliveryDto {
    id?: number;
    lote?: string | undefined;
    plannedDate?: Date | undefined;
    plannedQuantity?: number;
    deliveredQuantity?: number;
    notes?: string | undefined;
    created?: Date;

    constructor(data?: IWorkOrderItemDeliveryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lote = _data["lote"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.plannedQuantity = _data["plannedQuantity"];
            this.deliveredQuantity = _data["deliveredQuantity"];
            this.notes = _data["notes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkOrderItemDeliveryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderItemDeliveryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lote"] = this.lote;
        data["plannedDate"] = this.plannedDate ? this.plannedDate.toISOString() : undefined as any;
        data["plannedQuantity"] = this.plannedQuantity;
        data["deliveredQuantity"] = this.deliveredQuantity;
        data["notes"] = this.notes;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkOrderItemDeliveryDto {
    id?: number;
    lote?: string | undefined;
    plannedDate?: Date | undefined;
    plannedQuantity?: number;
    deliveredQuantity?: number;
    notes?: string | undefined;
    created?: Date;
}

export class UpdateWorkOrderCommand implements IUpdateWorkOrderCommand {
    workId?: number;
    orderId?: number;
    code?: string;
    type?: string | undefined;
    location?: string | undefined;
    description?: string;
    unit?: string;
    quantity?: number;
    wasteQuantity?: number;
    workItemStatusId?: number;
    needDate?: Date | undefined;
    deliveryDate?: Date | undefined;
    deliveryWarehouseId?: number | undefined;
    receptionResponsible?: string | undefined;
    deliveryNotes?: string | undefined;
    unitPrice?: number;
    supplier?: string | undefined;

    constructor(data?: IUpdateWorkOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.orderId = _data["orderId"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.wasteQuantity = _data["wasteQuantity"];
            this.workItemStatusId = _data["workItemStatusId"];
            this.needDate = _data["needDate"] ? new Date(_data["needDate"].toString()) : undefined as any;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined as any;
            this.deliveryWarehouseId = _data["deliveryWarehouseId"];
            this.receptionResponsible = _data["receptionResponsible"];
            this.deliveryNotes = _data["deliveryNotes"];
            this.unitPrice = _data["unitPrice"];
            this.supplier = _data["supplier"];
        }
    }

    static fromJS(data: any): UpdateWorkOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["orderId"] = this.orderId;
        data["code"] = this.code;
        data["type"] = this.type;
        data["location"] = this.location;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["wasteQuantity"] = this.wasteQuantity;
        data["workItemStatusId"] = this.workItemStatusId;
        data["needDate"] = this.needDate ? this.needDate.toISOString() : undefined as any;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined as any;
        data["deliveryWarehouseId"] = this.deliveryWarehouseId;
        data["receptionResponsible"] = this.receptionResponsible;
        data["deliveryNotes"] = this.deliveryNotes;
        data["unitPrice"] = this.unitPrice;
        data["supplier"] = this.supplier;
        return data;
    }
}

export interface IUpdateWorkOrderCommand {
    workId?: number;
    orderId?: number;
    code?: string;
    type?: string | undefined;
    location?: string | undefined;
    description?: string;
    unit?: string;
    quantity?: number;
    wasteQuantity?: number;
    workItemStatusId?: number;
    needDate?: Date | undefined;
    deliveryDate?: Date | undefined;
    deliveryWarehouseId?: number | undefined;
    receptionResponsible?: string | undefined;
    deliveryNotes?: string | undefined;
    unitPrice?: number;
    supplier?: string | undefined;
}

export class AddWorkOrderItemDeliveryCommand implements IAddWorkOrderItemDeliveryCommand {
    workId?: number;
    orderId?: number;
    lote?: string | undefined;
    plannedDate?: Date | undefined;
    plannedQuantity?: number;
    deliveredQuantity?: number;
    notes?: string | undefined;

    constructor(data?: IAddWorkOrderItemDeliveryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.orderId = _data["orderId"];
            this.lote = _data["lote"];
            this.plannedDate = _data["plannedDate"] ? new Date(_data["plannedDate"].toString()) : undefined as any;
            this.plannedQuantity = _data["plannedQuantity"];
            this.deliveredQuantity = _data["deliveredQuantity"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AddWorkOrderItemDeliveryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddWorkOrderItemDeliveryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["orderId"] = this.orderId;
        data["lote"] = this.lote;
        data["plannedDate"] = this.plannedDate ? this.plannedDate.toISOString() : undefined as any;
        data["plannedQuantity"] = this.plannedQuantity;
        data["deliveredQuantity"] = this.deliveredQuantity;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IAddWorkOrderItemDeliveryCommand {
    workId?: number;
    orderId?: number;
    lote?: string | undefined;
    plannedDate?: Date | undefined;
    plannedQuantity?: number;
    deliveredQuantity?: number;
    notes?: string | undefined;
}

export class WorkSubcontractorItemDto implements IWorkSubcontractorItemDto {
    id?: number;
    workId?: number;
    code?: string;
    type?: string | undefined;
    location?: string | undefined;
    description?: string;
    subcontractor?: string;
    value?: number;
    workItemStatusId?: number;
    statusCode?: string;
    statusName?: string;
    needDate?: Date | undefined;
    imputedCostId?: number | undefined;
    imputedAmount?: number | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWorkSubcontractorItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.description = _data["description"];
            this.subcontractor = _data["subcontractor"];
            this.value = _data["value"];
            this.workItemStatusId = _data["workItemStatusId"];
            this.statusCode = _data["statusCode"];
            this.statusName = _data["statusName"];
            this.needDate = _data["needDate"] ? new Date(_data["needDate"].toString()) : undefined as any;
            this.imputedCostId = _data["imputedCostId"];
            this.imputedAmount = _data["imputedAmount"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkSubcontractorItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkSubcontractorItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["code"] = this.code;
        data["type"] = this.type;
        data["location"] = this.location;
        data["description"] = this.description;
        data["subcontractor"] = this.subcontractor;
        data["value"] = this.value;
        data["workItemStatusId"] = this.workItemStatusId;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        data["needDate"] = this.needDate ? this.needDate.toISOString() : undefined as any;
        data["imputedCostId"] = this.imputedCostId;
        data["imputedAmount"] = this.imputedAmount;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkSubcontractorItemDto {
    id?: number;
    workId?: number;
    code?: string;
    type?: string | undefined;
    location?: string | undefined;
    description?: string;
    subcontractor?: string;
    value?: number;
    workItemStatusId?: number;
    statusCode?: string;
    statusName?: string;
    needDate?: Date | undefined;
    imputedCostId?: number | undefined;
    imputedAmount?: number | undefined;
    created?: Date;
    lastModified?: Date;
}

export class CreateWorkSubcontractorCommand implements ICreateWorkSubcontractorCommand {
    workId?: number;
    code?: string;
    type?: string | undefined;
    location?: string | undefined;
    description?: string;
    subcontractor?: string;
    value?: number;
    workItemStatusId?: number | undefined;
    needDate?: Date | undefined;

    constructor(data?: ICreateWorkSubcontractorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.description = _data["description"];
            this.subcontractor = _data["subcontractor"];
            this.value = _data["value"];
            this.workItemStatusId = _data["workItemStatusId"];
            this.needDate = _data["needDate"] ? new Date(_data["needDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateWorkSubcontractorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkSubcontractorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["code"] = this.code;
        data["type"] = this.type;
        data["location"] = this.location;
        data["description"] = this.description;
        data["subcontractor"] = this.subcontractor;
        data["value"] = this.value;
        data["workItemStatusId"] = this.workItemStatusId;
        data["needDate"] = this.needDate ? this.needDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateWorkSubcontractorCommand {
    workId?: number;
    code?: string;
    type?: string | undefined;
    location?: string | undefined;
    description?: string;
    subcontractor?: string;
    value?: number;
    workItemStatusId?: number | undefined;
    needDate?: Date | undefined;
}

export class UpdateWorkSubcontractorCommand implements IUpdateWorkSubcontractorCommand {
    workId?: number;
    itemId?: number;
    code?: string;
    type?: string | undefined;
    location?: string | undefined;
    description?: string;
    subcontractor?: string;
    value?: number;
    workItemStatusId?: number;
    needDate?: Date | undefined;

    constructor(data?: IUpdateWorkSubcontractorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.itemId = _data["itemId"];
            this.code = _data["code"];
            this.type = _data["type"];
            this.location = _data["location"];
            this.description = _data["description"];
            this.subcontractor = _data["subcontractor"];
            this.value = _data["value"];
            this.workItemStatusId = _data["workItemStatusId"];
            this.needDate = _data["needDate"] ? new Date(_data["needDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateWorkSubcontractorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkSubcontractorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["itemId"] = this.itemId;
        data["code"] = this.code;
        data["type"] = this.type;
        data["location"] = this.location;
        data["description"] = this.description;
        data["subcontractor"] = this.subcontractor;
        data["value"] = this.value;
        data["workItemStatusId"] = this.workItemStatusId;
        data["needDate"] = this.needDate ? this.needDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateWorkSubcontractorCommand {
    workId?: number;
    itemId?: number;
    code?: string;
    type?: string | undefined;
    location?: string | undefined;
    description?: string;
    subcontractor?: string;
    value?: number;
    workItemStatusId?: number;
    needDate?: Date | undefined;
}

export class WorkFinancialDocumentDto implements IWorkFinancialDocumentDto {
    id?: number;
    workId?: number;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;
    documentKindHint?: WorkFinancialDocumentKind;
    processingStatus?: DocumentProcessingStatus;
    processingError?: string | undefined;
    created?: Date;
    lastModified?: Date;
    entry?: WorkFinancialEntryDto | undefined;

    constructor(data?: IWorkFinancialDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.documentKindHint = _data["documentKindHint"];
            this.processingStatus = _data["processingStatus"];
            this.processingError = _data["processingError"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.entry = _data["entry"] ? WorkFinancialEntryDto.fromJS(_data["entry"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkFinancialDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFinancialDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["sizeInBytes"] = this.sizeInBytes;
        data["documentKindHint"] = this.documentKindHint;
        data["processingStatus"] = this.processingStatus;
        data["processingError"] = this.processingError;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["entry"] = this.entry ? this.entry.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkFinancialDocumentDto {
    id?: number;
    workId?: number;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;
    documentKindHint?: WorkFinancialDocumentKind;
    processingStatus?: DocumentProcessingStatus;
    processingError?: string | undefined;
    created?: Date;
    lastModified?: Date;
    entry?: WorkFinancialEntryDto | undefined;
}

export enum WorkFinancialDocumentKind {
    Auto = "Auto",
    Revenue = "Revenue",
    Expense = "Expense",
}

export enum DocumentProcessingStatus {
    Pending = "Pending",
    Processing = "Processing",
    Ready = "Ready",
    Failed = "Failed",
}

export class WorkFinancialEntryDto implements IWorkFinancialEntryDto {
    id?: number;
    workId?: number;
    workFinancialDocumentId?: number;
    entryType?: WorkFinancialEntryType;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    entityName?: string | undefined;
    entityTaxNumber?: string | undefined;
    description?: string | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    currencyCode?: string;
    confidence?: number | undefined;
    validationStatus?: WorkFinancialValidationStatus;
    autoValidated?: boolean;
    validatedAt?: Date | undefined;
    expenseCategoryId?: number | undefined;
    expenseCategoryCode?: string | undefined;
    expenseCategoryName?: string | undefined;
    suggestedExpenseCategoryCode?: string | undefined;
    suggestedExpenseCategoryName?: string | undefined;
    matchedSupplierId?: number | undefined;
    matchedSupplierName?: string | undefined;
    suggestedSupplierId?: number | undefined;
    suggestedSupplierName?: string | undefined;
    supplierMatchState?: SupplierMatchState;
    approvalStatusId?: number | undefined;
    approvalStatusCode?: string;
    approvalStatusName?: string;
    anomalies?: FinancialAnomalyDto[];
    isPotentialDuplicate?: boolean;
    duplicateOfEntryIds?: number[];
    qrCodeRead?: boolean;
    atcud?: string | undefined;
    atVerificationCode?: string | undefined;
    imputedCostId?: number | undefined;
    imputedAmount?: number | undefined;

    constructor(data?: IWorkFinancialEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.workFinancialDocumentId = _data["workFinancialDocumentId"];
            this.entryType = _data["entryType"];
            this.documentNumber = _data["documentNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.entityName = _data["entityName"];
            this.entityTaxNumber = _data["entityTaxNumber"];
            this.description = _data["description"];
            this.baseAmount = _data["baseAmount"];
            this.vatAmount = _data["vatAmount"];
            this.totalAmount = _data["totalAmount"];
            this.currencyCode = _data["currencyCode"];
            this.confidence = _data["confidence"];
            this.validationStatus = _data["validationStatus"];
            this.autoValidated = _data["autoValidated"];
            this.validatedAt = _data["validatedAt"] ? new Date(_data["validatedAt"].toString()) : undefined as any;
            this.expenseCategoryId = _data["expenseCategoryId"];
            this.expenseCategoryCode = _data["expenseCategoryCode"];
            this.expenseCategoryName = _data["expenseCategoryName"];
            this.suggestedExpenseCategoryCode = _data["suggestedExpenseCategoryCode"];
            this.suggestedExpenseCategoryName = _data["suggestedExpenseCategoryName"];
            this.matchedSupplierId = _data["matchedSupplierId"];
            this.matchedSupplierName = _data["matchedSupplierName"];
            this.suggestedSupplierId = _data["suggestedSupplierId"];
            this.suggestedSupplierName = _data["suggestedSupplierName"];
            this.supplierMatchState = _data["supplierMatchState"];
            this.approvalStatusId = _data["approvalStatusId"];
            this.approvalStatusCode = _data["approvalStatusCode"];
            this.approvalStatusName = _data["approvalStatusName"];
            if (Array.isArray(_data["anomalies"])) {
                this.anomalies = [] as any;
                for (let item of _data["anomalies"])
                    this.anomalies!.push(FinancialAnomalyDto.fromJS(item));
            }
            this.isPotentialDuplicate = _data["isPotentialDuplicate"];
            if (Array.isArray(_data["duplicateOfEntryIds"])) {
                this.duplicateOfEntryIds = [] as any;
                for (let item of _data["duplicateOfEntryIds"])
                    this.duplicateOfEntryIds!.push(item);
            }
            this.qrCodeRead = _data["qrCodeRead"];
            this.atcud = _data["atcud"];
            this.atVerificationCode = _data["atVerificationCode"];
            this.imputedCostId = _data["imputedCostId"];
            this.imputedAmount = _data["imputedAmount"];
        }
    }

    static fromJS(data: any): WorkFinancialEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFinancialEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["workFinancialDocumentId"] = this.workFinancialDocumentId;
        data["entryType"] = this.entryType;
        data["documentNumber"] = this.documentNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["entityName"] = this.entityName;
        data["entityTaxNumber"] = this.entityTaxNumber;
        data["description"] = this.description;
        data["baseAmount"] = this.baseAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["currencyCode"] = this.currencyCode;
        data["confidence"] = this.confidence;
        data["validationStatus"] = this.validationStatus;
        data["autoValidated"] = this.autoValidated;
        data["validatedAt"] = this.validatedAt ? this.validatedAt.toISOString() : undefined as any;
        data["expenseCategoryId"] = this.expenseCategoryId;
        data["expenseCategoryCode"] = this.expenseCategoryCode;
        data["expenseCategoryName"] = this.expenseCategoryName;
        data["suggestedExpenseCategoryCode"] = this.suggestedExpenseCategoryCode;
        data["suggestedExpenseCategoryName"] = this.suggestedExpenseCategoryName;
        data["matchedSupplierId"] = this.matchedSupplierId;
        data["matchedSupplierName"] = this.matchedSupplierName;
        data["suggestedSupplierId"] = this.suggestedSupplierId;
        data["suggestedSupplierName"] = this.suggestedSupplierName;
        data["supplierMatchState"] = this.supplierMatchState;
        data["approvalStatusId"] = this.approvalStatusId;
        data["approvalStatusCode"] = this.approvalStatusCode;
        data["approvalStatusName"] = this.approvalStatusName;
        if (Array.isArray(this.anomalies)) {
            data["anomalies"] = [];
            for (let item of this.anomalies)
                data["anomalies"].push(item ? item.toJSON() : undefined as any);
        }
        data["isPotentialDuplicate"] = this.isPotentialDuplicate;
        if (Array.isArray(this.duplicateOfEntryIds)) {
            data["duplicateOfEntryIds"] = [];
            for (let item of this.duplicateOfEntryIds)
                data["duplicateOfEntryIds"].push(item);
        }
        data["qrCodeRead"] = this.qrCodeRead;
        data["atcud"] = this.atcud;
        data["atVerificationCode"] = this.atVerificationCode;
        data["imputedCostId"] = this.imputedCostId;
        data["imputedAmount"] = this.imputedAmount;
        return data;
    }
}

export interface IWorkFinancialEntryDto {
    id?: number;
    workId?: number;
    workFinancialDocumentId?: number;
    entryType?: WorkFinancialEntryType;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    entityName?: string | undefined;
    entityTaxNumber?: string | undefined;
    description?: string | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    currencyCode?: string;
    confidence?: number | undefined;
    validationStatus?: WorkFinancialValidationStatus;
    autoValidated?: boolean;
    validatedAt?: Date | undefined;
    expenseCategoryId?: number | undefined;
    expenseCategoryCode?: string | undefined;
    expenseCategoryName?: string | undefined;
    suggestedExpenseCategoryCode?: string | undefined;
    suggestedExpenseCategoryName?: string | undefined;
    matchedSupplierId?: number | undefined;
    matchedSupplierName?: string | undefined;
    suggestedSupplierId?: number | undefined;
    suggestedSupplierName?: string | undefined;
    supplierMatchState?: SupplierMatchState;
    approvalStatusId?: number | undefined;
    approvalStatusCode?: string;
    approvalStatusName?: string;
    anomalies?: FinancialAnomalyDto[];
    isPotentialDuplicate?: boolean;
    duplicateOfEntryIds?: number[];
    qrCodeRead?: boolean;
    atcud?: string | undefined;
    atVerificationCode?: string | undefined;
    imputedCostId?: number | undefined;
    imputedAmount?: number | undefined;
}

export enum WorkFinancialEntryType {
    Revenue = "Revenue",
    Expense = "Expense",
}

export enum WorkFinancialValidationStatus {
    PendingValidation = "PendingValidation",
    Validated = "Validated",
}

export enum SupplierMatchState {
    Linked = "Linked",
    Suggested = "Suggested",
    NotFound = "NotFound",
    NoTaxNumber = "NoTaxNumber",
}

export class FinancialAnomalyDto implements IFinancialAnomalyDto {
    code?: string;
    message?: string;
    severity?: string;

    constructor(data?: IFinancialAnomalyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): FinancialAnomalyDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialAnomalyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["severity"] = this.severity;
        return data;
    }
}

export interface IFinancialAnomalyDto {
    code?: string;
    message?: string;
    severity?: string;
}

export enum WorkFinancialDocumentKind2 {
    Auto = 0,
    Revenue = 1,
    Expense = 2,
}

export class WorkFinancialDashboardDto implements IWorkFinancialDashboardDto {
    workId?: number;
    workCode?: string;
    workName?: string;
    clientName?: string;
    workStatus?: string | undefined;
    financialStatus?: FinancialStatus;
    totals?: FinancialDashboardTotalsDto;
    alerts?: FinancialAlertDto[];
    entries?: FinancialDashboardEntryDto[];
    monthlySeries?: MonthlyFinancialSeriesPointDto[];

    constructor(data?: IWorkFinancialDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.workCode = _data["workCode"];
            this.workName = _data["workName"];
            this.clientName = _data["clientName"];
            this.workStatus = _data["workStatus"];
            this.financialStatus = _data["financialStatus"];
            this.totals = _data["totals"] ? FinancialDashboardTotalsDto.fromJS(_data["totals"]) : undefined as any;
            if (Array.isArray(_data["alerts"])) {
                this.alerts = [] as any;
                for (let item of _data["alerts"])
                    this.alerts!.push(FinancialAlertDto.fromJS(item));
            }
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(FinancialDashboardEntryDto.fromJS(item));
            }
            if (Array.isArray(_data["monthlySeries"])) {
                this.monthlySeries = [] as any;
                for (let item of _data["monthlySeries"])
                    this.monthlySeries!.push(MonthlyFinancialSeriesPointDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkFinancialDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkFinancialDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["workCode"] = this.workCode;
        data["workName"] = this.workName;
        data["clientName"] = this.clientName;
        data["workStatus"] = this.workStatus;
        data["financialStatus"] = this.financialStatus;
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        if (Array.isArray(this.alerts)) {
            data["alerts"] = [];
            for (let item of this.alerts)
                data["alerts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.monthlySeries)) {
            data["monthlySeries"] = [];
            for (let item of this.monthlySeries)
                data["monthlySeries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkFinancialDashboardDto {
    workId?: number;
    workCode?: string;
    workName?: string;
    clientName?: string;
    workStatus?: string | undefined;
    financialStatus?: FinancialStatus;
    totals?: FinancialDashboardTotalsDto;
    alerts?: FinancialAlertDto[];
    entries?: FinancialDashboardEntryDto[];
    monthlySeries?: MonthlyFinancialSeriesPointDto[];
}

export enum FinancialStatus {
    NoData = "NoData",
    Healthy = "Healthy",
    Attention = "Attention",
    Critical = "Critical",
}

export class FinancialDashboardTotalsDto implements IFinancialDashboardTotalsDto {
    budgetedAmount?: number | undefined;
    budgetSource?: string;
    revenueAmount?: number;
    validatedRevenueAmount?: number;
    pendingRevenueAmount?: number;
    expenseAmount?: number;
    validatedExpenseAmount?: number;
    pendingExpenseAmount?: number;
    realMarginAmount?: number;
    realMarginPercent?: number | undefined;
    revenueDeviationAmount?: number | undefined;
    revenueDeviationPercent?: number | undefined;
    pendingValidationAmount?: number;
    pendingValidationCount?: number;

    constructor(data?: IFinancialDashboardTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetedAmount = _data["budgetedAmount"];
            this.budgetSource = _data["budgetSource"];
            this.revenueAmount = _data["revenueAmount"];
            this.validatedRevenueAmount = _data["validatedRevenueAmount"];
            this.pendingRevenueAmount = _data["pendingRevenueAmount"];
            this.expenseAmount = _data["expenseAmount"];
            this.validatedExpenseAmount = _data["validatedExpenseAmount"];
            this.pendingExpenseAmount = _data["pendingExpenseAmount"];
            this.realMarginAmount = _data["realMarginAmount"];
            this.realMarginPercent = _data["realMarginPercent"];
            this.revenueDeviationAmount = _data["revenueDeviationAmount"];
            this.revenueDeviationPercent = _data["revenueDeviationPercent"];
            this.pendingValidationAmount = _data["pendingValidationAmount"];
            this.pendingValidationCount = _data["pendingValidationCount"];
        }
    }

    static fromJS(data: any): FinancialDashboardTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDashboardTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetedAmount"] = this.budgetedAmount;
        data["budgetSource"] = this.budgetSource;
        data["revenueAmount"] = this.revenueAmount;
        data["validatedRevenueAmount"] = this.validatedRevenueAmount;
        data["pendingRevenueAmount"] = this.pendingRevenueAmount;
        data["expenseAmount"] = this.expenseAmount;
        data["validatedExpenseAmount"] = this.validatedExpenseAmount;
        data["pendingExpenseAmount"] = this.pendingExpenseAmount;
        data["realMarginAmount"] = this.realMarginAmount;
        data["realMarginPercent"] = this.realMarginPercent;
        data["revenueDeviationAmount"] = this.revenueDeviationAmount;
        data["revenueDeviationPercent"] = this.revenueDeviationPercent;
        data["pendingValidationAmount"] = this.pendingValidationAmount;
        data["pendingValidationCount"] = this.pendingValidationCount;
        return data;
    }
}

export interface IFinancialDashboardTotalsDto {
    budgetedAmount?: number | undefined;
    budgetSource?: string;
    revenueAmount?: number;
    validatedRevenueAmount?: number;
    pendingRevenueAmount?: number;
    expenseAmount?: number;
    validatedExpenseAmount?: number;
    pendingExpenseAmount?: number;
    realMarginAmount?: number;
    realMarginPercent?: number | undefined;
    revenueDeviationAmount?: number | undefined;
    revenueDeviationPercent?: number | undefined;
    pendingValidationAmount?: number;
    pendingValidationCount?: number;
}

export class FinancialAlertDto implements IFinancialAlertDto {
    severity?: FinancialStatus;
    code?: string;
    message?: string;

    constructor(data?: IFinancialAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.severity = _data["severity"];
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): FinancialAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["severity"] = this.severity;
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IFinancialAlertDto {
    severity?: FinancialStatus;
    code?: string;
    message?: string;
}

export class FinancialDashboardEntryDto implements IFinancialDashboardEntryDto {
    id?: number;
    workId?: number;
    workFinancialDocumentId?: number;
    entryType?: WorkFinancialEntryType2;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    entityName?: string | undefined;
    description?: string | undefined;
    totalAmount?: number | undefined;
    currencyCode?: string;
    validationStatus?: WorkFinancialValidationStatus2;
    confidence?: number | undefined;
    fileName?: string | undefined;

    constructor(data?: IFinancialDashboardEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.workFinancialDocumentId = _data["workFinancialDocumentId"];
            this.entryType = _data["entryType"];
            this.documentNumber = _data["documentNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.entityName = _data["entityName"];
            this.description = _data["description"];
            this.totalAmount = _data["totalAmount"];
            this.currencyCode = _data["currencyCode"];
            this.validationStatus = _data["validationStatus"];
            this.confidence = _data["confidence"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): FinancialDashboardEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDashboardEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["workFinancialDocumentId"] = this.workFinancialDocumentId;
        data["entryType"] = this.entryType;
        data["documentNumber"] = this.documentNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["entityName"] = this.entityName;
        data["description"] = this.description;
        data["totalAmount"] = this.totalAmount;
        data["currencyCode"] = this.currencyCode;
        data["validationStatus"] = this.validationStatus;
        data["confidence"] = this.confidence;
        data["fileName"] = this.fileName;
        return data;
    }
}

export interface IFinancialDashboardEntryDto {
    id?: number;
    workId?: number;
    workFinancialDocumentId?: number;
    entryType?: WorkFinancialEntryType2;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    entityName?: string | undefined;
    description?: string | undefined;
    totalAmount?: number | undefined;
    currencyCode?: string;
    validationStatus?: WorkFinancialValidationStatus2;
    confidence?: number | undefined;
    fileName?: string | undefined;
}

export enum WorkFinancialEntryType2 {
    Revenue = 1,
    Expense = 2,
}

export enum WorkFinancialValidationStatus2 {
    PendingValidation = 0,
    Validated = 1,
}

export class MonthlyFinancialSeriesPointDto implements IMonthlyFinancialSeriesPointDto {
    year?: number;
    month?: number;
    label?: string;
    revenueAmount?: number;
    expenseAmount?: number;
    marginAmount?: number;

    constructor(data?: IMonthlyFinancialSeriesPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.label = _data["label"];
            this.revenueAmount = _data["revenueAmount"];
            this.expenseAmount = _data["expenseAmount"];
            this.marginAmount = _data["marginAmount"];
        }
    }

    static fromJS(data: any): MonthlyFinancialSeriesPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyFinancialSeriesPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["label"] = this.label;
        data["revenueAmount"] = this.revenueAmount;
        data["expenseAmount"] = this.expenseAmount;
        data["marginAmount"] = this.marginAmount;
        return data;
    }
}

export interface IMonthlyFinancialSeriesPointDto {
    year?: number;
    month?: number;
    label?: string;
    revenueAmount?: number;
    expenseAmount?: number;
    marginAmount?: number;
}

export class UpdateWorkFinancialEntryCommand implements IUpdateWorkFinancialEntryCommand {
    workId?: number;
    entryId?: number;
    entryType?: WorkFinancialEntryType;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    entityName?: string | undefined;
    entityTaxNumber?: string | undefined;
    description?: string | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    currencyCode?: string | undefined;

    constructor(data?: IUpdateWorkFinancialEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.entryId = _data["entryId"];
            this.entryType = _data["entryType"];
            this.documentNumber = _data["documentNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.entityName = _data["entityName"];
            this.entityTaxNumber = _data["entityTaxNumber"];
            this.description = _data["description"];
            this.baseAmount = _data["baseAmount"];
            this.vatAmount = _data["vatAmount"];
            this.totalAmount = _data["totalAmount"];
            this.currencyCode = _data["currencyCode"];
        }
    }

    static fromJS(data: any): UpdateWorkFinancialEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkFinancialEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["entryId"] = this.entryId;
        data["entryType"] = this.entryType;
        data["documentNumber"] = this.documentNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["entityName"] = this.entityName;
        data["entityTaxNumber"] = this.entityTaxNumber;
        data["description"] = this.description;
        data["baseAmount"] = this.baseAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["currencyCode"] = this.currencyCode;
        return data;
    }
}

export interface IUpdateWorkFinancialEntryCommand {
    workId?: number;
    entryId?: number;
    entryType?: WorkFinancialEntryType;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    entityName?: string | undefined;
    entityTaxNumber?: string | undefined;
    description?: string | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    currencyCode?: string | undefined;
}

export class SetWorkFinancialEntryApprovalStatusCommand implements ISetWorkFinancialEntryApprovalStatusCommand {
    workId?: number;
    entryId?: number;
    statusCode?: string;

    constructor(data?: ISetWorkFinancialEntryApprovalStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.entryId = _data["entryId"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): SetWorkFinancialEntryApprovalStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetWorkFinancialEntryApprovalStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["entryId"] = this.entryId;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface ISetWorkFinancialEntryApprovalStatusCommand {
    workId?: number;
    entryId?: number;
    statusCode?: string;
}

export class CategorizeWorkFinancialEntryCommand implements ICategorizeWorkFinancialEntryCommand {
    workId?: number;
    entryId?: number;
    expenseCategoryId?: number | undefined;

    constructor(data?: ICategorizeWorkFinancialEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.entryId = _data["entryId"];
            this.expenseCategoryId = _data["expenseCategoryId"];
        }
    }

    static fromJS(data: any): CategorizeWorkFinancialEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CategorizeWorkFinancialEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["entryId"] = this.entryId;
        data["expenseCategoryId"] = this.expenseCategoryId;
        return data;
    }
}

export interface ICategorizeWorkFinancialEntryCommand {
    workId?: number;
    entryId?: number;
    expenseCategoryId?: number | undefined;
}

export class MatchWorkFinancialEntrySupplierCommand implements IMatchWorkFinancialEntrySupplierCommand {
    workId?: number;
    entryId?: number;
    supplierId?: number;

    constructor(data?: IMatchWorkFinancialEntrySupplierCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.entryId = _data["entryId"];
            this.supplierId = _data["supplierId"];
        }
    }

    static fromJS(data: any): MatchWorkFinancialEntrySupplierCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MatchWorkFinancialEntrySupplierCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["entryId"] = this.entryId;
        data["supplierId"] = this.supplierId;
        return data;
    }
}

export interface IMatchWorkFinancialEntrySupplierCommand {
    workId?: number;
    entryId?: number;
    supplierId?: number;
}

export class MeasurementAutoDto implements IMeasurementAutoDto {
    id?: number;
    workId?: number;
    number?: string;
    autoType?: string;
    autoDate?: Date;
    clientName?: string | undefined;
    notes?: string | undefined;
    status?: string;
    approvedAt?: Date | undefined;
    periodStart?: Date | undefined;
    periodEnd?: Date | undefined;
    totalAmount?: number;
    invoiceId?: number | undefined;
    invoiceNumber?: string | undefined;
    lines?: MeasurementAutoLineDto[];
    created?: Date;
    lastModified?: Date;

    constructor(data?: IMeasurementAutoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.number = _data["number"];
            this.autoType = _data["autoType"];
            this.autoDate = _data["autoDate"] ? new Date(_data["autoDate"].toString()) : undefined as any;
            this.clientName = _data["clientName"];
            this.notes = _data["notes"];
            this.status = _data["status"];
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : undefined as any;
            this.periodStart = _data["periodStart"] ? new Date(_data["periodStart"].toString()) : undefined as any;
            this.periodEnd = _data["periodEnd"] ? new Date(_data["periodEnd"].toString()) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.invoiceId = _data["invoiceId"];
            this.invoiceNumber = _data["invoiceNumber"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(MeasurementAutoLineDto.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MeasurementAutoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementAutoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["number"] = this.number;
        data["autoType"] = this.autoType;
        data["autoDate"] = this.autoDate ? this.autoDate.toISOString() : undefined as any;
        data["clientName"] = this.clientName;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["approvedAt"] = this.approvedAt ? this.approvedAt.toISOString() : undefined as any;
        data["periodStart"] = this.periodStart ? this.periodStart.toISOString() : undefined as any;
        data["periodEnd"] = this.periodEnd ? this.periodEnd.toISOString() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["invoiceId"] = this.invoiceId;
        data["invoiceNumber"] = this.invoiceNumber;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IMeasurementAutoDto {
    id?: number;
    workId?: number;
    number?: string;
    autoType?: string;
    autoDate?: Date;
    clientName?: string | undefined;
    notes?: string | undefined;
    status?: string;
    approvedAt?: Date | undefined;
    periodStart?: Date | undefined;
    periodEnd?: Date | undefined;
    totalAmount?: number;
    invoiceId?: number | undefined;
    invoiceNumber?: string | undefined;
    lines?: MeasurementAutoLineDto[];
    created?: Date;
    lastModified?: Date;
}

export class MeasurementAutoLineDto implements IMeasurementAutoLineDto {
    id?: number;
    sortOrder?: number;
    description?: string;
    unit?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    amount?: number;

    constructor(data?: IMeasurementAutoLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sortOrder = _data["sortOrder"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): MeasurementAutoLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementAutoLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sortOrder"] = this.sortOrder;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IMeasurementAutoLineDto {
    id?: number;
    sortOrder?: number;
    description?: string;
    unit?: string | undefined;
    quantity?: number;
    unitPrice?: number;
    amount?: number;
}

export class CreateMeasurementAutoCommand implements ICreateMeasurementAutoCommand {
    workId?: number;
    autoType?: string;
    autoDate?: Date;
    number?: string | undefined;
    clientName?: string | undefined;
    notes?: string | undefined;
    status?: string | undefined;
    periodStart?: Date | undefined;
    periodEnd?: Date | undefined;
    lines?: MeasurementAutoLineInput[];

    constructor(data?: ICreateMeasurementAutoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.autoType = _data["autoType"];
            this.autoDate = _data["autoDate"] ? new Date(_data["autoDate"].toString()) : undefined as any;
            this.number = _data["number"];
            this.clientName = _data["clientName"];
            this.notes = _data["notes"];
            this.status = _data["status"];
            this.periodStart = _data["periodStart"] ? new Date(_data["periodStart"].toString()) : undefined as any;
            this.periodEnd = _data["periodEnd"] ? new Date(_data["periodEnd"].toString()) : undefined as any;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(MeasurementAutoLineInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMeasurementAutoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeasurementAutoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["autoType"] = this.autoType;
        data["autoDate"] = this.autoDate ? this.autoDate.toISOString() : undefined as any;
        data["number"] = this.number;
        data["clientName"] = this.clientName;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["periodStart"] = this.periodStart ? this.periodStart.toISOString() : undefined as any;
        data["periodEnd"] = this.periodEnd ? this.periodEnd.toISOString() : undefined as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateMeasurementAutoCommand {
    workId?: number;
    autoType?: string;
    autoDate?: Date;
    number?: string | undefined;
    clientName?: string | undefined;
    notes?: string | undefined;
    status?: string | undefined;
    periodStart?: Date | undefined;
    periodEnd?: Date | undefined;
    lines?: MeasurementAutoLineInput[];
}

export class MeasurementAutoLineInput implements IMeasurementAutoLineInput {
    sortOrder?: number;
    description?: string;
    unit?: string | undefined;
    quantity?: number;
    unitPrice?: number;

    constructor(data?: IMeasurementAutoLineInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
        }
    }

    static fromJS(data: any): MeasurementAutoLineInput {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementAutoLineInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        return data;
    }
}

export interface IMeasurementAutoLineInput {
    sortOrder?: number;
    description?: string;
    unit?: string | undefined;
    quantity?: number;
    unitPrice?: number;
}

export class UpdateMeasurementAutoCommand implements IUpdateMeasurementAutoCommand {
    workId?: number;
    autoId?: number;
    autoType?: string;
    autoDate?: Date;
    number?: string | undefined;
    clientName?: string | undefined;
    notes?: string | undefined;
    status?: string | undefined;
    periodStart?: Date | undefined;
    periodEnd?: Date | undefined;
    lines?: MeasurementAutoLineInput[];

    constructor(data?: IUpdateMeasurementAutoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.autoId = _data["autoId"];
            this.autoType = _data["autoType"];
            this.autoDate = _data["autoDate"] ? new Date(_data["autoDate"].toString()) : undefined as any;
            this.number = _data["number"];
            this.clientName = _data["clientName"];
            this.notes = _data["notes"];
            this.status = _data["status"];
            this.periodStart = _data["periodStart"] ? new Date(_data["periodStart"].toString()) : undefined as any;
            this.periodEnd = _data["periodEnd"] ? new Date(_data["periodEnd"].toString()) : undefined as any;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(MeasurementAutoLineInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateMeasurementAutoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeasurementAutoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["autoId"] = this.autoId;
        data["autoType"] = this.autoType;
        data["autoDate"] = this.autoDate ? this.autoDate.toISOString() : undefined as any;
        data["number"] = this.number;
        data["clientName"] = this.clientName;
        data["notes"] = this.notes;
        data["status"] = this.status;
        data["periodStart"] = this.periodStart ? this.periodStart.toISOString() : undefined as any;
        data["periodEnd"] = this.periodEnd ? this.periodEnd.toISOString() : undefined as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateMeasurementAutoCommand {
    workId?: number;
    autoId?: number;
    autoType?: string;
    autoDate?: Date;
    number?: string | undefined;
    clientName?: string | undefined;
    notes?: string | undefined;
    status?: string | undefined;
    periodStart?: Date | undefined;
    periodEnd?: Date | undefined;
    lines?: MeasurementAutoLineInput[];
}

export class ClientInvoiceDto implements IClientInvoiceDto {
    id?: number;
    clientId?: number;
    clientName?: string;
    workId?: number | undefined;
    workName?: string | undefined;
    billingMilestoneId?: number | undefined;
    measurementAutoId?: number | undefined;
    measurementAutoNumber?: string | undefined;
    kind?: string;
    originalInvoiceId?: number | undefined;
    originalInvoiceNumber?: string | undefined;
    number?: string;
    statusId?: number;
    statusCode?: string;
    statusName?: string;
    issueDate?: Date | undefined;
    dueDate?: Date | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    paidAmount?: number;
    openAmount?: number;
    currencyCode?: string;
    description?: string | undefined;
    notes?: string | undefined;
    ageDays?: number | undefined;
    agingBucket?: string | undefined;
    created?: Date;
    lastModified?: Date;
    migratedToAccountAt?: Date | undefined;
    migratedBy?: string | undefined;
    migrationNotes?: string | undefined;
    isMigratedToAccount?: boolean;
    blockOverrideReason?: string | undefined;

    constructor(data?: IClientInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.billingMilestoneId = _data["billingMilestoneId"];
            this.measurementAutoId = _data["measurementAutoId"];
            this.measurementAutoNumber = _data["measurementAutoNumber"];
            this.kind = _data["kind"];
            this.originalInvoiceId = _data["originalInvoiceId"];
            this.originalInvoiceNumber = _data["originalInvoiceNumber"];
            this.number = _data["number"];
            this.statusId = _data["statusId"];
            this.statusCode = _data["statusCode"];
            this.statusName = _data["statusName"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.baseAmount = _data["baseAmount"];
            this.vatAmount = _data["vatAmount"];
            this.totalAmount = _data["totalAmount"];
            this.paidAmount = _data["paidAmount"];
            this.openAmount = _data["openAmount"];
            this.currencyCode = _data["currencyCode"];
            this.description = _data["description"];
            this.notes = _data["notes"];
            this.ageDays = _data["ageDays"];
            this.agingBucket = _data["agingBucket"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
            this.migratedToAccountAt = _data["migratedToAccountAt"] ? new Date(_data["migratedToAccountAt"].toString()) : undefined as any;
            this.migratedBy = _data["migratedBy"];
            this.migrationNotes = _data["migrationNotes"];
            this.isMigratedToAccount = _data["isMigratedToAccount"];
            this.blockOverrideReason = _data["blockOverrideReason"];
        }
    }

    static fromJS(data: any): ClientInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["billingMilestoneId"] = this.billingMilestoneId;
        data["measurementAutoId"] = this.measurementAutoId;
        data["measurementAutoNumber"] = this.measurementAutoNumber;
        data["kind"] = this.kind;
        data["originalInvoiceId"] = this.originalInvoiceId;
        data["originalInvoiceNumber"] = this.originalInvoiceNumber;
        data["number"] = this.number;
        data["statusId"] = this.statusId;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["baseAmount"] = this.baseAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["paidAmount"] = this.paidAmount;
        data["openAmount"] = this.openAmount;
        data["currencyCode"] = this.currencyCode;
        data["description"] = this.description;
        data["notes"] = this.notes;
        data["ageDays"] = this.ageDays;
        data["agingBucket"] = this.agingBucket;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        data["migratedToAccountAt"] = this.migratedToAccountAt ? this.migratedToAccountAt.toISOString() : undefined as any;
        data["migratedBy"] = this.migratedBy;
        data["migrationNotes"] = this.migrationNotes;
        data["isMigratedToAccount"] = this.isMigratedToAccount;
        data["blockOverrideReason"] = this.blockOverrideReason;
        return data;
    }
}

export interface IClientInvoiceDto {
    id?: number;
    clientId?: number;
    clientName?: string;
    workId?: number | undefined;
    workName?: string | undefined;
    billingMilestoneId?: number | undefined;
    measurementAutoId?: number | undefined;
    measurementAutoNumber?: string | undefined;
    kind?: string;
    originalInvoiceId?: number | undefined;
    originalInvoiceNumber?: string | undefined;
    number?: string;
    statusId?: number;
    statusCode?: string;
    statusName?: string;
    issueDate?: Date | undefined;
    dueDate?: Date | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    paidAmount?: number;
    openAmount?: number;
    currencyCode?: string;
    description?: string | undefined;
    notes?: string | undefined;
    ageDays?: number | undefined;
    agingBucket?: string | undefined;
    created?: Date;
    lastModified?: Date;
    migratedToAccountAt?: Date | undefined;
    migratedBy?: string | undefined;
    migrationNotes?: string | undefined;
    isMigratedToAccount?: boolean;
    blockOverrideReason?: string | undefined;
}

export class SubcontractorAutoDto implements ISubcontractorAutoDto {
    id?: number;
    workId?: number;
    workSubcontractorItemId?: number | undefined;
    subcontractorName?: string;
    number?: string;
    status?: string;
    measuredAmount?: number;
    approvedAt?: Date | undefined;
    approvedByUserId?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceDate?: Date | undefined;
    invoiceAmount?: number | undefined;
    retentionPercent?: number;
    retentionAmount?: number;
    netPayable?: number;
    paidAmount?: number;
    paidAt?: Date | undefined;
    notes?: string | undefined;
    currencyCode?: string;
    created?: Date;
    lastModified?: Date;

    constructor(data?: ISubcontractorAutoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.workSubcontractorItemId = _data["workSubcontractorItemId"];
            this.subcontractorName = _data["subcontractorName"];
            this.number = _data["number"];
            this.status = _data["status"];
            this.measuredAmount = _data["measuredAmount"];
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : undefined as any;
            this.approvedByUserId = _data["approvedByUserId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.invoiceAmount = _data["invoiceAmount"];
            this.retentionPercent = _data["retentionPercent"];
            this.retentionAmount = _data["retentionAmount"];
            this.netPayable = _data["netPayable"];
            this.paidAmount = _data["paidAmount"];
            this.paidAt = _data["paidAt"] ? new Date(_data["paidAt"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.currencyCode = _data["currencyCode"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SubcontractorAutoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractorAutoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["workSubcontractorItemId"] = this.workSubcontractorItemId;
        data["subcontractorName"] = this.subcontractorName;
        data["number"] = this.number;
        data["status"] = this.status;
        data["measuredAmount"] = this.measuredAmount;
        data["approvedAt"] = this.approvedAt ? this.approvedAt.toISOString() : undefined as any;
        data["approvedByUserId"] = this.approvedByUserId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["invoiceAmount"] = this.invoiceAmount;
        data["retentionPercent"] = this.retentionPercent;
        data["retentionAmount"] = this.retentionAmount;
        data["netPayable"] = this.netPayable;
        data["paidAmount"] = this.paidAmount;
        data["paidAt"] = this.paidAt ? this.paidAt.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["currencyCode"] = this.currencyCode;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface ISubcontractorAutoDto {
    id?: number;
    workId?: number;
    workSubcontractorItemId?: number | undefined;
    subcontractorName?: string;
    number?: string;
    status?: string;
    measuredAmount?: number;
    approvedAt?: Date | undefined;
    approvedByUserId?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceDate?: Date | undefined;
    invoiceAmount?: number | undefined;
    retentionPercent?: number;
    retentionAmount?: number;
    netPayable?: number;
    paidAmount?: number;
    paidAt?: Date | undefined;
    notes?: string | undefined;
    currencyCode?: string;
    created?: Date;
    lastModified?: Date;
}

export class SubcontractorRetentionsDto implements ISubcontractorRetentionsDto {
    bySubcontractor?: SubcontractorRetentionDto[];
    totalRetention?: number;

    constructor(data?: ISubcontractorRetentionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bySubcontractor"])) {
                this.bySubcontractor = [] as any;
                for (let item of _data["bySubcontractor"])
                    this.bySubcontractor!.push(SubcontractorRetentionDto.fromJS(item));
            }
            this.totalRetention = _data["totalRetention"];
        }
    }

    static fromJS(data: any): SubcontractorRetentionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractorRetentionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bySubcontractor)) {
            data["bySubcontractor"] = [];
            for (let item of this.bySubcontractor)
                data["bySubcontractor"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalRetention"] = this.totalRetention;
        return data;
    }
}

export interface ISubcontractorRetentionsDto {
    bySubcontractor?: SubcontractorRetentionDto[];
    totalRetention?: number;
}

export class SubcontractorRetentionDto implements ISubcontractorRetentionDto {
    subcontractorName?: string;
    totalRetention?: number;
    autoCount?: number;

    constructor(data?: ISubcontractorRetentionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subcontractorName = _data["subcontractorName"];
            this.totalRetention = _data["totalRetention"];
            this.autoCount = _data["autoCount"];
        }
    }

    static fromJS(data: any): SubcontractorRetentionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractorRetentionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subcontractorName"] = this.subcontractorName;
        data["totalRetention"] = this.totalRetention;
        data["autoCount"] = this.autoCount;
        return data;
    }
}

export interface ISubcontractorRetentionDto {
    subcontractorName?: string;
    totalRetention?: number;
    autoCount?: number;
}

export class CreateSubcontractorAutoCommand implements ICreateSubcontractorAutoCommand {
    workId?: number;
    workSubcontractorItemId?: number;
    measuredAmount?: number | undefined;
    retentionPercent?: number | undefined;
    notes?: string | undefined;

    constructor(data?: ICreateSubcontractorAutoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.workSubcontractorItemId = _data["workSubcontractorItemId"];
            this.measuredAmount = _data["measuredAmount"];
            this.retentionPercent = _data["retentionPercent"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateSubcontractorAutoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubcontractorAutoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["workSubcontractorItemId"] = this.workSubcontractorItemId;
        data["measuredAmount"] = this.measuredAmount;
        data["retentionPercent"] = this.retentionPercent;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateSubcontractorAutoCommand {
    workId?: number;
    workSubcontractorItemId?: number;
    measuredAmount?: number | undefined;
    retentionPercent?: number | undefined;
    notes?: string | undefined;
}

export class UpdateSubcontractorAutoCommand implements IUpdateSubcontractorAutoCommand {
    workId?: number;
    autoId?: number;
    measuredAmount?: number;
    retentionPercent?: number;
    notes?: string | undefined;

    constructor(data?: IUpdateSubcontractorAutoCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.autoId = _data["autoId"];
            this.measuredAmount = _data["measuredAmount"];
            this.retentionPercent = _data["retentionPercent"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateSubcontractorAutoCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubcontractorAutoCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["autoId"] = this.autoId;
        data["measuredAmount"] = this.measuredAmount;
        data["retentionPercent"] = this.retentionPercent;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateSubcontractorAutoCommand {
    workId?: number;
    autoId?: number;
    measuredAmount?: number;
    retentionPercent?: number;
    notes?: string | undefined;
}

export class RegisterSubcontractorInvoiceCommand implements IRegisterSubcontractorInvoiceCommand {
    workId?: number;
    autoId?: number;
    invoiceNumber?: string;
    invoiceDate?: Date;
    invoiceAmount?: number;

    constructor(data?: IRegisterSubcontractorInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.autoId = _data["autoId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.invoiceAmount = _data["invoiceAmount"];
        }
    }

    static fromJS(data: any): RegisterSubcontractorInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterSubcontractorInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["autoId"] = this.autoId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["invoiceAmount"] = this.invoiceAmount;
        return data;
    }
}

export interface IRegisterSubcontractorInvoiceCommand {
    workId?: number;
    autoId?: number;
    invoiceNumber?: string;
    invoiceDate?: Date;
    invoiceAmount?: number;
}

export class RegisterSubcontractorPaymentCommand implements IRegisterSubcontractorPaymentCommand {
    workId?: number;
    autoId?: number;
    amount?: number;
    paidAt?: Date | undefined;

    constructor(data?: IRegisterSubcontractorPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.autoId = _data["autoId"];
            this.amount = _data["amount"];
            this.paidAt = _data["paidAt"] ? new Date(_data["paidAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RegisterSubcontractorPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterSubcontractorPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["autoId"] = this.autoId;
        data["amount"] = this.amount;
        data["paidAt"] = this.paidAt ? this.paidAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IRegisterSubcontractorPaymentCommand {
    workId?: number;
    autoId?: number;
    amount?: number;
    paidAt?: Date | undefined;
}

export class WorkVariationsVm implements IWorkVariationsVm {
    variations?: WorkVariationDto[];
    approvedAdditions?: number;
    approvedReductions?: number;
    netApproved?: number;

    constructor(data?: IWorkVariationsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["variations"])) {
                this.variations = [] as any;
                for (let item of _data["variations"])
                    this.variations!.push(WorkVariationDto.fromJS(item));
            }
            this.approvedAdditions = _data["approvedAdditions"];
            this.approvedReductions = _data["approvedReductions"];
            this.netApproved = _data["netApproved"];
        }
    }

    static fromJS(data: any): WorkVariationsVm {
        data = typeof data === 'object' ? data : {};
        let result = new WorkVariationsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.variations)) {
            data["variations"] = [];
            for (let item of this.variations)
                data["variations"].push(item ? item.toJSON() : undefined as any);
        }
        data["approvedAdditions"] = this.approvedAdditions;
        data["approvedReductions"] = this.approvedReductions;
        data["netApproved"] = this.netApproved;
        return data;
    }
}

export interface IWorkVariationsVm {
    variations?: WorkVariationDto[];
    approvedAdditions?: number;
    approvedReductions?: number;
    netApproved?: number;
}

export class WorkVariationMapDto implements IWorkVariationMapDto {
    workId?: number;
    workName?: string;
    baseSell?: number;
    approvedAdditions?: number;
    approvedReductions?: number;
    revisedSell?: number;
    budgetedCost?: number;
    actualCost?: number;
    baseMargin?: number;
    revisedMargin?: number;
    revisedMarginPercent?: number | undefined;
    variations?: WorkVariationDto[];

    constructor(data?: IWorkVariationMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.baseSell = _data["baseSell"];
            this.approvedAdditions = _data["approvedAdditions"];
            this.approvedReductions = _data["approvedReductions"];
            this.revisedSell = _data["revisedSell"];
            this.budgetedCost = _data["budgetedCost"];
            this.actualCost = _data["actualCost"];
            this.baseMargin = _data["baseMargin"];
            this.revisedMargin = _data["revisedMargin"];
            this.revisedMarginPercent = _data["revisedMarginPercent"];
            if (Array.isArray(_data["variations"])) {
                this.variations = [] as any;
                for (let item of _data["variations"])
                    this.variations!.push(WorkVariationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkVariationMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkVariationMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["baseSell"] = this.baseSell;
        data["approvedAdditions"] = this.approvedAdditions;
        data["approvedReductions"] = this.approvedReductions;
        data["revisedSell"] = this.revisedSell;
        data["budgetedCost"] = this.budgetedCost;
        data["actualCost"] = this.actualCost;
        data["baseMargin"] = this.baseMargin;
        data["revisedMargin"] = this.revisedMargin;
        data["revisedMarginPercent"] = this.revisedMarginPercent;
        if (Array.isArray(this.variations)) {
            data["variations"] = [];
            for (let item of this.variations)
                data["variations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkVariationMapDto {
    workId?: number;
    workName?: string;
    baseSell?: number;
    approvedAdditions?: number;
    approvedReductions?: number;
    revisedSell?: number;
    budgetedCost?: number;
    actualCost?: number;
    baseMargin?: number;
    revisedMargin?: number;
    revisedMarginPercent?: number | undefined;
    variations?: WorkVariationDto[];
}

export class CreateWorkVariationCommand implements ICreateWorkVariationCommand {
    workId?: number;
    description?: string;
    kind?: string;
    amount?: number;
    notes?: string | undefined;

    constructor(data?: ICreateWorkVariationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.description = _data["description"];
            this.kind = _data["kind"];
            this.amount = _data["amount"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateWorkVariationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkVariationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["description"] = this.description;
        data["kind"] = this.kind;
        data["amount"] = this.amount;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateWorkVariationCommand {
    workId?: number;
    description?: string;
    kind?: string;
    amount?: number;
    notes?: string | undefined;
}

export class UpdateWorkVariationCommand implements IUpdateWorkVariationCommand {
    workId?: number;
    variationId?: number;
    description?: string;
    kind?: string;
    amount?: number;
    notes?: string | undefined;

    constructor(data?: IUpdateWorkVariationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.variationId = _data["variationId"];
            this.description = _data["description"];
            this.kind = _data["kind"];
            this.amount = _data["amount"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateWorkVariationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkVariationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["variationId"] = this.variationId;
        data["description"] = this.description;
        data["kind"] = this.kind;
        data["amount"] = this.amount;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateWorkVariationCommand {
    workId?: number;
    variationId?: number;
    description?: string;
    kind?: string;
    amount?: number;
    notes?: string | undefined;
}

export class RejectWorkVariationCommand implements IRejectWorkVariationCommand {
    workId?: number;
    variationId?: number;
    rejectionReason?: string | undefined;

    constructor(data?: IRejectWorkVariationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.variationId = _data["variationId"];
            this.rejectionReason = _data["rejectionReason"];
        }
    }

    static fromJS(data: any): RejectWorkVariationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RejectWorkVariationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["variationId"] = this.variationId;
        data["rejectionReason"] = this.rejectionReason;
        return data;
    }
}

export interface IRejectWorkVariationCommand {
    workId?: number;
    variationId?: number;
    rejectionReason?: string | undefined;
}

export class WorkAfterSalesInterventionsVm implements IWorkAfterSalesInterventionsVm {
    interventions?: WorkAfterSalesInterventionDto[];
    estimatedTotal?: number;
    actualTotal?: number;

    constructor(data?: IWorkAfterSalesInterventionsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["interventions"])) {
                this.interventions = [] as any;
                for (let item of _data["interventions"])
                    this.interventions!.push(WorkAfterSalesInterventionDto.fromJS(item));
            }
            this.estimatedTotal = _data["estimatedTotal"];
            this.actualTotal = _data["actualTotal"];
        }
    }

    static fromJS(data: any): WorkAfterSalesInterventionsVm {
        data = typeof data === 'object' ? data : {};
        let result = new WorkAfterSalesInterventionsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.interventions)) {
            data["interventions"] = [];
            for (let item of this.interventions)
                data["interventions"].push(item ? item.toJSON() : undefined as any);
        }
        data["estimatedTotal"] = this.estimatedTotal;
        data["actualTotal"] = this.actualTotal;
        return data;
    }
}

export interface IWorkAfterSalesInterventionsVm {
    interventions?: WorkAfterSalesInterventionDto[];
    estimatedTotal?: number;
    actualTotal?: number;
}

export class WorkAfterSalesInterventionDto implements IWorkAfterSalesInterventionDto {
    id?: number;
    workId?: number;
    description?: string;
    interventionDate?: Date;
    responsible?: string | undefined;
    estimatedValue?: number | undefined;
    actualValue?: number | undefined;
    notes?: string | undefined;
    hasImputedCost?: boolean;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWorkAfterSalesInterventionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.description = _data["description"];
            this.interventionDate = _data["interventionDate"] ? new Date(_data["interventionDate"].toString()) : undefined as any;
            this.responsible = _data["responsible"];
            this.estimatedValue = _data["estimatedValue"];
            this.actualValue = _data["actualValue"];
            this.notes = _data["notes"];
            this.hasImputedCost = _data["hasImputedCost"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkAfterSalesInterventionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkAfterSalesInterventionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["description"] = this.description;
        data["interventionDate"] = this.interventionDate ? this.interventionDate.toISOString() : undefined as any;
        data["responsible"] = this.responsible;
        data["estimatedValue"] = this.estimatedValue;
        data["actualValue"] = this.actualValue;
        data["notes"] = this.notes;
        data["hasImputedCost"] = this.hasImputedCost;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkAfterSalesInterventionDto {
    id?: number;
    workId?: number;
    description?: string;
    interventionDate?: Date;
    responsible?: string | undefined;
    estimatedValue?: number | undefined;
    actualValue?: number | undefined;
    notes?: string | undefined;
    hasImputedCost?: boolean;
    created?: Date;
    lastModified?: Date;
}

export class CreateWorkAfterSalesInterventionCommand implements ICreateWorkAfterSalesInterventionCommand {
    workId?: number;
    description?: string;
    interventionDate?: Date;
    responsible?: string | undefined;
    estimatedValue?: number | undefined;
    actualValue?: number | undefined;
    notes?: string | undefined;

    constructor(data?: ICreateWorkAfterSalesInterventionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.description = _data["description"];
            this.interventionDate = _data["interventionDate"] ? new Date(_data["interventionDate"].toString()) : undefined as any;
            this.responsible = _data["responsible"];
            this.estimatedValue = _data["estimatedValue"];
            this.actualValue = _data["actualValue"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateWorkAfterSalesInterventionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkAfterSalesInterventionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["description"] = this.description;
        data["interventionDate"] = this.interventionDate ? this.interventionDate.toISOString() : undefined as any;
        data["responsible"] = this.responsible;
        data["estimatedValue"] = this.estimatedValue;
        data["actualValue"] = this.actualValue;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateWorkAfterSalesInterventionCommand {
    workId?: number;
    description?: string;
    interventionDate?: Date;
    responsible?: string | undefined;
    estimatedValue?: number | undefined;
    actualValue?: number | undefined;
    notes?: string | undefined;
}

export class UpdateWorkAfterSalesInterventionCommand implements IUpdateWorkAfterSalesInterventionCommand {
    workId?: number;
    interventionId?: number;
    description?: string;
    interventionDate?: Date;
    responsible?: string | undefined;
    estimatedValue?: number | undefined;
    actualValue?: number | undefined;
    notes?: string | undefined;

    constructor(data?: IUpdateWorkAfterSalesInterventionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.interventionId = _data["interventionId"];
            this.description = _data["description"];
            this.interventionDate = _data["interventionDate"] ? new Date(_data["interventionDate"].toString()) : undefined as any;
            this.responsible = _data["responsible"];
            this.estimatedValue = _data["estimatedValue"];
            this.actualValue = _data["actualValue"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateWorkAfterSalesInterventionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkAfterSalesInterventionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["interventionId"] = this.interventionId;
        data["description"] = this.description;
        data["interventionDate"] = this.interventionDate ? this.interventionDate.toISOString() : undefined as any;
        data["responsible"] = this.responsible;
        data["estimatedValue"] = this.estimatedValue;
        data["actualValue"] = this.actualValue;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateWorkAfterSalesInterventionCommand {
    workId?: number;
    interventionId?: number;
    description?: string;
    interventionDate?: Date;
    responsible?: string | undefined;
    estimatedValue?: number | undefined;
    actualValue?: number | undefined;
    notes?: string | undefined;
}

export class WorkPhotosVm implements IWorkPhotosVm {
    photos?: WorkPhotoDto[];

    constructor(data?: IWorkPhotosVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["photos"])) {
                this.photos = [] as any;
                for (let item of _data["photos"])
                    this.photos!.push(WorkPhotoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkPhotosVm {
        data = typeof data === 'object' ? data : {};
        let result = new WorkPhotosVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.photos)) {
            data["photos"] = [];
            for (let item of this.photos)
                data["photos"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkPhotosVm {
    photos?: WorkPhotoDto[];
}

export class WorkPhotoDto implements IWorkPhotoDto {
    id?: number;
    workId?: number;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;
    note?: string | undefined;
    author?: WorkPhotoAuthorDto;
    isImage?: boolean;
    isVideo?: boolean;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWorkPhotoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.note = _data["note"];
            this.author = _data["author"] ? WorkPhotoAuthorDto.fromJS(_data["author"]) : undefined as any;
            this.isImage = _data["isImage"];
            this.isVideo = _data["isVideo"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkPhotoDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkPhotoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["sizeInBytes"] = this.sizeInBytes;
        data["note"] = this.note;
        data["author"] = this.author ? this.author.toJSON() : undefined as any;
        data["isImage"] = this.isImage;
        data["isVideo"] = this.isVideo;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkPhotoDto {
    id?: number;
    workId?: number;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;
    note?: string | undefined;
    author?: WorkPhotoAuthorDto;
    isImage?: boolean;
    isVideo?: boolean;
    created?: Date;
    lastModified?: Date;
}

export class WorkPhotoAuthorDto implements IWorkPhotoAuthorDto {
    id?: string | undefined;
    name?: string;

    constructor(data?: IWorkPhotoAuthorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WorkPhotoAuthorDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkPhotoAuthorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWorkPhotoAuthorDto {
    id?: string | undefined;
    name?: string;
}

export class UpdateWorkPhotoNoteCommand implements IUpdateWorkPhotoNoteCommand {
    id?: number;
    note?: string | undefined;

    constructor(data?: IUpdateWorkPhotoNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateWorkPhotoNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkPhotoNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateWorkPhotoNoteCommand {
    id?: number;
    note?: string | undefined;
}

export class WorkMaterialConsumptionDto implements IWorkMaterialConsumptionDto {
    id?: number;
    workId?: number;
    workName?: string;
    description?: string;
    quantity?: number;
    unit?: string | undefined;
    unitCost?: number | undefined;
    totalCost?: number;
    consumedOn?: Date;
    notes?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWorkMaterialConsumptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.unitCost = _data["unitCost"];
            this.totalCost = _data["totalCost"];
            this.consumedOn = _data["consumedOn"] ? new Date(_data["consumedOn"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkMaterialConsumptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkMaterialConsumptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["unitCost"] = this.unitCost;
        data["totalCost"] = this.totalCost;
        data["consumedOn"] = this.consumedOn ? this.consumedOn.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkMaterialConsumptionDto {
    id?: number;
    workId?: number;
    workName?: string;
    description?: string;
    quantity?: number;
    unit?: string | undefined;
    unitCost?: number | undefined;
    totalCost?: number;
    consumedOn?: Date;
    notes?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class CreateWorkMaterialConsumptionCommand implements ICreateWorkMaterialConsumptionCommand {
    workId?: number;
    description?: string;
    quantity?: number;
    unit?: string | undefined;
    unitCost?: number | undefined;
    consumedOn?: Date;
    notes?: string | undefined;

    constructor(data?: ICreateWorkMaterialConsumptionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.unitCost = _data["unitCost"];
            this.consumedOn = _data["consumedOn"] ? new Date(_data["consumedOn"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateWorkMaterialConsumptionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkMaterialConsumptionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["unitCost"] = this.unitCost;
        data["consumedOn"] = this.consumedOn ? this.consumedOn.toISOString() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateWorkMaterialConsumptionCommand {
    workId?: number;
    description?: string;
    quantity?: number;
    unit?: string | undefined;
    unitCost?: number | undefined;
    consumedOn?: Date;
    notes?: string | undefined;
}

export class UpdateWorkMaterialConsumptionCommand implements IUpdateWorkMaterialConsumptionCommand {
    id?: number;
    workId?: number;
    description?: string;
    quantity?: number;
    unit?: string | undefined;
    unitCost?: number | undefined;
    consumedOn?: Date;
    notes?: string | undefined;

    constructor(data?: IUpdateWorkMaterialConsumptionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.unitCost = _data["unitCost"];
            this.consumedOn = _data["consumedOn"] ? new Date(_data["consumedOn"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateWorkMaterialConsumptionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkMaterialConsumptionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["unitCost"] = this.unitCost;
        data["consumedOn"] = this.consumedOn ? this.consumedOn.toISOString() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateWorkMaterialConsumptionCommand {
    id?: number;
    workId?: number;
    description?: string;
    quantity?: number;
    unit?: string | undefined;
    unitCost?: number | undefined;
    consumedOn?: Date;
    notes?: string | undefined;
}

export class WorkLaborEntryDto implements IWorkLaborEntryDto {
    id?: number;
    workId?: number | undefined;
    workName?: string;
    locationText?: string | undefined;
    locationLabel?: string;
    workerId?: number | undefined;
    workerName?: string;
    workedOn?: Date;
    hours?: number;
    hourlyRate?: number | undefined;
    cost?: number;
    isValidated?: boolean;
    validatedAt?: Date | undefined;
    validatedByUserId?: string | undefined;
    notes?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWorkLaborEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.locationText = _data["locationText"];
            this.locationLabel = _data["locationLabel"];
            this.workerId = _data["workerId"];
            this.workerName = _data["workerName"];
            this.workedOn = _data["workedOn"] ? new Date(_data["workedOn"].toString()) : undefined as any;
            this.hours = _data["hours"];
            this.hourlyRate = _data["hourlyRate"];
            this.cost = _data["cost"];
            this.isValidated = _data["isValidated"];
            this.validatedAt = _data["validatedAt"] ? new Date(_data["validatedAt"].toString()) : undefined as any;
            this.validatedByUserId = _data["validatedByUserId"];
            this.notes = _data["notes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkLaborEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkLaborEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["locationText"] = this.locationText;
        data["locationLabel"] = this.locationLabel;
        data["workerId"] = this.workerId;
        data["workerName"] = this.workerName;
        data["workedOn"] = this.workedOn ? this.workedOn.toISOString() : undefined as any;
        data["hours"] = this.hours;
        data["hourlyRate"] = this.hourlyRate;
        data["cost"] = this.cost;
        data["isValidated"] = this.isValidated;
        data["validatedAt"] = this.validatedAt ? this.validatedAt.toISOString() : undefined as any;
        data["validatedByUserId"] = this.validatedByUserId;
        data["notes"] = this.notes;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkLaborEntryDto {
    id?: number;
    workId?: number | undefined;
    workName?: string;
    locationText?: string | undefined;
    locationLabel?: string;
    workerId?: number | undefined;
    workerName?: string;
    workedOn?: Date;
    hours?: number;
    hourlyRate?: number | undefined;
    cost?: number;
    isValidated?: boolean;
    validatedAt?: Date | undefined;
    validatedByUserId?: string | undefined;
    notes?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class WorkerDto implements IWorkerDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    role?: string | undefined;
    isActive?: boolean;
    hourlyCost?: number | undefined;
    identityUserId?: string | undefined;
    isSupervisor?: boolean;
    supervisorId?: number | undefined;
    supervisorName?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWorkerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.role = _data["role"];
            this.isActive = _data["isActive"];
            this.hourlyCost = _data["hourlyCost"];
            this.identityUserId = _data["identityUserId"];
            this.isSupervisor = _data["isSupervisor"];
            this.supervisorId = _data["supervisorId"];
            this.supervisorName = _data["supervisorName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkerDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["role"] = this.role;
        data["isActive"] = this.isActive;
        data["hourlyCost"] = this.hourlyCost;
        data["identityUserId"] = this.identityUserId;
        data["isSupervisor"] = this.isSupervisor;
        data["supervisorId"] = this.supervisorId;
        data["supervisorName"] = this.supervisorName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkerDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    role?: string | undefined;
    isActive?: boolean;
    hourlyCost?: number | undefined;
    identityUserId?: string | undefined;
    isSupervisor?: boolean;
    supervisorId?: number | undefined;
    supervisorName?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class CreateWorkLaborEntryCommand implements ICreateWorkLaborEntryCommand {
    workId?: number | undefined;
    locationText?: string | undefined;
    workerId?: number | undefined;
    workerName?: string;
    workedOn?: Date;
    hours?: number;
    hourlyRate?: number | undefined;
    notes?: string | undefined;

    constructor(data?: ICreateWorkLaborEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.locationText = _data["locationText"];
            this.workerId = _data["workerId"];
            this.workerName = _data["workerName"];
            this.workedOn = _data["workedOn"] ? new Date(_data["workedOn"].toString()) : undefined as any;
            this.hours = _data["hours"];
            this.hourlyRate = _data["hourlyRate"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateWorkLaborEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkLaborEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["locationText"] = this.locationText;
        data["workerId"] = this.workerId;
        data["workerName"] = this.workerName;
        data["workedOn"] = this.workedOn ? this.workedOn.toISOString() : undefined as any;
        data["hours"] = this.hours;
        data["hourlyRate"] = this.hourlyRate;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateWorkLaborEntryCommand {
    workId?: number | undefined;
    locationText?: string | undefined;
    workerId?: number | undefined;
    workerName?: string;
    workedOn?: Date;
    hours?: number;
    hourlyRate?: number | undefined;
    notes?: string | undefined;
}

export class CreateMyWorkLaborEntryCommand implements ICreateMyWorkLaborEntryCommand {
    workerId?: number | undefined;
    workId?: number | undefined;
    locationText?: string | undefined;
    workedOn?: Date;
    hours?: number;
    notes?: string | undefined;

    constructor(data?: ICreateMyWorkLaborEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workerId = _data["workerId"];
            this.workId = _data["workId"];
            this.locationText = _data["locationText"];
            this.workedOn = _data["workedOn"] ? new Date(_data["workedOn"].toString()) : undefined as any;
            this.hours = _data["hours"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateMyWorkLaborEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMyWorkLaborEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workerId"] = this.workerId;
        data["workId"] = this.workId;
        data["locationText"] = this.locationText;
        data["workedOn"] = this.workedOn ? this.workedOn.toISOString() : undefined as any;
        data["hours"] = this.hours;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateMyWorkLaborEntryCommand {
    workerId?: number | undefined;
    workId?: number | undefined;
    locationText?: string | undefined;
    workedOn?: Date;
    hours?: number;
    notes?: string | undefined;
}

export class UpdateWorkLaborEntryCommand implements IUpdateWorkLaborEntryCommand {
    id?: number;
    workId?: number | undefined;
    locationText?: string | undefined;
    workerId?: number | undefined;
    workerName?: string;
    workedOn?: Date;
    hours?: number;
    hourlyRate?: number | undefined;
    notes?: string | undefined;

    constructor(data?: IUpdateWorkLaborEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.locationText = _data["locationText"];
            this.workerId = _data["workerId"];
            this.workerName = _data["workerName"];
            this.workedOn = _data["workedOn"] ? new Date(_data["workedOn"].toString()) : undefined as any;
            this.hours = _data["hours"];
            this.hourlyRate = _data["hourlyRate"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateWorkLaborEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkLaborEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["locationText"] = this.locationText;
        data["workerId"] = this.workerId;
        data["workerName"] = this.workerName;
        data["workedOn"] = this.workedOn ? this.workedOn.toISOString() : undefined as any;
        data["hours"] = this.hours;
        data["hourlyRate"] = this.hourlyRate;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateWorkLaborEntryCommand {
    id?: number;
    workId?: number | undefined;
    locationText?: string | undefined;
    workerId?: number | undefined;
    workerName?: string;
    workedOn?: Date;
    hours?: number;
    hourlyRate?: number | undefined;
    notes?: string | undefined;
}

export class ValidateWorkLaborEntryCommand implements IValidateWorkLaborEntryCommand {
    id?: number;
    isValidated?: boolean;

    constructor(data?: IValidateWorkLaborEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isValidated = _data["isValidated"];
        }
    }

    static fromJS(data: any): ValidateWorkLaborEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateWorkLaborEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isValidated"] = this.isValidated;
        return data;
    }
}

export interface IValidateWorkLaborEntryCommand {
    id?: number;
    isValidated?: boolean;
}

export class LookupOptionDto implements ILookupOptionDto {
    id?: number;
    label?: string;
    description?: string | undefined;
    keywords?: string | undefined;

    constructor(data?: ILookupOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.keywords = _data["keywords"];
        }
    }

    static fromJS(data: any): LookupOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["description"] = this.description;
        data["keywords"] = this.keywords;
        return data;
    }
}

export interface ILookupOptionDto {
    id?: number;
    label?: string;
    description?: string | undefined;
    keywords?: string | undefined;
}

export class CreateWorkerCommand implements ICreateWorkerCommand {
    name?: string;
    code?: string | undefined;
    role?: string | undefined;
    isActive?: boolean;
    hourlyCost?: number | undefined;
    identityUserId?: string | undefined;
    isSupervisor?: boolean;
    supervisorId?: number | undefined;

    constructor(data?: ICreateWorkerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.role = _data["role"];
            this.isActive = _data["isActive"];
            this.hourlyCost = _data["hourlyCost"];
            this.identityUserId = _data["identityUserId"];
            this.isSupervisor = _data["isSupervisor"];
            this.supervisorId = _data["supervisorId"];
        }
    }

    static fromJS(data: any): CreateWorkerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["role"] = this.role;
        data["isActive"] = this.isActive;
        data["hourlyCost"] = this.hourlyCost;
        data["identityUserId"] = this.identityUserId;
        data["isSupervisor"] = this.isSupervisor;
        data["supervisorId"] = this.supervisorId;
        return data;
    }
}

export interface ICreateWorkerCommand {
    name?: string;
    code?: string | undefined;
    role?: string | undefined;
    isActive?: boolean;
    hourlyCost?: number | undefined;
    identityUserId?: string | undefined;
    isSupervisor?: boolean;
    supervisorId?: number | undefined;
}

export class UpdateWorkerCommand implements IUpdateWorkerCommand {
    id?: number;
    name?: string;
    code?: string | undefined;
    role?: string | undefined;
    isActive?: boolean;
    hourlyCost?: number | undefined;
    identityUserId?: string | undefined;
    isSupervisor?: boolean;
    supervisorId?: number | undefined;

    constructor(data?: IUpdateWorkerCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.role = _data["role"];
            this.isActive = _data["isActive"];
            this.hourlyCost = _data["hourlyCost"];
            this.identityUserId = _data["identityUserId"];
            this.isSupervisor = _data["isSupervisor"];
            this.supervisorId = _data["supervisorId"];
        }
    }

    static fromJS(data: any): UpdateWorkerCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkerCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["role"] = this.role;
        data["isActive"] = this.isActive;
        data["hourlyCost"] = this.hourlyCost;
        data["identityUserId"] = this.identityUserId;
        data["isSupervisor"] = this.isSupervisor;
        data["supervisorId"] = this.supervisorId;
        return data;
    }
}

export interface IUpdateWorkerCommand {
    id?: number;
    name?: string;
    code?: string | undefined;
    role?: string | undefined;
    isActive?: boolean;
    hourlyCost?: number | undefined;
    identityUserId?: string | undefined;
    isSupervisor?: boolean;
    supervisorId?: number | undefined;
}

export class WorkDiaryEntriesVm implements IWorkDiaryEntriesVm {
    entries?: WorkDiaryEntryDto[];

    constructor(data?: IWorkDiaryEntriesVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(WorkDiaryEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkDiaryEntriesVm {
        data = typeof data === 'object' ? data : {};
        let result = new WorkDiaryEntriesVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkDiaryEntriesVm {
    entries?: WorkDiaryEntryDto[];
}

export class WorkDiaryEntryDto implements IWorkDiaryEntryDto {
    id?: number;
    workId?: number;
    entryDate?: Date;
    content?: string;
    author?: WorkDiaryAuthorDto;
    attachments?: WorkDiaryAttachmentDto[];
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWorkDiaryEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : undefined as any;
            this.content = _data["content"];
            this.author = _data["author"] ? WorkDiaryAuthorDto.fromJS(_data["author"]) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(WorkDiaryAttachmentDto.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkDiaryEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkDiaryEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["content"] = this.content;
        data["author"] = this.author ? this.author.toJSON() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkDiaryEntryDto {
    id?: number;
    workId?: number;
    entryDate?: Date;
    content?: string;
    author?: WorkDiaryAuthorDto;
    attachments?: WorkDiaryAttachmentDto[];
    created?: Date;
    lastModified?: Date;
}

export class WorkDiaryAuthorDto implements IWorkDiaryAuthorDto {
    id?: string | undefined;
    name?: string;

    constructor(data?: IWorkDiaryAuthorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WorkDiaryAuthorDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkDiaryAuthorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWorkDiaryAuthorDto {
    id?: string | undefined;
    name?: string;
}

export class WorkDiaryAttachmentDto implements IWorkDiaryAttachmentDto {
    id?: number;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;

    constructor(data?: IWorkDiaryAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.sizeInBytes = _data["sizeInBytes"];
        }
    }

    static fromJS(data: any): WorkDiaryAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkDiaryAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["sizeInBytes"] = this.sizeInBytes;
        return data;
    }
}

export interface IWorkDiaryAttachmentDto {
    id?: number;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;
}

export class CreateWorkDiaryEntryCommand implements ICreateWorkDiaryEntryCommand {
    workId?: number;
    entryDate?: Date;
    content?: string;
    attachments?: WorkDiaryAttachmentUploadDto[] | undefined;

    constructor(data?: ICreateWorkDiaryEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : undefined as any;
            this.content = _data["content"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(WorkDiaryAttachmentUploadDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateWorkDiaryEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkDiaryEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["content"] = this.content;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateWorkDiaryEntryCommand {
    workId?: number;
    entryDate?: Date;
    content?: string;
    attachments?: WorkDiaryAttachmentUploadDto[] | undefined;
}

export class WorkDiaryAttachmentUploadDto implements IWorkDiaryAttachmentUploadDto {
    id?: number;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;
    url?: string | undefined;

    constructor(data?: IWorkDiaryAttachmentUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): WorkDiaryAttachmentUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkDiaryAttachmentUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["sizeInBytes"] = this.sizeInBytes;
        data["url"] = this.url;
        return data;
    }
}

export interface IWorkDiaryAttachmentUploadDto {
    id?: number;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;
    url?: string | undefined;
}

export class UpdateWorkDiaryEntryCommand implements IUpdateWorkDiaryEntryCommand {
    id?: number;
    entryDate?: Date;
    content?: string;
    attachments?: WorkDiaryAttachmentUploadDto[] | undefined;

    constructor(data?: IUpdateWorkDiaryEntryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entryDate = _data["entryDate"] ? new Date(_data["entryDate"].toString()) : undefined as any;
            this.content = _data["content"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(WorkDiaryAttachmentUploadDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateWorkDiaryEntryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkDiaryEntryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["content"] = this.content;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateWorkDiaryEntryCommand {
    id?: number;
    entryDate?: Date;
    content?: string;
    attachments?: WorkDiaryAttachmentUploadDto[] | undefined;
}

export class WorkCostDto implements IWorkCostDto {
    id?: number;
    workId?: number;
    workCostTypeId?: number;
    typeCode?: string;
    typeName?: string;
    description?: string;
    costDate?: Date;
    amount?: number;
    supplier?: string | undefined;
    documentReference?: string | undefined;
    workerId?: number | undefined;
    workerName?: string | undefined;
    hours?: number | undefined;
    hourlyRate?: number | undefined;
    quantity?: number | undefined;
    unit?: string | undefined;
    notes?: string | undefined;
    budgetAreaName?: string | undefined;
    budgetChapterName?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWorkCostDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.workCostTypeId = _data["workCostTypeId"];
            this.typeCode = _data["typeCode"];
            this.typeName = _data["typeName"];
            this.description = _data["description"];
            this.costDate = _data["costDate"] ? new Date(_data["costDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.supplier = _data["supplier"];
            this.documentReference = _data["documentReference"];
            this.workerId = _data["workerId"];
            this.workerName = _data["workerName"];
            this.hours = _data["hours"];
            this.hourlyRate = _data["hourlyRate"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.notes = _data["notes"];
            this.budgetAreaName = _data["budgetAreaName"];
            this.budgetChapterName = _data["budgetChapterName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WorkCostDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkCostDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["workCostTypeId"] = this.workCostTypeId;
        data["typeCode"] = this.typeCode;
        data["typeName"] = this.typeName;
        data["description"] = this.description;
        data["costDate"] = this.costDate ? this.costDate.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["supplier"] = this.supplier;
        data["documentReference"] = this.documentReference;
        data["workerId"] = this.workerId;
        data["workerName"] = this.workerName;
        data["hours"] = this.hours;
        data["hourlyRate"] = this.hourlyRate;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["notes"] = this.notes;
        data["budgetAreaName"] = this.budgetAreaName;
        data["budgetChapterName"] = this.budgetChapterName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWorkCostDto {
    id?: number;
    workId?: number;
    workCostTypeId?: number;
    typeCode?: string;
    typeName?: string;
    description?: string;
    costDate?: Date;
    amount?: number;
    supplier?: string | undefined;
    documentReference?: string | undefined;
    workerId?: number | undefined;
    workerName?: string | undefined;
    hours?: number | undefined;
    hourlyRate?: number | undefined;
    quantity?: number | undefined;
    unit?: string | undefined;
    notes?: string | undefined;
    budgetAreaName?: string | undefined;
    budgetChapterName?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class WorkCostTypeDto implements IWorkCostTypeDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;

    constructor(data?: IWorkCostTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): WorkCostTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkCostTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IWorkCostTypeDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
}

export class CreateWorkCostCommand implements ICreateWorkCostCommand {
    workId?: number;
    workCostTypeId?: number;
    description?: string;
    costDate?: Date;
    amount?: number;
    supplier?: string | undefined;
    documentReference?: string | undefined;
    workerId?: number | undefined;
    hours?: number | undefined;
    hourlyRate?: number | undefined;
    quantity?: number | undefined;
    unit?: string | undefined;
    notes?: string | undefined;
    budgetAreaName?: string | undefined;
    budgetChapterName?: string | undefined;

    constructor(data?: ICreateWorkCostCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.workCostTypeId = _data["workCostTypeId"];
            this.description = _data["description"];
            this.costDate = _data["costDate"] ? new Date(_data["costDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.supplier = _data["supplier"];
            this.documentReference = _data["documentReference"];
            this.workerId = _data["workerId"];
            this.hours = _data["hours"];
            this.hourlyRate = _data["hourlyRate"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.notes = _data["notes"];
            this.budgetAreaName = _data["budgetAreaName"];
            this.budgetChapterName = _data["budgetChapterName"];
        }
    }

    static fromJS(data: any): CreateWorkCostCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkCostCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["workCostTypeId"] = this.workCostTypeId;
        data["description"] = this.description;
        data["costDate"] = this.costDate ? this.costDate.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["supplier"] = this.supplier;
        data["documentReference"] = this.documentReference;
        data["workerId"] = this.workerId;
        data["hours"] = this.hours;
        data["hourlyRate"] = this.hourlyRate;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["notes"] = this.notes;
        data["budgetAreaName"] = this.budgetAreaName;
        data["budgetChapterName"] = this.budgetChapterName;
        return data;
    }
}

export interface ICreateWorkCostCommand {
    workId?: number;
    workCostTypeId?: number;
    description?: string;
    costDate?: Date;
    amount?: number;
    supplier?: string | undefined;
    documentReference?: string | undefined;
    workerId?: number | undefined;
    hours?: number | undefined;
    hourlyRate?: number | undefined;
    quantity?: number | undefined;
    unit?: string | undefined;
    notes?: string | undefined;
    budgetAreaName?: string | undefined;
    budgetChapterName?: string | undefined;
}

export class IndirectAllocationResultDto implements IIndirectAllocationResultDto {
    criterion?: string;
    totalAmount?: number;
    confirmed?: boolean;
    equalFallback?: boolean;
    includedCount?: number;
    allocations?: IndirectAllocationItemDto[];

    constructor(data?: IIndirectAllocationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criterion = _data["criterion"];
            this.totalAmount = _data["totalAmount"];
            this.confirmed = _data["confirmed"];
            this.equalFallback = _data["equalFallback"];
            this.includedCount = _data["includedCount"];
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(IndirectAllocationItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IndirectAllocationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndirectAllocationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criterion"] = this.criterion;
        data["totalAmount"] = this.totalAmount;
        data["confirmed"] = this.confirmed;
        data["equalFallback"] = this.equalFallback;
        data["includedCount"] = this.includedCount;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIndirectAllocationResultDto {
    criterion?: string;
    totalAmount?: number;
    confirmed?: boolean;
    equalFallback?: boolean;
    includedCount?: number;
    allocations?: IndirectAllocationItemDto[];
}

export class IndirectAllocationItemDto implements IIndirectAllocationItemDto {
    workId?: number;
    workName?: string;
    weight?: number;
    weightPercent?: number;
    amount?: number;

    constructor(data?: IIndirectAllocationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.weight = _data["weight"];
            this.weightPercent = _data["weightPercent"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): IndirectAllocationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndirectAllocationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["weight"] = this.weight;
        data["weightPercent"] = this.weightPercent;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIndirectAllocationItemDto {
    workId?: number;
    workName?: string;
    weight?: number;
    weightPercent?: number;
    amount?: number;
}

export class AllocateIndirectCostCommand implements IAllocateIndirectCostCommand {
    criterion?: string | undefined;
    totalAmount?: number;
    description?: string;
    costDate?: Date;
    confirm?: boolean;

    constructor(data?: IAllocateIndirectCostCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criterion = _data["criterion"];
            this.totalAmount = _data["totalAmount"];
            this.description = _data["description"];
            this.costDate = _data["costDate"] ? new Date(_data["costDate"].toString()) : undefined as any;
            this.confirm = _data["confirm"];
        }
    }

    static fromJS(data: any): AllocateIndirectCostCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AllocateIndirectCostCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criterion"] = this.criterion;
        data["totalAmount"] = this.totalAmount;
        data["description"] = this.description;
        data["costDate"] = this.costDate ? this.costDate.toISOString() : undefined as any;
        data["confirm"] = this.confirm;
        return data;
    }
}

export interface IAllocateIndirectCostCommand {
    criterion?: string | undefined;
    totalAmount?: number;
    description?: string;
    costDate?: Date;
    confirm?: boolean;
}

export class UpdateWorkCostCommand implements IUpdateWorkCostCommand {
    id?: number;
    workId?: number;
    workCostTypeId?: number;
    description?: string;
    costDate?: Date;
    amount?: number;
    supplier?: string | undefined;
    documentReference?: string | undefined;
    workerId?: number | undefined;
    hours?: number | undefined;
    hourlyRate?: number | undefined;
    quantity?: number | undefined;
    unit?: string | undefined;
    notes?: string | undefined;
    budgetAreaName?: string | undefined;
    budgetChapterName?: string | undefined;

    constructor(data?: IUpdateWorkCostCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.workCostTypeId = _data["workCostTypeId"];
            this.description = _data["description"];
            this.costDate = _data["costDate"] ? new Date(_data["costDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.supplier = _data["supplier"];
            this.documentReference = _data["documentReference"];
            this.workerId = _data["workerId"];
            this.hours = _data["hours"];
            this.hourlyRate = _data["hourlyRate"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.notes = _data["notes"];
            this.budgetAreaName = _data["budgetAreaName"];
            this.budgetChapterName = _data["budgetChapterName"];
        }
    }

    static fromJS(data: any): UpdateWorkCostCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkCostCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["workCostTypeId"] = this.workCostTypeId;
        data["description"] = this.description;
        data["costDate"] = this.costDate ? this.costDate.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["supplier"] = this.supplier;
        data["documentReference"] = this.documentReference;
        data["workerId"] = this.workerId;
        data["hours"] = this.hours;
        data["hourlyRate"] = this.hourlyRate;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["notes"] = this.notes;
        data["budgetAreaName"] = this.budgetAreaName;
        data["budgetChapterName"] = this.budgetChapterName;
        return data;
    }
}

export interface IUpdateWorkCostCommand {
    id?: number;
    workId?: number;
    workCostTypeId?: number;
    description?: string;
    costDate?: Date;
    amount?: number;
    supplier?: string | undefined;
    documentReference?: string | undefined;
    workerId?: number | undefined;
    hours?: number | undefined;
    hourlyRate?: number | undefined;
    quantity?: number | undefined;
    unit?: string | undefined;
    notes?: string | undefined;
    budgetAreaName?: string | undefined;
    budgetChapterName?: string | undefined;
}

export class WarehouseDto implements IWarehouseDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    address?: string | undefined;
    responsible?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IWarehouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.responsible = _data["responsible"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): WarehouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["responsible"] = this.responsible;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IWarehouseDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    address?: string | undefined;
    responsible?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class CreateWarehouseCommand implements ICreateWarehouseCommand {
    name?: string;
    code?: string | undefined;
    address?: string | undefined;
    responsible?: string | undefined;

    constructor(data?: ICreateWarehouseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.responsible = _data["responsible"];
        }
    }

    static fromJS(data: any): CreateWarehouseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWarehouseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["responsible"] = this.responsible;
        return data;
    }
}

export interface ICreateWarehouseCommand {
    name?: string;
    code?: string | undefined;
    address?: string | undefined;
    responsible?: string | undefined;
}

export class UpdateWarehouseCommand implements IUpdateWarehouseCommand {
    id?: number;
    name?: string;
    code?: string | undefined;
    address?: string | undefined;
    responsible?: string | undefined;

    constructor(data?: IUpdateWarehouseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.address = _data["address"];
            this.responsible = _data["responsible"];
        }
    }

    static fromJS(data: any): UpdateWarehouseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWarehouseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["address"] = this.address;
        data["responsible"] = this.responsible;
        return data;
    }
}

export interface IUpdateWarehouseCommand {
    id?: number;
    name?: string;
    code?: string | undefined;
    address?: string | undefined;
    responsible?: string | undefined;
}

export class UserProfileDto implements IUserProfileDto {
    userId?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string | undefined;
    department?: string | undefined;
    avatarUrl?: string | undefined;
    themeMode?: string;
    roles?: string[];

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.department = _data["department"];
            this.avatarUrl = _data["avatarUrl"];
            this.themeMode = _data["themeMode"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["department"] = this.department;
        data["avatarUrl"] = this.avatarUrl;
        data["themeMode"] = this.themeMode;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUserProfileDto {
    userId?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string | undefined;
    department?: string | undefined;
    avatarUrl?: string | undefined;
    themeMode?: string;
    roles?: string[];
}

export class CreateUserCommand implements ICreateUserCommand {
    email?: string;
    password?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string | undefined;
    department?: string | undefined;
    role?: string;
    roles?: string[] | undefined;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.department = _data["department"];
            this.role = _data["role"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["department"] = this.department;
        data["role"] = this.role;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ICreateUserCommand {
    email?: string;
    password?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string | undefined;
    department?: string | undefined;
    role?: string;
    roles?: string[] | undefined;
}

export class UserAdminDto implements IUserAdminDto {
    userId?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string | undefined;
    department?: string | undefined;
    avatarUrl?: string | undefined;
    roles?: string[];
    emailConfirmed?: boolean;
    lockoutEnd?: Date | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IUserAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.department = _data["department"];
            this.avatarUrl = _data["avatarUrl"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.emailConfirmed = _data["emailConfirmed"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UserAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["department"] = this.department;
        data["avatarUrl"] = this.avatarUrl;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["emailConfirmed"] = this.emailConfirmed;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IUserAdminDto {
    userId?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string | undefined;
    department?: string | undefined;
    avatarUrl?: string | undefined;
    roles?: string[];
    emailConfirmed?: boolean;
    lockoutEnd?: Date | undefined;
    created?: Date;
    lastModified?: Date;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    userId?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string | undefined;
    department?: string | undefined;
    role?: string;
    roles?: string[] | undefined;
    isActive?: boolean | undefined;
    newPassword?: string | undefined;

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.department = _data["department"];
            this.role = _data["role"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.isActive = _data["isActive"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["department"] = this.department;
        data["role"] = this.role;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["isActive"] = this.isActive;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IUpdateUserCommand {
    userId?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string | undefined;
    department?: string | undefined;
    role?: string;
    roles?: string[] | undefined;
    isActive?: boolean | undefined;
    newPassword?: string | undefined;
}

export class UpdateMyProfileCommand implements IUpdateMyProfileCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    department?: string | undefined;
    themeMode?: string | undefined;
    newPassword?: string | undefined;

    constructor(data?: IUpdateMyProfileCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.department = _data["department"];
            this.themeMode = _data["themeMode"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UpdateMyProfileCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMyProfileCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["department"] = this.department;
        data["themeMode"] = this.themeMode;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IUpdateMyProfileCommand {
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    department?: string | undefined;
    themeMode?: string | undefined;
    newPassword?: string | undefined;
}

export class UserPreferencesDto implements IUserPreferencesDto {
    themeMode?: string;

    constructor(data?: IUserPreferencesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.themeMode = _data["themeMode"];
        }
    }

    static fromJS(data: any): UserPreferencesDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPreferencesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["themeMode"] = this.themeMode;
        return data;
    }
}

export interface IUserPreferencesDto {
    themeMode?: string;
}

export class UpdateMyPreferencesCommand implements IUpdateMyPreferencesCommand {
    themeMode?: string | undefined;

    constructor(data?: IUpdateMyPreferencesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.themeMode = _data["themeMode"];
        }
    }

    static fromJS(data: any): UpdateMyPreferencesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMyPreferencesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["themeMode"] = this.themeMode;
        return data;
    }
}

export interface IUpdateMyPreferencesCommand {
    themeMode?: string | undefined;
}

export class UserAvatarDto implements IUserAvatarDto {
    avatarUrl?: string;

    constructor(data?: IUserAvatarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.avatarUrl = _data["avatarUrl"];
        }
    }

    static fromJS(data: any): UserAvatarDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAvatarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avatarUrl"] = this.avatarUrl;
        return data;
    }
}

export interface IUserAvatarDto {
    avatarUrl?: string;
}

export class CashflowCalendarDto implements ICashflowCalendarDto {
    days?: number;
    rangeStart?: Date;
    rangeEnd?: Date;
    totalInflows?: number;
    totalOutflows?: number;
    net?: number;
    events?: CashflowEventDto[];

    constructor(data?: ICashflowCalendarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.days = _data["days"];
            this.rangeStart = _data["rangeStart"] ? new Date(_data["rangeStart"].toString()) : undefined as any;
            this.rangeEnd = _data["rangeEnd"] ? new Date(_data["rangeEnd"].toString()) : undefined as any;
            this.totalInflows = _data["totalInflows"];
            this.totalOutflows = _data["totalOutflows"];
            this.net = _data["net"];
            if (Array.isArray(_data["events"])) {
                this.events = [] as any;
                for (let item of _data["events"])
                    this.events!.push(CashflowEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CashflowCalendarDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashflowCalendarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["days"] = this.days;
        data["rangeStart"] = this.rangeStart ? this.rangeStart.toISOString() : undefined as any;
        data["rangeEnd"] = this.rangeEnd ? this.rangeEnd.toISOString() : undefined as any;
        data["totalInflows"] = this.totalInflows;
        data["totalOutflows"] = this.totalOutflows;
        data["net"] = this.net;
        if (Array.isArray(this.events)) {
            data["events"] = [];
            for (let item of this.events)
                data["events"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICashflowCalendarDto {
    days?: number;
    rangeStart?: Date;
    rangeEnd?: Date;
    totalInflows?: number;
    totalOutflows?: number;
    net?: number;
    events?: CashflowEventDto[];
}

export class CashflowEventDto implements ICashflowEventDto {
    date?: Date;
    type?: string;
    category?: string;
    amount?: number;
    description?: string;
    reference?: string;

    constructor(data?: ICashflowEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.type = _data["type"];
            this.category = _data["category"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): CashflowEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CashflowEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["type"] = this.type;
        data["category"] = this.category;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["reference"] = this.reference;
        return data;
    }
}

export interface ICashflowEventDto {
    date?: Date;
    type?: string;
    category?: string;
    amount?: number;
    description?: string;
    reference?: string;
}

export class TreasuryForecastDto implements ITreasuryForecastDto {
    asOf?: Date;
    monthEnd?: Date;
    openingBalance?: number;
    openingBalanceAsOf?: Date | undefined;
    inflowsTotal?: number;
    outflowsTotal?: number;
    projectedBalance?: number;
    level?: string;
    inflows?: ForecastItemDto[];
    outflows?: ForecastItemDto[];
    alerts?: TreasuryAlertDto[];

    constructor(data?: ITreasuryForecastDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.asOf = _data["asOf"] ? new Date(_data["asOf"].toString()) : undefined as any;
            this.monthEnd = _data["monthEnd"] ? new Date(_data["monthEnd"].toString()) : undefined as any;
            this.openingBalance = _data["openingBalance"];
            this.openingBalanceAsOf = _data["openingBalanceAsOf"] ? new Date(_data["openingBalanceAsOf"].toString()) : undefined as any;
            this.inflowsTotal = _data["inflowsTotal"];
            this.outflowsTotal = _data["outflowsTotal"];
            this.projectedBalance = _data["projectedBalance"];
            this.level = _data["level"];
            if (Array.isArray(_data["inflows"])) {
                this.inflows = [] as any;
                for (let item of _data["inflows"])
                    this.inflows!.push(ForecastItemDto.fromJS(item));
            }
            if (Array.isArray(_data["outflows"])) {
                this.outflows = [] as any;
                for (let item of _data["outflows"])
                    this.outflows!.push(ForecastItemDto.fromJS(item));
            }
            if (Array.isArray(_data["alerts"])) {
                this.alerts = [] as any;
                for (let item of _data["alerts"])
                    this.alerts!.push(TreasuryAlertDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TreasuryForecastDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreasuryForecastDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asOf"] = this.asOf ? this.asOf.toISOString() : undefined as any;
        data["monthEnd"] = this.monthEnd ? this.monthEnd.toISOString() : undefined as any;
        data["openingBalance"] = this.openingBalance;
        data["openingBalanceAsOf"] = this.openingBalanceAsOf ? this.openingBalanceAsOf.toISOString() : undefined as any;
        data["inflowsTotal"] = this.inflowsTotal;
        data["outflowsTotal"] = this.outflowsTotal;
        data["projectedBalance"] = this.projectedBalance;
        data["level"] = this.level;
        if (Array.isArray(this.inflows)) {
            data["inflows"] = [];
            for (let item of this.inflows)
                data["inflows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.outflows)) {
            data["outflows"] = [];
            for (let item of this.outflows)
                data["outflows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.alerts)) {
            data["alerts"] = [];
            for (let item of this.alerts)
                data["alerts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITreasuryForecastDto {
    asOf?: Date;
    monthEnd?: Date;
    openingBalance?: number;
    openingBalanceAsOf?: Date | undefined;
    inflowsTotal?: number;
    outflowsTotal?: number;
    projectedBalance?: number;
    level?: string;
    inflows?: ForecastItemDto[];
    outflows?: ForecastItemDto[];
    alerts?: TreasuryAlertDto[];
}

export class ForecastItemDto implements IForecastItemDto {
    category?: string;
    date?: Date;
    amount?: number;
    description?: string;
    reference?: string;

    constructor(data?: IForecastItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): ForecastItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IForecastItemDto {
    category?: string;
    date?: Date;
    amount?: number;
    description?: string;
    reference?: string;
}

export class TreasuryAlertDto implements ITreasuryAlertDto {
    severity?: string;
    type?: string;
    message?: string;
    date?: Date | undefined;
    amount?: number | undefined;

    constructor(data?: ITreasuryAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.severity = _data["severity"];
            this.type = _data["type"];
            this.message = _data["message"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): TreasuryAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreasuryAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["severity"] = this.severity;
        data["type"] = this.type;
        data["message"] = this.message;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["amount"] = this.amount;
        return data;
    }
}

export interface ITreasuryAlertDto {
    severity?: string;
    type?: string;
    message?: string;
    date?: Date | undefined;
    amount?: number | undefined;
}

export class TenantDto implements ITenantDto {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    iban?: string | undefined;
    guarantor?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.iban = _data["iban"];
            this.guarantor = _data["guarantor"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["iban"] = this.iban;
        data["guarantor"] = this.guarantor;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface ITenantDto {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    iban?: string | undefined;
    guarantor?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class CreateTenantCommand implements ICreateTenantCommand {
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    iban?: string | undefined;
    guarantor?: string | undefined;

    constructor(data?: ICreateTenantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.iban = _data["iban"];
            this.guarantor = _data["guarantor"];
        }
    }

    static fromJS(data: any): CreateTenantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["iban"] = this.iban;
        data["guarantor"] = this.guarantor;
        return data;
    }
}

export interface ICreateTenantCommand {
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    iban?: string | undefined;
    guarantor?: string | undefined;
}

export class UpdateTenantCommand implements IUpdateTenantCommand {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    iban?: string | undefined;
    guarantor?: string | undefined;

    constructor(data?: IUpdateTenantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.iban = _data["iban"];
            this.guarantor = _data["guarantor"];
        }
    }

    static fromJS(data: any): UpdateTenantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["iban"] = this.iban;
        data["guarantor"] = this.guarantor;
        return data;
    }
}

export interface IUpdateTenantCommand {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    iban?: string | undefined;
    guarantor?: string | undefined;
}

export class BudgetDocumentDto implements IBudgetDocumentDto {
    id?: number;
    name?: string;
    sizeInBytes?: number;
    url?: string | undefined;
    processingStatus?: string;
    processingError?: string | undefined;
    category?: string | undefined;
    technicalDocumentStatus?: string | undefined;

    constructor(data?: IBudgetDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.url = _data["url"];
            this.processingStatus = _data["processingStatus"];
            this.processingError = _data["processingError"];
            this.category = _data["category"];
            this.technicalDocumentStatus = _data["technicalDocumentStatus"];
        }
    }

    static fromJS(data: any): BudgetDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sizeInBytes"] = this.sizeInBytes;
        data["url"] = this.url;
        data["processingStatus"] = this.processingStatus;
        data["processingError"] = this.processingError;
        data["category"] = this.category;
        data["technicalDocumentStatus"] = this.technicalDocumentStatus;
        return data;
    }
}

export interface IBudgetDocumentDto {
    id?: number;
    name?: string;
    sizeInBytes?: number;
    url?: string | undefined;
    processingStatus?: string;
    processingError?: string | undefined;
    category?: string | undefined;
    technicalDocumentStatus?: string | undefined;
}

export class TechnicalDocumentAnalysisDto implements ITechnicalDocumentAnalysisDto {
    id?: number;
    budgetDocumentId?: number;
    statusCode?: string;
    statusName?: string;
    extractedAt?: Date;
    boqLines?: PreliminaryBoqLineDto[];
    isExportReady?: boolean;

    constructor(data?: ITechnicalDocumentAnalysisDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.budgetDocumentId = _data["budgetDocumentId"];
            this.statusCode = _data["statusCode"];
            this.statusName = _data["statusName"];
            this.extractedAt = _data["extractedAt"] ? new Date(_data["extractedAt"].toString()) : undefined as any;
            if (Array.isArray(_data["boqLines"])) {
                this.boqLines = [] as any;
                for (let item of _data["boqLines"])
                    this.boqLines!.push(PreliminaryBoqLineDto.fromJS(item));
            }
            this.isExportReady = _data["isExportReady"];
        }
    }

    static fromJS(data: any): TechnicalDocumentAnalysisDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnicalDocumentAnalysisDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["budgetDocumentId"] = this.budgetDocumentId;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        data["extractedAt"] = this.extractedAt ? this.extractedAt.toISOString() : undefined as any;
        if (Array.isArray(this.boqLines)) {
            data["boqLines"] = [];
            for (let item of this.boqLines)
                data["boqLines"].push(item ? item.toJSON() : undefined as any);
        }
        data["isExportReady"] = this.isExportReady;
        return data;
    }
}

export interface ITechnicalDocumentAnalysisDto {
    id?: number;
    budgetDocumentId?: number;
    statusCode?: string;
    statusName?: string;
    extractedAt?: Date;
    boqLines?: PreliminaryBoqLineDto[];
    isExportReady?: boolean;
}

export class PreliminaryBoqLineDto implements IPreliminaryBoqLineDto {
    id?: number;
    description?: string;
    quantity?: number;
    unit?: string;
    measurementMethodCode?: string;
    measurementMethodName?: string;
    templateLineCode?: string | undefined;
    sourceReference?: string | undefined;
    suggestedAreaName?: string | undefined;
    suggestedChapterName?: string | undefined;
    isApproved?: boolean;

    constructor(data?: IPreliminaryBoqLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.measurementMethodCode = _data["measurementMethodCode"];
            this.measurementMethodName = _data["measurementMethodName"];
            this.templateLineCode = _data["templateLineCode"];
            this.sourceReference = _data["sourceReference"];
            this.suggestedAreaName = _data["suggestedAreaName"];
            this.suggestedChapterName = _data["suggestedChapterName"];
            this.isApproved = _data["isApproved"];
        }
    }

    static fromJS(data: any): PreliminaryBoqLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreliminaryBoqLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["measurementMethodCode"] = this.measurementMethodCode;
        data["measurementMethodName"] = this.measurementMethodName;
        data["templateLineCode"] = this.templateLineCode;
        data["sourceReference"] = this.sourceReference;
        data["suggestedAreaName"] = this.suggestedAreaName;
        data["suggestedChapterName"] = this.suggestedChapterName;
        data["isApproved"] = this.isApproved;
        return data;
    }
}

export interface IPreliminaryBoqLineDto {
    id?: number;
    description?: string;
    quantity?: number;
    unit?: string;
    measurementMethodCode?: string;
    measurementMethodName?: string;
    templateLineCode?: string | undefined;
    sourceReference?: string | undefined;
    suggestedAreaName?: string | undefined;
    suggestedChapterName?: string | undefined;
    isApproved?: boolean;
}

export class ApproveAllConfidentResult implements IApproveAllConfidentResult {
    approvedCount?: number;

    constructor(data?: IApproveAllConfidentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvedCount = _data["approvedCount"];
        }
    }

    static fromJS(data: any): ApproveAllConfidentResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveAllConfidentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvedCount"] = this.approvedCount;
        return data;
    }
}

export interface IApproveAllConfidentResult {
    approvedCount?: number;
}

export class UpdatePreliminaryBoqLineCommand implements IUpdatePreliminaryBoqLineCommand {
    lineId?: number;
    description?: string;
    quantity?: number;
    unit?: string;

    constructor(data?: IUpdatePreliminaryBoqLineCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): UpdatePreliminaryBoqLineCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePreliminaryBoqLineCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IUpdatePreliminaryBoqLineCommand {
    lineId?: number;
    description?: string;
    quantity?: number;
    unit?: string;
}

export class ImportBoqLineRequest implements IImportBoqLineRequest {
    areaName?: string;
    chapterName?: string;

    constructor(data?: IImportBoqLineRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.areaName = _data["areaName"];
            this.chapterName = _data["chapterName"];
        }
    }

    static fromJS(data: any): ImportBoqLineRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportBoqLineRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaName"] = this.areaName;
        data["chapterName"] = this.chapterName;
        return data;
    }
}

export interface IImportBoqLineRequest {
    areaName?: string;
    chapterName?: string;
}

export class ImportAllConfidentResult implements IImportAllConfidentResult {
    importedCount?: number;

    constructor(data?: IImportAllConfidentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importedCount = _data["importedCount"];
        }
    }

    static fromJS(data: any): ImportAllConfidentResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportAllConfidentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importedCount"] = this.importedCount;
        return data;
    }
}

export interface IImportAllConfidentResult {
    importedCount?: number;
}

export class ImportAllConfidentRequest implements IImportAllConfidentRequest {
    defaultAreaName?: string;
    defaultChapterName?: string;

    constructor(data?: IImportAllConfidentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultAreaName = _data["defaultAreaName"];
            this.defaultChapterName = _data["defaultChapterName"];
        }
    }

    static fromJS(data: any): ImportAllConfidentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportAllConfidentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultAreaName"] = this.defaultAreaName;
        data["defaultChapterName"] = this.defaultChapterName;
        return data;
    }
}

export interface IImportAllConfidentRequest {
    defaultAreaName?: string;
    defaultChapterName?: string;
}

export class ImportAllConfidentByBudgetResponse implements IImportAllConfidentByBudgetResponse {
    importedCount?: number;
    skippedCount?: number;

    constructor(data?: IImportAllConfidentByBudgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importedCount = _data["importedCount"];
            this.skippedCount = _data["skippedCount"];
        }
    }

    static fromJS(data: any): ImportAllConfidentByBudgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportAllConfidentByBudgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importedCount"] = this.importedCount;
        data["skippedCount"] = this.skippedCount;
        return data;
    }
}

export interface IImportAllConfidentByBudgetResponse {
    importedCount?: number;
    skippedCount?: number;
}

export class TaxObligationDto implements ITaxObligationDto {
    id?: number;
    kind?: string;
    description?: string | undefined;
    periodLabel?: string | undefined;
    amount?: number;
    dueDate?: Date;
    isPaid?: boolean;
    paidAt?: Date | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: ITaxObligationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kind = _data["kind"];
            this.description = _data["description"];
            this.periodLabel = _data["periodLabel"];
            this.amount = _data["amount"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.isPaid = _data["isPaid"];
            this.paidAt = _data["paidAt"] ? new Date(_data["paidAt"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): TaxObligationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxObligationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kind"] = this.kind;
        data["description"] = this.description;
        data["periodLabel"] = this.periodLabel;
        data["amount"] = this.amount;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["isPaid"] = this.isPaid;
        data["paidAt"] = this.paidAt ? this.paidAt.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface ITaxObligationDto {
    id?: number;
    kind?: string;
    description?: string | undefined;
    periodLabel?: string | undefined;
    amount?: number;
    dueDate?: Date;
    isPaid?: boolean;
    paidAt?: Date | undefined;
    created?: Date;
    lastModified?: Date;
}

export class IvaProvisionSuggestionDto implements IIvaProvisionSuggestionDto {
    periodLabel?: string;
    vatCollected?: number;
    vatPaid?: number;
    suggestedAmount?: number;
    suggestedDueDate?: Date;

    constructor(data?: IIvaProvisionSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodLabel = _data["periodLabel"];
            this.vatCollected = _data["vatCollected"];
            this.vatPaid = _data["vatPaid"];
            this.suggestedAmount = _data["suggestedAmount"];
            this.suggestedDueDate = _data["suggestedDueDate"] ? new Date(_data["suggestedDueDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): IvaProvisionSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IvaProvisionSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodLabel"] = this.periodLabel;
        data["vatCollected"] = this.vatCollected;
        data["vatPaid"] = this.vatPaid;
        data["suggestedAmount"] = this.suggestedAmount;
        data["suggestedDueDate"] = this.suggestedDueDate ? this.suggestedDueDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IIvaProvisionSuggestionDto {
    periodLabel?: string;
    vatCollected?: number;
    vatPaid?: number;
    suggestedAmount?: number;
    suggestedDueDate?: Date;
}

export class CreateTaxObligationCommand implements ICreateTaxObligationCommand {
    kind?: string;
    description?: string | undefined;
    periodLabel?: string | undefined;
    amount?: number;
    dueDate?: Date;

    constructor(data?: ICreateTaxObligationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.description = _data["description"];
            this.periodLabel = _data["periodLabel"];
            this.amount = _data["amount"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateTaxObligationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaxObligationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["description"] = this.description;
        data["periodLabel"] = this.periodLabel;
        data["amount"] = this.amount;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateTaxObligationCommand {
    kind?: string;
    description?: string | undefined;
    periodLabel?: string | undefined;
    amount?: number;
    dueDate?: Date;
}

export class UpdateTaxObligationCommand implements IUpdateTaxObligationCommand {
    id?: number;
    kind?: string;
    description?: string | undefined;
    periodLabel?: string | undefined;
    amount?: number;
    dueDate?: Date;

    constructor(data?: IUpdateTaxObligationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kind = _data["kind"];
            this.description = _data["description"];
            this.periodLabel = _data["periodLabel"];
            this.amount = _data["amount"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateTaxObligationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaxObligationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kind"] = this.kind;
        data["description"] = this.description;
        data["periodLabel"] = this.periodLabel;
        data["amount"] = this.amount;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateTaxObligationCommand {
    id?: number;
    kind?: string;
    description?: string | undefined;
    periodLabel?: string | undefined;
    amount?: number;
    dueDate?: Date;
}

export class MarkTaxObligationPaidCommand implements IMarkTaxObligationPaidCommand {
    id?: number;
    paidAt?: Date | undefined;

    constructor(data?: IMarkTaxObligationPaidCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paidAt = _data["paidAt"] ? new Date(_data["paidAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MarkTaxObligationPaidCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MarkTaxObligationPaidCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paidAt"] = this.paidAt ? this.paidAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IMarkTaxObligationPaidCommand {
    id?: number;
    paidAt?: Date | undefined;
}

export class TaskItemDto implements ITaskItemDto {
    id?: number;
    title?: string;
    description?: string | undefined;
    status?: TaskItemStatus;
    urgency?: TaskItemUrgency;
    responsibleUserId?: string | undefined;
    responsibleName?: string | undefined;
    dueDate?: Date | undefined;
    workId?: number | undefined;
    workName?: string | undefined;
    completedAt?: Date | undefined;
    created?: Date;
    recurringTaskId?: number | undefined;

    constructor(data?: ITaskItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.urgency = _data["urgency"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.responsibleName = _data["responsibleName"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.recurringTaskId = _data["recurringTaskId"];
        }
    }

    static fromJS(data: any): TaskItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        data["urgency"] = this.urgency;
        data["responsibleUserId"] = this.responsibleUserId;
        data["responsibleName"] = this.responsibleName;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["recurringTaskId"] = this.recurringTaskId;
        return data;
    }
}

export interface ITaskItemDto {
    id?: number;
    title?: string;
    description?: string | undefined;
    status?: TaskItemStatus;
    urgency?: TaskItemUrgency;
    responsibleUserId?: string | undefined;
    responsibleName?: string | undefined;
    dueDate?: Date | undefined;
    workId?: number | undefined;
    workName?: string | undefined;
    completedAt?: Date | undefined;
    created?: Date;
    recurringTaskId?: number | undefined;
}

export enum TaskItemStatus {
    ToDo = "ToDo",
    Waiting = "Waiting",
    InProgress = "InProgress",
    Done = "Done",
}

export enum TaskItemUrgency {
    Normal = "Normal",
    Urgent = "Urgent",
    VeryUrgent = "VeryUrgent",
}

export class TaskAssigneeDto implements ITaskAssigneeDto {
    userId?: string;
    name?: string;

    constructor(data?: ITaskAssigneeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TaskAssigneeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskAssigneeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        return data;
    }
}

export interface ITaskAssigneeDto {
    userId?: string;
    name?: string;
}

export class TaskSummaryVm implements ITaskSummaryVm {
    mineDueOrOverdue?: number;

    constructor(data?: ITaskSummaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mineDueOrOverdue = _data["mineDueOrOverdue"];
        }
    }

    static fromJS(data: any): TaskSummaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new TaskSummaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mineDueOrOverdue"] = this.mineDueOrOverdue;
        return data;
    }
}

export interface ITaskSummaryVm {
    mineDueOrOverdue?: number;
}

export class TaskCalendarVm implements ITaskCalendarVm {
    month?: Date;
    macros?: RecurringTaskDto[];
    occurrences?: RecurringOccurrenceDto[];
    tasks?: TaskItemDto[];

    constructor(data?: ITaskCalendarVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"] ? new Date(_data["month"].toString()) : undefined as any;
            if (Array.isArray(_data["macros"])) {
                this.macros = [] as any;
                for (let item of _data["macros"])
                    this.macros!.push(RecurringTaskDto.fromJS(item));
            }
            if (Array.isArray(_data["occurrences"])) {
                this.occurrences = [] as any;
                for (let item of _data["occurrences"])
                    this.occurrences!.push(RecurringOccurrenceDto.fromJS(item));
            }
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskCalendarVm {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCalendarVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month ? this.month.toISOString() : undefined as any;
        if (Array.isArray(this.macros)) {
            data["macros"] = [];
            for (let item of this.macros)
                data["macros"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.occurrences)) {
            data["occurrences"] = [];
            for (let item of this.occurrences)
                data["occurrences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskCalendarVm {
    month?: Date;
    macros?: RecurringTaskDto[];
    occurrences?: RecurringOccurrenceDto[];
    tasks?: TaskItemDto[];
}

export class RecurringTaskDto implements IRecurringTaskDto {
    id?: number;
    title?: string;
    description?: string | undefined;
    dayOfMonth?: number;
    intervalMonths?: number;
    frequencyLabel?: string;
    firstMonth?: Date;
    urgency?: TaskItemUrgency;
    responsibleUserId?: string | undefined;
    responsibleName?: string | undefined;
    workId?: number | undefined;
    workName?: string | undefined;

    constructor(data?: IRecurringTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.dayOfMonth = _data["dayOfMonth"];
            this.intervalMonths = _data["intervalMonths"];
            this.frequencyLabel = _data["frequencyLabel"];
            this.firstMonth = _data["firstMonth"] ? new Date(_data["firstMonth"].toString()) : undefined as any;
            this.urgency = _data["urgency"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.responsibleName = _data["responsibleName"];
            this.workId = _data["workId"];
            this.workName = _data["workName"];
        }
    }

    static fromJS(data: any): RecurringTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecurringTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["dayOfMonth"] = this.dayOfMonth;
        data["intervalMonths"] = this.intervalMonths;
        data["frequencyLabel"] = this.frequencyLabel;
        data["firstMonth"] = this.firstMonth ? this.firstMonth.toISOString() : undefined as any;
        data["urgency"] = this.urgency;
        data["responsibleUserId"] = this.responsibleUserId;
        data["responsibleName"] = this.responsibleName;
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        return data;
    }
}

export interface IRecurringTaskDto {
    id?: number;
    title?: string;
    description?: string | undefined;
    dayOfMonth?: number;
    intervalMonths?: number;
    frequencyLabel?: string;
    firstMonth?: Date;
    urgency?: TaskItemUrgency;
    responsibleUserId?: string | undefined;
    responsibleName?: string | undefined;
    workId?: number | undefined;
    workName?: string | undefined;
}

export class RecurringOccurrenceDto implements IRecurringOccurrenceDto {
    recurringTaskId?: number;
    date?: Date;
    taskId?: number | undefined;
    taskStatus?: TaskItemStatus | undefined;

    constructor(data?: IRecurringOccurrenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recurringTaskId = _data["recurringTaskId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : undefined as any;
            this.taskId = _data["taskId"];
            this.taskStatus = _data["taskStatus"];
        }
    }

    static fromJS(data: any): RecurringOccurrenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecurringOccurrenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recurringTaskId"] = this.recurringTaskId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["taskId"] = this.taskId;
        data["taskStatus"] = this.taskStatus;
        return data;
    }
}

export interface IRecurringOccurrenceDto {
    recurringTaskId?: number;
    date?: Date;
    taskId?: number | undefined;
    taskStatus?: TaskItemStatus | undefined;
}

export class SaveRecurringTaskCommand implements ISaveRecurringTaskCommand {
    id?: number | undefined;
    title?: string;
    description?: string | undefined;
    dayOfMonth?: number;
    intervalMonths?: number;
    firstMonth?: Date | undefined;
    urgency?: TaskItemUrgency | undefined;
    responsibleUserId?: string | undefined;
    workId?: number | undefined;

    constructor(data?: ISaveRecurringTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.dayOfMonth = _data["dayOfMonth"];
            this.intervalMonths = _data["intervalMonths"];
            this.firstMonth = _data["firstMonth"] ? new Date(_data["firstMonth"].toString()) : undefined as any;
            this.urgency = _data["urgency"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.workId = _data["workId"];
        }
    }

    static fromJS(data: any): SaveRecurringTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveRecurringTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["dayOfMonth"] = this.dayOfMonth;
        data["intervalMonths"] = this.intervalMonths;
        data["firstMonth"] = this.firstMonth ? formatDate(this.firstMonth) : undefined as any;
        data["urgency"] = this.urgency;
        data["responsibleUserId"] = this.responsibleUserId;
        data["workId"] = this.workId;
        return data;
    }
}

export interface ISaveRecurringTaskCommand {
    id?: number | undefined;
    title?: string;
    description?: string | undefined;
    dayOfMonth?: number;
    intervalMonths?: number;
    firstMonth?: Date | undefined;
    urgency?: TaskItemUrgency | undefined;
    responsibleUserId?: string | undefined;
    workId?: number | undefined;
}

export class CreateTaskItemCommand implements ICreateTaskItemCommand {
    title?: string;
    description?: string | undefined;
    status?: TaskItemStatus | undefined;
    urgency?: TaskItemUrgency | undefined;
    responsibleUserId?: string | undefined;
    dueDate?: Date | undefined;
    workId?: number | undefined;

    constructor(data?: ICreateTaskItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.urgency = _data["urgency"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.workId = _data["workId"];
        }
    }

    static fromJS(data: any): CreateTaskItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        data["urgency"] = this.urgency;
        data["responsibleUserId"] = this.responsibleUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["workId"] = this.workId;
        return data;
    }
}

export interface ICreateTaskItemCommand {
    title?: string;
    description?: string | undefined;
    status?: TaskItemStatus | undefined;
    urgency?: TaskItemUrgency | undefined;
    responsibleUserId?: string | undefined;
    dueDate?: Date | undefined;
    workId?: number | undefined;
}

export class UpdateTaskItemCommand implements IUpdateTaskItemCommand {
    id?: number;
    fields?: string[] | undefined;
    title?: string;
    description?: string | undefined;
    status?: TaskItemStatus;
    urgency?: TaskItemUrgency;
    responsibleUserId?: string | undefined;
    dueDate?: Date | undefined;
    workId?: number | undefined;

    constructor(data?: IUpdateTaskItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(item);
            }
            this.title = _data["title"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.urgency = _data["urgency"];
            this.responsibleUserId = _data["responsibleUserId"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.workId = _data["workId"];
        }
    }

    static fromJS(data: any): UpdateTaskItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTaskItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item);
        }
        data["title"] = this.title;
        data["description"] = this.description;
        data["status"] = this.status;
        data["urgency"] = this.urgency;
        data["responsibleUserId"] = this.responsibleUserId;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["workId"] = this.workId;
        return data;
    }
}

export interface IUpdateTaskItemCommand {
    id?: number;
    fields?: string[] | undefined;
    title?: string;
    description?: string | undefined;
    status?: TaskItemStatus;
    urgency?: TaskItemUrgency;
    responsibleUserId?: string | undefined;
    dueDate?: Date | undefined;
    workId?: number | undefined;
}

export class SupplierDto implements ISupplierDto {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    category?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    commercialTerms?: string | undefined;
    purchasesCount?: number;
    notes?: string | undefined;
    logoUrl?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: ISupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.category = _data["category"];
            this.contactName = _data["contactName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.commercialTerms = _data["commercialTerms"];
            this.purchasesCount = _data["purchasesCount"];
            this.notes = _data["notes"];
            this.logoUrl = _data["logoUrl"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["category"] = this.category;
        data["contactName"] = this.contactName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["commercialTerms"] = this.commercialTerms;
        data["purchasesCount"] = this.purchasesCount;
        data["notes"] = this.notes;
        data["logoUrl"] = this.logoUrl;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface ISupplierDto {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    category?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    commercialTerms?: string | undefined;
    purchasesCount?: number;
    notes?: string | undefined;
    logoUrl?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class DuplicateSupplierGroupDto implements IDuplicateSupplierGroupDto {
    matchType?: string;
    key?: string;
    suppliers?: SupplierDto[];

    constructor(data?: IDuplicateSupplierGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchType = _data["matchType"];
            this.key = _data["key"];
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(SupplierDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DuplicateSupplierGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicateSupplierGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchType"] = this.matchType;
        data["key"] = this.key;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDuplicateSupplierGroupDto {
    matchType?: string;
    key?: string;
    suppliers?: SupplierDto[];
}

export class CreateSupplierCommand implements ICreateSupplierCommand {
    name?: string;
    taxId?: string | undefined;
    category?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    commercialTerms?: string | undefined;
    notes?: string | undefined;
    purchasesCount?: number | undefined;

    constructor(data?: ICreateSupplierCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.category = _data["category"];
            this.contactName = _data["contactName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.commercialTerms = _data["commercialTerms"];
            this.notes = _data["notes"];
            this.purchasesCount = _data["purchasesCount"];
        }
    }

    static fromJS(data: any): CreateSupplierCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupplierCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["category"] = this.category;
        data["contactName"] = this.contactName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["commercialTerms"] = this.commercialTerms;
        data["notes"] = this.notes;
        data["purchasesCount"] = this.purchasesCount;
        return data;
    }
}

export interface ICreateSupplierCommand {
    name?: string;
    taxId?: string | undefined;
    category?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    commercialTerms?: string | undefined;
    notes?: string | undefined;
    purchasesCount?: number | undefined;
}

export class UpdateSupplierCommand implements IUpdateSupplierCommand {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    category?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    commercialTerms?: string | undefined;
    notes?: string | undefined;
    purchasesCount?: number | undefined;

    constructor(data?: IUpdateSupplierCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.category = _data["category"];
            this.contactName = _data["contactName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.commercialTerms = _data["commercialTerms"];
            this.notes = _data["notes"];
            this.purchasesCount = _data["purchasesCount"];
        }
    }

    static fromJS(data: any): UpdateSupplierCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSupplierCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["category"] = this.category;
        data["contactName"] = this.contactName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["commercialTerms"] = this.commercialTerms;
        data["notes"] = this.notes;
        data["purchasesCount"] = this.purchasesCount;
        return data;
    }
}

export interface IUpdateSupplierCommand {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    category?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    commercialTerms?: string | undefined;
    notes?: string | undefined;
    purchasesCount?: number | undefined;
}

export class MergeSuppliersCommand implements IMergeSuppliersCommand {
    survivorId?: number;
    loserIds?: number[];

    constructor(data?: IMergeSuppliersCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.survivorId = _data["survivorId"];
            if (Array.isArray(_data["loserIds"])) {
                this.loserIds = [] as any;
                for (let item of _data["loserIds"])
                    this.loserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MergeSuppliersCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MergeSuppliersCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["survivorId"] = this.survivorId;
        if (Array.isArray(this.loserIds)) {
            data["loserIds"] = [];
            for (let item of this.loserIds)
                data["loserIds"].push(item);
        }
        return data;
    }
}

export interface IMergeSuppliersCommand {
    survivorId?: number;
    loserIds?: number[];
}

export class SupplierLogoDto implements ISupplierLogoDto {
    supplierId?: number;
    logoUrl?: string | undefined;

    constructor(data?: ISupplierLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): SupplierLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}

export interface ISupplierLogoDto {
    supplierId?: number;
    logoUrl?: string | undefined;
}

export class SubcontractorSpecialtyDto implements ISubcontractorSpecialtyDto {
    id?: number;
    name?: string;

    constructor(data?: ISubcontractorSpecialtyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SubcontractorSpecialtyDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractorSpecialtyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISubcontractorSpecialtyDto {
    id?: number;
    name?: string;
}

export class SubcontractorDto implements ISubcontractorDto {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    status?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    projectsCount?: number;
    notes?: string | undefined;
    logoUrl?: string | undefined;
    specialties?: SubcontractorSpecialtyDto[];
    created?: Date;
    lastModified?: Date;

    constructor(data?: ISubcontractorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.status = _data["status"];
            this.contactName = _data["contactName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.projectsCount = _data["projectsCount"];
            this.notes = _data["notes"];
            this.logoUrl = _data["logoUrl"];
            if (Array.isArray(_data["specialties"])) {
                this.specialties = [] as any;
                for (let item of _data["specialties"])
                    this.specialties!.push(SubcontractorSpecialtyDto.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SubcontractorDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["status"] = this.status;
        data["contactName"] = this.contactName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["projectsCount"] = this.projectsCount;
        data["notes"] = this.notes;
        data["logoUrl"] = this.logoUrl;
        if (Array.isArray(this.specialties)) {
            data["specialties"] = [];
            for (let item of this.specialties)
                data["specialties"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface ISubcontractorDto {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    status?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    projectsCount?: number;
    notes?: string | undefined;
    logoUrl?: string | undefined;
    specialties?: SubcontractorSpecialtyDto[];
    created?: Date;
    lastModified?: Date;
}

export class CreateSubcontractorCommand implements ICreateSubcontractorCommand {
    name?: string;
    taxId?: string | undefined;
    specialtyIds?: number[] | undefined;
    status?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    projectsCount?: number | undefined;

    constructor(data?: ICreateSubcontractorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            if (Array.isArray(_data["specialtyIds"])) {
                this.specialtyIds = [] as any;
                for (let item of _data["specialtyIds"])
                    this.specialtyIds!.push(item);
            }
            this.status = _data["status"];
            this.contactName = _data["contactName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.notes = _data["notes"];
            this.projectsCount = _data["projectsCount"];
        }
    }

    static fromJS(data: any): CreateSubcontractorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubcontractorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        if (Array.isArray(this.specialtyIds)) {
            data["specialtyIds"] = [];
            for (let item of this.specialtyIds)
                data["specialtyIds"].push(item);
        }
        data["status"] = this.status;
        data["contactName"] = this.contactName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["notes"] = this.notes;
        data["projectsCount"] = this.projectsCount;
        return data;
    }
}

export interface ICreateSubcontractorCommand {
    name?: string;
    taxId?: string | undefined;
    specialtyIds?: number[] | undefined;
    status?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    projectsCount?: number | undefined;
}

export class UpdateSubcontractorCommand implements IUpdateSubcontractorCommand {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    specialtyIds?: number[] | undefined;
    status?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    projectsCount?: number | undefined;

    constructor(data?: IUpdateSubcontractorCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            if (Array.isArray(_data["specialtyIds"])) {
                this.specialtyIds = [] as any;
                for (let item of _data["specialtyIds"])
                    this.specialtyIds!.push(item);
            }
            this.status = _data["status"];
            this.contactName = _data["contactName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.notes = _data["notes"];
            this.projectsCount = _data["projectsCount"];
        }
    }

    static fromJS(data: any): UpdateSubcontractorCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSubcontractorCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        if (Array.isArray(this.specialtyIds)) {
            data["specialtyIds"] = [];
            for (let item of this.specialtyIds)
                data["specialtyIds"].push(item);
        }
        data["status"] = this.status;
        data["contactName"] = this.contactName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["notes"] = this.notes;
        data["projectsCount"] = this.projectsCount;
        return data;
    }
}

export interface IUpdateSubcontractorCommand {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    specialtyIds?: number[] | undefined;
    status?: string | undefined;
    contactName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    notes?: string | undefined;
    projectsCount?: number | undefined;
}

export class SubcontractorLogoDto implements ISubcontractorLogoDto {
    subcontractorId?: number;
    logoUrl?: string | undefined;

    constructor(data?: ISubcontractorLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subcontractorId = _data["subcontractorId"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): SubcontractorLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubcontractorLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subcontractorId"] = this.subcontractorId;
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}

export interface ISubcontractorLogoDto {
    subcontractorId?: number;
    logoUrl?: string | undefined;
}

export class MarginAlertRangeDto implements IMarginAlertRangeDto {
    id?: number;
    minPercent?: number;
    maxPercent?: number | undefined;
    color?: string;
    label?: string | undefined;
    position?: number;

    constructor(data?: IMarginAlertRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minPercent = _data["minPercent"];
            this.maxPercent = _data["maxPercent"];
            this.color = _data["color"];
            this.label = _data["label"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): MarginAlertRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarginAlertRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minPercent"] = this.minPercent;
        data["maxPercent"] = this.maxPercent;
        data["color"] = this.color;
        data["label"] = this.label;
        data["position"] = this.position;
        return data;
    }
}

export interface IMarginAlertRangeDto {
    id?: number;
    minPercent?: number;
    maxPercent?: number | undefined;
    color?: string;
    label?: string | undefined;
    position?: number;
}

export class SaveMarginAlertRangesCommand implements ISaveMarginAlertRangesCommand {
    ranges?: MarginAlertRangePayload[];

    constructor(data?: ISaveMarginAlertRangesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ranges"])) {
                this.ranges = [] as any;
                for (let item of _data["ranges"])
                    this.ranges!.push(MarginAlertRangePayload.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveMarginAlertRangesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveMarginAlertRangesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ranges)) {
            data["ranges"] = [];
            for (let item of this.ranges)
                data["ranges"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveMarginAlertRangesCommand {
    ranges?: MarginAlertRangePayload[];
}

export class MarginAlertRangePayload implements IMarginAlertRangePayload {
    minPercent?: number;
    maxPercent?: number | undefined;
    color?: string;
    label?: string | undefined;
    position?: number;

    constructor(data?: IMarginAlertRangePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minPercent = _data["minPercent"];
            this.maxPercent = _data["maxPercent"];
            this.color = _data["color"];
            this.label = _data["label"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): MarginAlertRangePayload {
        data = typeof data === 'object' ? data : {};
        let result = new MarginAlertRangePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minPercent"] = this.minPercent;
        data["maxPercent"] = this.maxPercent;
        data["color"] = this.color;
        data["label"] = this.label;
        data["position"] = this.position;
        return data;
    }
}

export interface IMarginAlertRangePayload {
    minPercent?: number;
    maxPercent?: number | undefined;
    color?: string;
    label?: string | undefined;
    position?: number;
}

export class AiSettingsDto implements IAiSettingsDto {
    hasAnthropicApiKey?: boolean;
    anthropicModel?: string | undefined;
    anthropicMaxTokens?: number;
    anthropicMaxPagesPerDocument?: number;
    defaultSuggestionMarginPercent?: number | undefined;

    constructor(data?: IAiSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAnthropicApiKey = _data["hasAnthropicApiKey"];
            this.anthropicModel = _data["anthropicModel"];
            this.anthropicMaxTokens = _data["anthropicMaxTokens"];
            this.anthropicMaxPagesPerDocument = _data["anthropicMaxPagesPerDocument"];
            this.defaultSuggestionMarginPercent = _data["defaultSuggestionMarginPercent"];
        }
    }

    static fromJS(data: any): AiSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AiSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAnthropicApiKey"] = this.hasAnthropicApiKey;
        data["anthropicModel"] = this.anthropicModel;
        data["anthropicMaxTokens"] = this.anthropicMaxTokens;
        data["anthropicMaxPagesPerDocument"] = this.anthropicMaxPagesPerDocument;
        data["defaultSuggestionMarginPercent"] = this.defaultSuggestionMarginPercent;
        return data;
    }
}

export interface IAiSettingsDto {
    hasAnthropicApiKey?: boolean;
    anthropicModel?: string | undefined;
    anthropicMaxTokens?: number;
    anthropicMaxPagesPerDocument?: number;
    defaultSuggestionMarginPercent?: number | undefined;
}

export class SaveAiSettingsCommand implements ISaveAiSettingsCommand {
    anthropicApiKey?: string | undefined;
    clearAnthropicApiKey?: boolean;
    anthropicModel?: string | undefined;
    anthropicMaxTokens?: number | undefined;
    anthropicMaxPagesPerDocument?: number | undefined;
    defaultSuggestionMarginPercent?: number | undefined;

    constructor(data?: ISaveAiSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.anthropicApiKey = _data["anthropicApiKey"];
            this.clearAnthropicApiKey = _data["clearAnthropicApiKey"];
            this.anthropicModel = _data["anthropicModel"];
            this.anthropicMaxTokens = _data["anthropicMaxTokens"];
            this.anthropicMaxPagesPerDocument = _data["anthropicMaxPagesPerDocument"];
            this.defaultSuggestionMarginPercent = _data["defaultSuggestionMarginPercent"];
        }
    }

    static fromJS(data: any): SaveAiSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAiSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["anthropicApiKey"] = this.anthropicApiKey;
        data["clearAnthropicApiKey"] = this.clearAnthropicApiKey;
        data["anthropicModel"] = this.anthropicModel;
        data["anthropicMaxTokens"] = this.anthropicMaxTokens;
        data["anthropicMaxPagesPerDocument"] = this.anthropicMaxPagesPerDocument;
        data["defaultSuggestionMarginPercent"] = this.defaultSuggestionMarginPercent;
        return data;
    }
}

export interface ISaveAiSettingsCommand {
    anthropicApiKey?: string | undefined;
    clearAnthropicApiKey?: boolean;
    anthropicModel?: string | undefined;
    anthropicMaxTokens?: number | undefined;
    anthropicMaxPagesPerDocument?: number | undefined;
    defaultSuggestionMarginPercent?: number | undefined;
}

export class BankSyncSettingsDto implements IBankSyncSettingsDto {
    hasApiToken?: boolean;
    enabled?: boolean;
    historyStartDate?: Date | undefined;
    pollIntervalMinutes?: number;
    lastSyncedAt?: Date | undefined;
    lastSyncError?: string | undefined;
    lastSyncCreatedCount?: number;
    lastSyncUpdatedCount?: number;

    constructor(data?: IBankSyncSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasApiToken = _data["hasApiToken"];
            this.enabled = _data["enabled"];
            this.historyStartDate = _data["historyStartDate"] ? new Date(_data["historyStartDate"].toString()) : undefined as any;
            this.pollIntervalMinutes = _data["pollIntervalMinutes"];
            this.lastSyncedAt = _data["lastSyncedAt"] ? new Date(_data["lastSyncedAt"].toString()) : undefined as any;
            this.lastSyncError = _data["lastSyncError"];
            this.lastSyncCreatedCount = _data["lastSyncCreatedCount"];
            this.lastSyncUpdatedCount = _data["lastSyncUpdatedCount"];
        }
    }

    static fromJS(data: any): BankSyncSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankSyncSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasApiToken"] = this.hasApiToken;
        data["enabled"] = this.enabled;
        data["historyStartDate"] = this.historyStartDate ? this.historyStartDate.toISOString() : undefined as any;
        data["pollIntervalMinutes"] = this.pollIntervalMinutes;
        data["lastSyncedAt"] = this.lastSyncedAt ? this.lastSyncedAt.toISOString() : undefined as any;
        data["lastSyncError"] = this.lastSyncError;
        data["lastSyncCreatedCount"] = this.lastSyncCreatedCount;
        data["lastSyncUpdatedCount"] = this.lastSyncUpdatedCount;
        return data;
    }
}

export interface IBankSyncSettingsDto {
    hasApiToken?: boolean;
    enabled?: boolean;
    historyStartDate?: Date | undefined;
    pollIntervalMinutes?: number;
    lastSyncedAt?: Date | undefined;
    lastSyncError?: string | undefined;
    lastSyncCreatedCount?: number;
    lastSyncUpdatedCount?: number;
}

export class SaveBankSyncSettingsCommand implements ISaveBankSyncSettingsCommand {
    apiToken?: string | undefined;
    clearApiToken?: boolean;
    enabled?: boolean | undefined;
    historyStartDate?: Date | undefined;
    pollIntervalMinutes?: number | undefined;

    constructor(data?: ISaveBankSyncSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiToken = _data["apiToken"];
            this.clearApiToken = _data["clearApiToken"];
            this.enabled = _data["enabled"];
            this.historyStartDate = _data["historyStartDate"] ? new Date(_data["historyStartDate"].toString()) : undefined as any;
            this.pollIntervalMinutes = _data["pollIntervalMinutes"];
        }
    }

    static fromJS(data: any): SaveBankSyncSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBankSyncSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiToken"] = this.apiToken;
        data["clearApiToken"] = this.clearApiToken;
        data["enabled"] = this.enabled;
        data["historyStartDate"] = this.historyStartDate ? this.historyStartDate.toISOString() : undefined as any;
        data["pollIntervalMinutes"] = this.pollIntervalMinutes;
        return data;
    }
}

export interface ISaveBankSyncSettingsCommand {
    apiToken?: string | undefined;
    clearApiToken?: boolean;
    enabled?: boolean | undefined;
    historyStartDate?: Date | undefined;
    pollIntervalMinutes?: number | undefined;
}

export class BudgetBakersConnectionTestDto implements IBudgetBakersConnectionTestDto {
    succeeded?: boolean;
    error?: string | undefined;
    accounts?: BudgetBakersAccountPreviewDto[];

    constructor(data?: IBudgetBakersConnectionTestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.error = _data["error"];
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(BudgetBakersAccountPreviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetBakersConnectionTestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetBakersConnectionTestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["error"] = this.error;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetBakersConnectionTestDto {
    succeeded?: boolean;
    error?: string | undefined;
    accounts?: BudgetBakersAccountPreviewDto[];
}

export class BudgetBakersAccountPreviewDto implements IBudgetBakersAccountPreviewDto {
    name?: string;
    currencyCode?: string;
    currentBalance?: number | undefined;
    recordCount?: number | undefined;
    isBankSync?: boolean;
    isArchived?: boolean;

    constructor(data?: IBudgetBakersAccountPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.currencyCode = _data["currencyCode"];
            this.currentBalance = _data["currentBalance"];
            this.recordCount = _data["recordCount"];
            this.isBankSync = _data["isBankSync"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): BudgetBakersAccountPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetBakersAccountPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["currencyCode"] = this.currencyCode;
        data["currentBalance"] = this.currentBalance;
        data["recordCount"] = this.recordCount;
        data["isBankSync"] = this.isBankSync;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IBudgetBakersAccountPreviewDto {
    name?: string;
    currencyCode?: string;
    currentBalance?: number | undefined;
    recordCount?: number | undefined;
    isBankSync?: boolean;
    isArchived?: boolean;
}

export class TestBudgetBakersConnectionCommand implements ITestBudgetBakersConnectionCommand {
    apiToken?: string | undefined;

    constructor(data?: ITestBudgetBakersConnectionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiToken = _data["apiToken"];
        }
    }

    static fromJS(data: any): TestBudgetBakersConnectionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TestBudgetBakersConnectionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiToken"] = this.apiToken;
        return data;
    }
}

export interface ITestBudgetBakersConnectionCommand {
    apiToken?: string | undefined;
}

export class BudgetPercentageRuleDto implements IBudgetPercentageRuleDto {
    id?: number;
    description?: string;
    defaultPercentage?: number;
    position?: number;

    constructor(data?: IBudgetPercentageRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.defaultPercentage = _data["defaultPercentage"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): BudgetPercentageRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetPercentageRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["defaultPercentage"] = this.defaultPercentage;
        data["position"] = this.position;
        return data;
    }
}

export interface IBudgetPercentageRuleDto {
    id?: number;
    description?: string;
    defaultPercentage?: number;
    position?: number;
}

export class SaveBudgetPercentageRulesCommand implements ISaveBudgetPercentageRulesCommand {
    rules?: BudgetPercentageRulePayload[];

    constructor(data?: ISaveBudgetPercentageRulesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(BudgetPercentageRulePayload.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveBudgetPercentageRulesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBudgetPercentageRulesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveBudgetPercentageRulesCommand {
    rules?: BudgetPercentageRulePayload[];
}

export class BudgetPercentageRulePayload implements IBudgetPercentageRulePayload {
    description?: string;
    defaultPercentage?: number;
    position?: number;

    constructor(data?: IBudgetPercentageRulePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.defaultPercentage = _data["defaultPercentage"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): BudgetPercentageRulePayload {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetPercentageRulePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["defaultPercentage"] = this.defaultPercentage;
        data["position"] = this.position;
        return data;
    }
}

export interface IBudgetPercentageRulePayload {
    description?: string;
    defaultPercentage?: number;
    position?: number;
}

export class ArticleClassificationRuleDto implements IArticleClassificationRuleDto {
    id?: number;
    matchType?: string;
    matchValue?: string;
    classificationCode?: string;
    position?: number;

    constructor(data?: IArticleClassificationRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchType = _data["matchType"];
            this.matchValue = _data["matchValue"];
            this.classificationCode = _data["classificationCode"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): ArticleClassificationRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleClassificationRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchType"] = this.matchType;
        data["matchValue"] = this.matchValue;
        data["classificationCode"] = this.classificationCode;
        data["position"] = this.position;
        return data;
    }
}

export interface IArticleClassificationRuleDto {
    id?: number;
    matchType?: string;
    matchValue?: string;
    classificationCode?: string;
    position?: number;
}

export class SaveArticleClassificationRulesCommand implements ISaveArticleClassificationRulesCommand {
    rules?: ArticleClassificationRulePayload[];

    constructor(data?: ISaveArticleClassificationRulesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(ArticleClassificationRulePayload.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveArticleClassificationRulesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveArticleClassificationRulesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveArticleClassificationRulesCommand {
    rules?: ArticleClassificationRulePayload[];
}

export class ArticleClassificationRulePayload implements IArticleClassificationRulePayload {
    matchType?: string;
    matchValue?: string;
    classificationCode?: string;
    position?: number;

    constructor(data?: IArticleClassificationRulePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchType = _data["matchType"];
            this.matchValue = _data["matchValue"];
            this.classificationCode = _data["classificationCode"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): ArticleClassificationRulePayload {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleClassificationRulePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchType"] = this.matchType;
        data["matchValue"] = this.matchValue;
        data["classificationCode"] = this.classificationCode;
        data["position"] = this.position;
        return data;
    }
}

export interface IArticleClassificationRulePayload {
    matchType?: string;
    matchValue?: string;
    classificationCode?: string;
    position?: number;
}

export class ExpenseCategoryRuleDto implements IExpenseCategoryRuleDto {
    id?: number;
    matchType?: string;
    matchValue?: string;
    categoryCode?: string;
    position?: number;

    constructor(data?: IExpenseCategoryRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.matchType = _data["matchType"];
            this.matchValue = _data["matchValue"];
            this.categoryCode = _data["categoryCode"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): ExpenseCategoryRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseCategoryRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["matchType"] = this.matchType;
        data["matchValue"] = this.matchValue;
        data["categoryCode"] = this.categoryCode;
        data["position"] = this.position;
        return data;
    }
}

export interface IExpenseCategoryRuleDto {
    id?: number;
    matchType?: string;
    matchValue?: string;
    categoryCode?: string;
    position?: number;
}

export class SaveExpenseCategoryRulesCommand implements ISaveExpenseCategoryRulesCommand {
    rules?: ExpenseCategoryRulePayload[];

    constructor(data?: ISaveExpenseCategoryRulesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(ExpenseCategoryRulePayload.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveExpenseCategoryRulesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveExpenseCategoryRulesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveExpenseCategoryRulesCommand {
    rules?: ExpenseCategoryRulePayload[];
}

export class ExpenseCategoryRulePayload implements IExpenseCategoryRulePayload {
    matchType?: string;
    matchValue?: string;
    categoryCode?: string;
    position?: number;

    constructor(data?: IExpenseCategoryRulePayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.matchType = _data["matchType"];
            this.matchValue = _data["matchValue"];
            this.categoryCode = _data["categoryCode"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): ExpenseCategoryRulePayload {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseCategoryRulePayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["matchType"] = this.matchType;
        data["matchValue"] = this.matchValue;
        data["categoryCode"] = this.categoryCode;
        data["position"] = this.position;
        return data;
    }
}

export interface IExpenseCategoryRulePayload {
    matchType?: string;
    matchValue?: string;
    categoryCode?: string;
    position?: number;
}

export class FinancialSettingsDto implements IFinancialSettingsDto {
    defaultVatRate?: number;
    defaultMarkupPercent?: number | undefined;
    costOverrunThresholdPercent?: number;
    defaultWarrantyMonths?: number;

    constructor(data?: IFinancialSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultVatRate = _data["defaultVatRate"];
            this.defaultMarkupPercent = _data["defaultMarkupPercent"];
            this.costOverrunThresholdPercent = _data["costOverrunThresholdPercent"];
            this.defaultWarrantyMonths = _data["defaultWarrantyMonths"];
        }
    }

    static fromJS(data: any): FinancialSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultVatRate"] = this.defaultVatRate;
        data["defaultMarkupPercent"] = this.defaultMarkupPercent;
        data["costOverrunThresholdPercent"] = this.costOverrunThresholdPercent;
        data["defaultWarrantyMonths"] = this.defaultWarrantyMonths;
        return data;
    }
}

export interface IFinancialSettingsDto {
    defaultVatRate?: number;
    defaultMarkupPercent?: number | undefined;
    costOverrunThresholdPercent?: number;
    defaultWarrantyMonths?: number;
}

export class SaveFinancialSettingsCommand implements ISaveFinancialSettingsCommand {
    defaultVatRate?: number | undefined;
    defaultMarkupPercent?: number | undefined;
    clearDefaultMarkupPercent?: boolean;
    costOverrunThresholdPercent?: number;
    defaultWarrantyMonths?: number | undefined;

    constructor(data?: ISaveFinancialSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultVatRate = _data["defaultVatRate"];
            this.defaultMarkupPercent = _data["defaultMarkupPercent"];
            this.clearDefaultMarkupPercent = _data["clearDefaultMarkupPercent"];
            this.costOverrunThresholdPercent = _data["costOverrunThresholdPercent"];
            this.defaultWarrantyMonths = _data["defaultWarrantyMonths"];
        }
    }

    static fromJS(data: any): SaveFinancialSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveFinancialSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultVatRate"] = this.defaultVatRate;
        data["defaultMarkupPercent"] = this.defaultMarkupPercent;
        data["clearDefaultMarkupPercent"] = this.clearDefaultMarkupPercent;
        data["costOverrunThresholdPercent"] = this.costOverrunThresholdPercent;
        data["defaultWarrantyMonths"] = this.defaultWarrantyMonths;
        return data;
    }
}

export interface ISaveFinancialSettingsCommand {
    defaultVatRate?: number | undefined;
    defaultMarkupPercent?: number | undefined;
    clearDefaultMarkupPercent?: boolean;
    costOverrunThresholdPercent?: number;
    defaultWarrantyMonths?: number | undefined;
}

export class IndirectCostSettingsDto implements IIndirectCostSettingsDto {
    criterion?: string;

    constructor(data?: IIndirectCostSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criterion = _data["criterion"];
        }
    }

    static fromJS(data: any): IndirectCostSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndirectCostSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criterion"] = this.criterion;
        return data;
    }
}

export interface IIndirectCostSettingsDto {
    criterion?: string;
}

export class SaveIndirectCostSettingsCommand implements ISaveIndirectCostSettingsCommand {
    criterion?: string;

    constructor(data?: ISaveIndirectCostSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.criterion = _data["criterion"];
        }
    }

    static fromJS(data: any): SaveIndirectCostSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveIndirectCostSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["criterion"] = this.criterion;
        return data;
    }
}

export interface ISaveIndirectCostSettingsCommand {
    criterion?: string;
}

export class AnomalySettingsDto implements IAnomalySettingsDto {
    nifCheckEnabled?: boolean;
    newSupplierEnabled?: boolean;
    valueAboveUsualEnabled?: boolean;
    valueAboveUsualMultiplier?: number;
    valueAboveUsualMinHistory?: number;
    weekendDateEnabled?: boolean;
    atypicalCategoryEnabled?: boolean;

    constructor(data?: IAnomalySettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nifCheckEnabled = _data["nifCheckEnabled"];
            this.newSupplierEnabled = _data["newSupplierEnabled"];
            this.valueAboveUsualEnabled = _data["valueAboveUsualEnabled"];
            this.valueAboveUsualMultiplier = _data["valueAboveUsualMultiplier"];
            this.valueAboveUsualMinHistory = _data["valueAboveUsualMinHistory"];
            this.weekendDateEnabled = _data["weekendDateEnabled"];
            this.atypicalCategoryEnabled = _data["atypicalCategoryEnabled"];
        }
    }

    static fromJS(data: any): AnomalySettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnomalySettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nifCheckEnabled"] = this.nifCheckEnabled;
        data["newSupplierEnabled"] = this.newSupplierEnabled;
        data["valueAboveUsualEnabled"] = this.valueAboveUsualEnabled;
        data["valueAboveUsualMultiplier"] = this.valueAboveUsualMultiplier;
        data["valueAboveUsualMinHistory"] = this.valueAboveUsualMinHistory;
        data["weekendDateEnabled"] = this.weekendDateEnabled;
        data["atypicalCategoryEnabled"] = this.atypicalCategoryEnabled;
        return data;
    }
}

export interface IAnomalySettingsDto {
    nifCheckEnabled?: boolean;
    newSupplierEnabled?: boolean;
    valueAboveUsualEnabled?: boolean;
    valueAboveUsualMultiplier?: number;
    valueAboveUsualMinHistory?: number;
    weekendDateEnabled?: boolean;
    atypicalCategoryEnabled?: boolean;
}

export class SaveAnomalySettingsCommand implements ISaveAnomalySettingsCommand {
    nifCheckEnabled?: boolean;
    newSupplierEnabled?: boolean;
    valueAboveUsualEnabled?: boolean;
    valueAboveUsualMultiplier?: number;
    valueAboveUsualMinHistory?: number;
    weekendDateEnabled?: boolean;
    atypicalCategoryEnabled?: boolean;

    constructor(data?: ISaveAnomalySettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nifCheckEnabled = _data["nifCheckEnabled"];
            this.newSupplierEnabled = _data["newSupplierEnabled"];
            this.valueAboveUsualEnabled = _data["valueAboveUsualEnabled"];
            this.valueAboveUsualMultiplier = _data["valueAboveUsualMultiplier"];
            this.valueAboveUsualMinHistory = _data["valueAboveUsualMinHistory"];
            this.weekendDateEnabled = _data["weekendDateEnabled"];
            this.atypicalCategoryEnabled = _data["atypicalCategoryEnabled"];
        }
    }

    static fromJS(data: any): SaveAnomalySettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAnomalySettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nifCheckEnabled"] = this.nifCheckEnabled;
        data["newSupplierEnabled"] = this.newSupplierEnabled;
        data["valueAboveUsualEnabled"] = this.valueAboveUsualEnabled;
        data["valueAboveUsualMultiplier"] = this.valueAboveUsualMultiplier;
        data["valueAboveUsualMinHistory"] = this.valueAboveUsualMinHistory;
        data["weekendDateEnabled"] = this.weekendDateEnabled;
        data["atypicalCategoryEnabled"] = this.atypicalCategoryEnabled;
        return data;
    }
}

export interface ISaveAnomalySettingsCommand {
    nifCheckEnabled?: boolean;
    newSupplierEnabled?: boolean;
    valueAboveUsualEnabled?: boolean;
    valueAboveUsualMultiplier?: number;
    valueAboveUsualMinHistory?: number;
    weekendDateEnabled?: boolean;
    atypicalCategoryEnabled?: boolean;
}

export class CreditControlSettingsDto implements ICreditControlSettingsDto {
    riskYellowOverdueDays?: number;
    riskYellowOverdueAmount?: number;
    riskRedOverdueDays?: number;
    riskRedOverdueAmount?: number;
    riskRedOnLegalProcess?: boolean;
    blockOnOverdueAmount?: boolean;
    blockOverdueAmountThreshold?: number;
    blockOnCreditLimitExceeded?: boolean;
    blockOnRedRisk?: boolean;
    jalOverdueDays?: number;
    collectionReminderLeadDays?: number;

    constructor(data?: ICreditControlSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riskYellowOverdueDays = _data["riskYellowOverdueDays"];
            this.riskYellowOverdueAmount = _data["riskYellowOverdueAmount"];
            this.riskRedOverdueDays = _data["riskRedOverdueDays"];
            this.riskRedOverdueAmount = _data["riskRedOverdueAmount"];
            this.riskRedOnLegalProcess = _data["riskRedOnLegalProcess"];
            this.blockOnOverdueAmount = _data["blockOnOverdueAmount"];
            this.blockOverdueAmountThreshold = _data["blockOverdueAmountThreshold"];
            this.blockOnCreditLimitExceeded = _data["blockOnCreditLimitExceeded"];
            this.blockOnRedRisk = _data["blockOnRedRisk"];
            this.jalOverdueDays = _data["jalOverdueDays"];
            this.collectionReminderLeadDays = _data["collectionReminderLeadDays"];
        }
    }

    static fromJS(data: any): CreditControlSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreditControlSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riskYellowOverdueDays"] = this.riskYellowOverdueDays;
        data["riskYellowOverdueAmount"] = this.riskYellowOverdueAmount;
        data["riskRedOverdueDays"] = this.riskRedOverdueDays;
        data["riskRedOverdueAmount"] = this.riskRedOverdueAmount;
        data["riskRedOnLegalProcess"] = this.riskRedOnLegalProcess;
        data["blockOnOverdueAmount"] = this.blockOnOverdueAmount;
        data["blockOverdueAmountThreshold"] = this.blockOverdueAmountThreshold;
        data["blockOnCreditLimitExceeded"] = this.blockOnCreditLimitExceeded;
        data["blockOnRedRisk"] = this.blockOnRedRisk;
        data["jalOverdueDays"] = this.jalOverdueDays;
        data["collectionReminderLeadDays"] = this.collectionReminderLeadDays;
        return data;
    }
}

export interface ICreditControlSettingsDto {
    riskYellowOverdueDays?: number;
    riskYellowOverdueAmount?: number;
    riskRedOverdueDays?: number;
    riskRedOverdueAmount?: number;
    riskRedOnLegalProcess?: boolean;
    blockOnOverdueAmount?: boolean;
    blockOverdueAmountThreshold?: number;
    blockOnCreditLimitExceeded?: boolean;
    blockOnRedRisk?: boolean;
    jalOverdueDays?: number;
    collectionReminderLeadDays?: number;
}

export class SaveCreditControlSettingsCommand implements ISaveCreditControlSettingsCommand {
    riskYellowOverdueDays?: number;
    riskYellowOverdueAmount?: number;
    riskRedOverdueDays?: number;
    riskRedOverdueAmount?: number;
    riskRedOnLegalProcess?: boolean;
    blockOnOverdueAmount?: boolean;
    blockOverdueAmountThreshold?: number;
    blockOnCreditLimitExceeded?: boolean;
    blockOnRedRisk?: boolean;
    jalOverdueDays?: number;
    collectionReminderLeadDays?: number;

    constructor(data?: ISaveCreditControlSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riskYellowOverdueDays = _data["riskYellowOverdueDays"];
            this.riskYellowOverdueAmount = _data["riskYellowOverdueAmount"];
            this.riskRedOverdueDays = _data["riskRedOverdueDays"];
            this.riskRedOverdueAmount = _data["riskRedOverdueAmount"];
            this.riskRedOnLegalProcess = _data["riskRedOnLegalProcess"];
            this.blockOnOverdueAmount = _data["blockOnOverdueAmount"];
            this.blockOverdueAmountThreshold = _data["blockOverdueAmountThreshold"];
            this.blockOnCreditLimitExceeded = _data["blockOnCreditLimitExceeded"];
            this.blockOnRedRisk = _data["blockOnRedRisk"];
            this.jalOverdueDays = _data["jalOverdueDays"];
            this.collectionReminderLeadDays = _data["collectionReminderLeadDays"];
        }
    }

    static fromJS(data: any): SaveCreditControlSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCreditControlSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riskYellowOverdueDays"] = this.riskYellowOverdueDays;
        data["riskYellowOverdueAmount"] = this.riskYellowOverdueAmount;
        data["riskRedOverdueDays"] = this.riskRedOverdueDays;
        data["riskRedOverdueAmount"] = this.riskRedOverdueAmount;
        data["riskRedOnLegalProcess"] = this.riskRedOnLegalProcess;
        data["blockOnOverdueAmount"] = this.blockOnOverdueAmount;
        data["blockOverdueAmountThreshold"] = this.blockOverdueAmountThreshold;
        data["blockOnCreditLimitExceeded"] = this.blockOnCreditLimitExceeded;
        data["blockOnRedRisk"] = this.blockOnRedRisk;
        data["jalOverdueDays"] = this.jalOverdueDays;
        data["collectionReminderLeadDays"] = this.collectionReminderLeadDays;
        return data;
    }
}

export interface ISaveCreditControlSettingsCommand {
    riskYellowOverdueDays?: number;
    riskYellowOverdueAmount?: number;
    riskRedOverdueDays?: number;
    riskRedOverdueAmount?: number;
    riskRedOnLegalProcess?: boolean;
    blockOnOverdueAmount?: boolean;
    blockOverdueAmountThreshold?: number;
    blockOnCreditLimitExceeded?: boolean;
    blockOnRedRisk?: boolean;
    jalOverdueDays?: number;
    collectionReminderLeadDays?: number;
}

export class TreasurySettingsDto implements ITreasurySettingsDto {
    openingBalance?: number;
    openingBalanceAsOf?: Date | undefined;
    defaultSupplierPaymentDays?: number;
    supplierPaymentDayOfMonth?: number | undefined;
    projectedBalanceWarningThreshold?: number;
    projectedBalanceCriticalThreshold?: number;
    upcomingDueDays?: number;
    confirmingPlafond?: number;
    confirmingAnnualRatePercent?: number;
    confirmingTermDays?: number;
    confirmingContractReferences?: string | undefined;

    constructor(data?: ITreasurySettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openingBalance = _data["openingBalance"];
            this.openingBalanceAsOf = _data["openingBalanceAsOf"] ? new Date(_data["openingBalanceAsOf"].toString()) : undefined as any;
            this.defaultSupplierPaymentDays = _data["defaultSupplierPaymentDays"];
            this.supplierPaymentDayOfMonth = _data["supplierPaymentDayOfMonth"];
            this.projectedBalanceWarningThreshold = _data["projectedBalanceWarningThreshold"];
            this.projectedBalanceCriticalThreshold = _data["projectedBalanceCriticalThreshold"];
            this.upcomingDueDays = _data["upcomingDueDays"];
            this.confirmingPlafond = _data["confirmingPlafond"];
            this.confirmingAnnualRatePercent = _data["confirmingAnnualRatePercent"];
            this.confirmingTermDays = _data["confirmingTermDays"];
            this.confirmingContractReferences = _data["confirmingContractReferences"];
        }
    }

    static fromJS(data: any): TreasurySettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TreasurySettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openingBalance"] = this.openingBalance;
        data["openingBalanceAsOf"] = this.openingBalanceAsOf ? this.openingBalanceAsOf.toISOString() : undefined as any;
        data["defaultSupplierPaymentDays"] = this.defaultSupplierPaymentDays;
        data["supplierPaymentDayOfMonth"] = this.supplierPaymentDayOfMonth;
        data["projectedBalanceWarningThreshold"] = this.projectedBalanceWarningThreshold;
        data["projectedBalanceCriticalThreshold"] = this.projectedBalanceCriticalThreshold;
        data["upcomingDueDays"] = this.upcomingDueDays;
        data["confirmingPlafond"] = this.confirmingPlafond;
        data["confirmingAnnualRatePercent"] = this.confirmingAnnualRatePercent;
        data["confirmingTermDays"] = this.confirmingTermDays;
        data["confirmingContractReferences"] = this.confirmingContractReferences;
        return data;
    }
}

export interface ITreasurySettingsDto {
    openingBalance?: number;
    openingBalanceAsOf?: Date | undefined;
    defaultSupplierPaymentDays?: number;
    supplierPaymentDayOfMonth?: number | undefined;
    projectedBalanceWarningThreshold?: number;
    projectedBalanceCriticalThreshold?: number;
    upcomingDueDays?: number;
    confirmingPlafond?: number;
    confirmingAnnualRatePercent?: number;
    confirmingTermDays?: number;
    confirmingContractReferences?: string | undefined;
}

export class SaveTreasurySettingsCommand implements ISaveTreasurySettingsCommand {
    openingBalance?: number;
    openingBalanceAsOf?: Date | undefined;
    defaultSupplierPaymentDays?: number;
    supplierPaymentDayOfMonth?: number | undefined;
    projectedBalanceWarningThreshold?: number;
    projectedBalanceCriticalThreshold?: number;
    upcomingDueDays?: number;
    confirmingPlafond?: number;
    confirmingAnnualRatePercent?: number;
    confirmingTermDays?: number | undefined;
    confirmingContractReferences?: string | undefined;

    constructor(data?: ISaveTreasurySettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openingBalance = _data["openingBalance"];
            this.openingBalanceAsOf = _data["openingBalanceAsOf"] ? new Date(_data["openingBalanceAsOf"].toString()) : undefined as any;
            this.defaultSupplierPaymentDays = _data["defaultSupplierPaymentDays"];
            this.supplierPaymentDayOfMonth = _data["supplierPaymentDayOfMonth"];
            this.projectedBalanceWarningThreshold = _data["projectedBalanceWarningThreshold"];
            this.projectedBalanceCriticalThreshold = _data["projectedBalanceCriticalThreshold"];
            this.upcomingDueDays = _data["upcomingDueDays"];
            this.confirmingPlafond = _data["confirmingPlafond"];
            this.confirmingAnnualRatePercent = _data["confirmingAnnualRatePercent"];
            this.confirmingTermDays = _data["confirmingTermDays"];
            this.confirmingContractReferences = _data["confirmingContractReferences"];
        }
    }

    static fromJS(data: any): SaveTreasurySettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTreasurySettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openingBalance"] = this.openingBalance;
        data["openingBalanceAsOf"] = this.openingBalanceAsOf ? this.openingBalanceAsOf.toISOString() : undefined as any;
        data["defaultSupplierPaymentDays"] = this.defaultSupplierPaymentDays;
        data["supplierPaymentDayOfMonth"] = this.supplierPaymentDayOfMonth;
        data["projectedBalanceWarningThreshold"] = this.projectedBalanceWarningThreshold;
        data["projectedBalanceCriticalThreshold"] = this.projectedBalanceCriticalThreshold;
        data["upcomingDueDays"] = this.upcomingDueDays;
        data["confirmingPlafond"] = this.confirmingPlafond;
        data["confirmingAnnualRatePercent"] = this.confirmingAnnualRatePercent;
        data["confirmingTermDays"] = this.confirmingTermDays;
        data["confirmingContractReferences"] = this.confirmingContractReferences;
        return data;
    }
}

export interface ISaveTreasurySettingsCommand {
    openingBalance?: number;
    openingBalanceAsOf?: Date | undefined;
    defaultSupplierPaymentDays?: number;
    supplierPaymentDayOfMonth?: number | undefined;
    projectedBalanceWarningThreshold?: number;
    projectedBalanceCriticalThreshold?: number;
    upcomingDueDays?: number;
    confirmingPlafond?: number;
    confirmingAnnualRatePercent?: number;
    confirmingTermDays?: number | undefined;
    confirmingContractReferences?: string | undefined;
}

export class GlobalSearchResultDto implements IGlobalSearchResultDto {
    hits?: SearchHit[];

    constructor(data?: IGlobalSearchResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hits"])) {
                this.hits = [] as any;
                for (let item of _data["hits"])
                    this.hits!.push(SearchHit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalSearchResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalSearchResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hits)) {
            data["hits"] = [];
            for (let item of this.hits)
                data["hits"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGlobalSearchResultDto {
    hits?: SearchHit[];
}

export class SearchHit implements ISearchHit {
    type?: string;
    id?: number;
    title?: string;
    subtitle?: string | undefined;

    constructor(data?: ISearchHit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
        }
    }

    static fromJS(data: any): SearchHit {
        data = typeof data === 'object' ? data : {};
        let result = new SearchHit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        return data;
    }
}

export interface ISearchHit {
    type?: string;
    id?: number;
    title?: string;
    subtitle?: string | undefined;
}

export class ScheduleTaskDto implements IScheduleTaskDto {
    id?: number;
    workId?: number;
    name?: string;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    statusId?: number;
    statusCode?: string;
    statusName?: string;
    responsible?: string | undefined;
    billingMilestoneId?: number | undefined;
    billingMilestoneDescription?: string | undefined;
    sortOrder?: number;
    notes?: string | undefined;
    subcontractorId?: number | undefined;
    subcontractorName?: string | undefined;
    subcontractorEmail?: string | undefined;
    deadlineChangePending?: boolean;
    previousEndDate?: Date | undefined;
    lastNotifiedAt?: Date | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IScheduleTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.name = _data["name"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.statusCode = _data["statusCode"];
            this.statusName = _data["statusName"];
            this.responsible = _data["responsible"];
            this.billingMilestoneId = _data["billingMilestoneId"];
            this.billingMilestoneDescription = _data["billingMilestoneDescription"];
            this.sortOrder = _data["sortOrder"];
            this.notes = _data["notes"];
            this.subcontractorId = _data["subcontractorId"];
            this.subcontractorName = _data["subcontractorName"];
            this.subcontractorEmail = _data["subcontractorEmail"];
            this.deadlineChangePending = _data["deadlineChangePending"];
            this.previousEndDate = _data["previousEndDate"] ? new Date(_data["previousEndDate"].toString()) : undefined as any;
            this.lastNotifiedAt = _data["lastNotifiedAt"] ? new Date(_data["lastNotifiedAt"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduleTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["name"] = this.name;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["statusId"] = this.statusId;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        data["responsible"] = this.responsible;
        data["billingMilestoneId"] = this.billingMilestoneId;
        data["billingMilestoneDescription"] = this.billingMilestoneDescription;
        data["sortOrder"] = this.sortOrder;
        data["notes"] = this.notes;
        data["subcontractorId"] = this.subcontractorId;
        data["subcontractorName"] = this.subcontractorName;
        data["subcontractorEmail"] = this.subcontractorEmail;
        data["deadlineChangePending"] = this.deadlineChangePending;
        data["previousEndDate"] = this.previousEndDate ? this.previousEndDate.toISOString() : undefined as any;
        data["lastNotifiedAt"] = this.lastNotifiedAt ? this.lastNotifiedAt.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IScheduleTaskDto {
    id?: number;
    workId?: number;
    name?: string;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    statusId?: number;
    statusCode?: string;
    statusName?: string;
    responsible?: string | undefined;
    billingMilestoneId?: number | undefined;
    billingMilestoneDescription?: string | undefined;
    sortOrder?: number;
    notes?: string | undefined;
    subcontractorId?: number | undefined;
    subcontractorName?: string | undefined;
    subcontractorEmail?: string | undefined;
    deadlineChangePending?: boolean;
    previousEndDate?: Date | undefined;
    lastNotifiedAt?: Date | undefined;
    created?: Date;
    lastModified?: Date;
}

export class ScheduleTaskStatusDto implements IScheduleTaskStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;

    constructor(data?: IScheduleTaskStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ScheduleTaskStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleTaskStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IScheduleTaskStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
}

export class CreateScheduleTaskCommand implements ICreateScheduleTaskCommand {
    workId?: number;
    name?: string;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    statusId?: number;
    responsible?: string | undefined;
    billingMilestoneId?: number | undefined;
    sortOrder?: number;
    notes?: string | undefined;
    subcontractorId?: number | undefined;

    constructor(data?: ICreateScheduleTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.name = _data["name"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.responsible = _data["responsible"];
            this.billingMilestoneId = _data["billingMilestoneId"];
            this.sortOrder = _data["sortOrder"];
            this.notes = _data["notes"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): CreateScheduleTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScheduleTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["name"] = this.name;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["statusId"] = this.statusId;
        data["responsible"] = this.responsible;
        data["billingMilestoneId"] = this.billingMilestoneId;
        data["sortOrder"] = this.sortOrder;
        data["notes"] = this.notes;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface ICreateScheduleTaskCommand {
    workId?: number;
    name?: string;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    statusId?: number;
    responsible?: string | undefined;
    billingMilestoneId?: number | undefined;
    sortOrder?: number;
    notes?: string | undefined;
    subcontractorId?: number | undefined;
}

export class UpdateScheduleTaskCommand implements IUpdateScheduleTaskCommand {
    id?: number;
    workId?: number;
    name?: string;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    statusId?: number;
    responsible?: string | undefined;
    billingMilestoneId?: number | undefined;
    sortOrder?: number;
    notes?: string | undefined;
    subcontractorId?: number | undefined;

    constructor(data?: IUpdateScheduleTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.name = _data["name"];
            this.plannedStartDate = _data["plannedStartDate"] ? new Date(_data["plannedStartDate"].toString()) : undefined as any;
            this.plannedEndDate = _data["plannedEndDate"] ? new Date(_data["plannedEndDate"].toString()) : undefined as any;
            this.statusId = _data["statusId"];
            this.responsible = _data["responsible"];
            this.billingMilestoneId = _data["billingMilestoneId"];
            this.sortOrder = _data["sortOrder"];
            this.notes = _data["notes"];
            this.subcontractorId = _data["subcontractorId"];
        }
    }

    static fromJS(data: any): UpdateScheduleTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["name"] = this.name;
        data["plannedStartDate"] = this.plannedStartDate ? this.plannedStartDate.toISOString() : undefined as any;
        data["plannedEndDate"] = this.plannedEndDate ? this.plannedEndDate.toISOString() : undefined as any;
        data["statusId"] = this.statusId;
        data["responsible"] = this.responsible;
        data["billingMilestoneId"] = this.billingMilestoneId;
        data["sortOrder"] = this.sortOrder;
        data["notes"] = this.notes;
        data["subcontractorId"] = this.subcontractorId;
        return data;
    }
}

export interface IUpdateScheduleTaskCommand {
    id?: number;
    workId?: number;
    name?: string;
    plannedStartDate?: Date | undefined;
    plannedEndDate?: Date | undefined;
    statusId?: number;
    responsible?: string | undefined;
    billingMilestoneId?: number | undefined;
    sortOrder?: number;
    notes?: string | undefined;
    subcontractorId?: number | undefined;
}

export class RentUpdateProposalDto implements IRentUpdateProposalDto {
    id?: number;
    rentalContractId?: number;
    contractNumber?: string | undefined;
    propertyName?: string;
    tenantName?: string;
    effectiveDate?: Date;
    currentRent?: number;
    coefficientPercent?: number;
    proposedRent?: number;
    status?: string;
    notifiedByEmail?: boolean;
    notifiedAt?: Date | undefined;
    notes?: string | undefined;

    constructor(data?: IRentUpdateProposalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rentalContractId = _data["rentalContractId"];
            this.contractNumber = _data["contractNumber"];
            this.propertyName = _data["propertyName"];
            this.tenantName = _data["tenantName"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.currentRent = _data["currentRent"];
            this.coefficientPercent = _data["coefficientPercent"];
            this.proposedRent = _data["proposedRent"];
            this.status = _data["status"];
            this.notifiedByEmail = _data["notifiedByEmail"];
            this.notifiedAt = _data["notifiedAt"] ? new Date(_data["notifiedAt"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): RentUpdateProposalDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentUpdateProposalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rentalContractId"] = this.rentalContractId;
        data["contractNumber"] = this.contractNumber;
        data["propertyName"] = this.propertyName;
        data["tenantName"] = this.tenantName;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        data["currentRent"] = this.currentRent;
        data["coefficientPercent"] = this.coefficientPercent;
        data["proposedRent"] = this.proposedRent;
        data["status"] = this.status;
        data["notifiedByEmail"] = this.notifiedByEmail;
        data["notifiedAt"] = this.notifiedAt ? this.notifiedAt.toISOString() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IRentUpdateProposalDto {
    id?: number;
    rentalContractId?: number;
    contractNumber?: string | undefined;
    propertyName?: string;
    tenantName?: string;
    effectiveDate?: Date;
    currentRent?: number;
    coefficientPercent?: number;
    proposedRent?: number;
    status?: string;
    notifiedByEmail?: boolean;
    notifiedAt?: Date | undefined;
    notes?: string | undefined;
}

export class CreateRentUpdateProposalCommand implements ICreateRentUpdateProposalCommand {
    rentalContractId?: number;
    effectiveDate?: Date;
    coefficientPercent?: number;
    notes?: string | undefined;

    constructor(data?: ICreateRentUpdateProposalCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rentalContractId = _data["rentalContractId"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.coefficientPercent = _data["coefficientPercent"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateRentUpdateProposalCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRentUpdateProposalCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rentalContractId"] = this.rentalContractId;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        data["coefficientPercent"] = this.coefficientPercent;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateRentUpdateProposalCommand {
    rentalContractId?: number;
    effectiveDate?: Date;
    coefficientPercent?: number;
    notes?: string | undefined;
}

export class RentRevenueReportDto implements IRentRevenueReportDto {
    year?: number;
    month?: number | undefined;
    rows?: RentRevenueRowDto[];
    totalExpected?: number;
    totalReceived?: number;
    totalPending?: number;

    constructor(data?: IRentRevenueReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(RentRevenueRowDto.fromJS(item));
            }
            this.totalExpected = _data["totalExpected"];
            this.totalReceived = _data["totalReceived"];
            this.totalPending = _data["totalPending"];
        }
    }

    static fromJS(data: any): RentRevenueReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentRevenueReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalExpected"] = this.totalExpected;
        data["totalReceived"] = this.totalReceived;
        data["totalPending"] = this.totalPending;
        return data;
    }
}

export interface IRentRevenueReportDto {
    year?: number;
    month?: number | undefined;
    rows?: RentRevenueRowDto[];
    totalExpected?: number;
    totalReceived?: number;
    totalPending?: number;
}

export class RentRevenueRowDto implements IRentRevenueRowDto {
    propertyId?: number;
    propertyName?: string;
    expectedTotal?: number;
    receivedTotal?: number;
    pendingTotal?: number;
    noticeCount?: number;

    constructor(data?: IRentRevenueRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.propertyName = _data["propertyName"];
            this.expectedTotal = _data["expectedTotal"];
            this.receivedTotal = _data["receivedTotal"];
            this.pendingTotal = _data["pendingTotal"];
            this.noticeCount = _data["noticeCount"];
        }
    }

    static fromJS(data: any): RentRevenueRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentRevenueRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["propertyName"] = this.propertyName;
        data["expectedTotal"] = this.expectedTotal;
        data["receivedTotal"] = this.receivedTotal;
        data["pendingTotal"] = this.pendingTotal;
        data["noticeCount"] = this.noticeCount;
        return data;
    }
}

export interface IRentRevenueRowDto {
    propertyId?: number;
    propertyName?: string;
    expectedTotal?: number;
    receivedTotal?: number;
    pendingTotal?: number;
    noticeCount?: number;
}

export class PropertyProfitabilityDto implements IPropertyProfitabilityDto {
    propertyId?: number;
    propertyName?: string;
    year?: number;
    rentExpected?: number;
    rentReceived?: number;
    annualImi?: number;
    netProfitability?: number;

    constructor(data?: IPropertyProfitabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.propertyName = _data["propertyName"];
            this.year = _data["year"];
            this.rentExpected = _data["rentExpected"];
            this.rentReceived = _data["rentReceived"];
            this.annualImi = _data["annualImi"];
            this.netProfitability = _data["netProfitability"];
        }
    }

    static fromJS(data: any): PropertyProfitabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyProfitabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["propertyName"] = this.propertyName;
        data["year"] = this.year;
        data["rentExpected"] = this.rentExpected;
        data["rentReceived"] = this.rentReceived;
        data["annualImi"] = this.annualImi;
        data["netProfitability"] = this.netProfitability;
        return data;
    }
}

export interface IPropertyProfitabilityDto {
    propertyId?: number;
    propertyName?: string;
    year?: number;
    rentExpected?: number;
    rentReceived?: number;
    annualImi?: number;
    netProfitability?: number;
}

export class RentArrearsReportDto implements IRentArrearsReportDto {
    year?: number;
    month?: number | undefined;
    byProperty?: RentArrearsPropertyRowDto[];
    byTenant?: RentArrearsTenantRowDto[];
    totalOverdue?: number;
    overdueCount?: number;

    constructor(data?: IRentArrearsReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            if (Array.isArray(_data["byProperty"])) {
                this.byProperty = [] as any;
                for (let item of _data["byProperty"])
                    this.byProperty!.push(RentArrearsPropertyRowDto.fromJS(item));
            }
            if (Array.isArray(_data["byTenant"])) {
                this.byTenant = [] as any;
                for (let item of _data["byTenant"])
                    this.byTenant!.push(RentArrearsTenantRowDto.fromJS(item));
            }
            this.totalOverdue = _data["totalOverdue"];
            this.overdueCount = _data["overdueCount"];
        }
    }

    static fromJS(data: any): RentArrearsReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentArrearsReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        if (Array.isArray(this.byProperty)) {
            data["byProperty"] = [];
            for (let item of this.byProperty)
                data["byProperty"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.byTenant)) {
            data["byTenant"] = [];
            for (let item of this.byTenant)
                data["byTenant"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalOverdue"] = this.totalOverdue;
        data["overdueCount"] = this.overdueCount;
        return data;
    }
}

export interface IRentArrearsReportDto {
    year?: number;
    month?: number | undefined;
    byProperty?: RentArrearsPropertyRowDto[];
    byTenant?: RentArrearsTenantRowDto[];
    totalOverdue?: number;
    overdueCount?: number;
}

export class RentArrearsPropertyRowDto implements IRentArrearsPropertyRowDto {
    propertyId?: number;
    propertyName?: string;
    overdueTotal?: number;
    overdueCount?: number;

    constructor(data?: IRentArrearsPropertyRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.propertyName = _data["propertyName"];
            this.overdueTotal = _data["overdueTotal"];
            this.overdueCount = _data["overdueCount"];
        }
    }

    static fromJS(data: any): RentArrearsPropertyRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentArrearsPropertyRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["propertyName"] = this.propertyName;
        data["overdueTotal"] = this.overdueTotal;
        data["overdueCount"] = this.overdueCount;
        return data;
    }
}

export interface IRentArrearsPropertyRowDto {
    propertyId?: number;
    propertyName?: string;
    overdueTotal?: number;
    overdueCount?: number;
}

export class RentArrearsTenantRowDto implements IRentArrearsTenantRowDto {
    tenantId?: number;
    tenantName?: string;
    overdueTotal?: number;
    overdueCount?: number;

    constructor(data?: IRentArrearsTenantRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.overdueTotal = _data["overdueTotal"];
            this.overdueCount = _data["overdueCount"];
        }
    }

    static fromJS(data: any): RentArrearsTenantRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentArrearsTenantRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["overdueTotal"] = this.overdueTotal;
        data["overdueCount"] = this.overdueCount;
        return data;
    }
}

export interface IRentArrearsTenantRowDto {
    tenantId?: number;
    tenantName?: string;
    overdueTotal?: number;
    overdueCount?: number;
}

export class RentReceiptDto implements IRentReceiptDto {
    id?: number;
    rentNoticeId?: number;
    rentalContractId?: number;
    receiptNumber?: string;
    issueDate?: Date;
    paidDate?: Date;
    periodYear?: number;
    periodMonth?: number;
    periodLabel?: string;
    amount?: number;
    landlordName?: string;
    landlordTaxId?: string | undefined;
    tenantName?: string;
    tenantTaxId?: string | undefined;
    propertyName?: string;
    propertyAddress?: string | undefined;
    status?: string;
    notes?: string | undefined;

    constructor(data?: IRentReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rentNoticeId = _data["rentNoticeId"];
            this.rentalContractId = _data["rentalContractId"];
            this.receiptNumber = _data["receiptNumber"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.paidDate = _data["paidDate"] ? new Date(_data["paidDate"].toString()) : undefined as any;
            this.periodYear = _data["periodYear"];
            this.periodMonth = _data["periodMonth"];
            this.periodLabel = _data["periodLabel"];
            this.amount = _data["amount"];
            this.landlordName = _data["landlordName"];
            this.landlordTaxId = _data["landlordTaxId"];
            this.tenantName = _data["tenantName"];
            this.tenantTaxId = _data["tenantTaxId"];
            this.propertyName = _data["propertyName"];
            this.propertyAddress = _data["propertyAddress"];
            this.status = _data["status"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): RentReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rentNoticeId"] = this.rentNoticeId;
        data["rentalContractId"] = this.rentalContractId;
        data["receiptNumber"] = this.receiptNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined as any;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : undefined as any;
        data["periodYear"] = this.periodYear;
        data["periodMonth"] = this.periodMonth;
        data["periodLabel"] = this.periodLabel;
        data["amount"] = this.amount;
        data["landlordName"] = this.landlordName;
        data["landlordTaxId"] = this.landlordTaxId;
        data["tenantName"] = this.tenantName;
        data["tenantTaxId"] = this.tenantTaxId;
        data["propertyName"] = this.propertyName;
        data["propertyAddress"] = this.propertyAddress;
        data["status"] = this.status;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IRentReceiptDto {
    id?: number;
    rentNoticeId?: number;
    rentalContractId?: number;
    receiptNumber?: string;
    issueDate?: Date;
    paidDate?: Date;
    periodYear?: number;
    periodMonth?: number;
    periodLabel?: string;
    amount?: number;
    landlordName?: string;
    landlordTaxId?: string | undefined;
    tenantName?: string;
    tenantTaxId?: string | undefined;
    propertyName?: string;
    propertyAddress?: string | undefined;
    status?: string;
    notes?: string | undefined;
}

export class GenerateRentReceiptCommand implements IGenerateRentReceiptCommand {
    rentNoticeId?: number;

    constructor(data?: IGenerateRentReceiptCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rentNoticeId = _data["rentNoticeId"];
        }
    }

    static fromJS(data: any): GenerateRentReceiptCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateRentReceiptCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rentNoticeId"] = this.rentNoticeId;
        return data;
    }
}

export interface IGenerateRentReceiptCommand {
    rentNoticeId?: number;
}

export class SetRentReceiptStatusCommand implements ISetRentReceiptStatusCommand {
    id?: number;
    status?: string;

    constructor(data?: ISetRentReceiptStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SetRentReceiptStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetRentReceiptStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface ISetRentReceiptStatusCommand {
    id?: number;
    status?: string;
}

export class GenerateRentNoticesResultDto implements IGenerateRentNoticesResultDto {
    created?: number;
    skipped?: number;
    notices?: RentNoticeDto[];

    constructor(data?: IGenerateRentNoticesResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.created = _data["created"];
            this.skipped = _data["skipped"];
            if (Array.isArray(_data["notices"])) {
                this.notices = [] as any;
                for (let item of _data["notices"])
                    this.notices!.push(RentNoticeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GenerateRentNoticesResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateRentNoticesResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created;
        data["skipped"] = this.skipped;
        if (Array.isArray(this.notices)) {
            data["notices"] = [];
            for (let item of this.notices)
                data["notices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGenerateRentNoticesResultDto {
    created?: number;
    skipped?: number;
    notices?: RentNoticeDto[];
}

export class RentNoticeDto implements IRentNoticeDto {
    id?: number;
    rentalContractId?: number;
    contractNumber?: string | undefined;
    propertyId?: number;
    propertyName?: string;
    tenantId?: number;
    tenantName?: string;
    periodYear?: number;
    periodMonth?: number;
    periodLabel?: string;
    amount?: number;
    dueDate?: Date;
    issueDate?: Date;
    isPaid?: boolean;
    paidAt?: Date | undefined;
    isOverdue?: boolean;
    statusCode?: string;
    notifiedByEmail?: boolean;
    notifiedAt?: Date | undefined;
    notes?: string | undefined;

    constructor(data?: IRentNoticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rentalContractId = _data["rentalContractId"];
            this.contractNumber = _data["contractNumber"];
            this.propertyId = _data["propertyId"];
            this.propertyName = _data["propertyName"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.periodYear = _data["periodYear"];
            this.periodMonth = _data["periodMonth"];
            this.periodLabel = _data["periodLabel"];
            this.amount = _data["amount"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.isPaid = _data["isPaid"];
            this.paidAt = _data["paidAt"] ? new Date(_data["paidAt"].toString()) : undefined as any;
            this.isOverdue = _data["isOverdue"];
            this.statusCode = _data["statusCode"];
            this.notifiedByEmail = _data["notifiedByEmail"];
            this.notifiedAt = _data["notifiedAt"] ? new Date(_data["notifiedAt"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): RentNoticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentNoticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rentalContractId"] = this.rentalContractId;
        data["contractNumber"] = this.contractNumber;
        data["propertyId"] = this.propertyId;
        data["propertyName"] = this.propertyName;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["periodYear"] = this.periodYear;
        data["periodMonth"] = this.periodMonth;
        data["periodLabel"] = this.periodLabel;
        data["amount"] = this.amount;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined as any;
        data["isPaid"] = this.isPaid;
        data["paidAt"] = this.paidAt ? this.paidAt.toISOString() : undefined as any;
        data["isOverdue"] = this.isOverdue;
        data["statusCode"] = this.statusCode;
        data["notifiedByEmail"] = this.notifiedByEmail;
        data["notifiedAt"] = this.notifiedAt ? this.notifiedAt.toISOString() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IRentNoticeDto {
    id?: number;
    rentalContractId?: number;
    contractNumber?: string | undefined;
    propertyId?: number;
    propertyName?: string;
    tenantId?: number;
    tenantName?: string;
    periodYear?: number;
    periodMonth?: number;
    periodLabel?: string;
    amount?: number;
    dueDate?: Date;
    issueDate?: Date;
    isPaid?: boolean;
    paidAt?: Date | undefined;
    isOverdue?: boolean;
    statusCode?: string;
    notifiedByEmail?: boolean;
    notifiedAt?: Date | undefined;
    notes?: string | undefined;
}

export class GenerateRentNoticesCommand implements IGenerateRentNoticesCommand {
    year?: number;
    month?: number;

    constructor(data?: IGenerateRentNoticesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): GenerateRentNoticesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateRentNoticesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }
}

export interface IGenerateRentNoticesCommand {
    year?: number;
    month?: number;
}

export class SetRentNoticePaidCommand implements ISetRentNoticePaidCommand {
    id?: number;
    isPaid?: boolean;
    paidAt?: Date | undefined;

    constructor(data?: ISetRentNoticePaidCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isPaid = _data["isPaid"];
            this.paidAt = _data["paidAt"] ? new Date(_data["paidAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SetRentNoticePaidCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetRentNoticePaidCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isPaid"] = this.isPaid;
        data["paidAt"] = this.paidAt ? this.paidAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ISetRentNoticePaidCommand {
    id?: number;
    isPaid?: boolean;
    paidAt?: Date | undefined;
}

export class RentCollectionActivityDto implements IRentCollectionActivityDto {
    id?: number;
    rentNoticeId?: number;
    tenantName?: string;
    propertyName?: string;
    stage?: string;
    stageName?: string;
    channel?: string;
    channelName?: string;
    activityDate?: Date;
    subject?: string | undefined;
    body?: string | undefined;
    outcome?: string | undefined;
    emailTo?: string | undefined;
    emailStatus?: string | undefined;
    createdBy?: string | undefined;

    constructor(data?: IRentCollectionActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.rentNoticeId = _data["rentNoticeId"];
            this.tenantName = _data["tenantName"];
            this.propertyName = _data["propertyName"];
            this.stage = _data["stage"];
            this.stageName = _data["stageName"];
            this.channel = _data["channel"];
            this.channelName = _data["channelName"];
            this.activityDate = _data["activityDate"] ? new Date(_data["activityDate"].toString()) : undefined as any;
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.outcome = _data["outcome"];
            this.emailTo = _data["emailTo"];
            this.emailStatus = _data["emailStatus"];
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): RentCollectionActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentCollectionActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["rentNoticeId"] = this.rentNoticeId;
        data["tenantName"] = this.tenantName;
        data["propertyName"] = this.propertyName;
        data["stage"] = this.stage;
        data["stageName"] = this.stageName;
        data["channel"] = this.channel;
        data["channelName"] = this.channelName;
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : undefined as any;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["outcome"] = this.outcome;
        data["emailTo"] = this.emailTo;
        data["emailStatus"] = this.emailStatus;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IRentCollectionActivityDto {
    id?: number;
    rentNoticeId?: number;
    tenantName?: string;
    propertyName?: string;
    stage?: string;
    stageName?: string;
    channel?: string;
    channelName?: string;
    activityDate?: Date;
    subject?: string | undefined;
    body?: string | undefined;
    outcome?: string | undefined;
    emailTo?: string | undefined;
    emailStatus?: string | undefined;
    createdBy?: string | undefined;
}

export class SendRentCollectionEmailCommand implements ISendRentCollectionEmailCommand {
    rentNoticeId?: number;
    stage?: string;

    constructor(data?: ISendRentCollectionEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rentNoticeId = _data["rentNoticeId"];
            this.stage = _data["stage"];
        }
    }

    static fromJS(data: any): SendRentCollectionEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendRentCollectionEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rentNoticeId"] = this.rentNoticeId;
        data["stage"] = this.stage;
        return data;
    }
}

export interface ISendRentCollectionEmailCommand {
    rentNoticeId?: number;
    stage?: string;
}

export class LogRentCollectionActivityCommand implements ILogRentCollectionActivityCommand {
    rentNoticeId?: number;
    stage?: string;
    channel?: string;
    outcome?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: ILogRentCollectionActivityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rentNoticeId = _data["rentNoticeId"];
            this.stage = _data["stage"];
            this.channel = _data["channel"];
            this.outcome = _data["outcome"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): LogRentCollectionActivityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LogRentCollectionActivityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rentNoticeId"] = this.rentNoticeId;
        data["stage"] = this.stage;
        data["channel"] = this.channel;
        data["outcome"] = this.outcome;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface ILogRentCollectionActivityCommand {
    rentNoticeId?: number;
    stage?: string;
    channel?: string;
    outcome?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
}

export class RentalContractStatusDto implements IRentalContractStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;

    constructor(data?: IRentalContractStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): RentalContractStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentalContractStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IRentalContractStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
}

export class RentalContractDto implements IRentalContractDto {
    id?: number;
    propertyId?: number;
    propertyName?: string;
    tenantId?: number;
    tenantName?: string;
    contractNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    monthlyRent?: number;
    paymentDueDay?: number;
    deposit?: number | undefined;
    statusId?: number;
    statusCode?: string;
    statusName?: string;
    notes?: string | undefined;

    constructor(data?: IRentalContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.propertyId = _data["propertyId"];
            this.propertyName = _data["propertyName"];
            this.tenantId = _data["tenantId"];
            this.tenantName = _data["tenantName"];
            this.contractNumber = _data["contractNumber"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.monthlyRent = _data["monthlyRent"];
            this.paymentDueDay = _data["paymentDueDay"];
            this.deposit = _data["deposit"];
            this.statusId = _data["statusId"];
            this.statusCode = _data["statusCode"];
            this.statusName = _data["statusName"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): RentalContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new RentalContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["propertyId"] = this.propertyId;
        data["propertyName"] = this.propertyName;
        data["tenantId"] = this.tenantId;
        data["tenantName"] = this.tenantName;
        data["contractNumber"] = this.contractNumber;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["monthlyRent"] = this.monthlyRent;
        data["paymentDueDay"] = this.paymentDueDay;
        data["deposit"] = this.deposit;
        data["statusId"] = this.statusId;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IRentalContractDto {
    id?: number;
    propertyId?: number;
    propertyName?: string;
    tenantId?: number;
    tenantName?: string;
    contractNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    monthlyRent?: number;
    paymentDueDay?: number;
    deposit?: number | undefined;
    statusId?: number;
    statusCode?: string;
    statusName?: string;
    notes?: string | undefined;
}

export class CreateRentalContractCommand implements ICreateRentalContractCommand {
    propertyId?: number;
    tenantId?: number;
    contractNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    monthlyRent?: number;
    paymentDueDay?: number;
    deposit?: number | undefined;
    statusId?: number | undefined;
    notes?: string | undefined;

    constructor(data?: ICreateRentalContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["propertyId"];
            this.tenantId = _data["tenantId"];
            this.contractNumber = _data["contractNumber"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.monthlyRent = _data["monthlyRent"];
            this.paymentDueDay = _data["paymentDueDay"];
            this.deposit = _data["deposit"];
            this.statusId = _data["statusId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateRentalContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRentalContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyId"] = this.propertyId;
        data["tenantId"] = this.tenantId;
        data["contractNumber"] = this.contractNumber;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["monthlyRent"] = this.monthlyRent;
        data["paymentDueDay"] = this.paymentDueDay;
        data["deposit"] = this.deposit;
        data["statusId"] = this.statusId;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateRentalContractCommand {
    propertyId?: number;
    tenantId?: number;
    contractNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    monthlyRent?: number;
    paymentDueDay?: number;
    deposit?: number | undefined;
    statusId?: number | undefined;
    notes?: string | undefined;
}

export class UpdateRentalContractCommand implements IUpdateRentalContractCommand {
    id?: number;
    propertyId?: number;
    tenantId?: number;
    contractNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    monthlyRent?: number;
    paymentDueDay?: number;
    deposit?: number | undefined;
    statusId?: number;
    notes?: string | undefined;

    constructor(data?: IUpdateRentalContractCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.propertyId = _data["propertyId"];
            this.tenantId = _data["tenantId"];
            this.contractNumber = _data["contractNumber"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : undefined as any;
            this.monthlyRent = _data["monthlyRent"];
            this.paymentDueDay = _data["paymentDueDay"];
            this.deposit = _data["deposit"];
            this.statusId = _data["statusId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateRentalContractCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRentalContractCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["propertyId"] = this.propertyId;
        data["tenantId"] = this.tenantId;
        data["contractNumber"] = this.contractNumber;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["monthlyRent"] = this.monthlyRent;
        data["paymentDueDay"] = this.paymentDueDay;
        data["deposit"] = this.deposit;
        data["statusId"] = this.statusId;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateRentalContractCommand {
    id?: number;
    propertyId?: number;
    tenantId?: number;
    contractNumber?: string | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    monthlyRent?: number;
    paymentDueDay?: number;
    deposit?: number | undefined;
    statusId?: number;
    notes?: string | undefined;
}

export class PropertyDto implements IPropertyDto {
    id?: number;
    name?: string;
    address?: string | undefined;
    propertyType?: string | undefined;
    area?: number | undefined;
    rentValue?: number | undefined;
    annualImi?: number | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.propertyType = _data["propertyType"];
            this.area = _data["area"];
            this.rentValue = _data["rentValue"];
            this.annualImi = _data["annualImi"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["propertyType"] = this.propertyType;
        data["area"] = this.area;
        data["rentValue"] = this.rentValue;
        data["annualImi"] = this.annualImi;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IPropertyDto {
    id?: number;
    name?: string;
    address?: string | undefined;
    propertyType?: string | undefined;
    area?: number | undefined;
    rentValue?: number | undefined;
    annualImi?: number | undefined;
    created?: Date;
    lastModified?: Date;
}

export class CreatePropertyCommand implements ICreatePropertyCommand {
    name?: string;
    address?: string | undefined;
    propertyType?: string | undefined;
    area?: number | undefined;
    rentValue?: number | undefined;
    annualImi?: number | undefined;

    constructor(data?: ICreatePropertyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.propertyType = _data["propertyType"];
            this.area = _data["area"];
            this.rentValue = _data["rentValue"];
            this.annualImi = _data["annualImi"];
        }
    }

    static fromJS(data: any): CreatePropertyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePropertyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["propertyType"] = this.propertyType;
        data["area"] = this.area;
        data["rentValue"] = this.rentValue;
        data["annualImi"] = this.annualImi;
        return data;
    }
}

export interface ICreatePropertyCommand {
    name?: string;
    address?: string | undefined;
    propertyType?: string | undefined;
    area?: number | undefined;
    rentValue?: number | undefined;
    annualImi?: number | undefined;
}

export class UpdatePropertyCommand implements IUpdatePropertyCommand {
    id?: number;
    name?: string;
    address?: string | undefined;
    propertyType?: string | undefined;
    area?: number | undefined;
    rentValue?: number | undefined;
    annualImi?: number | undefined;

    constructor(data?: IUpdatePropertyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.propertyType = _data["propertyType"];
            this.area = _data["area"];
            this.rentValue = _data["rentValue"];
            this.annualImi = _data["annualImi"];
        }
    }

    static fromJS(data: any): UpdatePropertyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePropertyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["propertyType"] = this.propertyType;
        data["area"] = this.area;
        data["rentValue"] = this.rentValue;
        data["annualImi"] = this.annualImi;
        return data;
    }
}

export interface IUpdatePropertyCommand {
    id?: number;
    name?: string;
    address?: string | undefined;
    propertyType?: string | undefined;
    area?: number | undefined;
    rentValue?: number | undefined;
    annualImi?: number | undefined;
}

export class MeetingMinuteDto implements IMeetingMinuteDto {
    id?: number;
    title?: string;
    meetingType?: string | undefined;
    meetingDate?: Date | undefined;
    participants?: string | undefined;
    notes?: string | undefined;
    workId?: number | undefined;
    workName?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IMeetingMinuteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.meetingType = _data["meetingType"];
            this.meetingDate = _data["meetingDate"] ? new Date(_data["meetingDate"].toString()) : undefined as any;
            this.participants = _data["participants"];
            this.notes = _data["notes"];
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): MeetingMinuteDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeetingMinuteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["meetingType"] = this.meetingType;
        data["meetingDate"] = this.meetingDate ? this.meetingDate.toISOString() : undefined as any;
        data["participants"] = this.participants;
        data["notes"] = this.notes;
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IMeetingMinuteDto {
    id?: number;
    title?: string;
    meetingType?: string | undefined;
    meetingDate?: Date | undefined;
    participants?: string | undefined;
    notes?: string | undefined;
    workId?: number | undefined;
    workName?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class CreateMeetingMinuteCommand implements ICreateMeetingMinuteCommand {
    title?: string;
    meetingType?: string | undefined;
    meetingDate?: Date | undefined;
    participants?: string | undefined;
    notes?: string | undefined;
    workId?: number | undefined;

    constructor(data?: ICreateMeetingMinuteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.meetingType = _data["meetingType"];
            this.meetingDate = _data["meetingDate"] ? new Date(_data["meetingDate"].toString()) : undefined as any;
            this.participants = _data["participants"];
            this.notes = _data["notes"];
            this.workId = _data["workId"];
        }
    }

    static fromJS(data: any): CreateMeetingMinuteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMeetingMinuteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["meetingType"] = this.meetingType;
        data["meetingDate"] = this.meetingDate ? this.meetingDate.toISOString() : undefined as any;
        data["participants"] = this.participants;
        data["notes"] = this.notes;
        data["workId"] = this.workId;
        return data;
    }
}

export interface ICreateMeetingMinuteCommand {
    title?: string;
    meetingType?: string | undefined;
    meetingDate?: Date | undefined;
    participants?: string | undefined;
    notes?: string | undefined;
    workId?: number | undefined;
}

export class UpdateMeetingMinuteCommand implements IUpdateMeetingMinuteCommand {
    id?: number;
    title?: string;
    meetingType?: string | undefined;
    meetingDate?: Date | undefined;
    participants?: string | undefined;
    notes?: string | undefined;
    workId?: number | undefined;

    constructor(data?: IUpdateMeetingMinuteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.meetingType = _data["meetingType"];
            this.meetingDate = _data["meetingDate"] ? new Date(_data["meetingDate"].toString()) : undefined as any;
            this.participants = _data["participants"];
            this.notes = _data["notes"];
            this.workId = _data["workId"];
        }
    }

    static fromJS(data: any): UpdateMeetingMinuteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeetingMinuteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["meetingType"] = this.meetingType;
        data["meetingDate"] = this.meetingDate ? this.meetingDate.toISOString() : undefined as any;
        data["participants"] = this.participants;
        data["notes"] = this.notes;
        data["workId"] = this.workId;
        return data;
    }
}

export interface IUpdateMeetingMinuteCommand {
    id?: number;
    title?: string;
    meetingType?: string | undefined;
    meetingDate?: Date | undefined;
    participants?: string | undefined;
    notes?: string | undefined;
    workId?: number | undefined;
}

export class LoanDto implements ILoanDto {
    id?: number;
    financialEntity?: string;
    description?: string | undefined;
    installmentValue?: number | undefined;
    dueDate?: Date | undefined;
    periodicity?: string | undefined;
    status?: string | undefined;
    principal?: number | undefined;
    annualInterestRatePercent?: number | undefined;
    numberOfInstallments?: number | undefined;
    firstInstallmentDate?: Date | undefined;
    frequencyMonths?: number | undefined;
    paidInstallmentsCount?: number;
    bankReference?: string | undefined;
    installmentAmount?: number | undefined;
    outstandingBalance?: number | undefined;
    nextInstallment?: LoanNextInstallmentDto | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: ILoanDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialEntity = _data["financialEntity"];
            this.description = _data["description"];
            this.installmentValue = _data["installmentValue"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.periodicity = _data["periodicity"];
            this.status = _data["status"];
            this.principal = _data["principal"];
            this.annualInterestRatePercent = _data["annualInterestRatePercent"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.firstInstallmentDate = _data["firstInstallmentDate"] ? new Date(_data["firstInstallmentDate"].toString()) : undefined as any;
            this.frequencyMonths = _data["frequencyMonths"];
            this.paidInstallmentsCount = _data["paidInstallmentsCount"];
            this.bankReference = _data["bankReference"];
            this.installmentAmount = _data["installmentAmount"];
            this.outstandingBalance = _data["outstandingBalance"];
            this.nextInstallment = _data["nextInstallment"] ? LoanNextInstallmentDto.fromJS(_data["nextInstallment"]) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LoanDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoanDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialEntity"] = this.financialEntity;
        data["description"] = this.description;
        data["installmentValue"] = this.installmentValue;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["periodicity"] = this.periodicity;
        data["status"] = this.status;
        data["principal"] = this.principal;
        data["annualInterestRatePercent"] = this.annualInterestRatePercent;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["firstInstallmentDate"] = this.firstInstallmentDate ? this.firstInstallmentDate.toISOString() : undefined as any;
        data["frequencyMonths"] = this.frequencyMonths;
        data["paidInstallmentsCount"] = this.paidInstallmentsCount;
        data["bankReference"] = this.bankReference;
        data["installmentAmount"] = this.installmentAmount;
        data["outstandingBalance"] = this.outstandingBalance;
        data["nextInstallment"] = this.nextInstallment ? this.nextInstallment.toJSON() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface ILoanDto {
    id?: number;
    financialEntity?: string;
    description?: string | undefined;
    installmentValue?: number | undefined;
    dueDate?: Date | undefined;
    periodicity?: string | undefined;
    status?: string | undefined;
    principal?: number | undefined;
    annualInterestRatePercent?: number | undefined;
    numberOfInstallments?: number | undefined;
    firstInstallmentDate?: Date | undefined;
    frequencyMonths?: number | undefined;
    paidInstallmentsCount?: number;
    bankReference?: string | undefined;
    installmentAmount?: number | undefined;
    outstandingBalance?: number | undefined;
    nextInstallment?: LoanNextInstallmentDto | undefined;
    created?: Date;
    lastModified?: Date;
}

export class LoanNextInstallmentDto implements ILoanNextInstallmentDto {
    number?: number;
    dueDate?: Date;
    amount?: number;
    principalPortion?: number;
    interestPortion?: number;

    constructor(data?: ILoanNextInstallmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.principalPortion = _data["principalPortion"];
            this.interestPortion = _data["interestPortion"];
        }
    }

    static fromJS(data: any): LoanNextInstallmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoanNextInstallmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["principalPortion"] = this.principalPortion;
        data["interestPortion"] = this.interestPortion;
        return data;
    }
}

export interface ILoanNextInstallmentDto {
    number?: number;
    dueDate?: Date;
    amount?: number;
    principalPortion?: number;
    interestPortion?: number;
}

export class DebtOverviewDto implements IDebtOverviewDto {
    today?: Date;
    includesConfirming?: boolean;
    confirmingPlafond?: number | undefined;
    confirmingPlafondUsed?: number | undefined;
    confirmingPlafondAvailable?: number | undefined;
    totalOutstanding?: number;
    loansOutstanding?: number;
    confirmingOutstanding?: number;
    overdueTotal?: number;
    horizons?: DebtHorizonDto[];
    lines?: DebtOverviewLineDto[];

    constructor(data?: IDebtOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.today = _data["today"] ? new Date(_data["today"].toString()) : undefined as any;
            this.includesConfirming = _data["includesConfirming"];
            this.confirmingPlafond = _data["confirmingPlafond"];
            this.confirmingPlafondUsed = _data["confirmingPlafondUsed"];
            this.confirmingPlafondAvailable = _data["confirmingPlafondAvailable"];
            this.totalOutstanding = _data["totalOutstanding"];
            this.loansOutstanding = _data["loansOutstanding"];
            this.confirmingOutstanding = _data["confirmingOutstanding"];
            this.overdueTotal = _data["overdueTotal"];
            if (Array.isArray(_data["horizons"])) {
                this.horizons = [] as any;
                for (let item of _data["horizons"])
                    this.horizons!.push(DebtHorizonDto.fromJS(item));
            }
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(DebtOverviewLineDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DebtOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["today"] = this.today ? this.today.toISOString() : undefined as any;
        data["includesConfirming"] = this.includesConfirming;
        data["confirmingPlafond"] = this.confirmingPlafond;
        data["confirmingPlafondUsed"] = this.confirmingPlafondUsed;
        data["confirmingPlafondAvailable"] = this.confirmingPlafondAvailable;
        data["totalOutstanding"] = this.totalOutstanding;
        data["loansOutstanding"] = this.loansOutstanding;
        data["confirmingOutstanding"] = this.confirmingOutstanding;
        data["overdueTotal"] = this.overdueTotal;
        if (Array.isArray(this.horizons)) {
            data["horizons"] = [];
            for (let item of this.horizons)
                data["horizons"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDebtOverviewDto {
    today?: Date;
    includesConfirming?: boolean;
    confirmingPlafond?: number | undefined;
    confirmingPlafondUsed?: number | undefined;
    confirmingPlafondAvailable?: number | undefined;
    totalOutstanding?: number;
    loansOutstanding?: number;
    confirmingOutstanding?: number;
    overdueTotal?: number;
    horizons?: DebtHorizonDto[];
    lines?: DebtOverviewLineDto[];
}

export class DebtHorizonDto implements IDebtHorizonDto {
    days?: number;
    until?: Date;
    principal?: number;
    interest?: number;
    total?: number;
    loansTotal?: number;
    confirmingTotal?: number;
    outstandingAfter?: number;
    loansOutstandingAfter?: number;
    confirmingOutstandingAfter?: number;

    constructor(data?: IDebtHorizonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.days = _data["days"];
            this.until = _data["until"] ? new Date(_data["until"].toString()) : undefined as any;
            this.principal = _data["principal"];
            this.interest = _data["interest"];
            this.total = _data["total"];
            this.loansTotal = _data["loansTotal"];
            this.confirmingTotal = _data["confirmingTotal"];
            this.outstandingAfter = _data["outstandingAfter"];
            this.loansOutstandingAfter = _data["loansOutstandingAfter"];
            this.confirmingOutstandingAfter = _data["confirmingOutstandingAfter"];
        }
    }

    static fromJS(data: any): DebtHorizonDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtHorizonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["days"] = this.days;
        data["until"] = this.until ? this.until.toISOString() : undefined as any;
        data["principal"] = this.principal;
        data["interest"] = this.interest;
        data["total"] = this.total;
        data["loansTotal"] = this.loansTotal;
        data["confirmingTotal"] = this.confirmingTotal;
        data["outstandingAfter"] = this.outstandingAfter;
        data["loansOutstandingAfter"] = this.loansOutstandingAfter;
        data["confirmingOutstandingAfter"] = this.confirmingOutstandingAfter;
        return data;
    }
}

export interface IDebtHorizonDto {
    days?: number;
    until?: Date;
    principal?: number;
    interest?: number;
    total?: number;
    loansTotal?: number;
    confirmingTotal?: number;
    outstandingAfter?: number;
    loansOutstandingAfter?: number;
    confirmingOutstandingAfter?: number;
}

export class DebtOverviewLineDto implements IDebtOverviewLineDto {
    kind?: string;
    id?: number;
    entity?: string;
    description?: string | undefined;
    outstandingBalance?: number | undefined;
    nextDueDate?: Date | undefined;
    nextAmount?: number | undefined;
    nextPrincipal?: number | undefined;
    nextInterest?: number | undefined;
    isOverdue?: boolean;
    remainingInstallments?: number;

    constructor(data?: IDebtOverviewLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
            this.id = _data["id"];
            this.entity = _data["entity"];
            this.description = _data["description"];
            this.outstandingBalance = _data["outstandingBalance"];
            this.nextDueDate = _data["nextDueDate"] ? new Date(_data["nextDueDate"].toString()) : undefined as any;
            this.nextAmount = _data["nextAmount"];
            this.nextPrincipal = _data["nextPrincipal"];
            this.nextInterest = _data["nextInterest"];
            this.isOverdue = _data["isOverdue"];
            this.remainingInstallments = _data["remainingInstallments"];
        }
    }

    static fromJS(data: any): DebtOverviewLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtOverviewLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        data["id"] = this.id;
        data["entity"] = this.entity;
        data["description"] = this.description;
        data["outstandingBalance"] = this.outstandingBalance;
        data["nextDueDate"] = this.nextDueDate ? this.nextDueDate.toISOString() : undefined as any;
        data["nextAmount"] = this.nextAmount;
        data["nextPrincipal"] = this.nextPrincipal;
        data["nextInterest"] = this.nextInterest;
        data["isOverdue"] = this.isOverdue;
        data["remainingInstallments"] = this.remainingInstallments;
        return data;
    }
}

export interface IDebtOverviewLineDto {
    kind?: string;
    id?: number;
    entity?: string;
    description?: string | undefined;
    outstandingBalance?: number | undefined;
    nextDueDate?: Date | undefined;
    nextAmount?: number | undefined;
    nextPrincipal?: number | undefined;
    nextInterest?: number | undefined;
    isOverdue?: boolean;
    remainingInstallments?: number;
}

export class LoanDetailDto extends LoanDto implements ILoanDetailDto {
    schedule?: LoanInstallmentDto[];

    constructor(data?: ILoanDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["schedule"])) {
                this.schedule = [] as any;
                for (let item of _data["schedule"])
                    this.schedule!.push(LoanInstallmentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): LoanDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoanDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.schedule)) {
            data["schedule"] = [];
            for (let item of this.schedule)
                data["schedule"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILoanDetailDto extends ILoanDto {
    schedule?: LoanInstallmentDto[];
}

export class LoanInstallmentDto implements ILoanInstallmentDto {
    number?: number;
    dueDate?: Date;
    amount?: number;
    principalPortion?: number;
    interestPortion?: number;
    outstandingAfter?: number;
    paid?: boolean;
    paidAmount?: number | undefined;
    paidOn?: Date | undefined;

    constructor(data?: ILoanInstallmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.principalPortion = _data["principalPortion"];
            this.interestPortion = _data["interestPortion"];
            this.outstandingAfter = _data["outstandingAfter"];
            this.paid = _data["paid"];
            this.paidAmount = _data["paidAmount"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LoanInstallmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoanInstallmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["principalPortion"] = this.principalPortion;
        data["interestPortion"] = this.interestPortion;
        data["outstandingAfter"] = this.outstandingAfter;
        data["paid"] = this.paid;
        data["paidAmount"] = this.paidAmount;
        data["paidOn"] = this.paidOn ? this.paidOn.toISOString() : undefined as any;
        return data;
    }
}

export interface ILoanInstallmentDto {
    number?: number;
    dueDate?: Date;
    amount?: number;
    principalPortion?: number;
    interestPortion?: number;
    outstandingAfter?: number;
    paid?: boolean;
    paidAmount?: number | undefined;
    paidOn?: Date | undefined;
}

export class CreateLoanCommand implements ICreateLoanCommand {
    financialEntity?: string;
    description?: string | undefined;
    installmentValue?: number | undefined;
    dueDate?: Date | undefined;
    periodicity?: string | undefined;
    status?: string | undefined;
    principal?: number | undefined;
    annualInterestRatePercent?: number | undefined;
    numberOfInstallments?: number | undefined;
    firstInstallmentDate?: Date | undefined;
    frequencyMonths?: number | undefined;
    bankReference?: string | undefined;

    constructor(data?: ICreateLoanCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialEntity = _data["financialEntity"];
            this.description = _data["description"];
            this.installmentValue = _data["installmentValue"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.periodicity = _data["periodicity"];
            this.status = _data["status"];
            this.principal = _data["principal"];
            this.annualInterestRatePercent = _data["annualInterestRatePercent"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.firstInstallmentDate = _data["firstInstallmentDate"] ? new Date(_data["firstInstallmentDate"].toString()) : undefined as any;
            this.frequencyMonths = _data["frequencyMonths"];
            this.bankReference = _data["bankReference"];
        }
    }

    static fromJS(data: any): CreateLoanCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLoanCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialEntity"] = this.financialEntity;
        data["description"] = this.description;
        data["installmentValue"] = this.installmentValue;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["periodicity"] = this.periodicity;
        data["status"] = this.status;
        data["principal"] = this.principal;
        data["annualInterestRatePercent"] = this.annualInterestRatePercent;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["firstInstallmentDate"] = this.firstInstallmentDate ? this.firstInstallmentDate.toISOString() : undefined as any;
        data["frequencyMonths"] = this.frequencyMonths;
        data["bankReference"] = this.bankReference;
        return data;
    }
}

export interface ICreateLoanCommand {
    financialEntity?: string;
    description?: string | undefined;
    installmentValue?: number | undefined;
    dueDate?: Date | undefined;
    periodicity?: string | undefined;
    status?: string | undefined;
    principal?: number | undefined;
    annualInterestRatePercent?: number | undefined;
    numberOfInstallments?: number | undefined;
    firstInstallmentDate?: Date | undefined;
    frequencyMonths?: number | undefined;
    bankReference?: string | undefined;
}

export class UpdateLoanCommand implements IUpdateLoanCommand {
    id?: number;
    financialEntity?: string;
    description?: string | undefined;
    installmentValue?: number | undefined;
    dueDate?: Date | undefined;
    periodicity?: string | undefined;
    status?: string | undefined;
    principal?: number | undefined;
    annualInterestRatePercent?: number | undefined;
    numberOfInstallments?: number | undefined;
    firstInstallmentDate?: Date | undefined;
    frequencyMonths?: number | undefined;
    bankReference?: string | undefined;
    paidInstallmentsCount?: number | undefined;

    constructor(data?: IUpdateLoanCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financialEntity = _data["financialEntity"];
            this.description = _data["description"];
            this.installmentValue = _data["installmentValue"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.periodicity = _data["periodicity"];
            this.status = _data["status"];
            this.principal = _data["principal"];
            this.annualInterestRatePercent = _data["annualInterestRatePercent"];
            this.numberOfInstallments = _data["numberOfInstallments"];
            this.firstInstallmentDate = _data["firstInstallmentDate"] ? new Date(_data["firstInstallmentDate"].toString()) : undefined as any;
            this.frequencyMonths = _data["frequencyMonths"];
            this.bankReference = _data["bankReference"];
            this.paidInstallmentsCount = _data["paidInstallmentsCount"];
        }
    }

    static fromJS(data: any): UpdateLoanCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLoanCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financialEntity"] = this.financialEntity;
        data["description"] = this.description;
        data["installmentValue"] = this.installmentValue;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["periodicity"] = this.periodicity;
        data["status"] = this.status;
        data["principal"] = this.principal;
        data["annualInterestRatePercent"] = this.annualInterestRatePercent;
        data["numberOfInstallments"] = this.numberOfInstallments;
        data["firstInstallmentDate"] = this.firstInstallmentDate ? this.firstInstallmentDate.toISOString() : undefined as any;
        data["frequencyMonths"] = this.frequencyMonths;
        data["bankReference"] = this.bankReference;
        data["paidInstallmentsCount"] = this.paidInstallmentsCount;
        return data;
    }
}

export interface IUpdateLoanCommand {
    id?: number;
    financialEntity?: string;
    description?: string | undefined;
    installmentValue?: number | undefined;
    dueDate?: Date | undefined;
    periodicity?: string | undefined;
    status?: string | undefined;
    principal?: number | undefined;
    annualInterestRatePercent?: number | undefined;
    numberOfInstallments?: number | undefined;
    firstInstallmentDate?: Date | undefined;
    frequencyMonths?: number | undefined;
    bankReference?: string | undefined;
    paidInstallmentsCount?: number | undefined;
}

export class RegisterLoanInstallmentPaymentCommand implements IRegisterLoanInstallmentPaymentCommand {
    id?: number;
    amount?: number | undefined;
    paidOn?: Date | undefined;

    constructor(data?: IRegisterLoanInstallmentPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RegisterLoanInstallmentPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterLoanInstallmentPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["paidOn"] = this.paidOn ? this.paidOn.toISOString() : undefined as any;
        return data;
    }
}

export interface IRegisterLoanInstallmentPaymentCommand {
    id?: number;
    amount?: number | undefined;
    paidOn?: Date | undefined;
}

export class InvoiceListVm implements IInvoiceListVm {
    items?: InvoiceDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    totals?: InvoiceTotalsDto;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IInvoiceListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InvoiceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.totals = _data["totals"] ? InvoiceTotalsDto.fromJS(_data["totals"]) : undefined as any;
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): InvoiceListVm {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IInvoiceListVm {
    items?: InvoiceDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    totals?: InvoiceTotalsDto;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class InvoiceDto implements IInvoiceDto {
    id?: number;
    companyId?: number | undefined;
    companyName?: string | undefined;
    workId?: number | undefined;
    workCode?: string | undefined;
    workName?: string | undefined;
    documentNumber?: string | undefined;
    isCreditNote?: boolean;
    isAnnulledByCreditNote?: boolean;
    excludeFromSummary?: boolean;
    plannedPaymentDate?: Date | undefined;
    paymentTaskItemId?: number | undefined;
    creditNoteReference?: string | undefined;
    documentDate?: Date | undefined;
    description?: string | undefined;
    supplierName?: string | undefined;
    supplierTaxNumber?: string | undefined;
    confidence?: number | undefined;
    matchedSupplierId?: number | undefined;
    matchedSupplierName?: string | undefined;
    expenseCategoryId?: number | undefined;
    expenseCategoryCode?: string | undefined;
    expenseCategoryName?: string | undefined;
    isStructural?: boolean | undefined;
    subType?: string | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    currencyCode?: string;
    approvalStatusId?: number | undefined;
    approvalStatusCode?: string;
    approvalStatusName?: string;
    documentId?: number | undefined;
    documentFileName?: string | undefined;
    hasDocument?: boolean;
    documentIsAuto?: boolean;
    autoDocumentsCount?: number;
    lifecyclePhase?: string;
    forecastedAmount?: number | undefined;
    forecastSuggestions?: ForecastSuggestionDto[];
    paidAmount?: number | undefined;
    hasPaymentProof?: boolean;
    paymentProofFileName?: string | undefined;
    paymentProofUploadedAt?: Date | undefined;
    paymentProofReadNote?: string | undefined;
    paymentProofs?: PaymentProofDto[];
    validationStatus?: WorkFinancialValidationStatus;
    autoValidated?: boolean;
    allocations?: InvoiceAllocationDto[];
    isSplit?: boolean;
    workCount?: number;
    imputedAmount?: number | undefined;
    imputedCostCount?: number;
    reappliedFromPreviousReview?: boolean;
    sourceChannel?: string | undefined;
    sourceSender?: string | undefined;
    sourceSubject?: string | undefined;
    sourceReceivedAt?: Date | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.workId = _data["workId"];
            this.workCode = _data["workCode"];
            this.workName = _data["workName"];
            this.documentNumber = _data["documentNumber"];
            this.isCreditNote = _data["isCreditNote"];
            this.isAnnulledByCreditNote = _data["isAnnulledByCreditNote"];
            this.excludeFromSummary = _data["excludeFromSummary"];
            this.plannedPaymentDate = _data["plannedPaymentDate"] ? new Date(_data["plannedPaymentDate"].toString()) : undefined as any;
            this.paymentTaskItemId = _data["paymentTaskItemId"];
            this.creditNoteReference = _data["creditNoteReference"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.supplierName = _data["supplierName"];
            this.supplierTaxNumber = _data["supplierTaxNumber"];
            this.confidence = _data["confidence"];
            this.matchedSupplierId = _data["matchedSupplierId"];
            this.matchedSupplierName = _data["matchedSupplierName"];
            this.expenseCategoryId = _data["expenseCategoryId"];
            this.expenseCategoryCode = _data["expenseCategoryCode"];
            this.expenseCategoryName = _data["expenseCategoryName"];
            this.isStructural = _data["isStructural"];
            this.subType = _data["subType"];
            this.baseAmount = _data["baseAmount"];
            this.vatAmount = _data["vatAmount"];
            this.totalAmount = _data["totalAmount"];
            this.currencyCode = _data["currencyCode"];
            this.approvalStatusId = _data["approvalStatusId"];
            this.approvalStatusCode = _data["approvalStatusCode"];
            this.approvalStatusName = _data["approvalStatusName"];
            this.documentId = _data["documentId"];
            this.documentFileName = _data["documentFileName"];
            this.hasDocument = _data["hasDocument"];
            this.documentIsAuto = _data["documentIsAuto"];
            this.autoDocumentsCount = _data["autoDocumentsCount"];
            this.lifecyclePhase = _data["lifecyclePhase"];
            this.forecastedAmount = _data["forecastedAmount"];
            if (Array.isArray(_data["forecastSuggestions"])) {
                this.forecastSuggestions = [] as any;
                for (let item of _data["forecastSuggestions"])
                    this.forecastSuggestions!.push(ForecastSuggestionDto.fromJS(item));
            }
            this.paidAmount = _data["paidAmount"];
            this.hasPaymentProof = _data["hasPaymentProof"];
            this.paymentProofFileName = _data["paymentProofFileName"];
            this.paymentProofUploadedAt = _data["paymentProofUploadedAt"] ? new Date(_data["paymentProofUploadedAt"].toString()) : undefined as any;
            this.paymentProofReadNote = _data["paymentProofReadNote"];
            if (Array.isArray(_data["paymentProofs"])) {
                this.paymentProofs = [] as any;
                for (let item of _data["paymentProofs"])
                    this.paymentProofs!.push(PaymentProofDto.fromJS(item));
            }
            this.validationStatus = _data["validationStatus"];
            this.autoValidated = _data["autoValidated"];
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(InvoiceAllocationDto.fromJS(item));
            }
            this.isSplit = _data["isSplit"];
            this.workCount = _data["workCount"];
            this.imputedAmount = _data["imputedAmount"];
            this.imputedCostCount = _data["imputedCostCount"];
            this.reappliedFromPreviousReview = _data["reappliedFromPreviousReview"];
            this.sourceChannel = _data["sourceChannel"];
            this.sourceSender = _data["sourceSender"];
            this.sourceSubject = _data["sourceSubject"];
            this.sourceReceivedAt = _data["sourceReceivedAt"] ? new Date(_data["sourceReceivedAt"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["workId"] = this.workId;
        data["workCode"] = this.workCode;
        data["workName"] = this.workName;
        data["documentNumber"] = this.documentNumber;
        data["isCreditNote"] = this.isCreditNote;
        data["isAnnulledByCreditNote"] = this.isAnnulledByCreditNote;
        data["excludeFromSummary"] = this.excludeFromSummary;
        data["plannedPaymentDate"] = this.plannedPaymentDate ? this.plannedPaymentDate.toISOString() : undefined as any;
        data["paymentTaskItemId"] = this.paymentTaskItemId;
        data["creditNoteReference"] = this.creditNoteReference;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["description"] = this.description;
        data["supplierName"] = this.supplierName;
        data["supplierTaxNumber"] = this.supplierTaxNumber;
        data["confidence"] = this.confidence;
        data["matchedSupplierId"] = this.matchedSupplierId;
        data["matchedSupplierName"] = this.matchedSupplierName;
        data["expenseCategoryId"] = this.expenseCategoryId;
        data["expenseCategoryCode"] = this.expenseCategoryCode;
        data["expenseCategoryName"] = this.expenseCategoryName;
        data["isStructural"] = this.isStructural;
        data["subType"] = this.subType;
        data["baseAmount"] = this.baseAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["currencyCode"] = this.currencyCode;
        data["approvalStatusId"] = this.approvalStatusId;
        data["approvalStatusCode"] = this.approvalStatusCode;
        data["approvalStatusName"] = this.approvalStatusName;
        data["documentId"] = this.documentId;
        data["documentFileName"] = this.documentFileName;
        data["hasDocument"] = this.hasDocument;
        data["documentIsAuto"] = this.documentIsAuto;
        data["autoDocumentsCount"] = this.autoDocumentsCount;
        data["lifecyclePhase"] = this.lifecyclePhase;
        data["forecastedAmount"] = this.forecastedAmount;
        if (Array.isArray(this.forecastSuggestions)) {
            data["forecastSuggestions"] = [];
            for (let item of this.forecastSuggestions)
                data["forecastSuggestions"].push(item ? item.toJSON() : undefined as any);
        }
        data["paidAmount"] = this.paidAmount;
        data["hasPaymentProof"] = this.hasPaymentProof;
        data["paymentProofFileName"] = this.paymentProofFileName;
        data["paymentProofUploadedAt"] = this.paymentProofUploadedAt ? this.paymentProofUploadedAt.toISOString() : undefined as any;
        data["paymentProofReadNote"] = this.paymentProofReadNote;
        if (Array.isArray(this.paymentProofs)) {
            data["paymentProofs"] = [];
            for (let item of this.paymentProofs)
                data["paymentProofs"].push(item ? item.toJSON() : undefined as any);
        }
        data["validationStatus"] = this.validationStatus;
        data["autoValidated"] = this.autoValidated;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSplit"] = this.isSplit;
        data["workCount"] = this.workCount;
        data["imputedAmount"] = this.imputedAmount;
        data["imputedCostCount"] = this.imputedCostCount;
        data["reappliedFromPreviousReview"] = this.reappliedFromPreviousReview;
        data["sourceChannel"] = this.sourceChannel;
        data["sourceSender"] = this.sourceSender;
        data["sourceSubject"] = this.sourceSubject;
        data["sourceReceivedAt"] = this.sourceReceivedAt ? this.sourceReceivedAt.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IInvoiceDto {
    id?: number;
    companyId?: number | undefined;
    companyName?: string | undefined;
    workId?: number | undefined;
    workCode?: string | undefined;
    workName?: string | undefined;
    documentNumber?: string | undefined;
    isCreditNote?: boolean;
    isAnnulledByCreditNote?: boolean;
    excludeFromSummary?: boolean;
    plannedPaymentDate?: Date | undefined;
    paymentTaskItemId?: number | undefined;
    creditNoteReference?: string | undefined;
    documentDate?: Date | undefined;
    description?: string | undefined;
    supplierName?: string | undefined;
    supplierTaxNumber?: string | undefined;
    confidence?: number | undefined;
    matchedSupplierId?: number | undefined;
    matchedSupplierName?: string | undefined;
    expenseCategoryId?: number | undefined;
    expenseCategoryCode?: string | undefined;
    expenseCategoryName?: string | undefined;
    isStructural?: boolean | undefined;
    subType?: string | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    currencyCode?: string;
    approvalStatusId?: number | undefined;
    approvalStatusCode?: string;
    approvalStatusName?: string;
    documentId?: number | undefined;
    documentFileName?: string | undefined;
    hasDocument?: boolean;
    documentIsAuto?: boolean;
    autoDocumentsCount?: number;
    lifecyclePhase?: string;
    forecastedAmount?: number | undefined;
    forecastSuggestions?: ForecastSuggestionDto[];
    paidAmount?: number | undefined;
    hasPaymentProof?: boolean;
    paymentProofFileName?: string | undefined;
    paymentProofUploadedAt?: Date | undefined;
    paymentProofReadNote?: string | undefined;
    paymentProofs?: PaymentProofDto[];
    validationStatus?: WorkFinancialValidationStatus;
    autoValidated?: boolean;
    allocations?: InvoiceAllocationDto[];
    isSplit?: boolean;
    workCount?: number;
    imputedAmount?: number | undefined;
    imputedCostCount?: number;
    reappliedFromPreviousReview?: boolean;
    sourceChannel?: string | undefined;
    sourceSender?: string | undefined;
    sourceSubject?: string | undefined;
    sourceReceivedAt?: Date | undefined;
    created?: Date;
    lastModified?: Date;
}

export class ForecastSuggestionDto implements IForecastSuggestionDto {
    forecastEntryId?: number;
    score?: number;
    description?: string | undefined;
    supplierName?: string | undefined;
    forecastAmount?: number | undefined;
    hasInvoice?: boolean;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    works?: ForecastSuggestionWorkDto[];

    constructor(data?: IForecastSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forecastEntryId = _data["forecastEntryId"];
            this.score = _data["score"];
            this.description = _data["description"];
            this.supplierName = _data["supplierName"];
            this.forecastAmount = _data["forecastAmount"];
            this.hasInvoice = _data["hasInvoice"];
            this.documentNumber = _data["documentNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            if (Array.isArray(_data["works"])) {
                this.works = [] as any;
                for (let item of _data["works"])
                    this.works!.push(ForecastSuggestionWorkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ForecastSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forecastEntryId"] = this.forecastEntryId;
        data["score"] = this.score;
        data["description"] = this.description;
        data["supplierName"] = this.supplierName;
        data["forecastAmount"] = this.forecastAmount;
        data["hasInvoice"] = this.hasInvoice;
        data["documentNumber"] = this.documentNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        if (Array.isArray(this.works)) {
            data["works"] = [];
            for (let item of this.works)
                data["works"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IForecastSuggestionDto {
    forecastEntryId?: number;
    score?: number;
    description?: string | undefined;
    supplierName?: string | undefined;
    forecastAmount?: number | undefined;
    hasInvoice?: boolean;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    works?: ForecastSuggestionWorkDto[];
}

export class ForecastSuggestionWorkDto implements IForecastSuggestionWorkDto {
    workId?: number | undefined;
    workName?: string | undefined;
    suggestedWorkName?: string | undefined;
    isStructural?: boolean;

    constructor(data?: IForecastSuggestionWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.suggestedWorkName = _data["suggestedWorkName"];
            this.isStructural = _data["isStructural"];
        }
    }

    static fromJS(data: any): ForecastSuggestionWorkDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastSuggestionWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["suggestedWorkName"] = this.suggestedWorkName;
        data["isStructural"] = this.isStructural;
        return data;
    }
}

export interface IForecastSuggestionWorkDto {
    workId?: number | undefined;
    workName?: string | undefined;
    suggestedWorkName?: string | undefined;
    isStructural?: boolean;
}

export class PaymentProofDto implements IPaymentProofDto {
    id?: number;
    fileName?: string;
    amount?: number | undefined;
    uploadedAt?: Date;

    constructor(data?: IPaymentProofDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.amount = _data["amount"];
            this.uploadedAt = _data["uploadedAt"] ? new Date(_data["uploadedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PaymentProofDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProofDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["amount"] = this.amount;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IPaymentProofDto {
    id?: number;
    fileName?: string;
    amount?: number | undefined;
    uploadedAt?: Date;
}

export class InvoiceAllocationDto implements IInvoiceAllocationDto {
    id?: number;
    workId?: number | undefined;
    workCode?: string | undefined;
    workName?: string | undefined;
    suggestedWorkName?: string | undefined;
    amount?: number;
    expenseCategoryId?: number | undefined;
    expenseCategoryName?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    isStructural?: boolean;
    assignmentSourceCode?: string | undefined;
    assignmentSourceName?: string | undefined;
    feedbackTypeCode?: string | undefined;
    feedbackErrorDescription?: string | undefined;
    feedbackCorrectedWorkId?: number | undefined;
    feedbackAt?: Date | undefined;

    constructor(data?: IInvoiceAllocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.workCode = _data["workCode"];
            this.workName = _data["workName"];
            this.suggestedWorkName = _data["suggestedWorkName"];
            this.amount = _data["amount"];
            this.expenseCategoryId = _data["expenseCategoryId"];
            this.expenseCategoryName = _data["expenseCategoryName"];
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.isStructural = _data["isStructural"];
            this.assignmentSourceCode = _data["assignmentSourceCode"];
            this.assignmentSourceName = _data["assignmentSourceName"];
            this.feedbackTypeCode = _data["feedbackTypeCode"];
            this.feedbackErrorDescription = _data["feedbackErrorDescription"];
            this.feedbackCorrectedWorkId = _data["feedbackCorrectedWorkId"];
            this.feedbackAt = _data["feedbackAt"] ? new Date(_data["feedbackAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): InvoiceAllocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAllocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["workCode"] = this.workCode;
        data["workName"] = this.workName;
        data["suggestedWorkName"] = this.suggestedWorkName;
        data["amount"] = this.amount;
        data["expenseCategoryId"] = this.expenseCategoryId;
        data["expenseCategoryName"] = this.expenseCategoryName;
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["isStructural"] = this.isStructural;
        data["assignmentSourceCode"] = this.assignmentSourceCode;
        data["assignmentSourceName"] = this.assignmentSourceName;
        data["feedbackTypeCode"] = this.feedbackTypeCode;
        data["feedbackErrorDescription"] = this.feedbackErrorDescription;
        data["feedbackCorrectedWorkId"] = this.feedbackCorrectedWorkId;
        data["feedbackAt"] = this.feedbackAt ? this.feedbackAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IInvoiceAllocationDto {
    id?: number;
    workId?: number | undefined;
    workCode?: string | undefined;
    workName?: string | undefined;
    suggestedWorkName?: string | undefined;
    amount?: number;
    expenseCategoryId?: number | undefined;
    expenseCategoryName?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
    isStructural?: boolean;
    assignmentSourceCode?: string | undefined;
    assignmentSourceName?: string | undefined;
    feedbackTypeCode?: string | undefined;
    feedbackErrorDescription?: string | undefined;
    feedbackCorrectedWorkId?: number | undefined;
    feedbackAt?: Date | undefined;
}

export class InvoiceTotalsDto implements IInvoiceTotalsDto {
    baseTotal?: number;
    vatTotal?: number;
    grandTotal?: number;
    count?: number;

    constructor(data?: IInvoiceTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseTotal = _data["baseTotal"];
            this.vatTotal = _data["vatTotal"];
            this.grandTotal = _data["grandTotal"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): InvoiceTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseTotal"] = this.baseTotal;
        data["vatTotal"] = this.vatTotal;
        data["grandTotal"] = this.grandTotal;
        data["count"] = this.count;
        return data;
    }
}

export interface IInvoiceTotalsDto {
    baseTotal?: number;
    vatTotal?: number;
    grandTotal?: number;
    count?: number;
}

export class InvoiceFilterOptionsVm implements IInvoiceFilterOptionsVm {
    entities?: string[];
    works?: InvoiceWorkOptionDto[];
    subTypes?: string[];

    constructor(data?: IInvoiceFilterOptionsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(item);
            }
            if (Array.isArray(_data["works"])) {
                this.works = [] as any;
                for (let item of _data["works"])
                    this.works!.push(InvoiceWorkOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["subTypes"])) {
                this.subTypes = [] as any;
                for (let item of _data["subTypes"])
                    this.subTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceFilterOptionsVm {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceFilterOptionsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item);
        }
        if (Array.isArray(this.works)) {
            data["works"] = [];
            for (let item of this.works)
                data["works"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subTypes)) {
            data["subTypes"] = [];
            for (let item of this.subTypes)
                data["subTypes"].push(item);
        }
        return data;
    }
}

export interface IInvoiceFilterOptionsVm {
    entities?: string[];
    works?: InvoiceWorkOptionDto[];
    subTypes?: string[];
}

export class InvoiceWorkOptionDto implements IInvoiceWorkOptionDto {
    id?: number;
    code?: string | undefined;
    name?: string;

    constructor(data?: IInvoiceWorkOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InvoiceWorkOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceWorkOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IInvoiceWorkOptionDto {
    id?: number;
    code?: string | undefined;
    name?: string;
}

export class PaginatedListOfEmailIngestionMessageDto implements IPaginatedListOfEmailIngestionMessageDto {
    items?: EmailIngestionMessageDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfEmailIngestionMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EmailIngestionMessageDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfEmailIngestionMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfEmailIngestionMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfEmailIngestionMessageDto {
    items?: EmailIngestionMessageDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class EmailIngestionMessageDto implements IEmailIngestionMessageDto {
    id?: number;
    gmailMessageId?: string;
    from?: string | undefined;
    subject?: string | undefined;
    receivedAt?: Date;
    processedAt?: Date;
    attachmentCount?: number;
    skippedAttachmentCount?: number;
    skippedAttachmentNames?: string | undefined;
    skippedDismissed?: boolean;
    importedCount?: number;
    status?: string;
    error?: string | undefined;
    hasEmail?: boolean;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IEmailIngestionMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gmailMessageId = _data["gmailMessageId"];
            this.from = _data["from"];
            this.subject = _data["subject"];
            this.receivedAt = _data["receivedAt"] ? new Date(_data["receivedAt"].toString()) : undefined as any;
            this.processedAt = _data["processedAt"] ? new Date(_data["processedAt"].toString()) : undefined as any;
            this.attachmentCount = _data["attachmentCount"];
            this.skippedAttachmentCount = _data["skippedAttachmentCount"];
            this.skippedAttachmentNames = _data["skippedAttachmentNames"];
            this.skippedDismissed = _data["skippedDismissed"];
            this.importedCount = _data["importedCount"];
            this.status = _data["status"];
            this.error = _data["error"];
            this.hasEmail = _data["hasEmail"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EmailIngestionMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailIngestionMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gmailMessageId"] = this.gmailMessageId;
        data["from"] = this.from;
        data["subject"] = this.subject;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toISOString() : undefined as any;
        data["processedAt"] = this.processedAt ? this.processedAt.toISOString() : undefined as any;
        data["attachmentCount"] = this.attachmentCount;
        data["skippedAttachmentCount"] = this.skippedAttachmentCount;
        data["skippedAttachmentNames"] = this.skippedAttachmentNames;
        data["skippedDismissed"] = this.skippedDismissed;
        data["importedCount"] = this.importedCount;
        data["status"] = this.status;
        data["error"] = this.error;
        data["hasEmail"] = this.hasEmail;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IEmailIngestionMessageDto {
    id?: number;
    gmailMessageId?: string;
    from?: string | undefined;
    subject?: string | undefined;
    receivedAt?: Date;
    processedAt?: Date;
    attachmentCount?: number;
    skippedAttachmentCount?: number;
    skippedAttachmentNames?: string | undefined;
    skippedDismissed?: boolean;
    importedCount?: number;
    status?: string;
    error?: string | undefined;
    hasEmail?: boolean;
    created?: Date;
    lastModified?: Date;
}

export class PaginatedListOfDiscardedDocumentDto implements IPaginatedListOfDiscardedDocumentDto {
    items?: DiscardedDocumentDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfDiscardedDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiscardedDocumentDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfDiscardedDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfDiscardedDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfDiscardedDocumentDto {
    items?: DiscardedDocumentDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class DiscardedDocumentDto implements IDiscardedDocumentDto {
    id?: number;
    fileName?: string;
    sourceSender?: string | undefined;
    sourceSubject?: string | undefined;
    sourceReceivedAt?: Date | undefined;
    classificationScore?: number | undefined;
    classificationReason?: string | undefined;
    kind?: string;
    motive?: string | undefined;
    created?: Date;

    constructor(data?: IDiscardedDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.sourceSender = _data["sourceSender"];
            this.sourceSubject = _data["sourceSubject"];
            this.sourceReceivedAt = _data["sourceReceivedAt"] ? new Date(_data["sourceReceivedAt"].toString()) : undefined as any;
            this.classificationScore = _data["classificationScore"];
            this.classificationReason = _data["classificationReason"];
            this.kind = _data["kind"];
            this.motive = _data["motive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DiscardedDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscardedDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["sourceSender"] = this.sourceSender;
        data["sourceSubject"] = this.sourceSubject;
        data["sourceReceivedAt"] = this.sourceReceivedAt ? this.sourceReceivedAt.toISOString() : undefined as any;
        data["classificationScore"] = this.classificationScore;
        data["classificationReason"] = this.classificationReason;
        data["kind"] = this.kind;
        data["motive"] = this.motive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        return data;
    }
}

export interface IDiscardedDocumentDto {
    id?: number;
    fileName?: string;
    sourceSender?: string | undefined;
    sourceSubject?: string | undefined;
    sourceReceivedAt?: Date | undefined;
    classificationScore?: number | undefined;
    classificationReason?: string | undefined;
    kind?: string;
    motive?: string | undefined;
    created?: Date;
}

export class ReclassifyDocumentResult implements IReclassifyDocumentResult {
    documentId?: number;
    queued?: boolean;

    constructor(data?: IReclassifyDocumentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.queued = _data["queued"];
        }
    }

    static fromJS(data: any): ReclassifyDocumentResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReclassifyDocumentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["queued"] = this.queued;
        return data;
    }
}

export interface IReclassifyDocumentResult {
    documentId?: number;
    queued?: boolean;
}

export class AllocationFeedbackDto implements IAllocationFeedbackDto {
    id?: number;
    workFinancialEntryId?: number;
    allocationId?: number | undefined;
    documentId?: number | undefined;
    feedbackTypeCode?: string;
    errorDescription?: string | undefined;
    suggestedWorkName?: string | undefined;
    proposedWorkId?: number | undefined;
    proposedWorkName?: string | undefined;
    correctedWorkId?: number | undefined;
    correctedWorkName?: string | undefined;
    amount?: number;
    supplierName?: string | undefined;
    supplierTaxNumber?: string | undefined;
    feedbackAt?: Date;

    constructor(data?: IAllocationFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workFinancialEntryId = _data["workFinancialEntryId"];
            this.allocationId = _data["allocationId"];
            this.documentId = _data["documentId"];
            this.feedbackTypeCode = _data["feedbackTypeCode"];
            this.errorDescription = _data["errorDescription"];
            this.suggestedWorkName = _data["suggestedWorkName"];
            this.proposedWorkId = _data["proposedWorkId"];
            this.proposedWorkName = _data["proposedWorkName"];
            this.correctedWorkId = _data["correctedWorkId"];
            this.correctedWorkName = _data["correctedWorkName"];
            this.amount = _data["amount"];
            this.supplierName = _data["supplierName"];
            this.supplierTaxNumber = _data["supplierTaxNumber"];
            this.feedbackAt = _data["feedbackAt"] ? new Date(_data["feedbackAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AllocationFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllocationFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workFinancialEntryId"] = this.workFinancialEntryId;
        data["allocationId"] = this.allocationId;
        data["documentId"] = this.documentId;
        data["feedbackTypeCode"] = this.feedbackTypeCode;
        data["errorDescription"] = this.errorDescription;
        data["suggestedWorkName"] = this.suggestedWorkName;
        data["proposedWorkId"] = this.proposedWorkId;
        data["proposedWorkName"] = this.proposedWorkName;
        data["correctedWorkId"] = this.correctedWorkId;
        data["correctedWorkName"] = this.correctedWorkName;
        data["amount"] = this.amount;
        data["supplierName"] = this.supplierName;
        data["supplierTaxNumber"] = this.supplierTaxNumber;
        data["feedbackAt"] = this.feedbackAt ? this.feedbackAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAllocationFeedbackDto {
    id?: number;
    workFinancialEntryId?: number;
    allocationId?: number | undefined;
    documentId?: number | undefined;
    feedbackTypeCode?: string;
    errorDescription?: string | undefined;
    suggestedWorkName?: string | undefined;
    proposedWorkId?: number | undefined;
    proposedWorkName?: string | undefined;
    correctedWorkId?: number | undefined;
    correctedWorkName?: string | undefined;
    amount?: number;
    supplierName?: string | undefined;
    supplierTaxNumber?: string | undefined;
    feedbackAt?: Date;
}

export class SubmitAllocationFeedbackCommand implements ISubmitAllocationFeedbackCommand {
    allocationId?: number;
    feedbackTypeCode?: string;
    errorDescription?: string | undefined;
    correctedWorkId?: number | undefined;

    constructor(data?: ISubmitAllocationFeedbackCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allocationId = _data["allocationId"];
            this.feedbackTypeCode = _data["feedbackTypeCode"];
            this.errorDescription = _data["errorDescription"];
            this.correctedWorkId = _data["correctedWorkId"];
        }
    }

    static fromJS(data: any): SubmitAllocationFeedbackCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitAllocationFeedbackCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allocationId"] = this.allocationId;
        data["feedbackTypeCode"] = this.feedbackTypeCode;
        data["errorDescription"] = this.errorDescription;
        data["correctedWorkId"] = this.correctedWorkId;
        return data;
    }
}

export interface ISubmitAllocationFeedbackCommand {
    allocationId?: number;
    feedbackTypeCode?: string;
    errorDescription?: string | undefined;
    correctedWorkId?: number | undefined;
}

export class PaginatedListOfAllocationFeedbackDto implements IPaginatedListOfAllocationFeedbackDto {
    items?: AllocationFeedbackDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfAllocationFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AllocationFeedbackDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAllocationFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAllocationFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfAllocationFeedbackDto {
    items?: AllocationFeedbackDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class ReprocessEmailInvoicesResult implements IReprocessEmailInvoicesResult {
    queued?: number;
    skippedValidated?: number;

    constructor(data?: IReprocessEmailInvoicesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queued = _data["queued"];
            this.skippedValidated = _data["skippedValidated"];
        }
    }

    static fromJS(data: any): ReprocessEmailInvoicesResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReprocessEmailInvoicesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queued"] = this.queued;
        data["skippedValidated"] = this.skippedValidated;
        return data;
    }
}

export interface IReprocessEmailInvoicesResult {
    queued?: number;
    skippedValidated?: number;
}

export class ResetEmailImportsResult implements IResetEmailImportsResult {
    documentsDeleted?: number;
    messagesDeleted?: number;
    skippedValidated?: number;

    constructor(data?: IResetEmailImportsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentsDeleted = _data["documentsDeleted"];
            this.messagesDeleted = _data["messagesDeleted"];
            this.skippedValidated = _data["skippedValidated"];
        }
    }

    static fromJS(data: any): ResetEmailImportsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ResetEmailImportsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentsDeleted"] = this.documentsDeleted;
        data["messagesDeleted"] = this.messagesDeleted;
        data["skippedValidated"] = this.skippedValidated;
        return data;
    }
}

export interface IResetEmailImportsResult {
    documentsDeleted?: number;
    messagesDeleted?: number;
    skippedValidated?: number;
}

export class CreateInvoiceCommand implements ICreateInvoiceCommand {
    companyId?: number | undefined;
    workId?: number | undefined;
    expenseCategoryId?: number | undefined;
    subType?: string | undefined;
    supplierName?: string | undefined;
    supplierTaxNumber?: string | undefined;
    matchedSupplierId?: number | undefined;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    description?: string | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    currencyCode?: string | undefined;
    allocations?: InvoiceAllocationInput[] | undefined;

    constructor(data?: ICreateInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyId = _data["companyId"];
            this.workId = _data["workId"];
            this.expenseCategoryId = _data["expenseCategoryId"];
            this.subType = _data["subType"];
            this.supplierName = _data["supplierName"];
            this.supplierTaxNumber = _data["supplierTaxNumber"];
            this.matchedSupplierId = _data["matchedSupplierId"];
            this.documentNumber = _data["documentNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.baseAmount = _data["baseAmount"];
            this.vatAmount = _data["vatAmount"];
            this.totalAmount = _data["totalAmount"];
            this.currencyCode = _data["currencyCode"];
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(InvoiceAllocationInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["workId"] = this.workId;
        data["expenseCategoryId"] = this.expenseCategoryId;
        data["subType"] = this.subType;
        data["supplierName"] = this.supplierName;
        data["supplierTaxNumber"] = this.supplierTaxNumber;
        data["matchedSupplierId"] = this.matchedSupplierId;
        data["documentNumber"] = this.documentNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["description"] = this.description;
        data["baseAmount"] = this.baseAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["currencyCode"] = this.currencyCode;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateInvoiceCommand {
    companyId?: number | undefined;
    workId?: number | undefined;
    expenseCategoryId?: number | undefined;
    subType?: string | undefined;
    supplierName?: string | undefined;
    supplierTaxNumber?: string | undefined;
    matchedSupplierId?: number | undefined;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    description?: string | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    currencyCode?: string | undefined;
    allocations?: InvoiceAllocationInput[] | undefined;
}

export class InvoiceAllocationInput implements IInvoiceAllocationInput {
    id?: number | undefined;
    workId?: number | undefined;
    suggestedWorkName?: string | undefined;
    amount?: number;
    expenseCategoryId?: number | undefined;
    description?: string | undefined;
    isStructural?: boolean;

    constructor(data?: IInvoiceAllocationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.suggestedWorkName = _data["suggestedWorkName"];
            this.amount = _data["amount"];
            this.expenseCategoryId = _data["expenseCategoryId"];
            this.description = _data["description"];
            this.isStructural = _data["isStructural"];
        }
    }

    static fromJS(data: any): InvoiceAllocationInput {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAllocationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["suggestedWorkName"] = this.suggestedWorkName;
        data["amount"] = this.amount;
        data["expenseCategoryId"] = this.expenseCategoryId;
        data["description"] = this.description;
        data["isStructural"] = this.isStructural;
        return data;
    }
}

export interface IInvoiceAllocationInput {
    id?: number | undefined;
    workId?: number | undefined;
    suggestedWorkName?: string | undefined;
    amount?: number;
    expenseCategoryId?: number | undefined;
    description?: string | undefined;
    isStructural?: boolean;
}

export class InvoiceExtractionDto implements IInvoiceExtractionDto {
    documentId?: number;
    fileName?: string;
    processingStatus?: DocumentProcessingStatus;
    processingError?: string | undefined;
    classification?: WorkFinancialDocumentClassification;
    classificationReason?: string | undefined;
    duplicateOfInvoiceIds?: number[];
    invoiceId?: number | undefined;
    invoice?: InvoiceDto | undefined;

    constructor(data?: IInvoiceExtractionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.fileName = _data["fileName"];
            this.processingStatus = _data["processingStatus"];
            this.processingError = _data["processingError"];
            this.classification = _data["classification"];
            this.classificationReason = _data["classificationReason"];
            if (Array.isArray(_data["duplicateOfInvoiceIds"])) {
                this.duplicateOfInvoiceIds = [] as any;
                for (let item of _data["duplicateOfInvoiceIds"])
                    this.duplicateOfInvoiceIds!.push(item);
            }
            this.invoiceId = _data["invoiceId"];
            this.invoice = _data["invoice"] ? InvoiceDto.fromJS(_data["invoice"]) : undefined as any;
        }
    }

    static fromJS(data: any): InvoiceExtractionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceExtractionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["fileName"] = this.fileName;
        data["processingStatus"] = this.processingStatus;
        data["processingError"] = this.processingError;
        data["classification"] = this.classification;
        data["classificationReason"] = this.classificationReason;
        if (Array.isArray(this.duplicateOfInvoiceIds)) {
            data["duplicateOfInvoiceIds"] = [];
            for (let item of this.duplicateOfInvoiceIds)
                data["duplicateOfInvoiceIds"].push(item);
        }
        data["invoiceId"] = this.invoiceId;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : undefined as any;
        return data;
    }
}

export interface IInvoiceExtractionDto {
    documentId?: number;
    fileName?: string;
    processingStatus?: DocumentProcessingStatus;
    processingError?: string | undefined;
    classification?: WorkFinancialDocumentClassification;
    classificationReason?: string | undefined;
    duplicateOfInvoiceIds?: number[];
    invoiceId?: number | undefined;
    invoice?: InvoiceDto | undefined;
}

export enum WorkFinancialDocumentClassification {
    Unclassified = "Unclassified",
    Invoice = "Invoice",
    NotInvoice = "NotInvoice",
    Duplicate = "Duplicate",
    PaymentProof = "PaymentProof",
}

export class UpdateInvoiceCommand implements IUpdateInvoiceCommand {
    id?: number;
    companyId?: number | undefined;
    workId?: number | undefined;
    expenseCategoryId?: number | undefined;
    subType?: string | undefined;
    supplierName?: string | undefined;
    supplierTaxNumber?: string | undefined;
    matchedSupplierId?: number | undefined;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    description?: string | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    paidAmount?: number | undefined;
    currencyCode?: string | undefined;
    allocations?: InvoiceAllocationInput[] | undefined;

    constructor(data?: IUpdateInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
            this.workId = _data["workId"];
            this.expenseCategoryId = _data["expenseCategoryId"];
            this.subType = _data["subType"];
            this.supplierName = _data["supplierName"];
            this.supplierTaxNumber = _data["supplierTaxNumber"];
            this.matchedSupplierId = _data["matchedSupplierId"];
            this.documentNumber = _data["documentNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.baseAmount = _data["baseAmount"];
            this.vatAmount = _data["vatAmount"];
            this.totalAmount = _data["totalAmount"];
            this.paidAmount = _data["paidAmount"];
            this.currencyCode = _data["currencyCode"];
            if (Array.isArray(_data["allocations"])) {
                this.allocations = [] as any;
                for (let item of _data["allocations"])
                    this.allocations!.push(InvoiceAllocationInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        data["workId"] = this.workId;
        data["expenseCategoryId"] = this.expenseCategoryId;
        data["subType"] = this.subType;
        data["supplierName"] = this.supplierName;
        data["supplierTaxNumber"] = this.supplierTaxNumber;
        data["matchedSupplierId"] = this.matchedSupplierId;
        data["documentNumber"] = this.documentNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["description"] = this.description;
        data["baseAmount"] = this.baseAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["paidAmount"] = this.paidAmount;
        data["currencyCode"] = this.currencyCode;
        if (Array.isArray(this.allocations)) {
            data["allocations"] = [];
            for (let item of this.allocations)
                data["allocations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateInvoiceCommand {
    id?: number;
    companyId?: number | undefined;
    workId?: number | undefined;
    expenseCategoryId?: number | undefined;
    subType?: string | undefined;
    supplierName?: string | undefined;
    supplierTaxNumber?: string | undefined;
    matchedSupplierId?: number | undefined;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    description?: string | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    paidAmount?: number | undefined;
    currencyCode?: string | undefined;
    allocations?: InvoiceAllocationInput[] | undefined;
}

export class DeleteInvoicesResult implements IDeleteInvoicesResult {
    deleted?: number;
    failed?: number;
    error?: string | undefined;

    constructor(data?: IDeleteInvoicesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deleted = _data["deleted"];
            this.failed = _data["failed"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): DeleteInvoicesResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInvoicesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deleted"] = this.deleted;
        data["failed"] = this.failed;
        data["error"] = this.error;
        return data;
    }
}

export interface IDeleteInvoicesResult {
    deleted?: number;
    failed?: number;
    error?: string | undefined;
}

export class DeleteInvoicesCommand implements IDeleteInvoicesCommand {
    ids?: number[];

    constructor(data?: IDeleteInvoicesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteInvoicesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteInvoicesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IDeleteInvoicesCommand {
    ids?: number[];
}

export class ValidateInvoicesResult implements IValidateInvoicesResult {
    validated?: number;

    constructor(data?: IValidateInvoicesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validated = _data["validated"];
        }
    }

    static fromJS(data: any): ValidateInvoicesResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateInvoicesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validated"] = this.validated;
        return data;
    }
}

export interface IValidateInvoicesResult {
    validated?: number;
}

export class ValidateInvoicesCommand implements IValidateInvoicesCommand {
    ids?: number[];

    constructor(data?: IValidateInvoicesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): ValidateInvoicesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateInvoicesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }
}

export interface IValidateInvoicesCommand {
    ids?: number[];
}

export class AttentionSummaryVm implements IAttentionSummaryVm {
    pendingValidation?: number;
    importsToReview?: number;
    discardedToReview?: number;
    skippedToReview?: number;

    constructor(data?: IAttentionSummaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingValidation = _data["pendingValidation"];
            this.importsToReview = _data["importsToReview"];
            this.discardedToReview = _data["discardedToReview"];
            this.skippedToReview = _data["skippedToReview"];
        }
    }

    static fromJS(data: any): AttentionSummaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new AttentionSummaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingValidation"] = this.pendingValidation;
        data["importsToReview"] = this.importsToReview;
        data["discardedToReview"] = this.discardedToReview;
        data["skippedToReview"] = this.skippedToReview;
        return data;
    }
}

export interface IAttentionSummaryVm {
    pendingValidation?: number;
    importsToReview?: number;
    discardedToReview?: number;
    skippedToReview?: number;
}

export class SetInvoiceApprovalStatusCommand implements ISetInvoiceApprovalStatusCommand {
    id?: number;
    statusCode?: string;

    constructor(data?: ISetInvoiceApprovalStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): SetInvoiceApprovalStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetInvoiceApprovalStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface ISetInvoiceApprovalStatusCommand {
    id?: number;
    statusCode?: string;
}

export class SetInvoiceCreditNoteCommand implements ISetInvoiceCreditNoteCommand {
    id?: number;
    isCreditNote?: boolean;

    constructor(data?: ISetInvoiceCreditNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCreditNote = _data["isCreditNote"];
        }
    }

    static fromJS(data: any): SetInvoiceCreditNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetInvoiceCreditNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCreditNote"] = this.isCreditNote;
        return data;
    }
}

export interface ISetInvoiceCreditNoteCommand {
    id?: number;
    isCreditNote?: boolean;
}

export class SetInvoiceAnnulmentCommand implements ISetInvoiceAnnulmentCommand {
    id?: number;
    isAnnulled?: boolean;
    creditNoteReference?: string | undefined;

    constructor(data?: ISetInvoiceAnnulmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isAnnulled = _data["isAnnulled"];
            this.creditNoteReference = _data["creditNoteReference"];
        }
    }

    static fromJS(data: any): SetInvoiceAnnulmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetInvoiceAnnulmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isAnnulled"] = this.isAnnulled;
        data["creditNoteReference"] = this.creditNoteReference;
        return data;
    }
}

export interface ISetInvoiceAnnulmentCommand {
    id?: number;
    isAnnulled?: boolean;
    creditNoteReference?: string | undefined;
}

export class SetInvoiceSummaryExclusionCommand implements ISetInvoiceSummaryExclusionCommand {
    id?: number;
    excluded?: boolean;

    constructor(data?: ISetInvoiceSummaryExclusionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.excluded = _data["excluded"];
        }
    }

    static fromJS(data: any): SetInvoiceSummaryExclusionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetInvoiceSummaryExclusionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["excluded"] = this.excluded;
        return data;
    }
}

export interface ISetInvoiceSummaryExclusionCommand {
    id?: number;
    excluded?: boolean;
}

export class SetInvoicesSummaryExclusionResult implements ISetInvoicesSummaryExclusionResult {
    updated?: number;

    constructor(data?: ISetInvoicesSummaryExclusionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updated = _data["updated"];
        }
    }

    static fromJS(data: any): SetInvoicesSummaryExclusionResult {
        data = typeof data === 'object' ? data : {};
        let result = new SetInvoicesSummaryExclusionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updated"] = this.updated;
        return data;
    }
}

export interface ISetInvoicesSummaryExclusionResult {
    updated?: number;
}

export class SetInvoicesSummaryExclusionCommand implements ISetInvoicesSummaryExclusionCommand {
    ids?: number[];
    excluded?: boolean;

    constructor(data?: ISetInvoicesSummaryExclusionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.excluded = _data["excluded"];
        }
    }

    static fromJS(data: any): SetInvoicesSummaryExclusionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetInvoicesSummaryExclusionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["excluded"] = this.excluded;
        return data;
    }
}

export interface ISetInvoicesSummaryExclusionCommand {
    ids?: number[];
    excluded?: boolean;
}

export class ScheduleInvoicePaymentResult implements IScheduleInvoicePaymentResult {
    updated?: number;
    skipped?: number;
    tasks?: PaymentTaskSummaryDto[];

    constructor(data?: IScheduleInvoicePaymentResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updated = _data["updated"];
            this.skipped = _data["skipped"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(PaymentTaskSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleInvoicePaymentResult {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleInvoicePaymentResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updated"] = this.updated;
        data["skipped"] = this.skipped;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScheduleInvoicePaymentResult {
    updated?: number;
    skipped?: number;
    tasks?: PaymentTaskSummaryDto[];
}

export class PaymentTaskSummaryDto implements IPaymentTaskSummaryDto {
    id?: number;
    title?: string;
    dueDate?: Date | undefined;

    constructor(data?: IPaymentTaskSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PaymentTaskSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTaskSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IPaymentTaskSummaryDto {
    id?: number;
    title?: string;
    dueDate?: Date | undefined;
}

export class ScheduleInvoicePaymentCommand implements IScheduleInvoicePaymentCommand {
    ids?: number[];
    paymentDate?: Date | undefined;

    constructor(data?: IScheduleInvoicePaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ScheduleInvoicePaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleInvoicePaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["paymentDate"] = this.paymentDate ? formatDate(this.paymentDate) : undefined as any;
        return data;
    }
}

export interface IScheduleInvoicePaymentCommand {
    ids?: number[];
    paymentDate?: Date | undefined;
}

export class PaymentProofProposalDto implements IPaymentProofProposalDto {
    blobName?: string;
    fileName?: string;
    proofAmount?: number | undefined;
    paidOn?: Date | undefined;
    lines?: PaymentProofLine[];
    matches?: PaymentProofMatchDto[];
    payable?: PaymentProofInvoiceDto[];
    summary?: string;

    constructor(data?: IPaymentProofProposalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blobName = _data["blobName"];
            this.fileName = _data["fileName"];
            this.proofAmount = _data["proofAmount"];
            this.paidOn = _data["paidOn"] ? new Date(_data["paidOn"].toString()) : undefined as any;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(PaymentProofLine.fromJS(item));
            }
            if (Array.isArray(_data["matches"])) {
                this.matches = [] as any;
                for (let item of _data["matches"])
                    this.matches!.push(PaymentProofMatchDto.fromJS(item));
            }
            if (Array.isArray(_data["payable"])) {
                this.payable = [] as any;
                for (let item of _data["payable"])
                    this.payable!.push(PaymentProofInvoiceDto.fromJS(item));
            }
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): PaymentProofProposalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProofProposalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blobName"] = this.blobName;
        data["fileName"] = this.fileName;
        data["proofAmount"] = this.proofAmount;
        data["paidOn"] = this.paidOn ? this.paidOn.toISOString() : undefined as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.matches)) {
            data["matches"] = [];
            for (let item of this.matches)
                data["matches"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.payable)) {
            data["payable"] = [];
            for (let item of this.payable)
                data["payable"].push(item ? item.toJSON() : undefined as any);
        }
        data["summary"] = this.summary;
        return data;
    }
}

export interface IPaymentProofProposalDto {
    blobName?: string;
    fileName?: string;
    proofAmount?: number | undefined;
    paidOn?: Date | undefined;
    lines?: PaymentProofLine[];
    matches?: PaymentProofMatchDto[];
    payable?: PaymentProofInvoiceDto[];
    summary?: string;
}

export class PaymentProofLine implements IPaymentProofLine {
    beneficiary?: string | undefined;
    amount?: number | undefined;
    reference?: string | undefined;

    constructor(data?: IPaymentProofLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beneficiary = _data["beneficiary"];
            this.amount = _data["amount"];
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): PaymentProofLine {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProofLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beneficiary"] = this.beneficiary;
        data["amount"] = this.amount;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IPaymentProofLine {
    beneficiary?: string | undefined;
    amount?: number | undefined;
    reference?: string | undefined;
}

export class PaymentProofMatchDto implements IPaymentProofMatchDto {
    invoices?: PaymentProofInvoiceDto[];
    total?: number;
    reason?: string;

    constructor(data?: IPaymentProofMatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(PaymentProofInvoiceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): PaymentProofMatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProofMatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["total"] = this.total;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IPaymentProofMatchDto {
    invoices?: PaymentProofInvoiceDto[];
    total?: number;
    reason?: string;
}

export class PaymentProofInvoiceDto implements IPaymentProofInvoiceDto {
    invoiceId?: number;
    supplierName?: string | undefined;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    outstanding?: number;

    constructor(data?: IPaymentProofInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.supplierName = _data["supplierName"];
            this.documentNumber = _data["documentNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.outstanding = _data["outstanding"];
        }
    }

    static fromJS(data: any): PaymentProofInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentProofInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["supplierName"] = this.supplierName;
        data["documentNumber"] = this.documentNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["outstanding"] = this.outstanding;
        return data;
    }
}

export interface IPaymentProofInvoiceDto {
    invoiceId?: number;
    supplierName?: string | undefined;
    documentNumber?: string | undefined;
    documentDate?: Date | undefined;
    outstanding?: number;
}

export class ApplyPaymentProofResult implements IApplyPaymentProofResult {
    settledCount?: number;
    partiallySettledCount?: number;
    unapplied?: number;

    constructor(data?: IApplyPaymentProofResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settledCount = _data["settledCount"];
            this.partiallySettledCount = _data["partiallySettledCount"];
            this.unapplied = _data["unapplied"];
        }
    }

    static fromJS(data: any): ApplyPaymentProofResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyPaymentProofResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settledCount"] = this.settledCount;
        data["partiallySettledCount"] = this.partiallySettledCount;
        data["unapplied"] = this.unapplied;
        return data;
    }
}

export interface IApplyPaymentProofResult {
    settledCount?: number;
    partiallySettledCount?: number;
    unapplied?: number;
}

export class ApplyPaymentProofCommand implements IApplyPaymentProofCommand {
    blobName?: string;
    amount?: number;
    fileName?: string;
    invoiceIds?: number[];

    constructor(data?: IApplyPaymentProofCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blobName = _data["blobName"];
            this.amount = _data["amount"];
            this.fileName = _data["fileName"];
            if (Array.isArray(_data["invoiceIds"])) {
                this.invoiceIds = [] as any;
                for (let item of _data["invoiceIds"])
                    this.invoiceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplyPaymentProofCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyPaymentProofCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blobName"] = this.blobName;
        data["amount"] = this.amount;
        data["fileName"] = this.fileName;
        if (Array.isArray(this.invoiceIds)) {
            data["invoiceIds"] = [];
            for (let item of this.invoiceIds)
                data["invoiceIds"].push(item);
        }
        return data;
    }
}

export interface IApplyPaymentProofCommand {
    blobName?: string;
    amount?: number;
    fileName?: string;
    invoiceIds?: number[];
}

export class BudgetQuantityImportJobStatusDto implements IBudgetQuantityImportJobStatusDto {
    jobId?: string;
    budgetId?: number;
    status?: string;
    stage?: string;
    message?: string;
    percent?: number | undefined;
    elapsedMs?: number | undefined;
    startedAt?: Date | undefined;
    updatedAt?: Date | undefined;
    completedAt?: Date | undefined;
    result?: BudgetQuantityImportJobResultDto | undefined;
    error?: string | undefined;

    constructor(data?: IBudgetQuantityImportJobStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.budgetId = _data["budgetId"];
            this.status = _data["status"];
            this.stage = _data["stage"];
            this.message = _data["message"];
            this.percent = _data["percent"];
            this.elapsedMs = _data["elapsedMs"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.result = _data["result"] ? BudgetQuantityImportJobResultDto.fromJS(_data["result"]) : undefined as any;
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): BudgetQuantityImportJobStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetQuantityImportJobStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["budgetId"] = this.budgetId;
        data["status"] = this.status;
        data["stage"] = this.stage;
        data["message"] = this.message;
        data["percent"] = this.percent;
        data["elapsedMs"] = this.elapsedMs;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        data["error"] = this.error;
        return data;
    }
}

export interface IBudgetQuantityImportJobStatusDto {
    jobId?: string;
    budgetId?: number;
    status?: string;
    stage?: string;
    message?: string;
    percent?: number | undefined;
    elapsedMs?: number | undefined;
    startedAt?: Date | undefined;
    updatedAt?: Date | undefined;
    completedAt?: Date | undefined;
    result?: BudgetQuantityImportJobResultDto | undefined;
    error?: string | undefined;
}

export class BudgetQuantityImportJobResultDto implements IBudgetQuantityImportJobResultDto {
    budgetId?: number;
    documentId?: number | undefined;
    areas?: number;
    chapters?: number;
    articles?: number;
    preview?: BudgetQuantityImportPreviewDto | undefined;

    constructor(data?: IBudgetQuantityImportJobResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetId = _data["budgetId"];
            this.documentId = _data["documentId"];
            this.areas = _data["areas"];
            this.chapters = _data["chapters"];
            this.articles = _data["articles"];
            this.preview = _data["preview"] ? BudgetQuantityImportPreviewDto.fromJS(_data["preview"]) : undefined as any;
        }
    }

    static fromJS(data: any): BudgetQuantityImportJobResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetQuantityImportJobResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetId"] = this.budgetId;
        data["documentId"] = this.documentId;
        data["areas"] = this.areas;
        data["chapters"] = this.chapters;
        data["articles"] = this.articles;
        data["preview"] = this.preview ? this.preview.toJSON() : undefined as any;
        return data;
    }
}

export interface IBudgetQuantityImportJobResultDto {
    budgetId?: number;
    documentId?: number | undefined;
    areas?: number;
    chapters?: number;
    articles?: number;
    preview?: BudgetQuantityImportPreviewDto | undefined;
}

export class BudgetQuantityImportPreviewDto implements IBudgetQuantityImportPreviewDto {
    areas?: BudgetQuantityImportAreaDto[];
    totalCapitulos?: number;
    totalArtigos?: number;

    constructor(data?: IBudgetQuantityImportPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(BudgetQuantityImportAreaDto.fromJS(item));
            }
            this.totalCapitulos = _data["totalCapitulos"];
            this.totalArtigos = _data["totalArtigos"];
        }
    }

    static fromJS(data: any): BudgetQuantityImportPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetQuantityImportPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCapitulos"] = this.totalCapitulos;
        data["totalArtigos"] = this.totalArtigos;
        return data;
    }
}

export interface IBudgetQuantityImportPreviewDto {
    areas?: BudgetQuantityImportAreaDto[];
    totalCapitulos?: number;
    totalArtigos?: number;
}

export class BudgetQuantityImportAreaDto implements IBudgetQuantityImportAreaDto {
    name?: string;
    chapters?: BudgetQuantityImportChapterDto[];

    constructor(data?: IBudgetQuantityImportAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["chapters"])) {
                this.chapters = [] as any;
                for (let item of _data["chapters"])
                    this.chapters!.push(BudgetQuantityImportChapterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetQuantityImportAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetQuantityImportAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.chapters)) {
            data["chapters"] = [];
            for (let item of this.chapters)
                data["chapters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetQuantityImportAreaDto {
    name?: string;
    chapters?: BudgetQuantityImportChapterDto[];
}

export class BudgetQuantityImportChapterDto implements IBudgetQuantityImportChapterDto {
    name?: string;
    note?: string | undefined;
    articles?: BudgetQuantityImportArticleDto[];

    constructor(data?: IBudgetQuantityImportChapterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.note = _data["note"];
            if (Array.isArray(_data["articles"])) {
                this.articles = [] as any;
                for (let item of _data["articles"])
                    this.articles!.push(BudgetQuantityImportArticleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetQuantityImportChapterDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetQuantityImportChapterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["note"] = this.note;
        if (Array.isArray(this.articles)) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetQuantityImportChapterDto {
    name?: string;
    note?: string | undefined;
    articles?: BudgetQuantityImportArticleDto[];
}

export class BudgetQuantityImportArticleDto implements IBudgetQuantityImportArticleDto {
    number?: string;
    description?: string;
    unit?: string;
    quantity?: number;
    measurementSource?: string | undefined;
    measurementNote?: string | undefined;
    suggestedCostUnitPrice?: number | undefined;
    suggestedCostMargin?: number | undefined;
    suggestedCostBudgetId?: number | undefined;
    suggestedCostBudgetReference?: string | undefined;

    constructor(data?: IBudgetQuantityImportArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.measurementSource = _data["measurementSource"];
            this.measurementNote = _data["measurementNote"];
            this.suggestedCostUnitPrice = _data["suggestedCostUnitPrice"];
            this.suggestedCostMargin = _data["suggestedCostMargin"];
            this.suggestedCostBudgetId = _data["suggestedCostBudgetId"];
            this.suggestedCostBudgetReference = _data["suggestedCostBudgetReference"];
        }
    }

    static fromJS(data: any): BudgetQuantityImportArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetQuantityImportArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["measurementSource"] = this.measurementSource;
        data["measurementNote"] = this.measurementNote;
        data["suggestedCostUnitPrice"] = this.suggestedCostUnitPrice;
        data["suggestedCostMargin"] = this.suggestedCostMargin;
        data["suggestedCostBudgetId"] = this.suggestedCostBudgetId;
        data["suggestedCostBudgetReference"] = this.suggestedCostBudgetReference;
        return data;
    }
}

export interface IBudgetQuantityImportArticleDto {
    number?: string;
    description?: string;
    unit?: string;
    quantity?: number;
    measurementSource?: string | undefined;
    measurementNote?: string | undefined;
    suggestedCostUnitPrice?: number | undefined;
    suggestedCostMargin?: number | undefined;
    suggestedCostBudgetId?: number | undefined;
    suggestedCostBudgetReference?: string | undefined;
}

export class GlossaryTermDto implements IGlossaryTermDto {
    id?: number;
    abbreviation?: string;
    fullName?: string | undefined;
    category?: string | undefined;
    synonyms?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IGlossaryTermDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.abbreviation = _data["abbreviation"];
            this.fullName = _data["fullName"];
            this.category = _data["category"];
            this.synonyms = _data["synonyms"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GlossaryTermDto {
        data = typeof data === 'object' ? data : {};
        let result = new GlossaryTermDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["abbreviation"] = this.abbreviation;
        data["fullName"] = this.fullName;
        data["category"] = this.category;
        data["synonyms"] = this.synonyms;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IGlossaryTermDto {
    id?: number;
    abbreviation?: string;
    fullName?: string | undefined;
    category?: string | undefined;
    synonyms?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class CreateGlossaryTermCommand implements ICreateGlossaryTermCommand {
    abbreviation?: string;
    fullName?: string | undefined;
    category?: string | undefined;
    synonyms?: string | undefined;

    constructor(data?: ICreateGlossaryTermCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.abbreviation = _data["abbreviation"];
            this.fullName = _data["fullName"];
            this.category = _data["category"];
            this.synonyms = _data["synonyms"];
        }
    }

    static fromJS(data: any): CreateGlossaryTermCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGlossaryTermCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["abbreviation"] = this.abbreviation;
        data["fullName"] = this.fullName;
        data["category"] = this.category;
        data["synonyms"] = this.synonyms;
        return data;
    }
}

export interface ICreateGlossaryTermCommand {
    abbreviation?: string;
    fullName?: string | undefined;
    category?: string | undefined;
    synonyms?: string | undefined;
}

export class UpdateGlossaryTermCommand implements IUpdateGlossaryTermCommand {
    id?: number;
    abbreviation?: string;
    fullName?: string | undefined;
    category?: string | undefined;
    synonyms?: string | undefined;

    constructor(data?: IUpdateGlossaryTermCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.abbreviation = _data["abbreviation"];
            this.fullName = _data["fullName"];
            this.category = _data["category"];
            this.synonyms = _data["synonyms"];
        }
    }

    static fromJS(data: any): UpdateGlossaryTermCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGlossaryTermCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["abbreviation"] = this.abbreviation;
        data["fullName"] = this.fullName;
        data["category"] = this.category;
        data["synonyms"] = this.synonyms;
        return data;
    }
}

export interface IUpdateGlossaryTermCommand {
    id?: number;
    abbreviation?: string;
    fullName?: string | undefined;
    category?: string | undefined;
    synonyms?: string | undefined;
}

export class FinancialSummaryVm implements IFinancialSummaryVm {
    year?: number;
    companyId?: number | undefined;
    invoicedNet?: number;
    expenseNet?: number;
    result?: number;
    taxRate?: number;
    tax?: number;
    incidence?: number;
    undatedRevenueCount?: number;
    undatedExpenseCount?: number;

    constructor(data?: IFinancialSummaryVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.companyId = _data["companyId"];
            this.invoicedNet = _data["invoicedNet"];
            this.expenseNet = _data["expenseNet"];
            this.result = _data["result"];
            this.taxRate = _data["taxRate"];
            this.tax = _data["tax"];
            this.incidence = _data["incidence"];
            this.undatedRevenueCount = _data["undatedRevenueCount"];
            this.undatedExpenseCount = _data["undatedExpenseCount"];
        }
    }

    static fromJS(data: any): FinancialSummaryVm {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialSummaryVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["companyId"] = this.companyId;
        data["invoicedNet"] = this.invoicedNet;
        data["expenseNet"] = this.expenseNet;
        data["result"] = this.result;
        data["taxRate"] = this.taxRate;
        data["tax"] = this.tax;
        data["incidence"] = this.incidence;
        data["undatedRevenueCount"] = this.undatedRevenueCount;
        data["undatedExpenseCount"] = this.undatedExpenseCount;
        return data;
    }
}

export interface IFinancialSummaryVm {
    year?: number;
    companyId?: number | undefined;
    invoicedNet?: number;
    expenseNet?: number;
    result?: number;
    taxRate?: number;
    tax?: number;
    incidence?: number;
    undatedRevenueCount?: number;
    undatedExpenseCount?: number;
}

export class FinancialDashboardWorksDto implements IFinancialDashboardWorksDto {
    totals?: FinancialDashboardTotalsDto;
    activeWorksCount?: number;
    riskWorksCount?: number;
    works?: FinancialDashboardWorkRowDto[];

    constructor(data?: IFinancialDashboardWorksDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totals = _data["totals"] ? FinancialDashboardTotalsDto.fromJS(_data["totals"]) : undefined as any;
            this.activeWorksCount = _data["activeWorksCount"];
            this.riskWorksCount = _data["riskWorksCount"];
            if (Array.isArray(_data["works"])) {
                this.works = [] as any;
                for (let item of _data["works"])
                    this.works!.push(FinancialDashboardWorkRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinancialDashboardWorksDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDashboardWorksDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        data["activeWorksCount"] = this.activeWorksCount;
        data["riskWorksCount"] = this.riskWorksCount;
        if (Array.isArray(this.works)) {
            data["works"] = [];
            for (let item of this.works)
                data["works"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFinancialDashboardWorksDto {
    totals?: FinancialDashboardTotalsDto;
    activeWorksCount?: number;
    riskWorksCount?: number;
    works?: FinancialDashboardWorkRowDto[];
}

export class FinancialDashboardWorkRowDto implements IFinancialDashboardWorkRowDto {
    workId?: number;
    workCode?: string;
    workName?: string;
    clientId?: number;
    clientName?: string;
    workStatus?: string | undefined;
    created?: Date;
    financialStatus?: FinancialStatus;
    totals?: FinancialDashboardTotalsDto;
    alerts?: FinancialAlertDto[];

    constructor(data?: IFinancialDashboardWorkRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.workCode = _data["workCode"];
            this.workName = _data["workName"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.workStatus = _data["workStatus"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.financialStatus = _data["financialStatus"];
            this.totals = _data["totals"] ? FinancialDashboardTotalsDto.fromJS(_data["totals"]) : undefined as any;
            if (Array.isArray(_data["alerts"])) {
                this.alerts = [] as any;
                for (let item of _data["alerts"])
                    this.alerts!.push(FinancialAlertDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FinancialDashboardWorkRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDashboardWorkRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["workCode"] = this.workCode;
        data["workName"] = this.workName;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["workStatus"] = this.workStatus;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["financialStatus"] = this.financialStatus;
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        if (Array.isArray(this.alerts)) {
            data["alerts"] = [];
            for (let item of this.alerts)
                data["alerts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFinancialDashboardWorkRowDto {
    workId?: number;
    workCode?: string;
    workName?: string;
    clientId?: number;
    clientName?: string;
    workStatus?: string | undefined;
    created?: Date;
    financialStatus?: FinancialStatus;
    totals?: FinancialDashboardTotalsDto;
    alerts?: FinancialAlertDto[];
}

export enum FinancialStatus2 {
    NoData = 0,
    Healthy = 1,
    Attention = 2,
    Critical = 3,
}

export class BillingDashboardDto implements IBillingDashboardDto {
    currentMonthTotal?: number;
    sameMonthLastYearTotal?: number;
    currentYearToDateTotal?: number;
    priorYearToDateTotal?: number;
    topClients?: BillingClientTotalDto[];

    constructor(data?: IBillingDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentMonthTotal = _data["currentMonthTotal"];
            this.sameMonthLastYearTotal = _data["sameMonthLastYearTotal"];
            this.currentYearToDateTotal = _data["currentYearToDateTotal"];
            this.priorYearToDateTotal = _data["priorYearToDateTotal"];
            if (Array.isArray(_data["topClients"])) {
                this.topClients = [] as any;
                for (let item of _data["topClients"])
                    this.topClients!.push(BillingClientTotalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillingDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentMonthTotal"] = this.currentMonthTotal;
        data["sameMonthLastYearTotal"] = this.sameMonthLastYearTotal;
        data["currentYearToDateTotal"] = this.currentYearToDateTotal;
        data["priorYearToDateTotal"] = this.priorYearToDateTotal;
        if (Array.isArray(this.topClients)) {
            data["topClients"] = [];
            for (let item of this.topClients)
                data["topClients"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBillingDashboardDto {
    currentMonthTotal?: number;
    sameMonthLastYearTotal?: number;
    currentYearToDateTotal?: number;
    priorYearToDateTotal?: number;
    topClients?: BillingClientTotalDto[];
}

export class BillingClientTotalDto implements IBillingClientTotalDto {
    clientName?: string;
    total?: number;

    constructor(data?: IBillingClientTotalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientName = _data["clientName"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): BillingClientTotalDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingClientTotalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientName"] = this.clientName;
        data["total"] = this.total;
        return data;
    }
}

export interface IBillingClientTotalDto {
    clientName?: string;
    total?: number;
}

export class TaxReconciliationDto implements ITaxReconciliationDto {
    granularity?: string;
    periods?: TaxReconciliationPeriodDto[];
    totals?: TaxReconciliationTotalsDto;

    constructor(data?: ITaxReconciliationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.granularity = _data["granularity"];
            if (Array.isArray(_data["periods"])) {
                this.periods = [] as any;
                for (let item of _data["periods"])
                    this.periods!.push(TaxReconciliationPeriodDto.fromJS(item));
            }
            this.totals = _data["totals"] ? TaxReconciliationTotalsDto.fromJS(_data["totals"]) : undefined as any;
        }
    }

    static fromJS(data: any): TaxReconciliationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReconciliationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["granularity"] = this.granularity;
        if (Array.isArray(this.periods)) {
            data["periods"] = [];
            for (let item of this.periods)
                data["periods"].push(item ? item.toJSON() : undefined as any);
        }
        data["totals"] = this.totals ? this.totals.toJSON() : undefined as any;
        return data;
    }
}

export interface ITaxReconciliationDto {
    granularity?: string;
    periods?: TaxReconciliationPeriodDto[];
    totals?: TaxReconciliationTotalsDto;
}

export class TaxReconciliationPeriodDto implements ITaxReconciliationPeriodDto {
    periodKey?: string;
    periodLabel?: string;
    year?: number;
    periodNumber?: number;
    revenueBase?: number;
    vatCollected?: number;
    expenseBase?: number;
    vatPaid?: number;
    vatBalance?: number;
    revenueCount?: number;
    expenseCount?: number;

    constructor(data?: ITaxReconciliationPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodKey = _data["periodKey"];
            this.periodLabel = _data["periodLabel"];
            this.year = _data["year"];
            this.periodNumber = _data["periodNumber"];
            this.revenueBase = _data["revenueBase"];
            this.vatCollected = _data["vatCollected"];
            this.expenseBase = _data["expenseBase"];
            this.vatPaid = _data["vatPaid"];
            this.vatBalance = _data["vatBalance"];
            this.revenueCount = _data["revenueCount"];
            this.expenseCount = _data["expenseCount"];
        }
    }

    static fromJS(data: any): TaxReconciliationPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReconciliationPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodKey"] = this.periodKey;
        data["periodLabel"] = this.periodLabel;
        data["year"] = this.year;
        data["periodNumber"] = this.periodNumber;
        data["revenueBase"] = this.revenueBase;
        data["vatCollected"] = this.vatCollected;
        data["expenseBase"] = this.expenseBase;
        data["vatPaid"] = this.vatPaid;
        data["vatBalance"] = this.vatBalance;
        data["revenueCount"] = this.revenueCount;
        data["expenseCount"] = this.expenseCount;
        return data;
    }
}

export interface ITaxReconciliationPeriodDto {
    periodKey?: string;
    periodLabel?: string;
    year?: number;
    periodNumber?: number;
    revenueBase?: number;
    vatCollected?: number;
    expenseBase?: number;
    vatPaid?: number;
    vatBalance?: number;
    revenueCount?: number;
    expenseCount?: number;
}

export class TaxReconciliationTotalsDto implements ITaxReconciliationTotalsDto {
    revenueBase?: number;
    vatCollected?: number;
    expenseBase?: number;
    vatPaid?: number;
    vatBalance?: number;
    revenueCount?: number;
    expenseCount?: number;

    constructor(data?: ITaxReconciliationTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.revenueBase = _data["revenueBase"];
            this.vatCollected = _data["vatCollected"];
            this.expenseBase = _data["expenseBase"];
            this.vatPaid = _data["vatPaid"];
            this.vatBalance = _data["vatBalance"];
            this.revenueCount = _data["revenueCount"];
            this.expenseCount = _data["expenseCount"];
        }
    }

    static fromJS(data: any): TaxReconciliationTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReconciliationTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["revenueBase"] = this.revenueBase;
        data["vatCollected"] = this.vatCollected;
        data["expenseBase"] = this.expenseBase;
        data["vatPaid"] = this.vatPaid;
        data["vatBalance"] = this.vatBalance;
        data["revenueCount"] = this.revenueCount;
        data["expenseCount"] = this.expenseCount;
        return data;
    }
}

export interface ITaxReconciliationTotalsDto {
    revenueBase?: number;
    vatCollected?: number;
    expenseBase?: number;
    vatPaid?: number;
    vatBalance?: number;
    revenueCount?: number;
    expenseCount?: number;
}

export class CreateFinancialApprovalStatusCommand implements ICreateFinancialApprovalStatusCommand {
    name?: string;

    constructor(data?: ICreateFinancialApprovalStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateFinancialApprovalStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFinancialApprovalStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateFinancialApprovalStatusCommand {
    name?: string;
}

export class UpdateFinancialApprovalStatusCommand implements IUpdateFinancialApprovalStatusCommand {
    id?: number;
    name?: string;
    sortOrder?: number | undefined;

    constructor(data?: IUpdateFinancialApprovalStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UpdateFinancialApprovalStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialApprovalStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUpdateFinancialApprovalStatusCommand {
    id?: number;
    name?: string;
    sortOrder?: number | undefined;
}

export class ExpenseCategoryDto implements IExpenseCategoryDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
    parentId?: number | undefined;
    isStructural?: boolean | undefined;

    constructor(data?: IExpenseCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
            this.parentId = _data["parentId"];
            this.isStructural = _data["isStructural"];
        }
    }

    static fromJS(data: any): ExpenseCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        data["parentId"] = this.parentId;
        data["isStructural"] = this.isStructural;
        return data;
    }
}

export interface IExpenseCategoryDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
    parentId?: number | undefined;
    isStructural?: boolean | undefined;
}

export class CreateExpenseCategoryCommand implements ICreateExpenseCategoryCommand {
    code?: string;
    name?: string;
    parentId?: number | undefined;
    sortOrder?: number | undefined;
    isStructural?: boolean | undefined;

    constructor(data?: ICreateExpenseCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.sortOrder = _data["sortOrder"];
            this.isStructural = _data["isStructural"];
        }
    }

    static fromJS(data: any): CreateExpenseCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExpenseCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["sortOrder"] = this.sortOrder;
        data["isStructural"] = this.isStructural;
        return data;
    }
}

export interface ICreateExpenseCategoryCommand {
    code?: string;
    name?: string;
    parentId?: number | undefined;
    sortOrder?: number | undefined;
    isStructural?: boolean | undefined;
}

export class UpdateExpenseCategoryCommand implements IUpdateExpenseCategoryCommand {
    id?: number;
    code?: string;
    name?: string;
    parentId?: number | undefined;
    sortOrder?: number | undefined;
    isStructural?: boolean | undefined;

    constructor(data?: IUpdateExpenseCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.sortOrder = _data["sortOrder"];
            this.isStructural = _data["isStructural"];
        }
    }

    static fromJS(data: any): UpdateExpenseCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExpenseCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["sortOrder"] = this.sortOrder;
        data["isStructural"] = this.isStructural;
        return data;
    }
}

export interface IUpdateExpenseCategoryCommand {
    id?: number;
    code?: string;
    name?: string;
    parentId?: number | undefined;
    sortOrder?: number | undefined;
    isStructural?: boolean | undefined;
}

export class EntityDocumentDto implements IEntityDocumentDto {
    id?: number;
    section?: string;
    ownerType?: string;
    ownerId?: number;
    workId?: number | undefined;
    clientId?: number | undefined;
    supplierId?: number | undefined;
    subcontractorId?: number | undefined;
    workFinancialEntryId?: number | undefined;
    title?: string;
    category?: string | undefined;
    counterpartyName?: string | undefined;
    reference?: string | undefined;
    documentDate?: Date | undefined;
    notes?: string | undefined;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;
    created?: Date;

    constructor(data?: IEntityDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.section = _data["section"];
            this.ownerType = _data["ownerType"];
            this.ownerId = _data["ownerId"];
            this.workId = _data["workId"];
            this.clientId = _data["clientId"];
            this.supplierId = _data["supplierId"];
            this.subcontractorId = _data["subcontractorId"];
            this.workFinancialEntryId = _data["workFinancialEntryId"];
            this.title = _data["title"];
            this.category = _data["category"];
            this.counterpartyName = _data["counterpartyName"];
            this.reference = _data["reference"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EntityDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["section"] = this.section;
        data["ownerType"] = this.ownerType;
        data["ownerId"] = this.ownerId;
        data["workId"] = this.workId;
        data["clientId"] = this.clientId;
        data["supplierId"] = this.supplierId;
        data["subcontractorId"] = this.subcontractorId;
        data["workFinancialEntryId"] = this.workFinancialEntryId;
        data["title"] = this.title;
        data["category"] = this.category;
        data["counterpartyName"] = this.counterpartyName;
        data["reference"] = this.reference;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["sizeInBytes"] = this.sizeInBytes;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        return data;
    }
}

export interface IEntityDocumentDto {
    id?: number;
    section?: string;
    ownerType?: string;
    ownerId?: number;
    workId?: number | undefined;
    clientId?: number | undefined;
    supplierId?: number | undefined;
    subcontractorId?: number | undefined;
    workFinancialEntryId?: number | undefined;
    title?: string;
    category?: string | undefined;
    counterpartyName?: string | undefined;
    reference?: string | undefined;
    documentDate?: Date | undefined;
    notes?: string | undefined;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;
    created?: Date;
}

export class UpdateEntityDocumentCommand implements IUpdateEntityDocumentCommand {
    id?: number;
    title?: string;
    category?: string | undefined;
    counterpartyName?: string | undefined;
    reference?: string | undefined;
    documentDate?: Date | undefined;
    notes?: string | undefined;

    constructor(data?: IUpdateEntityDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.category = _data["category"];
            this.counterpartyName = _data["counterpartyName"];
            this.reference = _data["reference"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateEntityDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEntityDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["category"] = this.category;
        data["counterpartyName"] = this.counterpartyName;
        data["reference"] = this.reference;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IUpdateEntityDocumentCommand {
    id?: number;
    title?: string;
    category?: string | undefined;
    counterpartyName?: string | undefined;
    reference?: string | undefined;
    documentDate?: Date | undefined;
    notes?: string | undefined;
}

export class ConfirmingPlafondVm implements IConfirmingPlafondVm {
    limit?: number;
    used?: number;
    available?: number;
    activeCount?: number;
    totalFinancialCost?: number;
    banks?: ConfirmingBankPlafondVm[];

    constructor(data?: IConfirmingPlafondVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limit = _data["limit"];
            this.used = _data["used"];
            this.available = _data["available"];
            this.activeCount = _data["activeCount"];
            this.totalFinancialCost = _data["totalFinancialCost"];
            if (Array.isArray(_data["banks"])) {
                this.banks = [] as any;
                for (let item of _data["banks"])
                    this.banks!.push(ConfirmingBankPlafondVm.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfirmingPlafondVm {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmingPlafondVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limit"] = this.limit;
        data["used"] = this.used;
        data["available"] = this.available;
        data["activeCount"] = this.activeCount;
        data["totalFinancialCost"] = this.totalFinancialCost;
        if (Array.isArray(this.banks)) {
            data["banks"] = [];
            for (let item of this.banks)
                data["banks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConfirmingPlafondVm {
    limit?: number;
    used?: number;
    available?: number;
    activeCount?: number;
    totalFinancialCost?: number;
    banks?: ConfirmingBankPlafondVm[];
}

export class ConfirmingBankPlafondVm implements IConfirmingBankPlafondVm {
    bankId?: number | undefined;
    name?: string;
    limit?: number;
    used?: number;
    available?: number;
    activeCount?: number;

    constructor(data?: IConfirmingBankPlafondVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankId = _data["bankId"];
            this.name = _data["name"];
            this.limit = _data["limit"];
            this.used = _data["used"];
            this.available = _data["available"];
            this.activeCount = _data["activeCount"];
        }
    }

    static fromJS(data: any): ConfirmingBankPlafondVm {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmingBankPlafondVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankId"] = this.bankId;
        data["name"] = this.name;
        data["limit"] = this.limit;
        data["used"] = this.used;
        data["available"] = this.available;
        data["activeCount"] = this.activeCount;
        return data;
    }
}

export interface IConfirmingBankPlafondVm {
    bankId?: number | undefined;
    name?: string;
    limit?: number;
    used?: number;
    available?: number;
    activeCount?: number;
}

export class ConfirmingBankDto implements IConfirmingBankDto {
    id?: number;
    name?: string;
    plafond?: number;
    termDays?: number;
    isTermFixed?: boolean;
    contractReference?: string | undefined;
    sortOrder?: number;

    constructor(data?: IConfirmingBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.plafond = _data["plafond"];
            this.termDays = _data["termDays"];
            this.isTermFixed = _data["isTermFixed"];
            this.contractReference = _data["contractReference"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ConfirmingBankDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmingBankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["plafond"] = this.plafond;
        data["termDays"] = this.termDays;
        data["isTermFixed"] = this.isTermFixed;
        data["contractReference"] = this.contractReference;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IConfirmingBankDto {
    id?: number;
    name?: string;
    plafond?: number;
    termDays?: number;
    isTermFixed?: boolean;
    contractReference?: string | undefined;
    sortOrder?: number;
}

export class SaveConfirmingBanksCommand implements ISaveConfirmingBanksCommand {
    banks?: ConfirmingBankDto[];

    constructor(data?: ISaveConfirmingBanksCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["banks"])) {
                this.banks = [] as any;
                for (let item of _data["banks"])
                    this.banks!.push(ConfirmingBankDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveConfirmingBanksCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveConfirmingBanksCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.banks)) {
            data["banks"] = [];
            for (let item of this.banks)
                data["banks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISaveConfirmingBanksCommand {
    banks?: ConfirmingBankDto[];
}

export class SupplierConfirmingHistoryDto implements ISupplierConfirmingHistoryDto {
    supplierId?: number | undefined;
    supplierName?: string;
    count?: number;
    totalAmount?: number;
    totalFinancialCost?: number;

    constructor(data?: ISupplierConfirmingHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.count = _data["count"];
            this.totalAmount = _data["totalAmount"];
            this.totalFinancialCost = _data["totalFinancialCost"];
        }
    }

    static fromJS(data: any): SupplierConfirmingHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierConfirmingHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["count"] = this.count;
        data["totalAmount"] = this.totalAmount;
        data["totalFinancialCost"] = this.totalFinancialCost;
        return data;
    }
}

export interface ISupplierConfirmingHistoryDto {
    supplierId?: number | undefined;
    supplierName?: string;
    count?: number;
    totalAmount?: number;
    totalFinancialCost?: number;
}

export class EligibleSupplierInvoiceDto implements IEligibleSupplierInvoiceDto {
    workFinancialEntryId?: number;
    supplierId?: number | undefined;
    supplierName?: string;
    invoiceNumber?: string | undefined;
    documentDate?: Date | undefined;
    totalAmount?: number | undefined;
    workId?: number | undefined;
    workName?: string | undefined;

    constructor(data?: IEligibleSupplierInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workFinancialEntryId = _data["workFinancialEntryId"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.totalAmount = _data["totalAmount"];
            this.workId = _data["workId"];
            this.workName = _data["workName"];
        }
    }

    static fromJS(data: any): EligibleSupplierInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EligibleSupplierInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workFinancialEntryId"] = this.workFinancialEntryId;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["invoiceNumber"] = this.invoiceNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["totalAmount"] = this.totalAmount;
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        return data;
    }
}

export interface IEligibleSupplierInvoiceDto {
    workFinancialEntryId?: number;
    supplierId?: number | undefined;
    supplierName?: string;
    invoiceNumber?: string | undefined;
    documentDate?: Date | undefined;
    totalAmount?: number | undefined;
    workId?: number | undefined;
    workName?: string | undefined;
}

export class ConfirmingNoticeProposalDto implements IConfirmingNoticeProposalDto {
    rows?: ConfirmingNoticeRowDto[];
    summary?: string;

    constructor(data?: IConfirmingNoticeProposalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ConfirmingNoticeRowDto.fromJS(item));
            }
            this.summary = _data["summary"];
        }
    }

    static fromJS(data: any): ConfirmingNoticeProposalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmingNoticeProposalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        data["summary"] = this.summary;
        return data;
    }
}

export interface IConfirmingNoticeProposalDto {
    rows?: ConfirmingNoticeRowDto[];
    summary?: string;
}

export class ConfirmingNoticeRowDto implements IConfirmingNoticeRowDto {
    reference?: string | undefined;
    supplierName?: string | undefined;
    amount?: number | undefined;
    paymentDate?: Date | undefined;
    settlementDate?: Date | undefined;
    status?: string;
    reason?: string;
    options?: ConfirmingNoticeInvoiceDto[][];
    supplierInvoices?: ConfirmingNoticeInvoiceDto[];

    constructor(data?: IConfirmingNoticeRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.supplierName = _data["supplierName"];
            this.amount = _data["amount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined as any;
            this.settlementDate = _data["settlementDate"] ? new Date(_data["settlementDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.reason = _data["reason"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
            if (Array.isArray(_data["supplierInvoices"])) {
                this.supplierInvoices = [] as any;
                for (let item of _data["supplierInvoices"])
                    this.supplierInvoices!.push(ConfirmingNoticeInvoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfirmingNoticeRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmingNoticeRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["supplierName"] = this.supplierName;
        data["amount"] = this.amount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined as any;
        data["settlementDate"] = this.settlementDate ? this.settlementDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["reason"] = this.reason;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        if (Array.isArray(this.supplierInvoices)) {
            data["supplierInvoices"] = [];
            for (let item of this.supplierInvoices)
                data["supplierInvoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConfirmingNoticeRowDto {
    reference?: string | undefined;
    supplierName?: string | undefined;
    amount?: number | undefined;
    paymentDate?: Date | undefined;
    settlementDate?: Date | undefined;
    status?: string;
    reason?: string;
    options?: ConfirmingNoticeInvoiceDto[][];
    supplierInvoices?: ConfirmingNoticeInvoiceDto[];
}

export class ConfirmingNoticeInvoiceDto implements IConfirmingNoticeInvoiceDto {
    workFinancialEntryId?: number;
    supplierName?: string | undefined;
    invoiceNumber?: string | undefined;
    documentDate?: Date | undefined;
    amount?: number;
    canJoin?: boolean;

    constructor(data?: IConfirmingNoticeInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workFinancialEntryId = _data["workFinancialEntryId"];
            this.supplierName = _data["supplierName"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
            this.canJoin = _data["canJoin"];
        }
    }

    static fromJS(data: any): ConfirmingNoticeInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmingNoticeInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workFinancialEntryId"] = this.workFinancialEntryId;
        data["supplierName"] = this.supplierName;
        data["invoiceNumber"] = this.invoiceNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["amount"] = this.amount;
        data["canJoin"] = this.canJoin;
        return data;
    }
}

export interface IConfirmingNoticeInvoiceDto {
    workFinancialEntryId?: number;
    supplierName?: string | undefined;
    invoiceNumber?: string | undefined;
    documentDate?: Date | undefined;
    amount?: number;
    canJoin?: boolean;
}

export class ConfirmingPaymentDto implements IConfirmingPaymentDto {
    id?: number;
    workFinancialEntryId?: number;
    workId?: number | undefined;
    workName?: string | undefined;
    supplierId?: number | undefined;
    supplierName?: string;
    invoiceNumber?: string | undefined;
    amount?: number;
    issueDate?: Date;
    dueDate?: Date;
    annualRatePercent?: number;
    termDays?: number;
    financialCost?: number;
    statusId?: number;
    statusCode?: string;
    statusName?: string;
    currencyCode?: string;
    notes?: string | undefined;
    reference?: string | undefined;
    settledOn?: Date | undefined;
    confirmingBankId?: number | undefined;
    confirmingBankName?: string | undefined;
    invoices?: ConfirmingPaymentInvoiceDto[];

    constructor(data?: IConfirmingPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workFinancialEntryId = _data["workFinancialEntryId"];
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.amount = _data["amount"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.annualRatePercent = _data["annualRatePercent"];
            this.termDays = _data["termDays"];
            this.financialCost = _data["financialCost"];
            this.statusId = _data["statusId"];
            this.statusCode = _data["statusCode"];
            this.statusName = _data["statusName"];
            this.currencyCode = _data["currencyCode"];
            this.notes = _data["notes"];
            this.reference = _data["reference"];
            this.settledOn = _data["settledOn"] ? new Date(_data["settledOn"].toString()) : undefined as any;
            this.confirmingBankId = _data["confirmingBankId"];
            this.confirmingBankName = _data["confirmingBankName"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(ConfirmingPaymentInvoiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConfirmingPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmingPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workFinancialEntryId"] = this.workFinancialEntryId;
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["invoiceNumber"] = this.invoiceNumber;
        data["amount"] = this.amount;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["annualRatePercent"] = this.annualRatePercent;
        data["termDays"] = this.termDays;
        data["financialCost"] = this.financialCost;
        data["statusId"] = this.statusId;
        data["statusCode"] = this.statusCode;
        data["statusName"] = this.statusName;
        data["currencyCode"] = this.currencyCode;
        data["notes"] = this.notes;
        data["reference"] = this.reference;
        data["settledOn"] = this.settledOn ? this.settledOn.toISOString() : undefined as any;
        data["confirmingBankId"] = this.confirmingBankId;
        data["confirmingBankName"] = this.confirmingBankName;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IConfirmingPaymentDto {
    id?: number;
    workFinancialEntryId?: number;
    workId?: number | undefined;
    workName?: string | undefined;
    supplierId?: number | undefined;
    supplierName?: string;
    invoiceNumber?: string | undefined;
    amount?: number;
    issueDate?: Date;
    dueDate?: Date;
    annualRatePercent?: number;
    termDays?: number;
    financialCost?: number;
    statusId?: number;
    statusCode?: string;
    statusName?: string;
    currencyCode?: string;
    notes?: string | undefined;
    reference?: string | undefined;
    settledOn?: Date | undefined;
    confirmingBankId?: number | undefined;
    confirmingBankName?: string | undefined;
    invoices?: ConfirmingPaymentInvoiceDto[];
}

export class ConfirmingPaymentInvoiceDto implements IConfirmingPaymentInvoiceDto {
    workFinancialEntryId?: number;
    invoiceNumber?: string | undefined;
    documentDate?: Date | undefined;
    amount?: number;

    constructor(data?: IConfirmingPaymentInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workFinancialEntryId = _data["workFinancialEntryId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ConfirmingPaymentInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmingPaymentInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workFinancialEntryId"] = this.workFinancialEntryId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IConfirmingPaymentInvoiceDto {
    workFinancialEntryId?: number;
    invoiceNumber?: string | undefined;
    documentDate?: Date | undefined;
    amount?: number;
}

export class CreateConfirmingPaymentCommand implements ICreateConfirmingPaymentCommand {
    workFinancialEntryId?: number;
    additionalWorkFinancialEntryIds?: number[] | undefined;
    allWorkFinancialEntryIds?: number[];
    amount?: number | undefined;
    issueDate?: Date | undefined;
    dueDate?: Date | undefined;
    notes?: string | undefined;
    reference?: string | undefined;
    confirmingBankId?: number | undefined;

    constructor(data?: ICreateConfirmingPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workFinancialEntryId = _data["workFinancialEntryId"];
            if (Array.isArray(_data["additionalWorkFinancialEntryIds"])) {
                this.additionalWorkFinancialEntryIds = [] as any;
                for (let item of _data["additionalWorkFinancialEntryIds"])
                    this.additionalWorkFinancialEntryIds!.push(item);
            }
            if (Array.isArray(_data["allWorkFinancialEntryIds"])) {
                this.allWorkFinancialEntryIds = [] as any;
                for (let item of _data["allWorkFinancialEntryIds"])
                    this.allWorkFinancialEntryIds!.push(item);
            }
            this.amount = _data["amount"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.reference = _data["reference"];
            this.confirmingBankId = _data["confirmingBankId"];
        }
    }

    static fromJS(data: any): CreateConfirmingPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConfirmingPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workFinancialEntryId"] = this.workFinancialEntryId;
        if (Array.isArray(this.additionalWorkFinancialEntryIds)) {
            data["additionalWorkFinancialEntryIds"] = [];
            for (let item of this.additionalWorkFinancialEntryIds)
                data["additionalWorkFinancialEntryIds"].push(item);
        }
        if (Array.isArray(this.allWorkFinancialEntryIds)) {
            data["allWorkFinancialEntryIds"] = [];
            for (let item of this.allWorkFinancialEntryIds)
                data["allWorkFinancialEntryIds"].push(item);
        }
        data["amount"] = this.amount;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["reference"] = this.reference;
        data["confirmingBankId"] = this.confirmingBankId;
        return data;
    }
}

export interface ICreateConfirmingPaymentCommand {
    workFinancialEntryId?: number;
    additionalWorkFinancialEntryIds?: number[] | undefined;
    allWorkFinancialEntryIds?: number[];
    amount?: number | undefined;
    issueDate?: Date | undefined;
    dueDate?: Date | undefined;
    notes?: string | undefined;
    reference?: string | undefined;
    confirmingBankId?: number | undefined;
}

export class UpdateConfirmingPaymentStatusCommand implements IUpdateConfirmingPaymentStatusCommand {
    id?: number;
    statusCode?: string;

    constructor(data?: IUpdateConfirmingPaymentStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): UpdateConfirmingPaymentStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfirmingPaymentStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface IUpdateConfirmingPaymentStatusCommand {
    id?: number;
    statusCode?: string;
}

export class UpdateConfirmingPaymentDetailsCommand implements IUpdateConfirmingPaymentDetailsCommand {
    id?: number;
    reference?: string | undefined;
    issueDate?: Date;
    dueDate?: Date;
    confirmingBankId?: number | undefined;

    constructor(data?: IUpdateConfirmingPaymentDetailsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.confirmingBankId = _data["confirmingBankId"];
        }
    }

    static fromJS(data: any): UpdateConfirmingPaymentDetailsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfirmingPaymentDetailsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["confirmingBankId"] = this.confirmingBankId;
        return data;
    }
}

export interface IUpdateConfirmingPaymentDetailsCommand {
    id?: number;
    reference?: string | undefined;
    issueDate?: Date;
    dueDate?: Date;
    confirmingBankId?: number | undefined;
}

export class CompanyDto implements ICompanyDto {
    id?: number;
    name?: string;
    taxId?: string;
    isDefault?: boolean;
    sortOrder?: number;
    financialEntriesCount?: number;

    constructor(data?: ICompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.isDefault = _data["isDefault"];
            this.sortOrder = _data["sortOrder"];
            this.financialEntriesCount = _data["financialEntriesCount"];
        }
    }

    static fromJS(data: any): CompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["isDefault"] = this.isDefault;
        data["sortOrder"] = this.sortOrder;
        data["financialEntriesCount"] = this.financialEntriesCount;
        return data;
    }
}

export interface ICompanyDto {
    id?: number;
    name?: string;
    taxId?: string;
    isDefault?: boolean;
    sortOrder?: number;
    financialEntriesCount?: number;
}

export class CreateCompanyCommand implements ICreateCompanyCommand {
    name?: string;
    taxId?: string;

    constructor(data?: ICreateCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.taxId = _data["taxId"];
        }
    }

    static fromJS(data: any): CreateCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        return data;
    }
}

export interface ICreateCompanyCommand {
    name?: string;
    taxId?: string;
}

export class UpdateCompanyCommand implements IUpdateCompanyCommand {
    id?: number;
    name?: string;
    taxId?: string;
    isDefault?: boolean;

    constructor(data?: IUpdateCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): UpdateCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IUpdateCompanyCommand {
    id?: number;
    name?: string;
    taxId?: string;
    isDefault?: boolean;
}

export class CommentDto implements ICommentDto {
    id?: number;
    contextType?: string;
    contextId?: number;
    content?: string;
    isSystem?: boolean;
    systemType?: string | undefined;
    author?: CommentAuthorDto;
    attachments?: CommentAttachmentDto[];
    created?: Date;
    canEdit?: boolean;

    constructor(data?: ICommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contextType = _data["contextType"];
            this.contextId = _data["contextId"];
            this.content = _data["content"];
            this.isSystem = _data["isSystem"];
            this.systemType = _data["systemType"];
            this.author = _data["author"] ? CommentAuthorDto.fromJS(_data["author"]) : undefined as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommentAttachmentDto.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.canEdit = _data["canEdit"];
        }
    }

    static fromJS(data: any): CommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contextType"] = this.contextType;
        data["contextId"] = this.contextId;
        data["content"] = this.content;
        data["isSystem"] = this.isSystem;
        data["systemType"] = this.systemType;
        data["author"] = this.author ? this.author.toJSON() : undefined as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["canEdit"] = this.canEdit;
        return data;
    }
}

export interface ICommentDto {
    id?: number;
    contextType?: string;
    contextId?: number;
    content?: string;
    isSystem?: boolean;
    systemType?: string | undefined;
    author?: CommentAuthorDto;
    attachments?: CommentAttachmentDto[];
    created?: Date;
    canEdit?: boolean;
}

export class CommentAuthorDto implements ICommentAuthorDto {
    name?: string;
    avatarUrl?: string | undefined;
    isSystem?: boolean;

    constructor(data?: ICommentAuthorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.avatarUrl = _data["avatarUrl"];
            this.isSystem = _data["isSystem"];
        }
    }

    static fromJS(data: any): CommentAuthorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentAuthorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["avatarUrl"] = this.avatarUrl;
        data["isSystem"] = this.isSystem;
        return data;
    }
}

export interface ICommentAuthorDto {
    name?: string;
    avatarUrl?: string | undefined;
    isSystem?: boolean;
}

export class CommentAttachmentDto implements ICommentAttachmentDto {
    id?: number;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;
    url?: string | undefined;

    constructor(data?: ICommentAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CommentAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["sizeInBytes"] = this.sizeInBytes;
        data["url"] = this.url;
        return data;
    }
}

export interface ICommentAttachmentDto {
    id?: number;
    fileName?: string;
    contentType?: string;
    sizeInBytes?: number;
    url?: string | undefined;
}

export class CreateCommentCommand implements ICreateCommentCommand {
    contextType?: string;
    contextId?: number;
    content?: string;
    isSystem?: boolean;
    systemType?: string | undefined;
    attachments?: CommentAttachmentDto[] | undefined;

    constructor(data?: ICreateCommentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contextType = _data["contextType"];
            this.contextId = _data["contextId"];
            this.content = _data["content"];
            this.isSystem = _data["isSystem"];
            this.systemType = _data["systemType"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(CommentAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCommentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contextType"] = this.contextType;
        data["contextId"] = this.contextId;
        data["content"] = this.content;
        data["isSystem"] = this.isSystem;
        data["systemType"] = this.systemType;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateCommentCommand {
    contextType?: string;
    contextId?: number;
    content?: string;
    isSystem?: boolean;
    systemType?: string | undefined;
    attachments?: CommentAttachmentDto[] | undefined;
}

export class UpdateCommentCommand implements IUpdateCommentCommand {
    id?: number;
    content?: string;

    constructor(data?: IUpdateCommentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): UpdateCommentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["content"] = this.content;
        return data;
    }
}

export interface IUpdateCommentCommand {
    id?: number;
    content?: string;
}

export class CollectionDashboardDto implements ICollectionDashboardDto {
    asOf?: Date;
    totalOpen?: number;
    totalOverdue?: number;
    overdueInvoiceCount?: number;
    stageCounts?: StageCountsDto;
    rows?: CollectionDashboardRowDto[];

    constructor(data?: ICollectionDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.asOf = _data["asOf"] ? new Date(_data["asOf"].toString()) : undefined as any;
            this.totalOpen = _data["totalOpen"];
            this.totalOverdue = _data["totalOverdue"];
            this.overdueInvoiceCount = _data["overdueInvoiceCount"];
            this.stageCounts = _data["stageCounts"] ? StageCountsDto.fromJS(_data["stageCounts"]) : undefined as any;
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CollectionDashboardRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CollectionDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asOf"] = this.asOf ? this.asOf.toISOString() : undefined as any;
        data["totalOpen"] = this.totalOpen;
        data["totalOverdue"] = this.totalOverdue;
        data["overdueInvoiceCount"] = this.overdueInvoiceCount;
        data["stageCounts"] = this.stageCounts ? this.stageCounts.toJSON() : undefined as any;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICollectionDashboardDto {
    asOf?: Date;
    totalOpen?: number;
    totalOverdue?: number;
    overdueInvoiceCount?: number;
    stageCounts?: StageCountsDto;
    rows?: CollectionDashboardRowDto[];
}

export class StageCountsDto implements IStageCountsDto {
    pre_due?: number;
    due_notice?: number;
    soft?: number;
    firm?: number;

    constructor(data?: IStageCountsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pre_due = _data["pre_due"];
            this.due_notice = _data["due_notice"];
            this.soft = _data["soft"];
            this.firm = _data["firm"];
        }
    }

    static fromJS(data: any): StageCountsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StageCountsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pre_due"] = this.pre_due;
        data["due_notice"] = this.due_notice;
        data["soft"] = this.soft;
        data["firm"] = this.firm;
        return data;
    }
}

export interface IStageCountsDto {
    pre_due?: number;
    due_notice?: number;
    soft?: number;
    firm?: number;
}

export class CollectionDashboardRowDto implements ICollectionDashboardRowDto {
    clientInvoiceId?: number;
    number?: string;
    clientId?: number;
    clientName?: string;
    clientEmail?: string | undefined;
    workName?: string | undefined;
    totalAmount?: number | undefined;
    openAmount?: number;
    dueDate?: Date | undefined;
    ageDays?: number | undefined;
    agingBucket?: string | undefined;
    suggestedStage?: string | undefined;
    suggestedStageName?: string | undefined;
    lastActivityStage?: string | undefined;
    lastActivityDate?: Date | undefined;
    riskLevel?: string;

    constructor(data?: ICollectionDashboardRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientInvoiceId = _data["clientInvoiceId"];
            this.number = _data["number"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.clientEmail = _data["clientEmail"];
            this.workName = _data["workName"];
            this.totalAmount = _data["totalAmount"];
            this.openAmount = _data["openAmount"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.ageDays = _data["ageDays"];
            this.agingBucket = _data["agingBucket"];
            this.suggestedStage = _data["suggestedStage"];
            this.suggestedStageName = _data["suggestedStageName"];
            this.lastActivityStage = _data["lastActivityStage"];
            this.lastActivityDate = _data["lastActivityDate"] ? new Date(_data["lastActivityDate"].toString()) : undefined as any;
            this.riskLevel = _data["riskLevel"];
        }
    }

    static fromJS(data: any): CollectionDashboardRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionDashboardRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientInvoiceId"] = this.clientInvoiceId;
        data["number"] = this.number;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["clientEmail"] = this.clientEmail;
        data["workName"] = this.workName;
        data["totalAmount"] = this.totalAmount;
        data["openAmount"] = this.openAmount;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["ageDays"] = this.ageDays;
        data["agingBucket"] = this.agingBucket;
        data["suggestedStage"] = this.suggestedStage;
        data["suggestedStageName"] = this.suggestedStageName;
        data["lastActivityStage"] = this.lastActivityStage;
        data["lastActivityDate"] = this.lastActivityDate ? this.lastActivityDate.toISOString() : undefined as any;
        data["riskLevel"] = this.riskLevel;
        return data;
    }
}

export interface ICollectionDashboardRowDto {
    clientInvoiceId?: number;
    number?: string;
    clientId?: number;
    clientName?: string;
    clientEmail?: string | undefined;
    workName?: string | undefined;
    totalAmount?: number | undefined;
    openAmount?: number;
    dueDate?: Date | undefined;
    ageDays?: number | undefined;
    agingBucket?: string | undefined;
    suggestedStage?: string | undefined;
    suggestedStageName?: string | undefined;
    lastActivityStage?: string | undefined;
    lastActivityDate?: Date | undefined;
    riskLevel?: string;
}

export class CollectionActivityDto implements ICollectionActivityDto {
    id?: number;
    clientId?: number;
    clientName?: string | undefined;
    clientInvoiceId?: number | undefined;
    invoiceNumber?: string | undefined;
    stage?: string;
    stageName?: string;
    channel?: string;
    channelName?: string;
    activityDate?: Date;
    subject?: string | undefined;
    body?: string | undefined;
    outcome?: string | undefined;
    emailTo?: string | undefined;
    emailStatus?: string | undefined;
    createdBy?: string | undefined;
    created?: Date;

    constructor(data?: ICollectionActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.clientInvoiceId = _data["clientInvoiceId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.stage = _data["stage"];
            this.stageName = _data["stageName"];
            this.channel = _data["channel"];
            this.channelName = _data["channelName"];
            this.activityDate = _data["activityDate"] ? new Date(_data["activityDate"].toString()) : undefined as any;
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.outcome = _data["outcome"];
            this.emailTo = _data["emailTo"];
            this.emailStatus = _data["emailStatus"];
            this.createdBy = _data["createdBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CollectionActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["clientInvoiceId"] = this.clientInvoiceId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["stage"] = this.stage;
        data["stageName"] = this.stageName;
        data["channel"] = this.channel;
        data["channelName"] = this.channelName;
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : undefined as any;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["outcome"] = this.outcome;
        data["emailTo"] = this.emailTo;
        data["emailStatus"] = this.emailStatus;
        data["createdBy"] = this.createdBy;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        return data;
    }
}

export interface ICollectionActivityDto {
    id?: number;
    clientId?: number;
    clientName?: string | undefined;
    clientInvoiceId?: number | undefined;
    invoiceNumber?: string | undefined;
    stage?: string;
    stageName?: string;
    channel?: string;
    channelName?: string;
    activityDate?: Date;
    subject?: string | undefined;
    body?: string | undefined;
    outcome?: string | undefined;
    emailTo?: string | undefined;
    emailStatus?: string | undefined;
    createdBy?: string | undefined;
    created?: Date;
}

export class LogCollectionActivityCommand implements ILogCollectionActivityCommand {
    clientId?: number;
    clientInvoiceId?: number | undefined;
    stage?: string;
    channel?: string;
    outcome?: string | undefined;
    activityDate?: Date | undefined;

    constructor(data?: ILogCollectionActivityCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientInvoiceId = _data["clientInvoiceId"];
            this.stage = _data["stage"];
            this.channel = _data["channel"];
            this.outcome = _data["outcome"];
            this.activityDate = _data["activityDate"] ? new Date(_data["activityDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): LogCollectionActivityCommand {
        data = typeof data === 'object' ? data : {};
        let result = new LogCollectionActivityCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientInvoiceId"] = this.clientInvoiceId;
        data["stage"] = this.stage;
        data["channel"] = this.channel;
        data["outcome"] = this.outcome;
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ILogCollectionActivityCommand {
    clientId?: number;
    clientInvoiceId?: number | undefined;
    stage?: string;
    channel?: string;
    outcome?: string | undefined;
    activityDate?: Date | undefined;
}

export class CollectionEmailDto implements ICollectionEmailDto {
    to?: string | undefined;
    subject?: string;
    body?: string;
    stage?: string;
    stageName?: string;
    clientInvoiceId?: number;

    constructor(data?: ICollectionEmailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.to = _data["to"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.stage = _data["stage"];
            this.stageName = _data["stageName"];
            this.clientInvoiceId = _data["clientInvoiceId"];
        }
    }

    static fromJS(data: any): CollectionEmailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionEmailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["stage"] = this.stage;
        data["stageName"] = this.stageName;
        data["clientInvoiceId"] = this.clientInvoiceId;
        return data;
    }
}

export interface ICollectionEmailDto {
    to?: string | undefined;
    subject?: string;
    body?: string;
    stage?: string;
    stageName?: string;
    clientInvoiceId?: number;
}

export class SendCollectionEmailCommand implements ISendCollectionEmailCommand {
    clientInvoiceId?: number;
    stage?: string;
    to?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;

    constructor(data?: ISendCollectionEmailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientInvoiceId = _data["clientInvoiceId"];
            this.stage = _data["stage"];
            this.to = _data["to"];
            this.subject = _data["subject"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): SendCollectionEmailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendCollectionEmailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientInvoiceId"] = this.clientInvoiceId;
        data["stage"] = this.stage;
        data["to"] = this.to;
        data["subject"] = this.subject;
        data["body"] = this.body;
        return data;
    }
}

export interface ISendCollectionEmailCommand {
    clientInvoiceId?: number;
    stage?: string;
    to?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
}

export class ClientDto implements IClientDto {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    notes?: string | undefined;
    primaryContactName?: string | undefined;
    primaryContactRole?: string | undefined;
    primaryContactEmail?: string | undefined;
    primaryContactPhone?: string | undefined;
    paymentTerms?: string | undefined;
    tags?: string[];
    workTypes?: WorkTypeDto[];
    logoUrl?: string | undefined;
    activeProjectsCount?: number;
    lastInteraction?: Date | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.website = _data["website"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.notes = _data["notes"];
            this.primaryContactName = _data["primaryContactName"];
            this.primaryContactRole = _data["primaryContactRole"];
            this.primaryContactEmail = _data["primaryContactEmail"];
            this.primaryContactPhone = _data["primaryContactPhone"];
            this.paymentTerms = _data["paymentTerms"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["workTypes"])) {
                this.workTypes = [] as any;
                for (let item of _data["workTypes"])
                    this.workTypes!.push(WorkTypeDto.fromJS(item));
            }
            this.logoUrl = _data["logoUrl"];
            this.activeProjectsCount = _data["activeProjectsCount"];
            this.lastInteraction = _data["lastInteraction"] ? new Date(_data["lastInteraction"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["website"] = this.website;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["notes"] = this.notes;
        data["primaryContactName"] = this.primaryContactName;
        data["primaryContactRole"] = this.primaryContactRole;
        data["primaryContactEmail"] = this.primaryContactEmail;
        data["primaryContactPhone"] = this.primaryContactPhone;
        data["paymentTerms"] = this.paymentTerms;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.workTypes)) {
            data["workTypes"] = [];
            for (let item of this.workTypes)
                data["workTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["logoUrl"] = this.logoUrl;
        data["activeProjectsCount"] = this.activeProjectsCount;
        data["lastInteraction"] = this.lastInteraction ? this.lastInteraction.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IClientDto {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    notes?: string | undefined;
    primaryContactName?: string | undefined;
    primaryContactRole?: string | undefined;
    primaryContactEmail?: string | undefined;
    primaryContactPhone?: string | undefined;
    paymentTerms?: string | undefined;
    tags?: string[];
    workTypes?: WorkTypeDto[];
    logoUrl?: string | undefined;
    activeProjectsCount?: number;
    lastInteraction?: Date | undefined;
    created?: Date;
    lastModified?: Date;
}

export class CreateClientCommand implements ICreateClientCommand {
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    notes?: string | undefined;
    primaryContactName?: string | undefined;
    primaryContactRole?: string | undefined;
    primaryContactEmail?: string | undefined;
    primaryContactPhone?: string | undefined;
    paymentTerms?: string | undefined;
    tags?: string[] | undefined;
    workTypeIds?: number[] | undefined;
    activeProjectsCount?: number | undefined;
    lastInteraction?: Date | undefined;

    constructor(data?: ICreateClientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.website = _data["website"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.notes = _data["notes"];
            this.primaryContactName = _data["primaryContactName"];
            this.primaryContactRole = _data["primaryContactRole"];
            this.primaryContactEmail = _data["primaryContactEmail"];
            this.primaryContactPhone = _data["primaryContactPhone"];
            this.paymentTerms = _data["paymentTerms"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["workTypeIds"])) {
                this.workTypeIds = [] as any;
                for (let item of _data["workTypeIds"])
                    this.workTypeIds!.push(item);
            }
            this.activeProjectsCount = _data["activeProjectsCount"];
            this.lastInteraction = _data["lastInteraction"] ? new Date(_data["lastInteraction"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["website"] = this.website;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["notes"] = this.notes;
        data["primaryContactName"] = this.primaryContactName;
        data["primaryContactRole"] = this.primaryContactRole;
        data["primaryContactEmail"] = this.primaryContactEmail;
        data["primaryContactPhone"] = this.primaryContactPhone;
        data["paymentTerms"] = this.paymentTerms;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.workTypeIds)) {
            data["workTypeIds"] = [];
            for (let item of this.workTypeIds)
                data["workTypeIds"].push(item);
        }
        data["activeProjectsCount"] = this.activeProjectsCount;
        data["lastInteraction"] = this.lastInteraction ? this.lastInteraction.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateClientCommand {
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    notes?: string | undefined;
    primaryContactName?: string | undefined;
    primaryContactRole?: string | undefined;
    primaryContactEmail?: string | undefined;
    primaryContactPhone?: string | undefined;
    paymentTerms?: string | undefined;
    tags?: string[] | undefined;
    workTypeIds?: number[] | undefined;
    activeProjectsCount?: number | undefined;
    lastInteraction?: Date | undefined;
}

export class UpdateClientCommand implements IUpdateClientCommand {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    notes?: string | undefined;
    primaryContactName?: string | undefined;
    primaryContactRole?: string | undefined;
    primaryContactEmail?: string | undefined;
    primaryContactPhone?: string | undefined;
    paymentTerms?: string | undefined;
    tags?: string[] | undefined;
    workTypeIds?: number[] | undefined;
    activeProjectsCount?: number | undefined;
    lastInteraction?: Date | undefined;

    constructor(data?: IUpdateClientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.taxId = _data["taxId"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.website = _data["website"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.notes = _data["notes"];
            this.primaryContactName = _data["primaryContactName"];
            this.primaryContactRole = _data["primaryContactRole"];
            this.primaryContactEmail = _data["primaryContactEmail"];
            this.primaryContactPhone = _data["primaryContactPhone"];
            this.paymentTerms = _data["paymentTerms"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["workTypeIds"])) {
                this.workTypeIds = [] as any;
                for (let item of _data["workTypeIds"])
                    this.workTypeIds!.push(item);
            }
            this.activeProjectsCount = _data["activeProjectsCount"];
            this.lastInteraction = _data["lastInteraction"] ? new Date(_data["lastInteraction"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["taxId"] = this.taxId;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["website"] = this.website;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["notes"] = this.notes;
        data["primaryContactName"] = this.primaryContactName;
        data["primaryContactRole"] = this.primaryContactRole;
        data["primaryContactEmail"] = this.primaryContactEmail;
        data["primaryContactPhone"] = this.primaryContactPhone;
        data["paymentTerms"] = this.paymentTerms;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.workTypeIds)) {
            data["workTypeIds"] = [];
            for (let item of this.workTypeIds)
                data["workTypeIds"].push(item);
        }
        data["activeProjectsCount"] = this.activeProjectsCount;
        data["lastInteraction"] = this.lastInteraction ? this.lastInteraction.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateClientCommand {
    id?: number;
    name?: string;
    taxId?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    notes?: string | undefined;
    primaryContactName?: string | undefined;
    primaryContactRole?: string | undefined;
    primaryContactEmail?: string | undefined;
    primaryContactPhone?: string | undefined;
    paymentTerms?: string | undefined;
    tags?: string[] | undefined;
    workTypeIds?: number[] | undefined;
    activeProjectsCount?: number | undefined;
    lastInteraction?: Date | undefined;
}

export class ClientLogoDto implements IClientLogoDto {
    clientId?: number;
    logoUrl?: string | undefined;

    constructor(data?: IClientLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.logoUrl = _data["logoUrl"];
        }
    }

    static fromJS(data: any): ClientLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["logoUrl"] = this.logoUrl;
        return data;
    }
}

export interface IClientLogoDto {
    clientId?: number;
    logoUrl?: string | undefined;
}

export class ClientAccountDto implements IClientAccountDto {
    clientId?: number;
    clientName?: string;
    taxId?: string | undefined;
    outstandingBalance?: number;
    openInvoiceCount?: number;
    invoices?: ClientInvoiceDto[];
    installmentAmount?: number | undefined;
    frequency?: string | undefined;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    agreementNotes?: string | undefined;
    hasLegalProcess?: boolean;
    legalProcessNotes?: string | undefined;
    creditLimit?: number | undefined;
    riskLevel?: string;
    riskReasons?: string[];

    constructor(data?: IClientAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.taxId = _data["taxId"];
            this.outstandingBalance = _data["outstandingBalance"];
            this.openInvoiceCount = _data["openInvoiceCount"];
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(ClientInvoiceDto.fromJS(item));
            }
            this.installmentAmount = _data["installmentAmount"];
            this.frequency = _data["frequency"];
            this.agreementStartDate = _data["agreementStartDate"] ? new Date(_data["agreementStartDate"].toString()) : undefined as any;
            this.agreementEndDate = _data["agreementEndDate"] ? new Date(_data["agreementEndDate"].toString()) : undefined as any;
            this.agreementNotes = _data["agreementNotes"];
            this.hasLegalProcess = _data["hasLegalProcess"];
            this.legalProcessNotes = _data["legalProcessNotes"];
            this.creditLimit = _data["creditLimit"];
            this.riskLevel = _data["riskLevel"];
            if (Array.isArray(_data["riskReasons"])) {
                this.riskReasons = [] as any;
                for (let item of _data["riskReasons"])
                    this.riskReasons!.push(item);
            }
        }
    }

    static fromJS(data: any): ClientAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["taxId"] = this.taxId;
        data["outstandingBalance"] = this.outstandingBalance;
        data["openInvoiceCount"] = this.openInvoiceCount;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item ? item.toJSON() : undefined as any);
        }
        data["installmentAmount"] = this.installmentAmount;
        data["frequency"] = this.frequency;
        data["agreementStartDate"] = this.agreementStartDate ? this.agreementStartDate.toISOString() : undefined as any;
        data["agreementEndDate"] = this.agreementEndDate ? this.agreementEndDate.toISOString() : undefined as any;
        data["agreementNotes"] = this.agreementNotes;
        data["hasLegalProcess"] = this.hasLegalProcess;
        data["legalProcessNotes"] = this.legalProcessNotes;
        data["creditLimit"] = this.creditLimit;
        data["riskLevel"] = this.riskLevel;
        if (Array.isArray(this.riskReasons)) {
            data["riskReasons"] = [];
            for (let item of this.riskReasons)
                data["riskReasons"].push(item);
        }
        return data;
    }
}

export interface IClientAccountDto {
    clientId?: number;
    clientName?: string;
    taxId?: string | undefined;
    outstandingBalance?: number;
    openInvoiceCount?: number;
    invoices?: ClientInvoiceDto[];
    installmentAmount?: number | undefined;
    frequency?: string | undefined;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    agreementNotes?: string | undefined;
    hasLegalProcess?: boolean;
    legalProcessNotes?: string | undefined;
    creditLimit?: number | undefined;
    riskLevel?: string;
    riskReasons?: string[];
}

export class SaveClientAccountCommand implements ISaveClientAccountCommand {
    clientId?: number;
    installmentAmount?: number | undefined;
    frequency?: string | undefined;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    agreementNotes?: string | undefined;
    hasLegalProcess?: boolean;
    legalProcessNotes?: string | undefined;
    creditLimit?: number | undefined;

    constructor(data?: ISaveClientAccountCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.installmentAmount = _data["installmentAmount"];
            this.frequency = _data["frequency"];
            this.agreementStartDate = _data["agreementStartDate"] ? new Date(_data["agreementStartDate"].toString()) : undefined as any;
            this.agreementEndDate = _data["agreementEndDate"] ? new Date(_data["agreementEndDate"].toString()) : undefined as any;
            this.agreementNotes = _data["agreementNotes"];
            this.hasLegalProcess = _data["hasLegalProcess"];
            this.legalProcessNotes = _data["legalProcessNotes"];
            this.creditLimit = _data["creditLimit"];
        }
    }

    static fromJS(data: any): SaveClientAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveClientAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["installmentAmount"] = this.installmentAmount;
        data["frequency"] = this.frequency;
        data["agreementStartDate"] = this.agreementStartDate ? this.agreementStartDate.toISOString() : undefined as any;
        data["agreementEndDate"] = this.agreementEndDate ? this.agreementEndDate.toISOString() : undefined as any;
        data["agreementNotes"] = this.agreementNotes;
        data["hasLegalProcess"] = this.hasLegalProcess;
        data["legalProcessNotes"] = this.legalProcessNotes;
        data["creditLimit"] = this.creditLimit;
        return data;
    }
}

export interface ISaveClientAccountCommand {
    clientId?: number;
    installmentAmount?: number | undefined;
    frequency?: string | undefined;
    agreementStartDate?: Date | undefined;
    agreementEndDate?: Date | undefined;
    agreementNotes?: string | undefined;
    hasLegalProcess?: boolean;
    legalProcessNotes?: string | undefined;
    creditLimit?: number | undefined;
}

export class ClientRiskDto implements IClientRiskDto {
    clientId?: number;
    level?: string;
    overdueAmount?: number;
    worstOverdueDays?: number;
    outstandingBalance?: number;
    openInvoiceCount?: number;
    reasons?: string[];

    constructor(data?: IClientRiskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.level = _data["level"];
            this.overdueAmount = _data["overdueAmount"];
            this.worstOverdueDays = _data["worstOverdueDays"];
            this.outstandingBalance = _data["outstandingBalance"];
            this.openInvoiceCount = _data["openInvoiceCount"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(item);
            }
        }
    }

    static fromJS(data: any): ClientRiskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientRiskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["level"] = this.level;
        data["overdueAmount"] = this.overdueAmount;
        data["worstOverdueDays"] = this.worstOverdueDays;
        data["outstandingBalance"] = this.outstandingBalance;
        data["openInvoiceCount"] = this.openInvoiceCount;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        return data;
    }
}

export interface IClientRiskDto {
    clientId?: number;
    level?: string;
    overdueAmount?: number;
    worstOverdueDays?: number;
    outstandingBalance?: number;
    openInvoiceCount?: number;
    reasons?: string[];
}

export class ClientInvoiceStatusDto implements IClientInvoiceStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;

    constructor(data?: IClientInvoiceStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ClientInvoiceStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInvoiceStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IClientInvoiceStatusDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
}

export class ReceivablesAgingDto implements IReceivablesAgingDto {
    asOf?: Date;
    totalOutstanding?: number;
    currentTotal?: number;
    bucket0_30?: number;
    bucket31_60?: number;
    bucket61_90?: number;
    bucket90Plus?: number;
    clients?: ClientAgingRowDto[];

    constructor(data?: IReceivablesAgingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.asOf = _data["asOf"] ? new Date(_data["asOf"].toString()) : undefined as any;
            this.totalOutstanding = _data["totalOutstanding"];
            this.currentTotal = _data["currentTotal"];
            this.bucket0_30 = _data["bucket0_30"];
            this.bucket31_60 = _data["bucket31_60"];
            this.bucket61_90 = _data["bucket61_90"];
            this.bucket90Plus = _data["bucket90Plus"];
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(ClientAgingRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReceivablesAgingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceivablesAgingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asOf"] = this.asOf ? this.asOf.toISOString() : undefined as any;
        data["totalOutstanding"] = this.totalOutstanding;
        data["currentTotal"] = this.currentTotal;
        data["bucket0_30"] = this.bucket0_30;
        data["bucket31_60"] = this.bucket31_60;
        data["bucket61_90"] = this.bucket61_90;
        data["bucket90Plus"] = this.bucket90Plus;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IReceivablesAgingDto {
    asOf?: Date;
    totalOutstanding?: number;
    currentTotal?: number;
    bucket0_30?: number;
    bucket31_60?: number;
    bucket61_90?: number;
    bucket90Plus?: number;
    clients?: ClientAgingRowDto[];
}

export class ClientAgingRowDto implements IClientAgingRowDto {
    clientId?: number;
    clientName?: string;
    totalOutstanding?: number;
    current?: number;
    d0_30?: number;
    d31_60?: number;
    d61_90?: number;
    d90Plus?: number;
    invoiceCount?: number;

    constructor(data?: IClientAgingRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.totalOutstanding = _data["totalOutstanding"];
            this.current = _data["current"];
            this.d0_30 = _data["d0_30"];
            this.d31_60 = _data["d31_60"];
            this.d61_90 = _data["d61_90"];
            this.d90Plus = _data["d90Plus"];
            this.invoiceCount = _data["invoiceCount"];
        }
    }

    static fromJS(data: any): ClientAgingRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAgingRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["totalOutstanding"] = this.totalOutstanding;
        data["current"] = this.current;
        data["d0_30"] = this.d0_30;
        data["d31_60"] = this.d31_60;
        data["d61_90"] = this.d61_90;
        data["d90Plus"] = this.d90Plus;
        data["invoiceCount"] = this.invoiceCount;
        return data;
    }
}

export interface IClientAgingRowDto {
    clientId?: number;
    clientName?: string;
    totalOutstanding?: number;
    current?: number;
    d0_30?: number;
    d31_60?: number;
    d61_90?: number;
    d90Plus?: number;
    invoiceCount?: number;
}

export class CreateClientInvoiceCommand implements ICreateClientInvoiceCommand {
    clientId?: number;
    workId?: number | undefined;
    issueDate?: Date | undefined;
    dueDate?: Date | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    description?: string | undefined;
    notes?: string | undefined;
    currencyCode?: string | undefined;

    constructor(data?: ICreateClientInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.workId = _data["workId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.baseAmount = _data["baseAmount"];
            this.vatAmount = _data["vatAmount"];
            this.totalAmount = _data["totalAmount"];
            this.description = _data["description"];
            this.notes = _data["notes"];
            this.currencyCode = _data["currencyCode"];
        }
    }

    static fromJS(data: any): CreateClientInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["workId"] = this.workId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["baseAmount"] = this.baseAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["description"] = this.description;
        data["notes"] = this.notes;
        data["currencyCode"] = this.currencyCode;
        return data;
    }
}

export interface ICreateClientInvoiceCommand {
    clientId?: number;
    workId?: number | undefined;
    issueDate?: Date | undefined;
    dueDate?: Date | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    description?: string | undefined;
    notes?: string | undefined;
    currencyCode?: string | undefined;
}

export class UpdateClientInvoiceCommand implements IUpdateClientInvoiceCommand {
    id?: number;
    workId?: number | undefined;
    issueDate?: Date | undefined;
    dueDate?: Date | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    description?: string | undefined;
    notes?: string | undefined;
    currencyCode?: string | undefined;

    constructor(data?: IUpdateClientInvoiceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.baseAmount = _data["baseAmount"];
            this.vatAmount = _data["vatAmount"];
            this.totalAmount = _data["totalAmount"];
            this.description = _data["description"];
            this.notes = _data["notes"];
            this.currencyCode = _data["currencyCode"];
        }
    }

    static fromJS(data: any): UpdateClientInvoiceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClientInvoiceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["baseAmount"] = this.baseAmount;
        data["vatAmount"] = this.vatAmount;
        data["totalAmount"] = this.totalAmount;
        data["description"] = this.description;
        data["notes"] = this.notes;
        data["currencyCode"] = this.currencyCode;
        return data;
    }
}

export interface IUpdateClientInvoiceCommand {
    id?: number;
    workId?: number | undefined;
    issueDate?: Date | undefined;
    dueDate?: Date | undefined;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    totalAmount?: number | undefined;
    description?: string | undefined;
    notes?: string | undefined;
    currencyCode?: string | undefined;
}

export class RegisterClientInvoicePaymentCommand implements IRegisterClientInvoicePaymentCommand {
    id?: number;
    amount?: number;
    paymentDate?: Date | undefined;

    constructor(data?: IRegisterClientInvoicePaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RegisterClientInvoicePaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterClientInvoicePaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IRegisterClientInvoicePaymentCommand {
    id?: number;
    amount?: number;
    paymentDate?: Date | undefined;
}

export class ChangeClientInvoiceStatusCommand implements IChangeClientInvoiceStatusCommand {
    id?: number;
    statusCode?: string;
    overrideBlock?: boolean;
    overrideReason?: string | undefined;

    constructor(data?: IChangeClientInvoiceStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.statusCode = _data["statusCode"];
            this.overrideBlock = _data["overrideBlock"];
            this.overrideReason = _data["overrideReason"];
        }
    }

    static fromJS(data: any): ChangeClientInvoiceStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeClientInvoiceStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["statusCode"] = this.statusCode;
        data["overrideBlock"] = this.overrideBlock;
        data["overrideReason"] = this.overrideReason;
        return data;
    }
}

export interface IChangeClientInvoiceStatusCommand {
    id?: number;
    statusCode?: string;
    overrideBlock?: boolean;
    overrideReason?: string | undefined;
}

export class CreateCreditNoteCommand implements ICreateCreditNoteCommand {
    originalInvoiceId?: number;
    amount?: number;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    description?: string | undefined;
    issueDate?: Date | undefined;

    constructor(data?: ICreateCreditNoteCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalInvoiceId = _data["originalInvoiceId"];
            this.amount = _data["amount"];
            this.baseAmount = _data["baseAmount"];
            this.vatAmount = _data["vatAmount"];
            this.description = _data["description"];
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateCreditNoteCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCreditNoteCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalInvoiceId"] = this.originalInvoiceId;
        data["amount"] = this.amount;
        data["baseAmount"] = this.baseAmount;
        data["vatAmount"] = this.vatAmount;
        data["description"] = this.description;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateCreditNoteCommand {
    originalInvoiceId?: number;
    amount?: number;
    baseAmount?: number | undefined;
    vatAmount?: number | undefined;
    description?: string | undefined;
    issueDate?: Date | undefined;
}

export class MigrateInvoiceToClientAccountCommand implements IMigrateInvoiceToClientAccountCommand {
    id?: number;
    migrationNotes?: string | undefined;

    constructor(data?: IMigrateInvoiceToClientAccountCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.migrationNotes = _data["migrationNotes"];
        }
    }

    static fromJS(data: any): MigrateInvoiceToClientAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MigrateInvoiceToClientAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["migrationNotes"] = this.migrationNotes;
        return data;
    }
}

export interface IMigrateInvoiceToClientAccountCommand {
    id?: number;
    migrationNotes?: string | undefined;
}

export class BudgetTemplateDto implements IBudgetTemplateDto {
    id?: number;
    name?: string;
    description?: string | undefined;
    createdByUserId?: string;
    createdByUserName?: string;
    chapterCount?: number;
    itemCount?: number;
    created?: Date;
    canDelete?: boolean;

    constructor(data?: IBudgetTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdByUserId = _data["createdByUserId"];
            this.createdByUserName = _data["createdByUserName"];
            this.chapterCount = _data["chapterCount"];
            this.itemCount = _data["itemCount"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.canDelete = _data["canDelete"];
        }
    }

    static fromJS(data: any): BudgetTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdByUserId"] = this.createdByUserId;
        data["createdByUserName"] = this.createdByUserName;
        data["chapterCount"] = this.chapterCount;
        data["itemCount"] = this.itemCount;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["canDelete"] = this.canDelete;
        return data;
    }
}

export interface IBudgetTemplateDto {
    id?: number;
    name?: string;
    description?: string | undefined;
    createdByUserId?: string;
    createdByUserName?: string;
    chapterCount?: number;
    itemCount?: number;
    created?: Date;
    canDelete?: boolean;
}

export class SaveBudgetAsTemplateCommand implements ISaveBudgetAsTemplateCommand {
    budgetId?: number;
    name?: string;
    description?: string | undefined;

    constructor(data?: ISaveBudgetAsTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetId = _data["budgetId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): SaveBudgetAsTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SaveBudgetAsTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetId"] = this.budgetId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ISaveBudgetAsTemplateCommand {
    budgetId?: number;
    name?: string;
    description?: string | undefined;
}

export class CreateBudgetFromTemplateCommand implements ICreateBudgetFromTemplateCommand {
    templateId?: number;
    budgetName?: string;

    constructor(data?: ICreateBudgetFromTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            this.budgetName = _data["budgetName"];
        }
    }

    static fromJS(data: any): CreateBudgetFromTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBudgetFromTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        data["budgetName"] = this.budgetName;
        return data;
    }
}

export interface ICreateBudgetFromTemplateCommand {
    templateId?: number;
    budgetName?: string;
}

export class BudgetSummaryDto implements IBudgetSummaryDto {
    id?: number;
    reference?: string;
    versionNumber?: number;
    versionLabel?: string | undefined;
    isActiveVersion?: boolean;
    status?: string;
    clientId?: number | undefined;
    clientName?: string;
    workName?: string;
    totalAmount?: number | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IBudgetSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.versionNumber = _data["versionNumber"];
            this.versionLabel = _data["versionLabel"];
            this.isActiveVersion = _data["isActiveVersion"];
            this.status = _data["status"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.workName = _data["workName"];
            this.totalAmount = _data["totalAmount"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BudgetSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["versionNumber"] = this.versionNumber;
        data["versionLabel"] = this.versionLabel;
        data["isActiveVersion"] = this.isActiveVersion;
        data["status"] = this.status;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["workName"] = this.workName;
        data["totalAmount"] = this.totalAmount;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IBudgetSummaryDto {
    id?: number;
    reference?: string;
    versionNumber?: number;
    versionLabel?: string | undefined;
    isActiveVersion?: boolean;
    status?: string;
    clientId?: number | undefined;
    clientName?: string;
    workName?: string;
    totalAmount?: number | undefined;
    created?: Date;
    lastModified?: Date;
}

export class BudgetDto implements IBudgetDto {
    id?: number;
    reference?: string;
    versionGroupId?: string;
    versionNumber?: number;
    versionLabel?: string | undefined;
    isActiveVersion?: boolean;
    status?: string;
    clientId?: number | undefined;
    clientName?: string;
    workId?: number | undefined;
    workCode?: string | undefined;
    workName?: string;
    responsible?: string | undefined;
    orderReference?: string | undefined;
    vatRate?: number;
    totalAmount?: number | undefined;
    workArea?: number | undefined;
    rejectionReason?: string | undefined;
    lines?: BudgetLineDto[];
    documents?: BudgetDocumentDto[];
    created?: Date;
    lastModified?: Date;

    constructor(data?: IBudgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.versionGroupId = _data["versionGroupId"];
            this.versionNumber = _data["versionNumber"];
            this.versionLabel = _data["versionLabel"];
            this.isActiveVersion = _data["isActiveVersion"];
            this.status = _data["status"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.workId = _data["workId"];
            this.workCode = _data["workCode"];
            this.workName = _data["workName"];
            this.responsible = _data["responsible"];
            this.orderReference = _data["orderReference"];
            this.vatRate = _data["vatRate"];
            this.totalAmount = _data["totalAmount"];
            this.workArea = _data["workArea"];
            this.rejectionReason = _data["rejectionReason"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(BudgetLineDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(BudgetDocumentDto.fromJS(item));
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BudgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["versionGroupId"] = this.versionGroupId;
        data["versionNumber"] = this.versionNumber;
        data["versionLabel"] = this.versionLabel;
        data["isActiveVersion"] = this.isActiveVersion;
        data["status"] = this.status;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["workId"] = this.workId;
        data["workCode"] = this.workCode;
        data["workName"] = this.workName;
        data["responsible"] = this.responsible;
        data["orderReference"] = this.orderReference;
        data["vatRate"] = this.vatRate;
        data["totalAmount"] = this.totalAmount;
        data["workArea"] = this.workArea;
        data["rejectionReason"] = this.rejectionReason;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : undefined as any);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IBudgetDto {
    id?: number;
    reference?: string;
    versionGroupId?: string;
    versionNumber?: number;
    versionLabel?: string | undefined;
    isActiveVersion?: boolean;
    status?: string;
    clientId?: number | undefined;
    clientName?: string;
    workId?: number | undefined;
    workCode?: string | undefined;
    workName?: string;
    responsible?: string | undefined;
    orderReference?: string | undefined;
    vatRate?: number;
    totalAmount?: number | undefined;
    workArea?: number | undefined;
    rejectionReason?: string | undefined;
    lines?: BudgetLineDto[];
    documents?: BudgetDocumentDto[];
    created?: Date;
    lastModified?: Date;
}

export class BudgetLineDto implements IBudgetLineDto {
    id?: number;
    areaName?: string;
    chapterName?: string;
    chapterNote?: string | undefined;
    code?: string;
    description?: string;
    unit?: string;
    quantity?: number;
    quantityFormula?: string | undefined;
    quantityFormulaNote?: string | undefined;
    unitPrice?: number;
    isPercentageOfWorkTotal?: boolean;
    percentageOfWorkTotal?: number | undefined;
    marginPercent?: number | undefined;
    costUnitPrice?: number | undefined;
    isCostPriceValidated?: boolean;
    costSuggestionBudgetId?: number | undefined;
    costSuggestionBudgetReference?: string | undefined;
    note?: string | undefined;
    internalTeamActive?: boolean;
    internalTeamValue?: number | undefined;
    internalTeamNotes?: string | undefined;
    subcontractorId?: number | undefined;
    subcontractors?: BudgetLineSubcontractorDto[];
    suppliers?: BudgetLineSupplierDto[];
    materials?: BudgetLineMaterialDto[];

    constructor(data?: IBudgetLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.areaName = _data["areaName"];
            this.chapterName = _data["chapterName"];
            this.chapterNote = _data["chapterNote"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.quantity = _data["quantity"];
            this.quantityFormula = _data["quantityFormula"];
            this.quantityFormulaNote = _data["quantityFormulaNote"];
            this.unitPrice = _data["unitPrice"];
            this.isPercentageOfWorkTotal = _data["isPercentageOfWorkTotal"];
            this.percentageOfWorkTotal = _data["percentageOfWorkTotal"];
            this.marginPercent = _data["marginPercent"];
            this.costUnitPrice = _data["costUnitPrice"];
            this.isCostPriceValidated = _data["isCostPriceValidated"];
            this.costSuggestionBudgetId = _data["costSuggestionBudgetId"];
            this.costSuggestionBudgetReference = _data["costSuggestionBudgetReference"];
            this.note = _data["note"];
            this.internalTeamActive = _data["internalTeamActive"];
            this.internalTeamValue = _data["internalTeamValue"];
            this.internalTeamNotes = _data["internalTeamNotes"];
            this.subcontractorId = _data["subcontractorId"];
            if (Array.isArray(_data["subcontractors"])) {
                this.subcontractors = [] as any;
                for (let item of _data["subcontractors"])
                    this.subcontractors!.push(BudgetLineSubcontractorDto.fromJS(item));
            }
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(BudgetLineSupplierDto.fromJS(item));
            }
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(BudgetLineMaterialDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["areaName"] = this.areaName;
        data["chapterName"] = this.chapterName;
        data["chapterNote"] = this.chapterNote;
        data["code"] = this.code;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["quantity"] = this.quantity;
        data["quantityFormula"] = this.quantityFormula;
        data["quantityFormulaNote"] = this.quantityFormulaNote;
        data["unitPrice"] = this.unitPrice;
        data["isPercentageOfWorkTotal"] = this.isPercentageOfWorkTotal;
        data["percentageOfWorkTotal"] = this.percentageOfWorkTotal;
        data["marginPercent"] = this.marginPercent;
        data["costUnitPrice"] = this.costUnitPrice;
        data["isCostPriceValidated"] = this.isCostPriceValidated;
        data["costSuggestionBudgetId"] = this.costSuggestionBudgetId;
        data["costSuggestionBudgetReference"] = this.costSuggestionBudgetReference;
        data["note"] = this.note;
        data["internalTeamActive"] = this.internalTeamActive;
        data["internalTeamValue"] = this.internalTeamValue;
        data["internalTeamNotes"] = this.internalTeamNotes;
        data["subcontractorId"] = this.subcontractorId;
        if (Array.isArray(this.subcontractors)) {
            data["subcontractors"] = [];
            for (let item of this.subcontractors)
                data["subcontractors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBudgetLineDto {
    id?: number;
    areaName?: string;
    chapterName?: string;
    chapterNote?: string | undefined;
    code?: string;
    description?: string;
    unit?: string;
    quantity?: number;
    quantityFormula?: string | undefined;
    quantityFormulaNote?: string | undefined;
    unitPrice?: number;
    isPercentageOfWorkTotal?: boolean;
    percentageOfWorkTotal?: number | undefined;
    marginPercent?: number | undefined;
    costUnitPrice?: number | undefined;
    isCostPriceValidated?: boolean;
    costSuggestionBudgetId?: number | undefined;
    costSuggestionBudgetReference?: string | undefined;
    note?: string | undefined;
    internalTeamActive?: boolean;
    internalTeamValue?: number | undefined;
    internalTeamNotes?: string | undefined;
    subcontractorId?: number | undefined;
    subcontractors?: BudgetLineSubcontractorDto[];
    suppliers?: BudgetLineSupplierDto[];
    materials?: BudgetLineMaterialDto[];
}

export class BudgetLineSubcontractorDto implements IBudgetLineSubcontractorDto {
    id?: number;
    subcontractorId?: number;
    subcontractorName?: string | undefined;
    description?: string;
    value?: number;

    constructor(data?: IBudgetLineSubcontractorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subcontractorId = _data["subcontractorId"];
            this.subcontractorName = _data["subcontractorName"];
            this.description = _data["description"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BudgetLineSubcontractorDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetLineSubcontractorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subcontractorId"] = this.subcontractorId;
        data["subcontractorName"] = this.subcontractorName;
        data["description"] = this.description;
        data["value"] = this.value;
        return data;
    }
}

export interface IBudgetLineSubcontractorDto {
    id?: number;
    subcontractorId?: number;
    subcontractorName?: string | undefined;
    description?: string;
    value?: number;
}

export class BudgetLineSupplierDto implements IBudgetLineSupplierDto {
    id?: number;
    supplierId?: number;
    supplierName?: string | undefined;
    description?: string;
    quantity?: number | undefined;
    unitPrice?: number | undefined;
    value?: number;

    constructor(data?: IBudgetLineSupplierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BudgetLineSupplierDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetLineSupplierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["value"] = this.value;
        return data;
    }
}

export interface IBudgetLineSupplierDto {
    id?: number;
    supplierId?: number;
    supplierName?: string | undefined;
    description?: string;
    quantity?: number | undefined;
    unitPrice?: number | undefined;
    value?: number;
}

export class BudgetLineMaterialDto implements IBudgetLineMaterialDto {
    id?: number;
    description?: string;
    quantity?: number | undefined;
    unitPrice?: number | undefined;
    value?: number;

    constructor(data?: IBudgetLineMaterialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BudgetLineMaterialDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetLineMaterialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["value"] = this.value;
        return data;
    }
}

export interface IBudgetLineMaterialDto {
    id?: number;
    description?: string;
    quantity?: number | undefined;
    unitPrice?: number | undefined;
    value?: number;
}

export class BudgetVersionDto implements IBudgetVersionDto {
    id?: number;
    versionNumber?: number;
    versionLabel?: string | undefined;
    isActiveVersion?: boolean;
    status?: string;
    totalAmount?: number | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    created?: Date;

    constructor(data?: IBudgetVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.versionNumber = _data["versionNumber"];
            this.versionLabel = _data["versionLabel"];
            this.isActiveVersion = _data["isActiveVersion"];
            this.status = _data["status"];
            this.totalAmount = _data["totalAmount"];
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BudgetVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["versionNumber"] = this.versionNumber;
        data["versionLabel"] = this.versionLabel;
        data["isActiveVersion"] = this.isActiveVersion;
        data["status"] = this.status;
        data["totalAmount"] = this.totalAmount;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        return data;
    }
}

export interface IBudgetVersionDto {
    id?: number;
    versionNumber?: number;
    versionLabel?: string | undefined;
    isActiveVersion?: boolean;
    status?: string;
    totalAmount?: number | undefined;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    created?: Date;
}

export class CreateBudgetCommand implements ICreateBudgetCommand {
    reference?: string;
    versionLabel?: string | undefined;
    clientId?: number | undefined;
    workId?: number | undefined;
    workName?: string;
    responsible?: string | undefined;
    orderReference?: string | undefined;
    vatRate?: number;
    totalAmount?: number | undefined;
    workArea?: number | undefined;
    rejectionReason?: string | undefined;
    lines?: BudgetLineDto[] | undefined;
    documents?: BudgetDocumentDto[] | undefined;

    constructor(data?: ICreateBudgetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reference = _data["reference"];
            this.versionLabel = _data["versionLabel"];
            this.clientId = _data["clientId"];
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.responsible = _data["responsible"];
            this.orderReference = _data["orderReference"];
            this.vatRate = _data["vatRate"];
            this.totalAmount = _data["totalAmount"];
            this.workArea = _data["workArea"];
            this.rejectionReason = _data["rejectionReason"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(BudgetLineDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(BudgetDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateBudgetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBudgetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["versionLabel"] = this.versionLabel;
        data["clientId"] = this.clientId;
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["responsible"] = this.responsible;
        data["orderReference"] = this.orderReference;
        data["vatRate"] = this.vatRate;
        data["totalAmount"] = this.totalAmount;
        data["workArea"] = this.workArea;
        data["rejectionReason"] = this.rejectionReason;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateBudgetCommand {
    reference?: string;
    versionLabel?: string | undefined;
    clientId?: number | undefined;
    workId?: number | undefined;
    workName?: string;
    responsible?: string | undefined;
    orderReference?: string | undefined;
    vatRate?: number;
    totalAmount?: number | undefined;
    workArea?: number | undefined;
    rejectionReason?: string | undefined;
    lines?: BudgetLineDto[] | undefined;
    documents?: BudgetDocumentDto[] | undefined;
}

export class CreateBudgetFromWorkTypeCommand implements ICreateBudgetFromWorkTypeCommand {
    workTypeId?: number;
    workArea?: number;
    workName?: string;
    clientId?: number | undefined;
    responsible?: string | undefined;
    orderReference?: string | undefined;

    constructor(data?: ICreateBudgetFromWorkTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workTypeId = _data["workTypeId"];
            this.workArea = _data["workArea"];
            this.workName = _data["workName"];
            this.clientId = _data["clientId"];
            this.responsible = _data["responsible"];
            this.orderReference = _data["orderReference"];
        }
    }

    static fromJS(data: any): CreateBudgetFromWorkTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBudgetFromWorkTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workTypeId"] = this.workTypeId;
        data["workArea"] = this.workArea;
        data["workName"] = this.workName;
        data["clientId"] = this.clientId;
        data["responsible"] = this.responsible;
        data["orderReference"] = this.orderReference;
        return data;
    }
}

export interface ICreateBudgetFromWorkTypeCommand {
    workTypeId?: number;
    workArea?: number;
    workName?: string;
    clientId?: number | undefined;
    responsible?: string | undefined;
    orderReference?: string | undefined;
}

export class UpdateBudgetCommand implements IUpdateBudgetCommand {
    id?: number;
    reference?: string;
    versionLabel?: string | undefined;
    clientId?: number | undefined;
    workId?: number | undefined;
    workName?: string;
    responsible?: string | undefined;
    orderReference?: string | undefined;
    vatRate?: number;
    totalAmount?: number | undefined;
    workArea?: number | undefined;
    rejectionReason?: string | undefined;
    lines?: BudgetLineDto[] | undefined;
    documents?: BudgetDocumentDto[] | undefined;

    constructor(data?: IUpdateBudgetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reference = _data["reference"];
            this.versionLabel = _data["versionLabel"];
            this.clientId = _data["clientId"];
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.responsible = _data["responsible"];
            this.orderReference = _data["orderReference"];
            this.vatRate = _data["vatRate"];
            this.totalAmount = _data["totalAmount"];
            this.workArea = _data["workArea"];
            this.rejectionReason = _data["rejectionReason"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(BudgetLineDto.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(BudgetDocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateBudgetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reference"] = this.reference;
        data["versionLabel"] = this.versionLabel;
        data["clientId"] = this.clientId;
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["responsible"] = this.responsible;
        data["orderReference"] = this.orderReference;
        data["vatRate"] = this.vatRate;
        data["totalAmount"] = this.totalAmount;
        data["workArea"] = this.workArea;
        data["rejectionReason"] = this.rejectionReason;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateBudgetCommand {
    id?: number;
    reference?: string;
    versionLabel?: string | undefined;
    clientId?: number | undefined;
    workId?: number | undefined;
    workName?: string;
    responsible?: string | undefined;
    orderReference?: string | undefined;
    vatRate?: number;
    totalAmount?: number | undefined;
    workArea?: number | undefined;
    rejectionReason?: string | undefined;
    lines?: BudgetLineDto[] | undefined;
    documents?: BudgetDocumentDto[] | undefined;
}

export class UpdateBudgetStatusCommand implements IUpdateBudgetStatusCommand {
    budgetId?: number;
    status?: string;
    rejectionReason?: string | undefined;

    constructor(data?: IUpdateBudgetStatusCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetId = _data["budgetId"];
            this.status = _data["status"];
            this.rejectionReason = _data["rejectionReason"];
        }
    }

    static fromJS(data: any): UpdateBudgetStatusCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetStatusCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetId"] = this.budgetId;
        data["status"] = this.status;
        data["rejectionReason"] = this.rejectionReason;
        return data;
    }
}

export interface IUpdateBudgetStatusCommand {
    budgetId?: number;
    status?: string;
    rejectionReason?: string | undefined;
}

export class CreateBudgetVersionCommand implements ICreateBudgetVersionCommand {
    budgetId?: number;
    sourceBudgetId?: number | undefined;
    versionLabel?: string | undefined;

    constructor(data?: ICreateBudgetVersionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetId = _data["budgetId"];
            this.sourceBudgetId = _data["sourceBudgetId"];
            this.versionLabel = _data["versionLabel"];
        }
    }

    static fromJS(data: any): CreateBudgetVersionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBudgetVersionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetId"] = this.budgetId;
        data["sourceBudgetId"] = this.sourceBudgetId;
        data["versionLabel"] = this.versionLabel;
        return data;
    }
}

export interface ICreateBudgetVersionCommand {
    budgetId?: number;
    sourceBudgetId?: number | undefined;
    versionLabel?: string | undefined;
}

export class BudgetQuantityImportJobCreatedDto implements IBudgetQuantityImportJobCreatedDto {
    jobId?: string;

    constructor(data?: IBudgetQuantityImportJobCreatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
        }
    }

    static fromJS(data: any): BudgetQuantityImportJobCreatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetQuantityImportJobCreatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        return data;
    }
}

export interface IBudgetQuantityImportJobCreatedDto {
    jobId?: string;
}

export class ExtractBudgetDocumentsResult implements IExtractBudgetDocumentsResult {
    documentCount?: number;

    constructor(data?: IExtractBudgetDocumentsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentCount = _data["documentCount"];
        }
    }

    static fromJS(data: any): ExtractBudgetDocumentsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractBudgetDocumentsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentCount"] = this.documentCount;
        return data;
    }
}

export interface IExtractBudgetDocumentsResult {
    documentCount?: number;
}

export class BudgetLineCostSuggestionDto implements IBudgetLineCostSuggestionDto {
    budgetId?: number;
    budgetReference?: string;
    budgetDate?: Date;
    clientName?: string;
    workName?: string;
    lineCode?: string;
    lineDescription?: string;
    unit?: string;
    costUnitPrice?: number;
    margin?: number | undefined;

    constructor(data?: IBudgetLineCostSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetId = _data["budgetId"];
            this.budgetReference = _data["budgetReference"];
            this.budgetDate = _data["budgetDate"] ? new Date(_data["budgetDate"].toString()) : undefined as any;
            this.clientName = _data["clientName"];
            this.workName = _data["workName"];
            this.lineCode = _data["lineCode"];
            this.lineDescription = _data["lineDescription"];
            this.unit = _data["unit"];
            this.costUnitPrice = _data["costUnitPrice"];
            this.margin = _data["margin"];
        }
    }

    static fromJS(data: any): BudgetLineCostSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetLineCostSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetId"] = this.budgetId;
        data["budgetReference"] = this.budgetReference;
        data["budgetDate"] = this.budgetDate ? this.budgetDate.toISOString() : undefined as any;
        data["clientName"] = this.clientName;
        data["workName"] = this.workName;
        data["lineCode"] = this.lineCode;
        data["lineDescription"] = this.lineDescription;
        data["unit"] = this.unit;
        data["costUnitPrice"] = this.costUnitPrice;
        data["margin"] = this.margin;
        return data;
    }
}

export interface IBudgetLineCostSuggestionDto {
    budgetId?: number;
    budgetReference?: string;
    budgetDate?: Date;
    clientName?: string;
    workName?: string;
    lineCode?: string;
    lineDescription?: string;
    unit?: string;
    costUnitPrice?: number;
    margin?: number | undefined;
}

export class BudgetChapterTypeDto implements IBudgetChapterTypeDto {
    id?: number;
    budgetAreaTypeId?: number;
    code?: string;
    name?: string;
    sortOrder?: number;

    constructor(data?: IBudgetChapterTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.budgetAreaTypeId = _data["budgetAreaTypeId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): BudgetChapterTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetChapterTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["budgetAreaTypeId"] = this.budgetAreaTypeId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IBudgetChapterTypeDto {
    id?: number;
    budgetAreaTypeId?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
}

export class CreateBudgetChapterTypeCommand implements ICreateBudgetChapterTypeCommand {
    budgetAreaTypeId?: number;
    code?: string | undefined;
    name?: string;
    sortOrder?: number | undefined;

    constructor(data?: ICreateBudgetChapterTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.budgetAreaTypeId = _data["budgetAreaTypeId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreateBudgetChapterTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBudgetChapterTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["budgetAreaTypeId"] = this.budgetAreaTypeId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICreateBudgetChapterTypeCommand {
    budgetAreaTypeId?: number;
    code?: string | undefined;
    name?: string;
    sortOrder?: number | undefined;
}

export class UpdateBudgetChapterTypeCommand implements IUpdateBudgetChapterTypeCommand {
    id?: number;
    budgetAreaTypeId?: number;
    code?: string;
    name?: string;
    sortOrder?: number;

    constructor(data?: IUpdateBudgetChapterTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.budgetAreaTypeId = _data["budgetAreaTypeId"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UpdateBudgetChapterTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetChapterTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["budgetAreaTypeId"] = this.budgetAreaTypeId;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUpdateBudgetChapterTypeCommand {
    id?: number;
    budgetAreaTypeId?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
}

export class BudgetAreaTypeDto implements IBudgetAreaTypeDto {
    id?: number;
    name?: string;
    sortOrder?: number;

    constructor(data?: IBudgetAreaTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): BudgetAreaTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetAreaTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IBudgetAreaTypeDto {
    id?: number;
    name?: string;
    sortOrder?: number;
}

export class CreateBudgetAreaTypeCommand implements ICreateBudgetAreaTypeCommand {
    name?: string;
    sortOrder?: number | undefined;

    constructor(data?: ICreateBudgetAreaTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreateBudgetAreaTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBudgetAreaTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICreateBudgetAreaTypeCommand {
    name?: string;
    sortOrder?: number | undefined;
}

export class UpdateBudgetAreaTypeCommand implements IUpdateBudgetAreaTypeCommand {
    id?: number;
    name?: string;
    sortOrder?: number;

    constructor(data?: IUpdateBudgetAreaTypeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UpdateBudgetAreaTypeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetAreaTypeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUpdateBudgetAreaTypeCommand {
    id?: number;
    name?: string;
    sortOrder?: number;
}

export class BillingMilestoneDto implements IBillingMilestoneDto {
    id?: number;
    workId?: number;
    workName?: string;
    description?: string;
    percentage?: number | undefined;
    value?: number | undefined;
    expectedDate?: Date | undefined;
    invoiceId?: number | undefined;
    invoiceNumber?: string | undefined;
    isBilled?: boolean;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IBillingMilestoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.workName = _data["workName"];
            this.description = _data["description"];
            this.percentage = _data["percentage"];
            this.value = _data["value"];
            this.expectedDate = _data["expectedDate"] ? new Date(_data["expectedDate"].toString()) : undefined as any;
            this.invoiceId = _data["invoiceId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.isBilled = _data["isBilled"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BillingMilestoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillingMilestoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["workName"] = this.workName;
        data["description"] = this.description;
        data["percentage"] = this.percentage;
        data["value"] = this.value;
        data["expectedDate"] = this.expectedDate ? this.expectedDate.toISOString() : undefined as any;
        data["invoiceId"] = this.invoiceId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["isBilled"] = this.isBilled;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IBillingMilestoneDto {
    id?: number;
    workId?: number;
    workName?: string;
    description?: string;
    percentage?: number | undefined;
    value?: number | undefined;
    expectedDate?: Date | undefined;
    invoiceId?: number | undefined;
    invoiceNumber?: string | undefined;
    isBilled?: boolean;
    created?: Date;
    lastModified?: Date;
}

export class CreateBillingMilestoneCommand implements ICreateBillingMilestoneCommand {
    workId?: number;
    description?: string;
    percentage?: number | undefined;
    value?: number | undefined;
    expectedDate?: Date | undefined;

    constructor(data?: ICreateBillingMilestoneCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workId = _data["workId"];
            this.description = _data["description"];
            this.percentage = _data["percentage"];
            this.value = _data["value"];
            this.expectedDate = _data["expectedDate"] ? new Date(_data["expectedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateBillingMilestoneCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBillingMilestoneCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workId"] = this.workId;
        data["description"] = this.description;
        data["percentage"] = this.percentage;
        data["value"] = this.value;
        data["expectedDate"] = this.expectedDate ? this.expectedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateBillingMilestoneCommand {
    workId?: number;
    description?: string;
    percentage?: number | undefined;
    value?: number | undefined;
    expectedDate?: Date | undefined;
}

export class UpdateBillingMilestoneCommand implements IUpdateBillingMilestoneCommand {
    id?: number;
    workId?: number;
    description?: string;
    percentage?: number | undefined;
    value?: number | undefined;
    expectedDate?: Date | undefined;

    constructor(data?: IUpdateBillingMilestoneCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.workId = _data["workId"];
            this.description = _data["description"];
            this.percentage = _data["percentage"];
            this.value = _data["value"];
            this.expectedDate = _data["expectedDate"] ? new Date(_data["expectedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateBillingMilestoneCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBillingMilestoneCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["workId"] = this.workId;
        data["description"] = this.description;
        data["percentage"] = this.percentage;
        data["value"] = this.value;
        data["expectedDate"] = this.expectedDate ? this.expectedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IUpdateBillingMilestoneCommand {
    id?: number;
    workId?: number;
    description?: string;
    percentage?: number | undefined;
    value?: number | undefined;
    expectedDate?: Date | undefined;
}

export class SuggestionsVm implements ISuggestionsVm {
    bankMovementId?: number;
    movementAmount?: number;
    movementRemaining?: number;
    movementDate?: Date;
    direction?: string;
    suggestions?: ReconciliationSuggestionDto[];

    constructor(data?: ISuggestionsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankMovementId = _data["bankMovementId"];
            this.movementAmount = _data["movementAmount"];
            this.movementRemaining = _data["movementRemaining"];
            this.movementDate = _data["movementDate"] ? new Date(_data["movementDate"].toString()) : undefined as any;
            this.direction = _data["direction"];
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(ReconciliationSuggestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SuggestionsVm {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankMovementId"] = this.bankMovementId;
        data["movementAmount"] = this.movementAmount;
        data["movementRemaining"] = this.movementRemaining;
        data["movementDate"] = this.movementDate ? this.movementDate.toISOString() : undefined as any;
        data["direction"] = this.direction;
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISuggestionsVm {
    bankMovementId?: number;
    movementAmount?: number;
    movementRemaining?: number;
    movementDate?: Date;
    direction?: string;
    suggestions?: ReconciliationSuggestionDto[];
}

export class ReconciliationSuggestionDto implements IReconciliationSuggestionDto {
    targetKind?: string;
    targetId?: number;
    targetDisplayName?: string;
    invoiceNumber?: string | undefined;
    invoiceDate?: Date | undefined;
    outstandingAmount?: number;
    suggestedAmount?: number;
    score?: number;
    matchReason?: string;
    isCertain?: boolean;

    constructor(data?: IReconciliationSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetKind = _data["targetKind"];
            this.targetId = _data["targetId"];
            this.targetDisplayName = _data["targetDisplayName"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.outstandingAmount = _data["outstandingAmount"];
            this.suggestedAmount = _data["suggestedAmount"];
            this.score = _data["score"];
            this.matchReason = _data["matchReason"];
            this.isCertain = _data["isCertain"];
        }
    }

    static fromJS(data: any): ReconciliationSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReconciliationSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetKind"] = this.targetKind;
        data["targetId"] = this.targetId;
        data["targetDisplayName"] = this.targetDisplayName;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["outstandingAmount"] = this.outstandingAmount;
        data["suggestedAmount"] = this.suggestedAmount;
        data["score"] = this.score;
        data["matchReason"] = this.matchReason;
        data["isCertain"] = this.isCertain;
        return data;
    }
}

export interface IReconciliationSuggestionDto {
    targetKind?: string;
    targetId?: number;
    targetDisplayName?: string;
    invoiceNumber?: string | undefined;
    invoiceDate?: Date | undefined;
    outstandingAmount?: number;
    suggestedAmount?: number;
    score?: number;
    matchReason?: string;
    isCertain?: boolean;
}

export class AutoReconcileBankMovementsResult implements IAutoReconcileBankMovementsResult {
    linked?: number;

    constructor(data?: IAutoReconcileBankMovementsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linked = _data["linked"];
        }
    }

    static fromJS(data: any): AutoReconcileBankMovementsResult {
        data = typeof data === 'object' ? data : {};
        let result = new AutoReconcileBankMovementsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linked"] = this.linked;
        return data;
    }
}

export interface IAutoReconcileBankMovementsResult {
    linked?: number;
}

export class BankReconciliationDto implements IBankReconciliationDto {
    id?: number;
    bankMovementId?: number;
    targetKind?: string;
    targetId?: number;
    targetDisplayName?: string;
    targetInvoiceNumber?: string | undefined;
    targetInvoiceDate?: Date | undefined;
    targetTotalAmount?: number | undefined;
    targetOutstandingAmount?: number;
    allocatedAmount?: number;
    notes?: string | undefined;
    created?: Date;
    lastModified?: Date | undefined;

    constructor(data?: IBankReconciliationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankMovementId = _data["bankMovementId"];
            this.targetKind = _data["targetKind"];
            this.targetId = _data["targetId"];
            this.targetDisplayName = _data["targetDisplayName"];
            this.targetInvoiceNumber = _data["targetInvoiceNumber"];
            this.targetInvoiceDate = _data["targetInvoiceDate"] ? new Date(_data["targetInvoiceDate"].toString()) : undefined as any;
            this.targetTotalAmount = _data["targetTotalAmount"];
            this.targetOutstandingAmount = _data["targetOutstandingAmount"];
            this.allocatedAmount = _data["allocatedAmount"];
            this.notes = _data["notes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BankReconciliationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankReconciliationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankMovementId"] = this.bankMovementId;
        data["targetKind"] = this.targetKind;
        data["targetId"] = this.targetId;
        data["targetDisplayName"] = this.targetDisplayName;
        data["targetInvoiceNumber"] = this.targetInvoiceNumber;
        data["targetInvoiceDate"] = this.targetInvoiceDate ? this.targetInvoiceDate.toISOString() : undefined as any;
        data["targetTotalAmount"] = this.targetTotalAmount;
        data["targetOutstandingAmount"] = this.targetOutstandingAmount;
        data["allocatedAmount"] = this.allocatedAmount;
        data["notes"] = this.notes;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IBankReconciliationDto {
    id?: number;
    bankMovementId?: number;
    targetKind?: string;
    targetId?: number;
    targetDisplayName?: string;
    targetInvoiceNumber?: string | undefined;
    targetInvoiceDate?: Date | undefined;
    targetTotalAmount?: number | undefined;
    targetOutstandingAmount?: number;
    allocatedAmount?: number;
    notes?: string | undefined;
    created?: Date;
    lastModified?: Date | undefined;
}

export class CreateBankReconciliationCommand implements ICreateBankReconciliationCommand {
    bankMovementId?: number;
    targetKind?: string;
    targetId?: number;
    allocatedAmount?: number;
    notes?: string | undefined;

    constructor(data?: ICreateBankReconciliationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankMovementId = _data["bankMovementId"];
            this.targetKind = _data["targetKind"];
            this.targetId = _data["targetId"];
            this.allocatedAmount = _data["allocatedAmount"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateBankReconciliationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBankReconciliationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankMovementId"] = this.bankMovementId;
        data["targetKind"] = this.targetKind;
        data["targetId"] = this.targetId;
        data["allocatedAmount"] = this.allocatedAmount;
        data["notes"] = this.notes;
        return data;
    }
}

export interface ICreateBankReconciliationCommand {
    bankMovementId?: number;
    targetKind?: string;
    targetId?: number;
    allocatedAmount?: number;
    notes?: string | undefined;
}

export class BankMovementListVm implements IBankMovementListVm {
    items?: BankMovementDto[];
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalCount?: number;
    totalInflow?: number;
    totalOutflow?: number;

    constructor(data?: IBankMovementListVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BankMovementDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.totalInflow = _data["totalInflow"];
            this.totalOutflow = _data["totalOutflow"];
        }
    }

    static fromJS(data: any): BankMovementListVm {
        data = typeof data === 'object' ? data : {};
        let result = new BankMovementListVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["totalInflow"] = this.totalInflow;
        data["totalOutflow"] = this.totalOutflow;
        return data;
    }
}

export interface IBankMovementListVm {
    items?: BankMovementDto[];
    pageNumber?: number;
    pageSize?: number;
    totalPages?: number;
    totalCount?: number;
    totalInflow?: number;
    totalOutflow?: number;
}

export class BankMovementDto implements IBankMovementDto {
    id?: number;
    movementDate?: Date;
    valueDate?: Date | undefined;
    description?: string;
    counterpartyName?: string | undefined;
    amount?: number;
    currencyCode?: string;
    balance?: number | undefined;
    accountLabel?: string | undefined;
    categoryId?: number | undefined;
    categoryCode?: string | undefined;
    categoryName?: string | undefined;
    isInternalTransfer?: boolean;
    isExcludedFromReconciliation?: boolean;
    isBankCharge?: boolean;
    isCategorizedManually?: boolean;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
    suggestedSupplierId?: number | undefined;
    suggestedSupplierName?: string | undefined;
    supplierMatchScore?: number | undefined;
    supplierMatchSource?: string | undefined;
    supplierMatchReason?: string | undefined;
    supplierNameHint?: string | undefined;
    isSupplierMatchedManually?: boolean;
    clientId?: number | undefined;
    isClientMatchedManually?: boolean;
    clientName?: string | undefined;
    reconciledAmount?: number;
    isFullyReconciled?: boolean;
    created?: Date;
    lastModified?: Date | undefined;

    constructor(data?: IBankMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.movementDate = _data["movementDate"] ? new Date(_data["movementDate"].toString()) : undefined as any;
            this.valueDate = _data["valueDate"] ? new Date(_data["valueDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.counterpartyName = _data["counterpartyName"];
            this.amount = _data["amount"];
            this.currencyCode = _data["currencyCode"];
            this.balance = _data["balance"];
            this.accountLabel = _data["accountLabel"];
            this.categoryId = _data["categoryId"];
            this.categoryCode = _data["categoryCode"];
            this.categoryName = _data["categoryName"];
            this.isInternalTransfer = _data["isInternalTransfer"];
            this.isExcludedFromReconciliation = _data["isExcludedFromReconciliation"];
            this.isBankCharge = _data["isBankCharge"];
            this.isCategorizedManually = _data["isCategorizedManually"];
            this.supplierId = _data["supplierId"];
            this.supplierName = _data["supplierName"];
            this.suggestedSupplierId = _data["suggestedSupplierId"];
            this.suggestedSupplierName = _data["suggestedSupplierName"];
            this.supplierMatchScore = _data["supplierMatchScore"];
            this.supplierMatchSource = _data["supplierMatchSource"];
            this.supplierMatchReason = _data["supplierMatchReason"];
            this.supplierNameHint = _data["supplierNameHint"];
            this.isSupplierMatchedManually = _data["isSupplierMatchedManually"];
            this.clientId = _data["clientId"];
            this.isClientMatchedManually = _data["isClientMatchedManually"];
            this.clientName = _data["clientName"];
            this.reconciledAmount = _data["reconciledAmount"];
            this.isFullyReconciled = _data["isFullyReconciled"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BankMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["movementDate"] = this.movementDate ? this.movementDate.toISOString() : undefined as any;
        data["valueDate"] = this.valueDate ? this.valueDate.toISOString() : undefined as any;
        data["description"] = this.description;
        data["counterpartyName"] = this.counterpartyName;
        data["amount"] = this.amount;
        data["currencyCode"] = this.currencyCode;
        data["balance"] = this.balance;
        data["accountLabel"] = this.accountLabel;
        data["categoryId"] = this.categoryId;
        data["categoryCode"] = this.categoryCode;
        data["categoryName"] = this.categoryName;
        data["isInternalTransfer"] = this.isInternalTransfer;
        data["isExcludedFromReconciliation"] = this.isExcludedFromReconciliation;
        data["isBankCharge"] = this.isBankCharge;
        data["isCategorizedManually"] = this.isCategorizedManually;
        data["supplierId"] = this.supplierId;
        data["supplierName"] = this.supplierName;
        data["suggestedSupplierId"] = this.suggestedSupplierId;
        data["suggestedSupplierName"] = this.suggestedSupplierName;
        data["supplierMatchScore"] = this.supplierMatchScore;
        data["supplierMatchSource"] = this.supplierMatchSource;
        data["supplierMatchReason"] = this.supplierMatchReason;
        data["supplierNameHint"] = this.supplierNameHint;
        data["isSupplierMatchedManually"] = this.isSupplierMatchedManually;
        data["clientId"] = this.clientId;
        data["isClientMatchedManually"] = this.isClientMatchedManually;
        data["clientName"] = this.clientName;
        data["reconciledAmount"] = this.reconciledAmount;
        data["isFullyReconciled"] = this.isFullyReconciled;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IBankMovementDto {
    id?: number;
    movementDate?: Date;
    valueDate?: Date | undefined;
    description?: string;
    counterpartyName?: string | undefined;
    amount?: number;
    currencyCode?: string;
    balance?: number | undefined;
    accountLabel?: string | undefined;
    categoryId?: number | undefined;
    categoryCode?: string | undefined;
    categoryName?: string | undefined;
    isInternalTransfer?: boolean;
    isExcludedFromReconciliation?: boolean;
    isBankCharge?: boolean;
    isCategorizedManually?: boolean;
    supplierId?: number | undefined;
    supplierName?: string | undefined;
    suggestedSupplierId?: number | undefined;
    suggestedSupplierName?: string | undefined;
    supplierMatchScore?: number | undefined;
    supplierMatchSource?: string | undefined;
    supplierMatchReason?: string | undefined;
    supplierNameHint?: string | undefined;
    isSupplierMatchedManually?: boolean;
    clientId?: number | undefined;
    isClientMatchedManually?: boolean;
    clientName?: string | undefined;
    reconciledAmount?: number;
    isFullyReconciled?: boolean;
    created?: Date;
    lastModified?: Date | undefined;
}

export class BankMovementCategoryDto implements IBankMovementCategoryDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;

    constructor(data?: IBankMovementCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): BankMovementCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankMovementCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IBankMovementCategoryDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
}

export class ImportBankMovementsResult implements IImportBankMovementsResult {
    importBatchId?: string;
    imported?: number;
    skippedDuplicates?: number;
    categorized?: number;
    internalTransfersFlagged?: number;
    bankChargesFlagged?: number;
    suppliersMatched?: number;
    rowErrors?: BankImportRowErrorDto[];
    movements?: BankMovementDto[];

    constructor(data?: IImportBankMovementsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importBatchId = _data["importBatchId"];
            this.imported = _data["imported"];
            this.skippedDuplicates = _data["skippedDuplicates"];
            this.categorized = _data["categorized"];
            this.internalTransfersFlagged = _data["internalTransfersFlagged"];
            this.bankChargesFlagged = _data["bankChargesFlagged"];
            this.suppliersMatched = _data["suppliersMatched"];
            if (Array.isArray(_data["rowErrors"])) {
                this.rowErrors = [] as any;
                for (let item of _data["rowErrors"])
                    this.rowErrors!.push(BankImportRowErrorDto.fromJS(item));
            }
            if (Array.isArray(_data["movements"])) {
                this.movements = [] as any;
                for (let item of _data["movements"])
                    this.movements!.push(BankMovementDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportBankMovementsResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportBankMovementsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importBatchId"] = this.importBatchId;
        data["imported"] = this.imported;
        data["skippedDuplicates"] = this.skippedDuplicates;
        data["categorized"] = this.categorized;
        data["internalTransfersFlagged"] = this.internalTransfersFlagged;
        data["bankChargesFlagged"] = this.bankChargesFlagged;
        data["suppliersMatched"] = this.suppliersMatched;
        if (Array.isArray(this.rowErrors)) {
            data["rowErrors"] = [];
            for (let item of this.rowErrors)
                data["rowErrors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.movements)) {
            data["movements"] = [];
            for (let item of this.movements)
                data["movements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportBankMovementsResult {
    importBatchId?: string;
    imported?: number;
    skippedDuplicates?: number;
    categorized?: number;
    internalTransfersFlagged?: number;
    bankChargesFlagged?: number;
    suppliersMatched?: number;
    rowErrors?: BankImportRowErrorDto[];
    movements?: BankMovementDto[];
}

export class BankImportRowErrorDto implements IBankImportRowErrorDto {
    line?: number;
    message?: string;

    constructor(data?: IBankImportRowErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.line = _data["line"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BankImportRowErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankImportRowErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["line"] = this.line;
        data["message"] = this.message;
        return data;
    }
}

export interface IBankImportRowErrorDto {
    line?: number;
    message?: string;
}

export class RecategorizeBankMovementsResult implements IRecategorizeBankMovementsResult {
    updated?: number;

    constructor(data?: IRecategorizeBankMovementsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updated = _data["updated"];
        }
    }

    static fromJS(data: any): RecategorizeBankMovementsResult {
        data = typeof data === 'object' ? data : {};
        let result = new RecategorizeBankMovementsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updated"] = this.updated;
        return data;
    }
}

export interface IRecategorizeBankMovementsResult {
    updated?: number;
}

export class CreateBankMovementCommand implements ICreateBankMovementCommand {
    movementDate?: Date;
    valueDate?: Date | undefined;
    description?: string;
    counterpartyName?: string | undefined;
    amount?: number;
    currencyCode?: string | undefined;
    balance?: number | undefined;
    accountLabel?: string | undefined;
    categoryId?: number | undefined;

    constructor(data?: ICreateBankMovementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.movementDate = _data["movementDate"] ? new Date(_data["movementDate"].toString()) : undefined as any;
            this.valueDate = _data["valueDate"] ? new Date(_data["valueDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.counterpartyName = _data["counterpartyName"];
            this.amount = _data["amount"];
            this.currencyCode = _data["currencyCode"];
            this.balance = _data["balance"];
            this.accountLabel = _data["accountLabel"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): CreateBankMovementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBankMovementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["movementDate"] = this.movementDate ? this.movementDate.toISOString() : undefined as any;
        data["valueDate"] = this.valueDate ? this.valueDate.toISOString() : undefined as any;
        data["description"] = this.description;
        data["counterpartyName"] = this.counterpartyName;
        data["amount"] = this.amount;
        data["currencyCode"] = this.currencyCode;
        data["balance"] = this.balance;
        data["accountLabel"] = this.accountLabel;
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface ICreateBankMovementCommand {
    movementDate?: Date;
    valueDate?: Date | undefined;
    description?: string;
    counterpartyName?: string | undefined;
    amount?: number;
    currencyCode?: string | undefined;
    balance?: number | undefined;
    accountLabel?: string | undefined;
    categoryId?: number | undefined;
}

export class UpdateBankMovementCommand implements IUpdateBankMovementCommand {
    id?: number;
    movementDate?: Date;
    valueDate?: Date | undefined;
    description?: string;
    counterpartyName?: string | undefined;
    amount?: number;
    currencyCode?: string | undefined;
    balance?: number | undefined;
    accountLabel?: string | undefined;
    categoryId?: number | undefined;

    constructor(data?: IUpdateBankMovementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.movementDate = _data["movementDate"] ? new Date(_data["movementDate"].toString()) : undefined as any;
            this.valueDate = _data["valueDate"] ? new Date(_data["valueDate"].toString()) : undefined as any;
            this.description = _data["description"];
            this.counterpartyName = _data["counterpartyName"];
            this.amount = _data["amount"];
            this.currencyCode = _data["currencyCode"];
            this.balance = _data["balance"];
            this.accountLabel = _data["accountLabel"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): UpdateBankMovementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBankMovementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["movementDate"] = this.movementDate ? this.movementDate.toISOString() : undefined as any;
        data["valueDate"] = this.valueDate ? this.valueDate.toISOString() : undefined as any;
        data["description"] = this.description;
        data["counterpartyName"] = this.counterpartyName;
        data["amount"] = this.amount;
        data["currencyCode"] = this.currencyCode;
        data["balance"] = this.balance;
        data["accountLabel"] = this.accountLabel;
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface IUpdateBankMovementCommand {
    id?: number;
    movementDate?: Date;
    valueDate?: Date | undefined;
    description?: string;
    counterpartyName?: string | undefined;
    amount?: number;
    currencyCode?: string | undefined;
    balance?: number | undefined;
    accountLabel?: string | undefined;
    categoryId?: number | undefined;
}

export class BankMovementEntityResult implements IBankMovementEntityResult {
    movement?: BankMovementDto;
    alsoAssociated?: number;
    categorized?: number;
    autoReconciled?: number;

    constructor(data?: IBankMovementEntityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.movement = _data["movement"] ? BankMovementDto.fromJS(_data["movement"]) : undefined as any;
            this.alsoAssociated = _data["alsoAssociated"];
            this.categorized = _data["categorized"];
            this.autoReconciled = _data["autoReconciled"];
        }
    }

    static fromJS(data: any): BankMovementEntityResult {
        data = typeof data === 'object' ? data : {};
        let result = new BankMovementEntityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["movement"] = this.movement ? this.movement.toJSON() : undefined as any;
        data["alsoAssociated"] = this.alsoAssociated;
        data["categorized"] = this.categorized;
        data["autoReconciled"] = this.autoReconciled;
        return data;
    }
}

export interface IBankMovementEntityResult {
    movement?: BankMovementDto;
    alsoAssociated?: number;
    categorized?: number;
    autoReconciled?: number;
}

export class CategorizeBankMovementCommand implements ICategorizeBankMovementCommand {
    id?: number;
    categoryId?: number;

    constructor(data?: ICategorizeBankMovementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.categoryId = _data["categoryId"];
        }
    }

    static fromJS(data: any): CategorizeBankMovementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CategorizeBankMovementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["categoryId"] = this.categoryId;
        return data;
    }
}

export interface ICategorizeBankMovementCommand {
    id?: number;
    categoryId?: number;
}

export class MatchBankMovementSupplierCommand implements IMatchBankMovementSupplierCommand {
    id?: number;
    supplierId?: number | undefined;

    constructor(data?: IMatchBankMovementSupplierCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supplierId = _data["supplierId"];
        }
    }

    static fromJS(data: any): MatchBankMovementSupplierCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MatchBankMovementSupplierCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supplierId"] = this.supplierId;
        return data;
    }
}

export interface IMatchBankMovementSupplierCommand {
    id?: number;
    supplierId?: number | undefined;
}

export class CreateSupplierFromBankMovementCommand implements ICreateSupplierFromBankMovementCommand {
    id?: number;
    name?: string;

    constructor(data?: ICreateSupplierFromBankMovementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateSupplierFromBankMovementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSupplierFromBankMovementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateSupplierFromBankMovementCommand {
    id?: number;
    name?: string;
}

export class MatchBankMovementClientCommand implements IMatchBankMovementClientCommand {
    id?: number;
    clientId?: number | undefined;

    constructor(data?: IMatchBankMovementClientCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): MatchBankMovementClientCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MatchBankMovementClientCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IMatchBankMovementClientCommand {
    id?: number;
    clientId?: number | undefined;
}

export class SetBankMovementReconciliationExclusionCommand implements ISetBankMovementReconciliationExclusionCommand {
    id?: number;
    excluded?: boolean;

    constructor(data?: ISetBankMovementReconciliationExclusionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.excluded = _data["excluded"];
        }
    }

    static fromJS(data: any): SetBankMovementReconciliationExclusionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetBankMovementReconciliationExclusionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["excluded"] = this.excluded;
        return data;
    }
}

export interface ISetBankMovementReconciliationExclusionCommand {
    id?: number;
    excluded?: boolean;
}

export class CreateClientFromBankMovementCommand implements ICreateClientFromBankMovementCommand {
    id?: number;
    name?: string;

    constructor(data?: ICreateClientFromBankMovementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateClientFromBankMovementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClientFromBankMovementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateClientFromBankMovementCommand {
    id?: number;
    name?: string;
}

export class RecognizeBankMovementSuppliersResult implements IRecognizeBankMovementSuppliersResult {
    examined?: number;
    matched?: number;
    hinted?: number;

    constructor(data?: IRecognizeBankMovementSuppliersResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examined = _data["examined"];
            this.matched = _data["matched"];
            this.hinted = _data["hinted"];
        }
    }

    static fromJS(data: any): RecognizeBankMovementSuppliersResult {
        data = typeof data === 'object' ? data : {};
        let result = new RecognizeBankMovementSuppliersResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examined"] = this.examined;
        data["matched"] = this.matched;
        data["hinted"] = this.hinted;
        return data;
    }
}

export interface IRecognizeBankMovementSuppliersResult {
    examined?: number;
    matched?: number;
    hinted?: number;
}

export class BankMovementEntityResolution implements IBankMovementEntityResolution {
    suppliersLinked?: number;
    clientsLinked?: number;
    categoriesApplied?: number;
    autoReconciled?: number;

    constructor(data?: IBankMovementEntityResolution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.suppliersLinked = _data["suppliersLinked"];
            this.clientsLinked = _data["clientsLinked"];
            this.categoriesApplied = _data["categoriesApplied"];
            this.autoReconciled = _data["autoReconciled"];
        }
    }

    static fromJS(data: any): BankMovementEntityResolution {
        data = typeof data === 'object' ? data : {};
        let result = new BankMovementEntityResolution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["suppliersLinked"] = this.suppliersLinked;
        data["clientsLinked"] = this.clientsLinked;
        data["categoriesApplied"] = this.categoriesApplied;
        data["autoReconciled"] = this.autoReconciled;
        return data;
    }
}

export interface IBankMovementEntityResolution {
    suppliersLinked?: number;
    clientsLinked?: number;
    categoriesApplied?: number;
    autoReconciled?: number;
}

export class BankSyncRunDto implements IBankSyncRunDto {
    id?: number;
    startedAt?: Date;
    finishedAt?: Date | undefined;
    trigger?: string;
    succeeded?: boolean;
    error?: string | undefined;
    accountsCreated?: number;
    accountsUpdated?: number;
    movementsCreated?: number;
    movementsUpdated?: number;
    suppliersMatched?: number;
    clientsMatched?: number;
    movementsPendingRecognition?: number;
    movementsAutoReconciled?: number;
    triggeredBy?: string | undefined;

    constructor(data?: IBankSyncRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            this.finishedAt = _data["finishedAt"] ? new Date(_data["finishedAt"].toString()) : undefined as any;
            this.trigger = _data["trigger"];
            this.succeeded = _data["succeeded"];
            this.error = _data["error"];
            this.accountsCreated = _data["accountsCreated"];
            this.accountsUpdated = _data["accountsUpdated"];
            this.movementsCreated = _data["movementsCreated"];
            this.movementsUpdated = _data["movementsUpdated"];
            this.suppliersMatched = _data["suppliersMatched"];
            this.clientsMatched = _data["clientsMatched"];
            this.movementsPendingRecognition = _data["movementsPendingRecognition"];
            this.movementsAutoReconciled = _data["movementsAutoReconciled"];
            this.triggeredBy = _data["triggeredBy"];
        }
    }

    static fromJS(data: any): BankSyncRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankSyncRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : undefined as any;
        data["trigger"] = this.trigger;
        data["succeeded"] = this.succeeded;
        data["error"] = this.error;
        data["accountsCreated"] = this.accountsCreated;
        data["accountsUpdated"] = this.accountsUpdated;
        data["movementsCreated"] = this.movementsCreated;
        data["movementsUpdated"] = this.movementsUpdated;
        data["suppliersMatched"] = this.suppliersMatched;
        data["clientsMatched"] = this.clientsMatched;
        data["movementsPendingRecognition"] = this.movementsPendingRecognition;
        data["movementsAutoReconciled"] = this.movementsAutoReconciled;
        data["triggeredBy"] = this.triggeredBy;
        return data;
    }
}

export interface IBankSyncRunDto {
    id?: number;
    startedAt?: Date;
    finishedAt?: Date | undefined;
    trigger?: string;
    succeeded?: boolean;
    error?: string | undefined;
    accountsCreated?: number;
    accountsUpdated?: number;
    movementsCreated?: number;
    movementsUpdated?: number;
    suppliersMatched?: number;
    clientsMatched?: number;
    movementsPendingRecognition?: number;
    movementsAutoReconciled?: number;
    triggeredBy?: string | undefined;
}

export class SyncBankMovementsResult implements ISyncBankMovementsResult {
    succeeded?: boolean;
    error?: string | undefined;
    syncedAt?: Date | undefined;
    accountsCreated?: number;
    accountsUpdated?: number;
    movementsCreated?: number;
    movementsUpdated?: number;
    movementsSkippedVoid?: number;
    suppliersMatched?: number;
    clientsMatched?: number;
    movementsPendingRecognition?: number;
    movementsAutoReconciled?: number;
    legacyMovementsInWindow?: number;

    constructor(data?: ISyncBankMovementsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.error = _data["error"];
            this.syncedAt = _data["syncedAt"] ? new Date(_data["syncedAt"].toString()) : undefined as any;
            this.accountsCreated = _data["accountsCreated"];
            this.accountsUpdated = _data["accountsUpdated"];
            this.movementsCreated = _data["movementsCreated"];
            this.movementsUpdated = _data["movementsUpdated"];
            this.movementsSkippedVoid = _data["movementsSkippedVoid"];
            this.suppliersMatched = _data["suppliersMatched"];
            this.clientsMatched = _data["clientsMatched"];
            this.movementsPendingRecognition = _data["movementsPendingRecognition"];
            this.movementsAutoReconciled = _data["movementsAutoReconciled"];
            this.legacyMovementsInWindow = _data["legacyMovementsInWindow"];
        }
    }

    static fromJS(data: any): SyncBankMovementsResult {
        data = typeof data === 'object' ? data : {};
        let result = new SyncBankMovementsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["error"] = this.error;
        data["syncedAt"] = this.syncedAt ? this.syncedAt.toISOString() : undefined as any;
        data["accountsCreated"] = this.accountsCreated;
        data["accountsUpdated"] = this.accountsUpdated;
        data["movementsCreated"] = this.movementsCreated;
        data["movementsUpdated"] = this.movementsUpdated;
        data["movementsSkippedVoid"] = this.movementsSkippedVoid;
        data["suppliersMatched"] = this.suppliersMatched;
        data["clientsMatched"] = this.clientsMatched;
        data["movementsPendingRecognition"] = this.movementsPendingRecognition;
        data["movementsAutoReconciled"] = this.movementsAutoReconciled;
        data["legacyMovementsInWindow"] = this.legacyMovementsInWindow;
        return data;
    }
}

export interface ISyncBankMovementsResult {
    succeeded?: boolean;
    error?: string | undefined;
    syncedAt?: Date | undefined;
    accountsCreated?: number;
    accountsUpdated?: number;
    movementsCreated?: number;
    movementsUpdated?: number;
    movementsSkippedVoid?: number;
    suppliersMatched?: number;
    clientsMatched?: number;
    movementsPendingRecognition?: number;
    movementsAutoReconciled?: number;
    legacyMovementsInWindow?: number;
}

export class SyncBankMovementsCommand implements ISyncBankMovementsCommand {
    fullResync?: boolean;

    constructor(data?: ISyncBankMovementsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullResync = _data["fullResync"];
        }
    }

    static fromJS(data: any): SyncBankMovementsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SyncBankMovementsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullResync"] = this.fullResync;
        return data;
    }
}

export interface ISyncBankMovementsCommand {
    fullResync?: boolean;
}

export class BankAccountDto implements IBankAccountDto {
    id?: number;
    name?: string;
    bankAccountNumber?: string | undefined;
    accountType?: string | undefined;
    currencyCode?: string;
    currentBalance?: number | undefined;
    balanceUpdatedAt?: Date | undefined;
    isBankSync?: boolean;
    isArchived?: boolean;
    color?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
    lastSyncedAt?: Date | undefined;
    externalSource?: string | undefined;
    movementCount?: number;
    lastMovementDate?: Date | undefined;

    constructor(data?: IBankAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.accountType = _data["accountType"];
            this.currencyCode = _data["currencyCode"];
            this.currentBalance = _data["currentBalance"];
            this.balanceUpdatedAt = _data["balanceUpdatedAt"] ? new Date(_data["balanceUpdatedAt"].toString()) : undefined as any;
            this.isBankSync = _data["isBankSync"];
            this.isArchived = _data["isArchived"];
            this.color = _data["color"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.lastSyncedAt = _data["lastSyncedAt"] ? new Date(_data["lastSyncedAt"].toString()) : undefined as any;
            this.externalSource = _data["externalSource"];
            this.movementCount = _data["movementCount"];
            this.lastMovementDate = _data["lastMovementDate"] ? new Date(_data["lastMovementDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BankAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["accountType"] = this.accountType;
        data["currencyCode"] = this.currencyCode;
        data["currentBalance"] = this.currentBalance;
        data["balanceUpdatedAt"] = this.balanceUpdatedAt ? this.balanceUpdatedAt.toISOString() : undefined as any;
        data["isBankSync"] = this.isBankSync;
        data["isArchived"] = this.isArchived;
        data["color"] = this.color;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["lastSyncedAt"] = this.lastSyncedAt ? this.lastSyncedAt.toISOString() : undefined as any;
        data["externalSource"] = this.externalSource;
        data["movementCount"] = this.movementCount;
        data["lastMovementDate"] = this.lastMovementDate ? this.lastMovementDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IBankAccountDto {
    id?: number;
    name?: string;
    bankAccountNumber?: string | undefined;
    accountType?: string | undefined;
    currencyCode?: string;
    currentBalance?: number | undefined;
    balanceUpdatedAt?: Date | undefined;
    isBankSync?: boolean;
    isArchived?: boolean;
    color?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
    lastSyncedAt?: Date | undefined;
    externalSource?: string | undefined;
    movementCount?: number;
    lastMovementDate?: Date | undefined;
}

export class UpdateBankAccountCommand implements IUpdateBankAccountCommand {
    id?: number;
    companyId?: number | undefined;

    constructor(data?: IUpdateBankAccountCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyId = _data["companyId"];
        }
    }

    static fromJS(data: any): UpdateBankAccountCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBankAccountCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyId"] = this.companyId;
        return data;
    }
}

export interface IUpdateBankAccountCommand {
    id?: number;
    companyId?: number | undefined;
}

export class AuthLoginResponse implements IAuthLoginResponse {
    ok?: boolean;

    constructor(data?: IAuthLoginResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AuthLoginResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLoginResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAuthLoginResponse {
    ok?: boolean;
}

export class AuthLoginRequest implements IAuthLoginRequest {
    email?: string;
    password?: string;

    constructor(data?: IAuthLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IAuthLoginRequest {
    email?: string;
    password?: string;
}

export class AuthLogoutResponse implements IAuthLogoutResponse {
    ok?: boolean;

    constructor(data?: IAuthLogoutResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AuthLogoutResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLogoutResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAuthLogoutResponse {
    ok?: boolean;
}

export class AuthLogoutRequest implements IAuthLogoutRequest {
    refreshToken?: string;

    constructor(data?: IAuthLogoutRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): AuthLogoutRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLogoutRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IAuthLogoutRequest {
    refreshToken?: string;
}

export class AuthMeResponse implements IAuthMeResponse {
    isAuthenticated?: boolean;
    email?: string | undefined;
    userId?: string | undefined;
    emailConfirmed?: boolean | undefined;
    roles?: string[] | undefined;
    features?: string[] | undefined;

    constructor(data?: IAuthMeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthenticated = _data["isAuthenticated"];
            this.email = _data["email"];
            this.userId = _data["userId"];
            this.emailConfirmed = _data["emailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(item);
            }
        }
    }

    static fromJS(data: any): AuthMeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthMeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthenticated"] = this.isAuthenticated;
        data["email"] = this.email;
        data["userId"] = this.userId;
        data["emailConfirmed"] = this.emailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        return data;
    }
}

export interface IAuthMeResponse {
    isAuthenticated?: boolean;
    email?: string | undefined;
    userId?: string | undefined;
    emailConfirmed?: boolean | undefined;
    roles?: string[] | undefined;
    features?: string[] | undefined;
}

export class AuthForgotPasswordResponse implements IAuthForgotPasswordResponse {
    ok?: boolean;
    resetToken?: string | undefined;

    constructor(data?: IAuthForgotPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
            this.resetToken = _data["resetToken"];
        }
    }

    static fromJS(data: any): AuthForgotPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthForgotPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        data["resetToken"] = this.resetToken;
        return data;
    }
}

export interface IAuthForgotPasswordResponse {
    ok?: boolean;
    resetToken?: string | undefined;
}

export class AuthForgotPasswordRequest implements IAuthForgotPasswordRequest {
    email?: string;

    constructor(data?: IAuthForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AuthForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IAuthForgotPasswordRequest {
    email?: string;
}

export class AuthResetPasswordResponse implements IAuthResetPasswordResponse {
    ok?: boolean;

    constructor(data?: IAuthResetPasswordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ok = _data["ok"];
        }
    }

    static fromJS(data: any): AuthResetPasswordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResetPasswordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ok"] = this.ok;
        return data;
    }
}

export interface IAuthResetPasswordResponse {
    ok?: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static override fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export class AuthResetPasswordRequest implements IAuthResetPasswordRequest {
    email?: string;
    resetToken?: string;
    newPassword?: string;

    constructor(data?: IAuthResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.resetToken = _data["resetToken"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): AuthResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["resetToken"] = this.resetToken;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IAuthResetPasswordRequest {
    email?: string;
    resetToken?: string;
    newPassword?: string;
}

export class AuditLogDto implements IAuditLogDto {
    id?: number;
    entityName?: string;
    entityId?: number;
    operation?: string;
    description?: string;
    changes?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    timestamp?: Date;

    constructor(data?: IAuditLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityName = _data["entityName"];
            this.entityId = _data["entityId"];
            this.operation = _data["operation"];
            this.description = _data["description"];
            this.changes = _data["changes"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AuditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityName"] = this.entityName;
        data["entityId"] = this.entityId;
        data["operation"] = this.operation;
        data["description"] = this.description;
        data["changes"] = this.changes;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        return data;
    }
}

export interface IAuditLogDto {
    id?: number;
    entityName?: string;
    entityId?: number;
    operation?: string;
    description?: string;
    changes?: string | undefined;
    userId?: string | undefined;
    userName?: string | undefined;
    timestamp?: Date;
}

export class ArticleDto implements IArticleDto {
    id?: number;
    code?: string;
    name?: string;
    unit?: string | undefined;
    articleCategoryId?: number | undefined;
    categoryName?: string | undefined;
    classificationId?: number | undefined;
    suggestedClassificationCode?: string | undefined;
    referencePrice?: number | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.unit = _data["unit"];
            this.articleCategoryId = _data["articleCategoryId"];
            this.categoryName = _data["categoryName"];
            this.classificationId = _data["classificationId"];
            this.suggestedClassificationCode = _data["suggestedClassificationCode"];
            this.referencePrice = _data["referencePrice"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["articleCategoryId"] = this.articleCategoryId;
        data["categoryName"] = this.categoryName;
        data["classificationId"] = this.classificationId;
        data["suggestedClassificationCode"] = this.suggestedClassificationCode;
        data["referencePrice"] = this.referencePrice;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IArticleDto {
    id?: number;
    code?: string;
    name?: string;
    unit?: string | undefined;
    articleCategoryId?: number | undefined;
    categoryName?: string | undefined;
    classificationId?: number | undefined;
    suggestedClassificationCode?: string | undefined;
    referencePrice?: number | undefined;
    created?: Date;
    lastModified?: Date;
}

export class ArticleClassificationDto implements IArticleClassificationDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;

    constructor(data?: IArticleClassificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ArticleClassificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleClassificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IArticleClassificationDto {
    id?: number;
    code?: string;
    name?: string;
    sortOrder?: number;
}

export class CreateArticleCommand implements ICreateArticleCommand {
    code?: string;
    name?: string;
    unit?: string | undefined;
    articleCategoryId?: number | undefined;
    classificationId?: number | undefined;
    referencePrice?: number | undefined;

    constructor(data?: ICreateArticleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.unit = _data["unit"];
            this.articleCategoryId = _data["articleCategoryId"];
            this.classificationId = _data["classificationId"];
            this.referencePrice = _data["referencePrice"];
        }
    }

    static fromJS(data: any): CreateArticleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArticleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["articleCategoryId"] = this.articleCategoryId;
        data["classificationId"] = this.classificationId;
        data["referencePrice"] = this.referencePrice;
        return data;
    }
}

export interface ICreateArticleCommand {
    code?: string;
    name?: string;
    unit?: string | undefined;
    articleCategoryId?: number | undefined;
    classificationId?: number | undefined;
    referencePrice?: number | undefined;
}

export class UpdateArticleCommand implements IUpdateArticleCommand {
    id?: number;
    code?: string;
    name?: string;
    unit?: string | undefined;
    articleCategoryId?: number | undefined;
    classificationId?: number | undefined;
    referencePrice?: number | undefined;

    constructor(data?: IUpdateArticleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.unit = _data["unit"];
            this.articleCategoryId = _data["articleCategoryId"];
            this.classificationId = _data["classificationId"];
            this.referencePrice = _data["referencePrice"];
        }
    }

    static fromJS(data: any): UpdateArticleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["articleCategoryId"] = this.articleCategoryId;
        data["classificationId"] = this.classificationId;
        data["referencePrice"] = this.referencePrice;
        return data;
    }
}

export interface IUpdateArticleCommand {
    id?: number;
    code?: string;
    name?: string;
    unit?: string | undefined;
    articleCategoryId?: number | undefined;
    classificationId?: number | undefined;
    referencePrice?: number | undefined;
}

export class ArticleCategoryDto implements IArticleCategoryDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    created?: Date;
    lastModified?: Date;

    constructor(data?: IArticleCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ArticleCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined as any;
        return data;
    }
}

export interface IArticleCategoryDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    created?: Date;
    lastModified?: Date;
}

export class CreateArticleCategoryCommand implements ICreateArticleCategoryCommand {
    name?: string;
    code?: string | undefined;

    constructor(data?: ICreateArticleCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateArticleCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateArticleCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface ICreateArticleCategoryCommand {
    name?: string;
    code?: string | undefined;
}

export class UpdateArticleCategoryCommand implements IUpdateArticleCategoryCommand {
    id?: number;
    name?: string;
    code?: string | undefined;

    constructor(data?: IUpdateArticleCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): UpdateArticleCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateArticleCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IUpdateArticleCategoryCommand {
    id?: number;
    name?: string;
    code?: string | undefined;
}

export class AppVersionResponse implements IAppVersionResponse {
    version?: string;
    commit?: string;
    commitFull?: string;
    repository?: string | undefined;

    constructor(data?: IAppVersionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.commit = _data["commit"];
            this.commitFull = _data["commitFull"];
            this.repository = _data["repository"];
        }
    }

    static fromJS(data: any): AppVersionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AppVersionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["commit"] = this.commit;
        data["commitFull"] = this.commitFull;
        data["repository"] = this.repository;
        return data;
    }
}

export interface IAppVersionResponse {
    version?: string;
    commit?: string;
    commitFull?: string;
    repository?: string | undefined;
}

export class AiChatResponse implements IAiChatResponse {
    output?: string;
    model?: string | undefined;
    agentId?: string | undefined;
    responseId?: string | undefined;
    createdAt?: Date | undefined;

    constructor(data?: IAiChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
            this.model = _data["model"];
            this.agentId = _data["agentId"];
            this.responseId = _data["responseId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AiChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AiChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        data["model"] = this.model;
        data["agentId"] = this.agentId;
        data["responseId"] = this.responseId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAiChatResponse {
    output?: string;
    model?: string | undefined;
    agentId?: string | undefined;
    responseId?: string | undefined;
    createdAt?: Date | undefined;
}

export class RunAiChatCommand implements IRunAiChatCommand {
    prompt?: string;
    instructions?: string | undefined;

    constructor(data?: IRunAiChatCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
            this.instructions = _data["instructions"];
        }
    }

    static fromJS(data: any): RunAiChatCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RunAiChatCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        data["instructions"] = this.instructions;
        return data;
    }
}

export interface IRunAiChatCommand {
    prompt?: string;
    instructions?: string | undefined;
}

export class RunAiChatStreamCommand implements IRunAiChatStreamCommand {
    prompt?: string;
    instructions?: string | undefined;

    constructor(data?: IRunAiChatStreamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
            this.instructions = _data["instructions"];
        }
    }

    static fromJS(data: any): RunAiChatStreamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RunAiChatStreamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        data["instructions"] = this.instructions;
        return data;
    }
}

export interface IRunAiChatStreamCommand {
    prompt?: string;
    instructions?: string | undefined;
}

export class AiChatMemoryResponse implements IAiChatMemoryResponse {
    output?: string;
    threadId?: string;
    model?: string | undefined;

    constructor(data?: IAiChatMemoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
            this.threadId = _data["threadId"];
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): AiChatMemoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AiChatMemoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        data["threadId"] = this.threadId;
        data["model"] = this.model;
        return data;
    }
}

export interface IAiChatMemoryResponse {
    output?: string;
    threadId?: string;
    model?: string | undefined;
}

export class RunAiChatWithMemoryCommand implements IRunAiChatWithMemoryCommand {
    prompt?: string;
    threadId?: string | undefined;

    constructor(data?: IRunAiChatWithMemoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
            this.threadId = _data["threadId"];
        }
    }

    static fromJS(data: any): RunAiChatWithMemoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RunAiChatWithMemoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        data["threadId"] = this.threadId;
        return data;
    }
}

export interface IRunAiChatWithMemoryCommand {
    prompt?: string;
    threadId?: string | undefined;
}

export class AiMultiAgentResponse implements IAiMultiAgentResponse {
    plan?: string;
    result?: string;
    model?: string | undefined;

    constructor(data?: IAiMultiAgentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plan = _data["plan"];
            this.result = _data["result"];
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): AiMultiAgentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AiMultiAgentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plan"] = this.plan;
        data["result"] = this.result;
        data["model"] = this.model;
        return data;
    }
}

export interface IAiMultiAgentResponse {
    plan?: string;
    result?: string;
    model?: string | undefined;
}

export class RunAiMultiAgentCommand implements IRunAiMultiAgentCommand {
    prompt?: string;

    constructor(data?: IRunAiMultiAgentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
        }
    }

    static fromJS(data: any): RunAiMultiAgentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RunAiMultiAgentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        return data;
    }
}

export interface IRunAiMultiAgentCommand {
    prompt?: string;
}

export class AiToolCallResponse implements IAiToolCallResponse {
    output?: string;
    invocations?: AiToolInvocation[];
    model?: string | undefined;

    constructor(data?: IAiToolCallResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
            if (Array.isArray(_data["invocations"])) {
                this.invocations = [] as any;
                for (let item of _data["invocations"])
                    this.invocations!.push(AiToolInvocation.fromJS(item));
            }
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): AiToolCallResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AiToolCallResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        if (Array.isArray(this.invocations)) {
            data["invocations"] = [];
            for (let item of this.invocations)
                data["invocations"].push(item ? item.toJSON() : undefined as any);
        }
        data["model"] = this.model;
        return data;
    }
}

export interface IAiToolCallResponse {
    output?: string;
    invocations?: AiToolInvocation[];
    model?: string | undefined;
}

export class AiToolInvocation implements IAiToolInvocation {
    name?: string;
    arguments?: string;
    result?: string;

    constructor(data?: IAiToolInvocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.arguments = _data["arguments"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): AiToolInvocation {
        data = typeof data === 'object' ? data : {};
        let result = new AiToolInvocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["arguments"] = this.arguments;
        data["result"] = this.result;
        return data;
    }
}

export interface IAiToolInvocation {
    name?: string;
    arguments?: string;
    result?: string;
}

export class RunAiToolCallCommand implements IRunAiToolCallCommand {
    prompt?: string;

    constructor(data?: IRunAiToolCallCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
        }
    }

    static fromJS(data: any): RunAiToolCallCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RunAiToolCallCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        return data;
    }
}

export interface IRunAiToolCallCommand {
    prompt?: string;
}

export class AiRagResponse implements IAiRagResponse {
    output?: string;
    sources?: AiRagSource[];
    model?: string | undefined;

    constructor(data?: IAiRagResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(AiRagSource.fromJS(item));
            }
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): AiRagResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AiRagResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item ? item.toJSON() : undefined as any);
        }
        data["model"] = this.model;
        return data;
    }
}

export interface IAiRagResponse {
    output?: string;
    sources?: AiRagSource[];
    model?: string | undefined;
}

export class AiRagSource implements IAiRagSource {
    sourceName?: string | undefined;
    sourceLink?: string | undefined;
    text?: string | undefined;

    constructor(data?: IAiRagSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.sourceLink = _data["sourceLink"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AiRagSource {
        data = typeof data === 'object' ? data : {};
        let result = new AiRagSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["sourceLink"] = this.sourceLink;
        data["text"] = this.text;
        return data;
    }
}

export interface IAiRagSource {
    sourceName?: string | undefined;
    sourceLink?: string | undefined;
    text?: string | undefined;
}

export class RunAiRagCommand implements IRunAiRagCommand {
    prompt?: string;

    constructor(data?: IRunAiRagCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
        }
    }

    static fromJS(data: any): RunAiRagCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RunAiRagCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        return data;
    }
}

export interface IRunAiRagCommand {
    prompt?: string;
}

export class AiWorkflowResponse implements IAiWorkflowResponse {
    output?: string;
    invocations?: AiToolInvocation[];
    model?: string | undefined;

    constructor(data?: IAiWorkflowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
            if (Array.isArray(_data["invocations"])) {
                this.invocations = [] as any;
                for (let item of _data["invocations"])
                    this.invocations!.push(AiToolInvocation.fromJS(item));
            }
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): AiWorkflowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AiWorkflowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        if (Array.isArray(this.invocations)) {
            data["invocations"] = [];
            for (let item of this.invocations)
                data["invocations"].push(item ? item.toJSON() : undefined as any);
        }
        data["model"] = this.model;
        return data;
    }
}

export interface IAiWorkflowResponse {
    output?: string;
    invocations?: AiToolInvocation[];
    model?: string | undefined;
}

export class RunAiWorkflowCommand implements IRunAiWorkflowCommand {
    prompt?: string;

    constructor(data?: IRunAiWorkflowCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prompt = _data["prompt"];
        }
    }

    static fromJS(data: any): RunAiWorkflowCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RunAiWorkflowCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prompt"] = this.prompt;
        return data;
    }
}

export interface IRunAiWorkflowCommand {
    prompt?: string;
}

export class AiExtractionResponse implements IAiExtractionResponse {
    parsed?: boolean;
    raw?: string;
    error?: string | undefined;
    items?: AiExtractionItem[];
    model?: string | undefined;

    constructor(data?: IAiExtractionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parsed = _data["parsed"];
            this.raw = _data["raw"];
            this.error = _data["error"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AiExtractionItem.fromJS(item));
            }
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): AiExtractionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AiExtractionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parsed"] = this.parsed;
        data["raw"] = this.raw;
        data["error"] = this.error;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["model"] = this.model;
        return data;
    }
}

export interface IAiExtractionResponse {
    parsed?: boolean;
    raw?: string;
    error?: string | undefined;
    items?: AiExtractionItem[];
    model?: string | undefined;
}

export class AiExtractionItem implements IAiExtractionItem {
    name?: string;
    quantity?: string | undefined;
    unit?: string | undefined;
    notes?: string | undefined;

    constructor(data?: IAiExtractionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AiExtractionItem {
        data = typeof data === 'object' ? data : {};
        let result = new AiExtractionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IAiExtractionItem {
    name?: string;
    quantity?: string | undefined;
    unit?: string | undefined;
    notes?: string | undefined;
}

export class RunAiExtractionCommand implements IRunAiExtractionCommand {
    input?: string;

    constructor(data?: IRunAiExtractionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.input = _data["input"];
        }
    }

    static fromJS(data: any): RunAiExtractionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RunAiExtractionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["input"] = this.input;
        return data;
    }
}

export interface IRunAiExtractionCommand {
    input?: string;
}

export class HelpChatResponse implements IHelpChatResponse {
    reply?: string;

    constructor(data?: IHelpChatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reply = _data["reply"];
        }
    }

    static fromJS(data: any): HelpChatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HelpChatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reply"] = this.reply;
        return data;
    }
}

export interface IHelpChatResponse {
    reply?: string;
}

export class RunHelpChatCommand implements IRunHelpChatCommand {
    message?: string;
    conversationHistory?: HelpChatMessage[];

    constructor(data?: IRunHelpChatCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["conversationHistory"])) {
                this.conversationHistory = [] as any;
                for (let item of _data["conversationHistory"])
                    this.conversationHistory!.push(HelpChatMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RunHelpChatCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RunHelpChatCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.conversationHistory)) {
            data["conversationHistory"] = [];
            for (let item of this.conversationHistory)
                data["conversationHistory"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRunHelpChatCommand {
    message?: string;
    conversationHistory?: HelpChatMessage[];
}

export class HelpChatMessage implements IHelpChatMessage {
    role?: string;
    content?: string;

    constructor(data?: IHelpChatMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): HelpChatMessage {
        data = typeof data === 'object' ? data : {};
        let result = new HelpChatMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["content"] = this.content;
        return data;
    }
}

export interface IHelpChatMessage {
    role?: string;
    content?: string;
}

export class ReindexBudgetLinesResult implements IReindexBudgetLinesResult {
    queuedBudgets?: number;

    constructor(data?: IReindexBudgetLinesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queuedBudgets = _data["queuedBudgets"];
        }
    }

    static fromJS(data: any): ReindexBudgetLinesResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReindexBudgetLinesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queuedBudgets"] = this.queuedBudgets;
        return data;
    }
}

export interface IReindexBudgetLinesResult {
    queuedBudgets?: number;
}

export class BudgetLineSuggestionSettingsDto implements IBudgetLineSuggestionSettingsDto {
    limit?: number | undefined;

    constructor(data?: IBudgetLineSuggestionSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): BudgetLineSuggestionSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetLineSuggestionSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limit"] = this.limit;
        return data;
    }
}

export interface IBudgetLineSuggestionSettingsDto {
    limit?: number | undefined;
}

export class UpdateBudgetLineSuggestionSettingsCommand implements IUpdateBudgetLineSuggestionSettingsCommand {
    limit?: number | undefined;

    constructor(data?: IUpdateBudgetLineSuggestionSettingsCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limit = _data["limit"];
        }
    }

    static fromJS(data: any): UpdateBudgetLineSuggestionSettingsCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBudgetLineSuggestionSettingsCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limit"] = this.limit;
        return data;
    }
}

export interface IUpdateBudgetLineSuggestionSettingsCommand {
    limit?: number | undefined;
}

export class AccessControlVm implements IAccessControlVm {
    features?: AccessFeatureDto[];
    roles?: AccessRoleDto[];

    constructor(data?: IAccessControlVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(AccessFeatureDto.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(AccessRoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccessControlVm {
        data = typeof data === 'object' ? data : {};
        let result = new AccessControlVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAccessControlVm {
    features?: AccessFeatureDto[];
    roles?: AccessRoleDto[];
}

export class AccessFeatureDto implements IAccessFeatureDto {
    code?: string;
    name?: string;

    constructor(data?: IAccessFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AccessFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        return data;
    }
}

export interface IAccessFeatureDto {
    code?: string;
    name?: string;
}

export class AccessRoleDto implements IAccessRoleDto {
    id?: string;
    name?: string;
    isSystem?: boolean;
    canEditFeatures?: boolean;
    featureCodes?: string[];
    userCount?: number;

    constructor(data?: IAccessRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isSystem = _data["isSystem"];
            this.canEditFeatures = _data["canEditFeatures"];
            if (Array.isArray(_data["featureCodes"])) {
                this.featureCodes = [] as any;
                for (let item of _data["featureCodes"])
                    this.featureCodes!.push(item);
            }
            this.userCount = _data["userCount"];
        }
    }

    static fromJS(data: any): AccessRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isSystem"] = this.isSystem;
        data["canEditFeatures"] = this.canEditFeatures;
        if (Array.isArray(this.featureCodes)) {
            data["featureCodes"] = [];
            for (let item of this.featureCodes)
                data["featureCodes"].push(item);
        }
        data["userCount"] = this.userCount;
        return data;
    }
}

export interface IAccessRoleDto {
    id?: string;
    name?: string;
    isSystem?: boolean;
    canEditFeatures?: boolean;
    featureCodes?: string[];
    userCount?: number;
}

export class CreateRoleRequest implements ICreateRoleRequest {
    name?: string;

    constructor(data?: ICreateRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateRoleRequest {
    name?: string;
}

export class RenameRoleRequest implements IRenameRoleRequest {
    name?: string;

    constructor(data?: IRenameRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RenameRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenameRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IRenameRoleRequest {
    name?: string;
}

export class SetRoleFeaturesRequest implements ISetRoleFeaturesRequest {
    featureCodes?: string[];

    constructor(data?: ISetRoleFeaturesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureCodes"])) {
                this.featureCodes = [] as any;
                for (let item of _data["featureCodes"])
                    this.featureCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): SetRoleFeaturesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetRoleFeaturesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureCodes)) {
            data["featureCodes"] = [];
            for (let item of this.featureCodes)
                data["featureCodes"].push(item);
        }
        return data;
    }
}

export interface ISetRoleFeaturesRequest {
    featureCodes?: string[];
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}